import "./AdmissionForm.css";
import "../shared/Component/payment/Payment.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Razorpay from "react-razorpay";
import intlTelInput from "intl-tel-input";
import {
  Alarm,
  ConstructionOutlined,
  CurrencyRupee,
  Download,
  LaptopChromebook,
  Today,
} from "@mui/icons-material";
import React, { useState, useEffect, useRef, useContext } from "react";
import $ from "jquery";
/// import files

import { AxiosInstance } from "../axios";
import { validateFields } from "./Validation";
import { TechQualification } from "./TechnicalQualification";
import {
  GSTPRICE,
  ImageUrlPrefix,
  LBL_BASIC_DETAILS,
  LBL_CONTACT_DETAILS,
  LBL_ID_PROOFS,
  PaymentSKey,
} from "../labels";
import Subnav from "../features/Core/Header/Subnav";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SpecialPrefrence from "./dashboard/SpecialPrefrence";
import MultiSelect from "multiselect-react-dropdown";
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";
import { object } from "yup";
import SpecialPre from "./dashboard/SpecialPre";
// import { PictureAsPdfIcon } from '@mui/icons-material'
// function start
import facebook from "../img/socialicons/facebook.png";
import insta from "../img/socialicons/insta.png";
import linkedin from "../img/socialicons/linkedin.png";
import twitter from "../img/socialicons/twitter.svg";
import whatsapp from "../img/socialicons/whastapp.png";
import youtube from "../img/socialicons/youtube.png";
// import { toWords } from "number-to-words";
import { ToWords } from "to-words";
import Select, { components } from "react-select";
import { customStyles } from "./customStyles";
import { multiCusutomStyle } from "./Multicustomstyles";
import { CommonOption } from "../labels/Lableoption";
import DatePickerSample from "../shared/Component/DatePicker";
import MonthDatePicker from "../shared/Component/MonthDatePicker";
import SelectDropdown from "../shared/Component/BackOffice/CourseBatch/SelectDropdown";
import DropdownHeader from "../shared/Component/BackOffice/CourseBatch/DropdownHeader";
import ModelComForP from "./ModelComForP";
import { UserContext } from "../context/UserDetails";
//multiple dropdown chip
import { Dialog, DialogContent } from "@mui/material";
import Loader from "../shared/Component/Loader";
function TestBatch() {
  const navigate = useNavigate();
  const toWords = new ToWords({
    localeCode: "en-IN",
    converterOptions: {
      currency: true,
      ignoreDecimal: false,
      ignoreZeroCurrency: false,
      doNotAddOnly: false,
      currencyOptions: {
        // can be used to override defaults for the selected locale
        name: "Rupee",
        plural: "Rupees",
        symbol: "₹",
        fractionalUnit: {
          name: "Paisa",
          plural: "Paise",
          symbol: "",
        },
      },
    },
  });
  const location = useLocation();
  //fields use current fields focus
  const stateRefreshs_test = sessionStorage.getItem("stateRefreshs_test");
  const { user, logout } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const txtAdFname = useRef(null);
  const txtAdLname = useRef(null);
  const txtAdAge = useRef(null);
  const txtAdMDob = useRef(null);
  const txtadVerifyHere = useRef(null);
  const txtAdMStatus = useRef(null);
  const txtAdGender = useRef(null);
  const txtAdFath = useRef(null);
  const txtAdMoth = useRef(null);
  const txtAdPSize = useRef(null);
  const txtAdAno = useRef(null);
  const txtbatchDet = useRef(null);
  const txtAdApath = useRef(null);
  const txtAdCno = useRef(null);
  const txtAdSpc = useRef(null);
  const txtAdCpath = useRef(null);
  const txtAdPno = useRef(null);
  const txtAdWno = useRef(null);
  const txtAdFpo = useRef(null);
  const txtAdEmail = useRef(null);
  const txtAdPhno = useRef(null);
  const txtAdPsname = useRef(null);
  const txtAdParea = useRef(null);
  const txtAdPland = useRef(null);
  const txtAdPpost = useRef(null);
  const txtAdPtaluk = useRef(null);
  const txtAdPpincode = useRef(null);
  const txtAdPcity = useRef(null);
  const txtAdPstate = useRef(null);
  const txtAdPdistrict = useRef(null);
  const txtAdPerhno = useRef(null);
  const txtAdPersname = useRef(null);
  const txtAdPerarea = useRef(null);
  const txtAdPerland = useRef(null);
  const txtAdPererpost = useRef(null);
  const txtAdPertaluk = useRef(null);
  const txtAdPerpincode = useRef(null);
  const txtAdPercity = useRef(null);
  const txtAdPerstate = useRef(null);
  const txtAdPerdistrict = useRef(null);

  const txtAdEduc = useRef(null);
  const txtAdSslc = useRef(null);
  const txtAdSpass = useRef(null);
  const txtAdSmarks = useRef(null);
  const txtAdSboard = useRef(null);
  const txtAdSschool = useRef(null);
  const txtAdSins = useRef(null);
  const txtAdSfile = useRef(null);
  const txtAdHslc = useRef(null);
  const txtAdHpass = useRef(null);
  const txtAdHmarks = useRef(null);
  const txtAdHboard = useRef(null);
  const txtAdHschool = useRef(null);
  const txtAdHins = useRef(null);
  const txtAdHfile = useRef(null);
  const txtAdUCer = useRef(null);
  const txtAdUpass = useRef(null);
  const txtAdUmarks = useRef(null);
  const txtAdUdeg = useRef(null);
  const txtAdUMaj = useRef(null);
  const txtAdUMajOther = useRef(null);
  const txtAdUclass = useRef(null);
  const txtAdUins = useRef(null);
  const txtAdUfile = useRef(null);
  const txtAdPCer = useRef(null);
  const txtAdPpass = useRef(null);
  const txtAdPmarks = useRef(null);
  const txtAdPdeg = useRef(null);
  const txtAdPMaj = useRef(null);
  const txtAdPMajOther = useRef(null);
  const txtAdIMajOther = useRef(null);
  const txtAdDMajOther = useRef(null);
  const txtAdCMajOther = useRef(null);
  const txtAdPclass = useRef(null);
  const txtAdPins = useRef(null);
  const txtAdPfile = useRef(null);
  const txtAdICer = useRef(null);
  const txtAdIpass = useRef(null);
  const txtAdImarks = useRef(null);
  const txtAdIdeg = useRef(null);
  const txtAdIMaj = useRef(null);
  const txtAdIclass = useRef(null);
  const txtAdIins = useRef(null);
  const txtAdIfile = useRef(null);
  const txtAdDCer = useRef(null);
  const txtAdDpass = useRef(null);
  const txtAdDmarks = useRef(null);
  const txtAdDdeg = useRef(null);
  const txtAdDMaj = useRef(null);
  const txtAdDclass = useRef(null);
  const txtAdDins = useRef(null);
  const txtAdDfile = useRef(null);
  const txtAdCCer = useRef(null);
  const txtAdCpass = useRef(null);
  const txtAdCmarks = useRef(null);
  const txtAdCdeg = useRef(null);
  const txtAdCMaj = useRef(null);
  const txtAdCclass = useRef(null);
  const txtAdCins = useRef(null);
  const txtAdCfile = useRef(null);
  const txtAdOCer = useRef(null);
  const txtAdOpass = useRef(null);
  const txtAdOmarks = useRef(null);
  const txtAdOdeg = useRef(null);
  const txtAdOMaj = useRef(null);
  const txtAdOclass = useRef(null);
  const txtAdOins = useRef(null);
  const txtAdOfile = useRef(null);
  const txtAdCate = useRef(null);
  const txtAdCourse = useRef(null);
  const txtAdMedium = useRef(null);
  const txtAdLoca = useRef(null);
  const txtAdcMode = useRef(null);
  const txtAdBtype = useRef(null);
  const txtAdSub = useRef(null);
  const txtAdExam = useRef(null);
  const txtAdinsu = useRef(null);
  const txtAdEdetail = useRef(null);
  const txtAdEclear = useRef(null);
  const txtAdDesg = useRef(null);
  const txtAdDep = useRef(null);
  const txtAdDjoin = useRef(null);
  const txtAdayear = useRef(null);
  const txtAdacate = useRef(null);
  const txtAdacourse = useRef(null);
  const txtAdaIdnum = useRef(null);
  const txtAdafile = useRef(null);
  const hasInfoViewAdmBeenCalled = useRef(false);
  const txtAdPPayment = useRef(null);
  const txtAdPPaymentMode = useRef(null);
  const txtAdCouponCode = useRef(null);
  const [subjectselect, setSubjectselect] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [uniqueCoursedata, setUniqueCoursedata] = useState([]);
  const [subcategory, setSubcategory] = useState([]);
  const [pgDegree, setPGDegree] = useState([]);
  const [ipgDegree, setIPGDegree] = useState([]);
  const [readbatch, setReadbatch] = useState([]);
  const [readSpecialpre, setReadSpecialpre] = useState([]);
  const [step, setStep] = useState(1);
  const [cOption, setCOption] = useState([]);
  const [catOption, setCatOption] = useState([]);
  const [teachMedium, setTeachMedium] = useState([]);
  const [department, setDepartment] = useState([]);
  const [examination, setExamination] = useState([]);
  const [previousexam, setPreviousexam] = useState([]);
  const [educationOptions, setEducationOptions] = useState([]);
  const [technicalOption, setTechnicalOption] = useState([]);
  const [pcDegree, setPCDegree] = useState([]);
  const [diplomaDegree, setDiplomaDegree] = useState([]);
  const [categoryOption, setCategoryOption] = useState([]);
  const [stepperButton, setStepperButton] = useState(false);
  const [dropDowns, setDropDowns] = useState({
    Cast: null,
    CourseCate: null,
  });
  const [coursesCate, setCoursesCate] = useState([]);
  const [selectedPrev, setSelectedPrev] = useState([]);
  const [city, setCity] = useState([]);
  const [major, setMajor] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [specialPrefrence, setSpecialPrefrence] = useState([]);
  const [ugDegree, setUGDegree] = useState([]);
  const [pgMajor, setPgMajor] = useState([]);
  const [subject, setSubject] = useState([]);
  const [ipMajor, setIpMajor] = useState([]);
  const [dmajor, setDmajor] = useState([]);
  const [pcMajor, setPcmajor] = useState([]);
  const [otMajor, setOTmajor] = useState([]);
  const [classOption, setClassOption] = useState([]);
  const [listErrors, setListErrors] = useState({});
  const [batchDetails, setBatchDetails] = useState([]);
  const [courseAias, setCourseAias] = useState([]);
  const [selectedSub, setSelectedSub] = useState([]);
  const [dis, setDis] = useState(null);
  const [isSubOpen, setIsSubOpen] = useState(false);
  const [batchMessage, setBatchMessage] = useState(null);
  // switching the upcoming batches
  const [switchbatch, setSwitchbatch] = useState(false);
  const [message, setMessage] = useState("");
  const [Coupon_status, setCoupon_status] = useState(true);
  //admission id  after the step 4 api call
  const [admissionID, setAdmissionID] = useState({
    adId: 0,
    is_paid: null,
    batch_id: null,
  });
  const [couName, setCouName] = useState({
    coueName: "",
  });
  const [scp_stt, setScp_stt] = useState(false);
  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, [step]);

  const handleKeyDown = (e) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  };
  const handleWheel = (e) => {
    e.preventDefault();
  };
  useEffect(() => {
    const inputElement = txtAdAno.current;
    // console.log(inputElement, "adhar");
    if (inputElement) {
      inputElement.addEventListener("wheel", handleWheel);
    }

    // Cleanup the event listener on component unmount
    return () => {
      if (inputElement) {
        inputElement.removeEventListener("wheel", handleWheel);
      }
    };
  }, []);

  useEffect(() => {
    const inputElement = txtAdPno.current;
    // console.log(inputElement, "phone");

    if (inputElement) {
      inputElement.addEventListener("wheel", handleWheel);
    }

    // Cleanup the event listener on component unmount
    return () => {
      if (inputElement) {
        inputElement.removeEventListener("wheel", handleWheel);
      }
    };
  });
  const courseListSortData = subjects
    .filter((item) => item && item.label) // Filter out null and undefined elements
    .sort((a, b) => a.label.localeCompare(b.label));
  // console.log(courseListSortData, "subjectssubjectssubjects");
  useEffect(() => {
    const inputElement = txtAdWno.current;
    // console.log(inputElement, "whatsapp");

    if (inputElement) {
      inputElement.addEventListener("wheel", handleWheel);
    }

    // Cleanup the event listener on component unmount
    return () => {
      if (inputElement) {
        inputElement.removeEventListener("wheel", handleWheel);
      }
    };
  });
  useEffect(() => {
    const inputElement = txtAdFpo.current;
    // console.log(inputElement, "fatheeph");

    if (inputElement) {
      inputElement.addEventListener("wheel", handleWheel);
    }

    // Cleanup the event listener on component unmount
    return () => {
      if (inputElement) {
        inputElement.removeEventListener("wheel", handleWheel);
      }
    };
  });

  useEffect(() => {
    const inputElement = txtAdPpincode.current;
    // console.log(inputElement, "pincode");

    if (inputElement) {
      inputElement.addEventListener("wheel", handleWheel);
    }

    // Cleanup the event listener on component unmount
    return () => {
      if (inputElement) {
        inputElement.removeEventListener("wheel", handleWheel);
      }
    };
  });
  useEffect(() => {
    const inputElement = txtAdSmarks.current;
    // console.log(inputElement, "marks");

    if (inputElement) {
      inputElement.addEventListener("wheel", handleWheel);
    }

    // Cleanup the event listener on component unmount
    return () => {
      if (inputElement) {
        inputElement.removeEventListener("wheel", handleWheel);
      }
    };
  });

  useEffect(() => {
    const inputElement = txtAdSmarks.current;
    // console.log(inputElement, "marks");
    if (inputElement) {
      inputElement.addEventListener("wheel", handleWheel);
    }

    // Cleanup the event listener on component unmount
    return () => {
      if (inputElement) {
        inputElement.removeEventListener("wheel", handleWheel);
      }
    };
  }, []);
  //get user_id from localhost and set global

  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    } else {
      logout();
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }
  const currentDate_Join = moment().format("YYYY-MM-DD"); // step 4 join govt date
  //coupon code applied usestate
  const [couponApplied, setCouponApplied] = useState({
    coupon_status: false,
    amount: 0,
    coupon_code: "",
  });
  //education useState
  const [educationQualification, setEducationQualification] = useState([
    "SSLC",
  ]);
  const [uGisOther, setUGIsOther] = useState(false);
  const [pGisOther, setPGIsOther] = useState(false);
  const [iPGisOther, setIPGIsOther] = useState(false);
  const [dipisOther, setDipIsOther] = useState(false);
  const [pCisOther, setPCIsOther] = useState(false);

  const [ugOption, setUgOption] = useState({
    UG: null,
    PG: null,
    Integrated_PG: null,
    Diploma: null,
    Professional_Courses: null,
  });

  const [mOption, setMOption] = useState({
    UGMajor: null,
    UGClassName: null,
    PGMajor: null,
    PGClassName: null,
    IPMajor: null,
    IPClassName: null,
    DMajor: null,
    DClassName: null,
    PCMajor: null,
    PCClassName: null,
    OtClassName: null,
  });

  const [swalMsg, setSwalMsg] = useState({
    show: false,
    status: "",
    message: "",
    title: "",
    BottomOkBtn: "",
    BottomCancelBtn: "",
    BottomOkClose: "",
  });
  //education useState
  const [sslcCerficates, setSslcCerficates] = useState([
    {
      name: "sslc",
      SSLC_CNo: "",
      SSLC_Year: "",
      SSLC_Marks: "",
      SSLC_Eboard: "",
      SSLC_Scl: "",
      SSLC_MI: "",
      SSLC_Path: null,
      original_file_path: null,
    },
    {
      name: "hsc",
      HSC_CNo: "",
      HSC_Year: "",
      HSC_Marks: "",
      HSC_Ebaord: "",
      HSC_Scl: "",
      HSC_MI: "",
      HSC_Path: null,
      original_file_path: null,
    },
    {
      name: "UG",
      UGCertificateNumber: "",
      UGYearpassing: "",
      UGDegree: "",
      UGMajor: "",
      UGMajor_Other: "",
      UGMarksPercentage: "",
      UGClassName: "",
      UGNameInstitute: "",
      UG_Path: null,
      original_file_path: null,
    },
    {
      name: "PG",
      PGCertificateNumber: "",
      PGYearpassing: "",
      PGDegree: "",
      PGMajor: "",
      PGMajor_Other: "",
      PGMarksPercentage: "",
      PGClassName: "",
      PGNameInstitute: "",
      PG_Path: null,
      original_file_path: null,
    },
    {
      name: "Integrated PG",
      IPCertificateNumber: "",
      IPYearpassing: "",
      IPDegree: "",
      IPMajor: "",
      IPMajor_Other: "",
      IPMarksPercentage: "",
      IPClassName: "",
      IPNameInstitute: "",
      IP_Path: null,
      original_file_path: null,
    },
    {
      name: "Diploma",
      DCertificateNumber: "",
      DYearpassing: "",
      DDegree: "",
      DMajor: "",
      DMajor_other: "",
      DMarksPercentage: "",
      DClassName: "",
      DNameInstitute: "",
      D_Path: null,
      original_file_path: null,
    },
    {
      name: "Professional Courses",
      PCCertificateNumber: "",
      PCYearpassing: "",
      PCDegree: "",
      PCMajor: "",
      PCMajor_Other: "",
      PCMarksPercentage: "",
      PCClassName: "",
      PCNameInstitute: "",
      PC_Path: null,
      original_file_path: null,
    },
    {
      name: "Others",
      OtCertificateNumber: "",
      OtYearpassing: "",
      OtDegree: "",
      OtMajor: "",
      OtMarksPercentage: "",
      OtClassName: "",
      OtNameInstitute: "",
      Ot_Path: null,
      original_file_path: null,
    },
  ]);
  //specialPreference
  const [specialAdmissionPre, setSpecialAdmissionPre] = useState([
    // {
    //   id: 1,
    //   name: "",
    //   file: "",
    // },
  ]);
  //technical qualification
  const [techQualification, setTechQualification] = useState([
    {
      id: 0,
      name: "",
      level: "",
      lang: "",
      Cnum: "",
      grade: "",
      year: "",
      file: "",
      error_name: "",
      edu_medium: "",
      error_certificate_no: "",
      error_year_of_passing: "",
      error_level: "",
      error_grade: "",
      error_certificate_path: "",
    },
  ]);

  //list of inputs
  const [list, setList] = useState({
    FirstName: "",
    LastName: "",
    Fathername: "",
    MotherName: "",
    Profilephoto: null,
    DOB: "",
    age: 0,
    gender: "Male",
    MaritalStatus: "Single/Unmarried",
    aadharNo: "",
    aadharCardphoto: null,
    original_aadhar_path: null,
    original_profile_path: null,
    original_caste_path: null,
    Mobile: "",
    MobileCode: "",
    WhatsAppNumberCode: "",
    ParentMobileNoCode: "",
    WhatsAppNumber: "",
    ParentMobileNo: "",
    ContactNumber: false,
    SamePresentAddress: false,
    emailaddress: "",
    BuildingNumberPresent: "",
    BuildingNumberPresent: "",
    StreetNamePresent: "",
    AreaPresent: "",
    LandmarkPresent: "",
    districtPresent: "",
    CityPresent: "",
    statePresent: "",
    PostPresent: "",
    TalukPresent: "",
    PincodePresent: 0,
    BuildingNumberPermanent: "",
    StreetNamePermanent: "",
    AreaPermanent: "",
    LandmarkPermanent: "",
    CityPermanent: "",
    districtPermanent: "",
    statePermanent: "",
    PincodePermanent: 0,
    PostPermanent: "",
    TalukPermanent: "",
    PresentAddress: false,
    Cast: "",
    CastFile: null,
    category: "",
    SPCcategory: "",
    classMode: "Online",
    BatchType: "Regular",
    location: "2",
    CompetitiveExamination: "Yes",
    CompetitiveExamName: "",
    Institute: "",
    ExamPreviously: "Yes",
    ExamDetailsRes: "",
    ExamWrite: "",
    workingRes: "Yes",
    Designation: "",
    Department: "",
    JoinGovt: "",
    AIASAStudent: "Yes",
    Year: "",
    CategoryAias: "",
    CourseAias: "",
    IDPhoto: null,
    original_aiasa_id_path: null,
    IDNumber: "",
    ClassType: "",
    CourseCate: "",
    CouresName: "",
    CourseSubCate: "",
    TeachMedium: "",
    Verify: false,
    admission_status: "",
    location_name: "",
    PPayment: "",
    PPaymentMode: "",
  });
  const [examDetailsExam, setExamDetailsExam] = useState([]);
  const [locations, setLocations] = useState([]);
  //when course category select batch details fill with ui
  // admission form read api for all steps
  useEffect(() => {
    const userJSON = sessionStorage.getItem("userDetails");
    if (userJSON) {
      const user = JSON.parse(userJSON);
      if (user && user.user_id) {
        const userid = user.user_id;
        //  0 -> course admission
        if (stateRefreshs_test !== null) {
          Info_View(userid);
        }
      }
    }
  }, [stateRefreshs_test]);

  useEffect(() => {
    const userJSON = sessionStorage.getItem("userDetails");
    if (userJSON) {
      const user = JSON.parse(userJSON);
      if (user && user.user_id) {
        const userid = user.user_id;

        if (scp_stt) {
          AxiosInstance.post(`api/course/admission/info_view/${userid}/1`)
            .then((res) => {
              const userinfo = res.data.data;
              const SpecPrefrence = userinfo.scp;
              // console.log(SpecPrefrence, "SpecPrefrence");
              setSpecialAdmissionPre(SpecPrefrence);
            })
            .catch((error) => {
              return error;
            });
        }
      }
    }
  }, [scp_stt]);

  useEffect(() => {
    CallInfoView();
  }, []);

  const CallInfoView = () => {
    const userJSON = sessionStorage.getItem("userDetails");
    if (userJSON) {
      const user = JSON.parse(userJSON);
      if (user && user.user_id) {
        const userid = user.user_id;
        AxiosInstance.post(`api/course/admission/info_view/${userid}/1`)
          .then((res) => {
            if (res.data.status === true) {
              const userinfo = res.data.data;
              const admiId = userinfo.Courses
                ? userinfo.Courses.batch_details !== null &&
                  userinfo.Courses.batch_details.ID !== null
                  ? userinfo.Courses.batch_details.ID
                  : null
                : userinfo.Courses[0].batch_details !== null &&
                  userinfo.Courses[0].batch_details.ID !== null
                  ? userinfo.Courses[0].batch_details.ID
                  : null;
              if (admiId === 0 || admiId === null) {
                Info_View(userid);
              } else {
                if (!hasInfoViewAdmBeenCalled.current) {
                  InfoViewAdm(admiId, userid);
                  hasInfoViewAdmBeenCalled.current = true;
                }
              }
            } else {
              Swal.fire({
                title: "Warning",
                text: res.data.message,
                icon: "Warning",
                confirmButtonText: "Ok",
              });
              logout();
            }
          })
          .catch((error) => {
            return error;
          });
      }
    }
  };

  const Info_View = (user_idd) => {
    if (user_idd) {
      setIsLoading(true);
      AxiosInstance.post(`api/course/admission/info_view/${user_idd}/1`)
        .then((res) => {
          const userinfo = res.data.data;
          setIsLoading(false);
          const PersonDetails = {
            FirstName: userinfo.first_name,
            LastName: userinfo.last_name,
            Fathername: userinfo.father_name,
            MotherName: userinfo.mother_name,
            Profilephoto:
              userinfo.profile_path !== null ? userinfo.profile_path : null,
            original_profile_path:
              userinfo.original_profile_path !== null
                ? userinfo.original_profile_path
                : null,
            original_aadhar_path:
              userinfo.original_aadhar_path !== null
                ? userinfo.original_aadhar_path
                : null,
            original_caste_path:
              userinfo.original_caste_path !== null
                ? userinfo.original_caste_path
                : null,
            DOB:
              userinfo.dob !== null && userinfo.dob !== ""
                ? dobCon(userinfo.dob)
                : "",
            //  DOB: "2000-07-29",
            age: userinfo.age,
            gender: userinfo.gender,
            MaritalStatus: userinfo.marital_status,
            aadharNo: userinfo.aadhar_no,
            aadharCardphoto:
              userinfo.aadhar_path !== null ? userinfo.aadhar_path : null,
            Cast: userinfo.community,
            CastFile:
              userinfo.community_path !== null ? userinfo.community_path : null,
            SPCcategory:
              userinfo.scp[0].category !== null ? userinfo.scp[0].category : "",
            Mobile: userinfo.phone_no,
            WhatsAppNumber: userinfo.whatsapp_no,
            ContactNumber: userinfo.contact_type === 0 ? false : true,
            ParentMobileNo: userinfo.parent_mob_no,
            MobileCode:
              userinfo.country_code !== null ? userinfo.country_code : "+91",
            WhatsAppNumberCode:
              userinfo.country_code !== null ? userinfo.country_code : "+91",
            ParentMobileNoCode:
              userinfo.country_code !== null ? userinfo.country_code : "+91",
            emailaddress: userinfo.email,
            reply_student: "",
          };
          if (userinfo.community !== null) {
            setDropDowns((prevState) => ({
              ...prevState,
              ["Cast"]: {
                value: userinfo.community, // Set to null if userinfo.community is falsy
                label: userinfo.community, // Set a default label if userinfo.community is falsy
              },
            }));
          }

          // --- dashboard screen join now button redirect to the step1 category ---
          const storedBatch = sessionStorage.getItem("selectedBatch");
          if (storedBatch) {
            const parsedBatch = JSON.parse(storedBatch);
            // console.log("TestparseBatch:", parsedBatch);
            PersonDetails.SPCcategory = parsedBatch.category;
          } else {
            PersonDetails.SPCcategory =
              userinfo.scp[0].category !== null ? userinfo.scp[0].category : "";
          }
          setList(PersonDetails);
          const SpecPrefrence = userinfo.scp;

          setSpecialAdmissionPre(SpecPrefrence);

          userinfo.address.map((obj) => {
            if (obj.address_type === 1) {
              PersonDetails.SamePresentAddress =
                obj.same_address === 0 ? true : false;
              PersonDetails.BuildingNumberPresent = obj.address1;
              PersonDetails.StreetNamePresent = obj.address2;
              PersonDetails.AreaPresent = obj.address3;
              PersonDetails.LandmarkPresent = obj.landmark;
              PersonDetails.districtPresent = obj.district_name;
              PersonDetails.CityPresent = obj.city;
              PersonDetails.statePresent = obj.state_name;
              PersonDetails.PostPresent = obj.post_name;
              PersonDetails.TalukPresent = obj.taluk;
              PersonDetails.PincodePresent = obj.postal_code;
            } else {
              PersonDetails.SamePresentAddress =
                obj.same_address === 0 ? true : false;
              PersonDetails.BuildingNumberPermanent = obj.address1;
              PersonDetails.StreetNamePermanent = obj.address2;
              PersonDetails.AreaPermanent = obj.address3;
              PersonDetails.LandmarkPermanent = obj.landmark;
              PersonDetails.districtPermanent = obj.district_name;
              PersonDetails.CityPermanent = obj.city;
              PersonDetails.statePermanent = obj.state_name;
              PersonDetails.PostPermanent = obj.post_name;
              PersonDetails.TalukPermanent = obj.taluk;
              PersonDetails.PincodePermanent = obj.postal_code;
            }
          });
          let el = userinfo.Courses[0] ? userinfo.Courses[0] : userinfo.Courses;

          PersonDetails.CompetitiveExamination =
            el.competitive_exam === 1 ? "Yes" : "NO";
          PersonDetails.CompetitiveExamName = el.competitive_exam_name;
          PersonDetails.Institute = el.institute_name;
          PersonDetails.ExamPreviously =
            el.cleared_any_exam === 1 ? "Yes" : "NO";

          PersonDetails.ExamWrite = el.exam_details;
          PersonDetails.workingRes = el.govt_emp === 1 ? "Yes" : "NO";
          PersonDetails.Designation = el.designation;
          PersonDetails.Department = el.department;
          PersonDetails.JoinGovt =
            el.govt_join_dt !== "" && el.govt_join_dt !== null
              ? dobCon(el.govt_join_dt)
              : "";
          PersonDetails.AIASAStudent = el.aiasa_student === 1 ? "Yes" : "NO";
          PersonDetails.Year = el.aiasa_year;
          PersonDetails.CategoryAias = el.aiasa_category;
          PersonDetails.CourseAias = el.aiasa_course;
          PersonDetails.IDNumber = el.aiasa_id_number;
          PersonDetails.IDPhoto =
            el.aiasa_id_path !== null ? el.aiasa_id_path : null;
          PersonDetails.original_aiasa_id_path =
            el.original_aiasa_id_path !== null
              ? el.original_aiasa_id_path
              : null;
          PersonDetails.admission_status = el.admission_status;
          PersonDetails.location =
            el.location_id && el.location_id !== null && el.location_id !== ""
              ? el.location_id
              : "2";
          PersonDetails.location_name =
            el.location && el.location !== null && el.location !== ""
              ? el.location
              : "Kanchipuram";
          // console.log(el.subject,"reslt key");
          // updated subject in dashboard to step4 screen
          const storedBatchs = sessionStorage.getItem("selectedBatch");
          if (storedBatchs) {
            const parsedBatch = JSON.parse(storedBatch);
            console.log("subject", parsedBatch);
            if (parsedBatch.subject && parsedBatch.subject.length > 0) {
              // Creating an array of objects in the desired format
              var result = parsedBatch.subject.map((mmm) => ({
                label: mmm.subject,
                value: mmm.subject,
                pk: mmm.id,
              }));
              // console.log(result,"reslt kxcxcvxcey");
              setSelectedSub(result);
            }
          } else {
            if (el.subject && el.subject.length > 0) {
              // Creating an array of objects in the desired format
              var result = el.subject.map((mmm) => ({
                label: mmm.name,
                value: mmm.name,
                pk: mmm.pk,
              }));
              // console.log(result,"reslt kxcxcvxcey");
              setSelectedSub(result);
            }
          }
          if (el.exam_title !== null && el.exam_title !== "") {
            var exam_title = el.exam_title.split(",");
            // Creating an array of objects in the desired format
            var result = exam_title.map(function (sub, index) {
              return {
                id: index,
                examvalue: sub,
                error_name_exam: "",
              };
            });
            // setSelectedPrev(result);
            setExamDetailsExam(result);
          }
          // step4 added batch update function
          if (userinfo.Courses.batch_details !== null) {
            // console.log("one");
            PersonDetails.category =
              (userinfo.Courses.batch_details.category ===
                userinfo.scp[0].category) !==
                null && userinfo.scp[0].category
                ? userinfo.scp[0].category !== null
                  ? userinfo.scp[0].category
                  : ""
                : userinfo.Courses.batch_details.category;

            PersonDetails.CourseCate = userinfo.Courses.batch_details.course_id;
            PersonDetails.CouresName =
              userinfo.Courses.batch_details.course_name;
            PersonDetails.CourseSubCate = userinfo.Courses.batch_details
              .subcategory
              ? userinfo.Courses.batch_details.subcategory
              : "";
            PersonDetails.TeachMedium =
              userinfo.Courses.batch_details.batch_medium;
            PersonDetails.classMode = userinfo.Courses.batch_details.class_mode;
            PersonDetails.BatchType = userinfo.Courses.batch_details.batch_type;

            setDropDowns((prevState) => ({
              ...prevState,
              ["CourseCate"]: {
                value: userinfo.Courses.batch_details.course_name,
                label: userinfo.Courses.batch_details.course_name,
              },
            }));
          } else {
            // console.log("two");
            PersonDetails.SPCcategory =
              userinfo.scp[0].category !== null ? userinfo.scp[0].category : "";
            PersonDetails.CourseCate = "";
            PersonDetails.CouresName = "";
            PersonDetails.TeachMedium = "";
            PersonDetails.classMode = "Online";
            PersonDetails.BatchType = "Regular";
          }
          setList(PersonDetails);
          const PartialPayment = userinfo.Courses[0]
            ? userinfo.Courses[0].batch_details !== null &&
              userinfo.Courses[0].batch_details.partial_payment !== null
              ? userinfo.Courses[0].batch_details.partial_payment == 1
                ? "1"
                : "0"
              : "0"
            : userinfo.Courses.batch_details !== null &&
              userinfo.Courses.batch_details.partial_payment !== null
              ? userinfo.Courses.batch_details.partial_payment == 1
                ? "1"
                : "0"
              : "0";

          PersonDetails.PPayment = PartialPayment.toString();

          setList(PersonDetails);
          const bath_id =
            userinfo.Courses.batch_details !== null
              ? {
                batch_id: userinfo.Courses.batch_details.batch_id,
              }
              : null;
          let admiId = {};
          try {
            admiId = userinfo.Courses[0]
              ? {
                adId:
                  userinfo.Courses[0].batch_details !== null &&
                    userinfo.Courses[0].batch_details.ID !== null
                    ? userinfo.Courses[0].batch_details.ID
                    : null,
                is_paid: userinfo.Courses[0].is_paid,
                batch_id:
                  userinfo.Courses[0].batch_details !== null
                    ? userinfo.Courses[0].batch_details.batch_id
                    : null,
              }
              : {
                adId:
                  userinfo.Courses.batch_details !== null &&
                    userinfo.Courses.batch_details.ID !== null
                    ? userinfo.Courses.batch_details.ID
                    : null,
                is_paid: userinfo.Courses.batch_details.is_paid,
                batch_id:
                  userinfo.Courses.batch_details !== null
                    ? userinfo.Courses.batch_details.batch_id
                    : null,
              };
          } catch (e) { }
          setAdmissionID(admiId);
          setReadbatch([]);
          setBatchDetails([]);
          // setReadSpecialpre(SpecPrefrence);
          let edq = userinfo.edu
            .filter((item) => item.qualification_type === "EDQ")
            .map((obj) => {
              let name = "";
              if (obj.name === "sslc") {
                name = "SSLC";
              } else if (obj.name === "hsc") {
                name = "HSC";
              } else {
                name = obj.name;
              }
              return name;
            });

          setEducationQualification(edq);
          let sslcCert = userinfo.edu
            .filter((item) => item.qualification_type === "EDQ")
            .map((el, index) => {
              if (el.name === "sslc") {
                const matchingCertificate = {};
                // if a matching certificate is found, update its properties
                matchingCertificate.name = el.name;
                matchingCertificate.SSLC_CNo = el.certificate_no;
                matchingCertificate.SSLC_Year = el.year_of_passing;
                matchingCertificate.SSLC_Marks = el.marks_percentage;
                matchingCertificate.SSLC_Eboard = el.edu_board;
                matchingCertificate.SSLC_Scl = el.institute;
                matchingCertificate.SSLC_MI = el.edu_medium;
                matchingCertificate.SSLC_Path = el.certificate_path;
                matchingCertificate.original_file_path = el.original_file_path;
                setSslcCerficates((prevState) => {
                  return prevState.map((q) => {
                    if (q.name === el.name) {
                      // return { ...q, matchingCertificate };
                      return matchingCertificate;
                    }
                    return q;
                  });
                });
              } else if (el.name === "hsc") {
                const matchingCertificate = {};
                // if a matching certificate is found, update its properties
                matchingCertificate.name = el.name;
                matchingCertificate.HSC_CNo = el.certificate_no;
                matchingCertificate.HSC_Year = el.year_of_passing;
                matchingCertificate.HSC_Marks = el.marks_percentage;
                matchingCertificate.HSC_Ebaord = el.edu_board;
                matchingCertificate.HSC_Scl = el.institute;
                matchingCertificate.HSC_MI = el.edu_medium;
                matchingCertificate.HSC_Path = el.certificate_path;
                matchingCertificate.original_file_path = el.original_file_path;
                setSslcCerficates((prevState) => {
                  return prevState.map((q) => {
                    if (q.name === el.name) {
                      // return { ...q, matchingCertificate };
                      return matchingCertificate;
                    }
                    return q;
                  });
                });
              } else if (el.name === "UG") {
                const matchingCertificate = {};
                if (el.type_of_degree == 1) {
                  setUGIsOther(true);
                  setMOption((prevState) => ({
                    ...prevState,
                    ["UGMajor"]: {
                      value: "Others",
                      label: "Others",
                    },
                  }));
                } else {
                  setMOption((prevState) => ({
                    ...prevState,
                    ["UGMajor"]: {
                      value: el.major_subject,
                      label: el.major_subject,
                    },
                  }));
                }
                setUgOption((prevState) => ({
                  ...prevState,
                  ["UG"]: {
                    value: el.degree_name,
                    label: el.degree_name,
                  },
                }));
                // if a matching certificate is found, update its properties
                matchingCertificate.name = el.name;
                matchingCertificate.UGCertificateNumber = el.certificate_no;
                matchingCertificate.UGYearpassing = el.year_of_passing;
                matchingCertificate.UGDegree = el.degree_name;
                matchingCertificate.UGMajor_Other = el.major_subject;
                matchingCertificate.UGMajor =
                  el.type_of_degree === 1 ? "Others" : el.major_subject;
                matchingCertificate.UGMarksPercentage = el.marks_percentage;
                matchingCertificate.UGClassName = el.grade;
                matchingCertificate.original_file_path = el.original_file_path;
                setMOption((prevState) => ({
                  ...prevState,
                  ["UGClassName"]: {
                    value: el.grade,
                    label: el.grade,
                  },
                }));
                matchingCertificate.UGNameInstitute = el.institute;
                matchingCertificate.UG_Path = el.certificate_path;
                setSslcCerficates((prevState) => {
                  return prevState.map((q) => {
                    if (q.name === el.name) {
                      // return { ...q, matchingCertificate };
                      return matchingCertificate;
                    }
                    return q;
                  });
                });
              } else if (el.name === "PG") {
                const matchingCertificate = {};
                if (el.type_of_degree === 1) {
                  setPGIsOther(true);
                  setMOption((prevState) => ({
                    ...prevState,
                    ["PGMajor"]: {
                      value: "Others",
                      label: "Others",
                    },
                  }));
                } else {
                  setMOption((prevState) => ({
                    ...prevState,
                    ["PGMajor"]: {
                      value: el.major_subject,
                      label: el.major_subject,
                    },
                  }));
                }

                setUgOption((prevState) => ({
                  ...prevState,
                  ["PG"]: {
                    value: el.degree_name,
                    label: el.degree_name,
                  },
                }));

                // if a matching certificate is found, update its properties
                matchingCertificate.name = el.name;
                matchingCertificate.PGCertificateNumber = el.certificate_no;
                matchingCertificate.PGYearpassing = el.year_of_passing;
                matchingCertificate.PGMarksPercentage = el.marks_percentage;
                matchingCertificate.PGDegree = el.degree_name;
                matchingCertificate.PGMajor_Other = el.major_subject;
                matchingCertificate.PGMajor =
                  el.type_of_degree === 1 ? "Others" : el.major_subject;
                matchingCertificate.PGClassName = el.grade;
                matchingCertificate.original_file_path = el.original_file_path;
                setMOption((prevState) => ({
                  ...prevState,
                  ["PGClassName"]: {
                    value: el.grade,
                    label: el.grade,
                  },
                }));
                matchingCertificate.PGNameInstitute = el.institute;
                matchingCertificate.PG_Path = el.certificate_path;
                setSslcCerficates((prevState) => {
                  return prevState.map((q) => {
                    if (q.name === el.name) {
                      return matchingCertificate;
                    }
                    return q;
                  });
                });
              } else if (el.name === "Integrated PG") {
                const matchingCertificate = {};
                if (el.type_of_degree === 1) {
                  setIPGIsOther(true);
                  setMOption((prevState) => ({
                    ...prevState,
                    ["IPMajor"]: {
                      value: "Others",
                      label: "Others",
                    },
                  }));
                } else {
                  setMOption((prevState) => ({
                    ...prevState,
                    ["IPMajor"]: {
                      value: el.major_subject,
                      label: el.major_subject,
                    },
                  }));
                }

                setUgOption((prevState) => ({
                  ...prevState,
                  ["Integrated_PG"]: {
                    value: el.degree_name,
                    label: el.degree_name,
                  },
                }));

                // if a matching certificate is found, update its properties
                matchingCertificate.name = el.name;
                matchingCertificate.IPCertificateNumber = el.certificate_no;
                matchingCertificate.IPYearpassing = el.year_of_passing;
                matchingCertificate.IPDegree = el.degree_name;
                matchingCertificate.IPMajor_Other = el.major_subject;
                matchingCertificate.IPMajor =
                  el.type_of_degree === 1 ? "Others" : el.major_subject;
                matchingCertificate.IPMarksPercentage = el.marks_percentage;
                matchingCertificate.IPClassName = el.grade;
                matchingCertificate.original_file_path = el.original_file_path;
                setMOption((prevState) => ({
                  ...prevState,
                  ["IPClassName"]: {
                    value: el.grade,
                    label: el.grade,
                  },
                }));
                matchingCertificate.IPNameInstitute = el.institute;
                matchingCertificate.IP_Path = el.certificate_path;
                setSslcCerficates((prevState) => {
                  return prevState.map((q) => {
                    if (q.name === el.name) {
                      // return { ...q, matchingCertificate };
                      return matchingCertificate;
                    }
                    return q;
                  });
                });
              } else if (el.name === "Diploma") {
                const matchingCertificate = {};
                if (el.type_of_degree === 1) {
                  setDipIsOther(true);
                  setMOption((prevState) => ({
                    ...prevState,
                    ["DMajor"]: {
                      value: "Others",
                      label: "Others",
                    },
                  }));
                } else {
                  setMOption((prevState) => ({
                    ...prevState,
                    ["DMajor"]: {
                      value: el.major_subject,
                      label: el.major_subject,
                    },
                  }));
                }
                setUgOption((prevState) => ({
                  ...prevState,
                  ["Diploma"]: {
                    value: el.degree_name,
                    label: el.degree_name,
                  },
                }));

                // if a matching certificate is found, update its properties
                matchingCertificate.name = el.name;
                matchingCertificate.DCertificateNumber = el.certificate_no;
                matchingCertificate.DYearpassing = el.year_of_passing;
                matchingCertificate.DDegree = el.degree_name;
                matchingCertificate.DMajor_Other = el.major_subject;
                matchingCertificate.DMajor =
                  el.type_of_degree === 1 ? "Others" : el.major_subject;
                matchingCertificate.DMarksPercentage = el.marks_percentage;
                matchingCertificate.DClassName = el.grade;
                matchingCertificate.original_file_path = el.original_file_path;
                setMOption((prevState) => ({
                  ...prevState,
                  ["DClassName"]: {
                    value: el.grade,
                    label: el.grade,
                  },
                }));
                matchingCertificate.DNameInstitute = el.institute;
                matchingCertificate.D_Path = el.certificate_path;
                setSslcCerficates((prevState) => {
                  return prevState.map((q) => {
                    if (q.name === el.name) {
                      // return { ...q, matchingCertificate };
                      return matchingCertificate;
                    }
                    return q;
                  });
                });
              } else if (el.name === "Professional Courses") {
                const matchingCertificate = {};

                if (el.type_of_degree === 1) {
                  setPCIsOther(true);
                  setMOption((prevState) => ({
                    ...prevState,
                    ["PCMajor"]: {
                      value: "Others",
                      label: "Others",
                    },
                  }));
                } else {
                  setMOption((prevState) => ({
                    ...prevState,
                    ["PCMajor"]: {
                      value: el.major_subject,
                      label: el.major_subject,
                    },
                  }));
                }

                setUgOption((prevState) => ({
                  ...prevState,
                  ["Professional_Courses"]: {
                    value: el.degree_name,
                    label: el.degree_name,
                  },
                }));

                // if a matching certificate is found, update its properties
                matchingCertificate.name = el.name;
                matchingCertificate.PCCertificateNumber = el.certificate_no;
                matchingCertificate.PCYearpassing = el.year_of_passing;
                matchingCertificate.PCDegree = el.degree_name;
                matchingCertificate.PCMajor_Other = el.major_subject;
                matchingCertificate.PCMajor =
                  el.type_of_degree === 1 ? "Others" : el.major_subject;
                matchingCertificate.PCMarksPercentage = el.marks_percentage;
                matchingCertificate.PCClassName = el.grade;
                matchingCertificate.original_file_path = el.original_file_path;
                setMOption((prevState) => ({
                  ...prevState,
                  ["PCClassName"]: {
                    value: el.grade,
                    label: el.grade,
                  },
                }));
                matchingCertificate.PCNameInstitute = el.institute;
                matchingCertificate.PC_Path = el.certificate_path;
                setSslcCerficates((prevState) => {
                  return prevState.map((q) => {
                    if (q.name === el.name) {
                      // return { ...q, matchingCertificate };
                      return matchingCertificate;
                    }
                    return q;
                  });
                });
              } else if (el.name === "Others") {
                const matchingCertificate = {};

                // if a matching certificate is found, update its properties
                matchingCertificate.name = el.name;
                matchingCertificate.OtCertificateNumber = el.certificate_no;
                matchingCertificate.OtYearpassing = el.year_of_passing;
                matchingCertificate.OtDegree = el.degree_name;
                matchingCertificate.OtMajor = el.major_subject;
                matchingCertificate.OtMarksPercentage = el.marks_percentage;
                matchingCertificate.OtClassName = el.grade;
                matchingCertificate.original_file_path = el.original_file_path;
                setMOption((prevState) => ({
                  ...prevState,
                  ["OtClassName"]: {
                    value: el.grade,
                    label: el.grade,
                  },
                }));
                matchingCertificate.OtNameInstitute = el.institute;
                matchingCertificate.Ot_Path = el.certificate_path;
                setSslcCerficates((prevState) => {
                  return prevState.map((q) => {
                    if (q.name === el.name) {
                      // return { ...q, matchingCertificate };
                      return matchingCertificate;
                    }
                    return q;
                  });
                });
              }
            });
          let teach = userinfo.edu
            .filter((item) => item.qualification_type === "THQ")
            .map((el, index) => {
              const Teachqu = {};
              // if a matching certificate is found, update its properties
              Teachqu.id = el.id ? el.id : 0;
              Teachqu.name = el.name;
              Teachqu.level = el.level;
              Teachqu.lang = el.edu_medium;
              Teachqu.Cnum = el.certificate_no;
              Teachqu.grade = el.grade;
              Teachqu.year =
                el.year_of_passing !== "" && el.year_of_passing !== null
                  ? el.year_of_passing
                  : "";
              Teachqu.file = el.certificate_path;
              Teachqu.error_name = "";
              Teachqu.error_certificate_no = "";
              Teachqu.error_year_of_passing = "";
              Teachqu.error_level = "";
              Teachqu.error_grade = "";
              Teachqu.error_certificate_path = "";
              Teachqu.original_file_path = el.original_file_path;

              return Teachqu;
            });
          setTechQualification(teach);
          setReadbatch([]);
          setBatchDetails([]);
          // console.log(userinfo.Courses, "userinfo.Courses");
          // dashboard join now conditions
          let batchDe =
            userinfo.Courses.batch_details !== null
              ? {
                batch_id: userinfo.Courses.batch_details.batch_id,
                id: userinfo.Courses.batch_details.batch_id,
                img_url: userinfo.Courses.batch_details.img_url,
                course_name: userinfo.Courses.batch_details.course_name,
                CourseSubCate: userinfo.Courses.batch_details.subcategory,
                course_id: userinfo.Courses.batch_details.course_id,
                batch_details: userinfo.Courses.batch_details.batch_details,
                class_mode: userinfo.Courses.batch_details.class_mode,
                start_on: dobCon(userinfo.Courses.batch_details.start_on),
                duration: userinfo.Courses.batch_details.duration,
                act_c_fee: userinfo.Courses.batch_details.act_c_fee,
                offer_spl: userinfo.Courses.batch_details.offer_spl,
                dis_amt: userinfo.Courses.batch_details.dis_amt,
                medium: userinfo.Courses.batch_details.medium,
                no_of_test: userinfo.Courses.batch_details.no_of_test,
                batch_name: userinfo.Courses.batch_details.batch_name,
                name: userinfo.Courses.batch_details.batch_name,
                partial_payment:
                  userinfo.Courses.batch_details.partial_payment,
                pay_1_perc: userinfo.Courses.batch_details.pay_1_perc,
                pay_2_perc: userinfo.Courses.batch_details.pay_2_perc,
                pay_3_perc: userinfo.Courses.batch_details.pay_3_perc,
                pay_2_duedate: userinfo.Courses.batch_details.pay_2_duedate,
                pay_3_duedate: userinfo.Courses.batch_details.pay_3_duedate,
                is_selected: true,
              }
              : null;
          // compare the batch while switching the same or not
          const storedBatchc = sessionStorage.getItem("selectedBatch");
          // console.log("sessionStorage selectedBatch ", storedBatchc);

          if (storedBatchc) {
            const parsedBatch = JSON.parse(storedBatch);
            if (batchDe !== null) {
              if (batchDe.batch_id != parsedBatch.id) {
                Swal.fire({
                  title: "Are you sure?",
                  text: "Do you want to switch the batch?",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Yes",
                  cancelButtonText: "Cancel",
                }).then((result) => {
                  if (result.isConfirmed) {
                    getDisocount(parsedBatch.id);
                    // console.log("three");
                    // Example for `batchDe` assignment (make sure parsedBatch exists)
                    batchDe =
                      parsedBatch !== null
                        ? {
                          batch_id: parsedBatch.id,
                          id: 0,
                          img_url: parsedBatch.img_url,
                          course_name: parsedBatch.category_class,
                          course_id: parsedBatch.course_id,
                          category: parsedBatch.category,
                          CouresName: parsedBatch.category_class,
                          CourseCate: parsedBatch.category_course_id,
                          batch_type: parsedBatch.batch_type,
                          batch_details: `${moment(
                            parsedBatch.start_time,
                            "HH:mm:ss"
                          ).format("hh:mm A")} to ${moment(
                            parsedBatch.end_time,
                            "HH:mm:ss"
                          ).format("hh:mm A")}`,
                          class_mode: parsedBatch.class_mode,
                          start_on: dobCon(parsedBatch.started_dt),
                          duration: parsedBatch.duration,
                          act_c_fee: parsedBatch.fees,
                          offer_spl: parsedBatch.discount,
                          dis_amt: parsedBatch.discounted_fees,
                          medium: parsedBatch.medium,
                          no_of_test: parsedBatch.no_of_test,
                          batch_name: parsedBatch.name,
                          name: parsedBatch.name,
                          partial_payment: "",
                          pay_1_perc: "",
                          pay_2_perc: "",
                          pay_3_perc: "",
                          pay_2_duedate: "",
                          pay_3_duedate: "",
                          districts: "",
                          districts_name: "",
                          is_selected: true,
                        }
                        : null;
                    PersonDetails.category = parsedBatch.category;
                    PersonDetails.CourseCate = parsedBatch.category_course_id;
                    PersonDetails.CouresName = parsedBatch.category_class;
                    PersonDetails.TeachMedium = parsedBatch.medium;
                    PersonDetails.classMode = parsedBatch.class_mode;
                    PersonDetails.BatchType = parsedBatch.batch_type;
                    //
                    setDropDowns((prevState) => ({
                      ...prevState,
                      ["CourseCate"]: {
                        value: parsedBatch.category_class,
                        label: parsedBatch.category_class,
                      },
                    }));
                    // Map over `exam_details` and set properties as needed

                    admiId = { adId: 0, is_paid: 0, batch_id: parsedBatch.id };
                  }
                  setSwitchbatch(true);
                  sessionStorage.removeItem("selectedBatch");
                }); //
              }
            } else {
              // console.log("four");
              PersonDetails.category = parsedBatch.category;
              PersonDetails.CourseCate = parsedBatch.category_course_id;
              PersonDetails.CouresName = parsedBatch.category_class;
              PersonDetails.TeachMedium = parsedBatch.medium;
              PersonDetails.classMode = parsedBatch.class_mode;
              PersonDetails.BatchType = parsedBatch.batch_type;
              //
              setDropDowns((prevState) => ({
                ...prevState,
                ["CourseCate"]: {
                  value: parsedBatch.category_class,
                  label: parsedBatch.category_class,
                },
              }));
              txtbatchDet.current.checked = true;
              sessionStorage.removeItem("selectedBatch");
            }
          }
          setAdmissionID(admiId);
          // }
          setList(PersonDetails);

          // console.log(batchDe, "-----batchDe");
          setReadbatch([batchDe]);
          if (batchDe !== null) {
            setBatchDetails([batchDe]);
          } else {
            setBatchDetails([]);
          }
        })
        .catch((error) => {
          return error;
        });
    }
  };

  const InfoViewAdm = async (AdmisId, user_iddd) => {
    try {
      if (AdmisId) {
        const admissionResponse = await AxiosInstance.post(
          `api/course/admission/getOrderby/rpay`,
          { admission_id: AdmisId }
        );

        if (admissionResponse.data.status === true) {
          // const lastIndexCaptured =
          //   admissionResponse.data.data.items.length > 0 &&
          //   admissionResponse.data.data.items.reduceRight(
          //     (acc, item, index) => {
          //       if (item.status == "captured" && acc === -1) {
          //         acc = item;
          //       }
          //       return acc;
          //     },
          //     admissionResponse.data.data.items[
          //       admissionResponse.data.data.items.length - 1
          //     ]
          //   );

          let lastIndexCaptured = {};
          const lastIndexCaptureds =
            admissionResponse.data.data.items.length > 0 &&
            admissionResponse.data.data.items
              .filter((el, inex) => el.status === "captured")
              .map((el) => el);
          if (lastIndexCaptureds.length > 0) {
            lastIndexCaptured = lastIndexCaptureds[0];
          } else {
            lastIndexCaptured =
              admissionResponse.data.data.items[
              admissionResponse.data.data.items.length - 1
              ];
          }

          let payment_status_info_ko = "";
          if (lastIndexCaptured.status === "failed") {
            payment_status_info_ko = 0;
          } else if (lastIndexCaptured.status === "created") {
            payment_status_info_ko = 1;
          } else if (lastIndexCaptured.status === "authenticated") {
            payment_status_info_ko = 2;
          } else if (lastIndexCaptured.status === "authorized") {
            payment_status_info_ko = 3;
          } else if (lastIndexCaptured.status === "captured") {
            payment_status_info_ko = 4;
          } else if (lastIndexCaptured.status === "refunded") {
            payment_status_info_ko = 5;
          }

          const lastIndexreqdata = admissionResponse.data.basic_info;

          if (payment_status_info_ko === 4) {
            const dats = {
              id: lastIndexreqdata.admission_history_id
                ? lastIndexreqdata.admission_history_id
                : "",
              step: 7,
              location_id: lastIndexreqdata.location
                ? lastIndexreqdata.location
                : "",
              category: lastIndexreqdata.category_code
                ? lastIndexreqdata.category_code
                : "",
              subject: lastIndexreqdata.subject ? lastIndexreqdata.subject : [], //send  if subject having only
              type: 1,
              Isverify: lastIndexreqdata.Isverify
                ? lastIndexreqdata.Isverify
                : true,
              AdmissionID: AdmisId,
              CouresName: lastIndexreqdata.course_name
                ? lastIndexreqdata.course_name
                : "",
              discountAmount: lastIndexreqdata.discount_amt,
              gst: lastIndexreqdata.gst_percent,
              SpecialOffer: lastIndexreqdata.special_offer,
              spc_offer_type: lastIndexreqdata.spc_offer_type,
              batch_id: lastIndexreqdata.batch_id
                ? lastIndexreqdata.batch_id
                : "",
              coures_id: lastIndexreqdata.course_id
                ? lastIndexreqdata.course_id
                : "",
              user_id: lastIndexreqdata.user_id ? lastIndexreqdata.user_id : "",
              old_stud_disc_perc: lastIndexreqdata.old_stud_disc_perc,
              old_stud_disc: lastIndexreqdata.old_stud_disc,
              iscoupon: lastIndexreqdata.is_coupon,
              couponAmount: lastIndexreqdata.coupon_amount,
              couponcode: lastIndexreqdata.coupon_code,
              Netamount: lastIndexCaptured.amount
                ? lastIndexCaptured.amount / 100
                : "",
              status: payment_status_info_ko,
              transaction_id: lastIndexCaptured.id ? lastIndexCaptured.id : "",
              razorpay_order_id: lastIndexCaptured.order_id
                ? lastIndexCaptured.order_id
                : "",
              razorpay_signature: "",
              created_at: moment
                .unix(lastIndexCaptured.created_at)
                .format("YYYY-MM-DD HH:mm:ss"),
              partial_payment: lastIndexreqdata.partial_payment,
              old_stud_disc_applied: lastIndexreqdata.old_stud_disc_applied,
              tot_amt: lastIndexreqdata.tot_amt,
              gst_amt: lastIndexreqdata.gst_amt,
              payment_type: list.PPaymentMode === "0" ? 0 : 1,
              created_by: user_iddd,
              updated_by: user_iddd,
              installment_type:
                lastIndexreqdata.partial_payment === "1" ? [1] : [1, 2, 3],
            };
            const RegsisteRes = await AxiosInstance.post(
              `api/course/admission/register`,
              dats
            );
            if (RegsisteRes.data.status === true) {
              Info_View(user_iddd);
            } else {
              Info_View(user_iddd);
            }
          } else {
            Info_View(user_iddd);
          }
        } else {
          Info_View(user_iddd);
        }
      } else {
        Info_View(user_iddd);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (step === 2) {
      // Initialize intl-tel-input on component mount
      const iti = intlTelInput(txtAdPno.current, {
        // Add options as needed, refer to the intl-tel-input documentation
        initialCountry: "in",
        separateDialCode: true,
      });
      // You can listen for changes if needed
      txtAdPno.current.addEventListener("countrychange", () => {
        // console.log('Country changed:', iti.getSelectedCountryData());
        const selectedCountryData = iti.getSelectedCountryData();
        setList((prevFields) => ({
          ...prevFields,
          MobileCode: `+${selectedCountryData.dialCode}`, // Update phone number with the new country code
        }));
      });

      const iti_wha = intlTelInput(txtAdWno.current, {
        // Add options as needed, refer to the intl-tel-input documentation
        initialCountry: "in",
        separateDialCode: true,
      });
      // You can listen for changes if needed
      txtAdWno.current.addEventListener("countrychange", () => {
        // console.log('Country changed:', iti_wha.getSelectedCountryData());
        const selectedCountryData = iti_wha.getSelectedCountryData();
        setList((prevFields) => ({
          ...prevFields,
          WhatsAppNumberCode: `+${selectedCountryData.dialCode}`, // Update phone number with the new country code
        }));
      });

      const iti_whaParent = intlTelInput(txtAdFpo.current, {
        // Add options as needed, refer to the intl-tel-input documentation
        initialCountry: "in",
        separateDialCode: true,
      });
      // You can listen for changes if needed
      txtAdFpo.current.addEventListener("countrychange", () => {
        // console.log('Country changed:', iti_whaParent.getSelectedCountryData());
        const selectedCountryData = iti_whaParent.getSelectedCountryData();
        setList((prevFields) => ({
          ...prevFields,
          ParentMobileNoCode: `+${selectedCountryData.dialCode}`, // Update phone number with the new country code
        }));
      });

      // Clean up on component unmount
      return () => {
        iti.destroy();
        iti_wha.destroy();
        iti_whaParent.destroy();
      };
    }
  }, [step]);

  //date and time convert to normal data
  //date and time convert to normal data
  const dobCon = (userdate) => {
    if (!userdate) {
      return ""; // Handle empty input
    }
    const date = new Date(userdate);
    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return ""; // Handle invalid date
    }
    // Extract the year, month, and day components
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Month is 0-indexed
    const day = String(date.getUTCDate()).padStart(2, "0");
    // Format the date as "YYYY-MM-DD"
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };
  useEffect(() => {
    AxiosInstance.post("api/branch/list")
      .then((res) => {
        // console.log(res,"locations")
        if (res.data.data.length > 0) {
          let locations = res.data.data.map((item, index) => (
            <option key={index} id={item.name} value={item.id}>
              {item.name}
            </option>
          ));
          setLocations(locations);
        } else {
          let locations = <option value="select"> Please select </option>;
          setLocations(locations);
        }
      })
      .catch((error) => {
        return error;
      });
  }, []);
  // get course list
  useEffect(() => {
    if (list.SPCcategory !== "" && list.category !== "") {
      AxiosInstance.get(`api/all/getCourses/${list.SPCcategory}/1`) // 1 means test batch
        .then((res) => {
          const coursesCate = res.data.data.map((item, index) => ({
            value: item.id,
            label: item.name,
            subCategory: item.subcategory_code,
            course_name: item.course_name,
          }));

          const subcategorys = res.data.data;

          const bb = res.data.data
            .filter((el) => el.subcategory_code)
            .map((el, index) => ({
              id: el.id,
              value: el.subcategory_code,
              label: el.subcategory_code,
              name: el.name,
              subCategory: el.subcategory_code,
              course_name: el.course_name,
              ind: index,
              isArr: true,
            }));
          const uniqueValuesSet = new Set();
          // Filter the array to get unique items based on the 'value' property
          const uniqueData = bb.filter((item) => {
            if (!uniqueValuesSet.has(item.subCategory)) {
              uniqueValuesSet.add(item.subCategory);
              return true;
            }
            return false;
          });

          //  console.log(uniqueData,"uniqueData");
          const Tempndex = uniqueData.map((el, index) => ({
            ...el,
            ind: index,
            isArr: true,
          }));
          // console.log(Tempndex,"Tempndex");
          setUniqueCoursedata(Tempndex);
          const options_class_name = transformData(res.data.data);
          setSubjects(options_class_name);
          setCoursesCate(coursesCate);
          setSubcategory(subcategorys);
          // console.log(subcategory,"subcategory");
          setSubjectselect([]);
        })
        .catch((error) => {
          return error;
        });
    }
  }, [list.SPCcategory, list.category]);
  // get batch details
  useEffect(() => {
    if (list.category !== "" && list.CourseCate !== "") {
      // console.log("-----lalitha");
      AxiosInstance.post("api/all/getCourseBatchesList/1", {
        medium: list.TeachMedium !== "" ? list.TeachMedium : "",
        class_mode: list.classMode !== "" ? list.classMode : "",
        location: list.location !== "" ? list.location : "",
        //  "location":"",
        category_course_id: parseInt(list.CourseCate),
        passed_exam_name: "",
        batch_type: list.BatchType !== "" ? list.BatchType : "",
        subject: selectedSub.map((item) => item.pk),
      })
        .then((res) => {
          let batch = res.data.data;
          if (res.data.data.length > 0) {
            // console.log(readbatch, "readbatch");
            if (readbatch[0] !== null && readbatch.length > 0) {
              batch.map((obj, index) => {
                if (obj.id === readbatch[0].batch_id) {
                  obj.is_selected = true;
                  // setBatchId(readbatch[0].batch_id);
                  getDisocount(readbatch[0].batch_id);
                }
                batch[index] = obj;
                list.PPayment = obj.partial_payment.toString();
                // console.log(batch, "batch----lalitha");
                setBatchDetails(batch);
              });
            } else {
              const storedBatch = sessionStorage.getItem("selectedBatch");
              if (storedBatch) {
                const parsedBatch = JSON.parse(storedBatch);
                const filteredItem = batch.filter(
                  (item) => item.id === parsedBatch.id
                );
                // console.log(filteredItem, "-----ghssssl", parsedBatch);
                if (filteredItem.length > 0) {
                  filteredItem[0].is_selected = true;
                  setBatchDetails(filteredItem);
                  list.PPayment = filteredItem[0].partial_payment.toString();
                  getDisocount(filteredItem[0].id);
                } else {
                  parsedBatch.is_selected = true;
                  setBatchDetails(parsedBatch);
                  list.PPayment = parsedBatch.partial_payment.toString();
                  getDisocount(parsedBatch.id);
                }
              } else {
                setBatchDetails(batch);
                list.PPayment = batch[0].partial_payment.toString();
                getDisocount(batch[0].id);
              }
            }
          } else {
            // console.log("----lalitha two");
            setBatchDetails(batch);
          }
        })
        .catch((error) => {
          return error;
        });
    } else {
      // console.log("-ddd----lalitha");
    }
  }, [
    list.CourseCate,
    list.category,
    list.TeachMedium,
    list.classMode,
    list.location,
    list.BatchType,
    selectedSub,
  ]);

  useEffect(() => {
    if (stateRefreshs_test) {
      setStep(1);
    }
  }, [stateRefreshs_test]);

  useEffect(() => {
    if (list.category !== "" && list.CourseCate !== "")
      AxiosInstance.post("api/course/subject/byBatch", {
        category_name: list.category,
        course_name: list.CouresName,
        subcategory: list.CourseSubCate,
        type: 1, // 1 means test
      })
        .then((res) => {
          if (res.data.status === true) {
            if (res.data.data.length > 0) {
              // const subject = res.data.data.map((item, index) => (
              //   <option key={index} value={item.subject}>
              //     {item.subject}
              //   </option>
              // ));
              // setSubject(subject);
              setIsSubOpen(true);
              const subject = res.data.data.map((item, index) => ({
                value: item.subject,
                label: item.subject,
                pk: item.subject_pk,
              }));
              setSubject(subject);
            } else {
              setIsSubOpen(false);
              setSubject([]);
            }
          } else {
            setIsSubOpen(false);
            setSubject([]);
          }
        })
        .catch((error) => {
          return error;
        });
  }, [list.category, list.CourseCate]);

  useEffect(() => {
    if (list.category === "TNPSC" && list.CourseCate !== "") {
      const validCourseCategories = [
        279,
        280,
        281,
        313,
        312,
        "279",
        "280",
        "281",
        "313",
        "312",
      ];

      if (validCourseCategories.includes(list.CourseCate)) {
        // console.log(list.category,"list.category 1,3 - ",list.CourseCate)
        setIsSubOpen(true);
      } else {
        // console.log(list.category,"list.category---- ",list.CourseCate)
        setIsSubOpen(false);
      }
    } else {
      // console.log(list.category,"list.categorysss else")
      setIsSubOpen(false);
    }
  }, [list.CourseCate]);
  //Aiasa student (yes | no ) coures
  useEffect(() => {
    if (list.CategoryAias) {
      AxiosInstance.get(`api/all/getCourses/${list.CategoryAias}/1`)
        .then((res) => {
          const courseAias = res.data.data.map((item, index) => ({
            value: item.name,
            label: item.name,
          }));
          setCourseAias(courseAias);
        })
        .catch((error) => {
          return error;
        });
    }
  }, [list.CategoryAias]);
  //when pincode enter city dropdown , state , district  fill with ui
  useEffect(() => {
    if (list.PincodePresent !== "") {
      AxiosInstance.get(`api/all/getAddress/${list.PincodePresent}`)
        .then((res) => {
          let code = res.data.data;
          // const city = code.map((item, index) => (
          //   <option key={index} value={item.city}>
          //     {item.city}
          //   </option>
          // ));
          const city = code.map((item, index) => ({
            value: item.city,
            label: item.city,
          }));
          setCity(city);
          list.statePresent = code[0].state;
          list.districtPresent = code[0].district;
        })
        .catch((error) => {
          return error;
        });
    }
  }, [list.PincodePresent]);
  useEffect(() => {
    if (list.PincodePermanent !== "") {
      AxiosInstance.get(`api/all/getAddress/${list.PincodePermanent}`)
        .then((res) => {
          let code = res.data.data;
          const city = code.map((item, index) => ({
            value: item.city,
            label: item.city,
          }));
          setCity(city);
          list.statePermanent = code[0].state;
          list.districtPermanent = code[0].district;
        })
        .catch((error) => {
          return error;
        });
    }
  }, [list.PincodePermanent]);
  //when pincode enter city dropdown , state , district  fill with ui -- end

  useEffect(() => {
    if (sslcCerficates[2].UGDegree !== "") {
      const dat = {
        degree_name: sslcCerficates[2].UGDegree,
        type: "UG",
      };
      AxiosInstance.post(`api/all/getDegreeMajor/`, dat)
        .then((res) => {
          if (res.data.data.length > 0) {
            // in response duplicate entry come means its showing extra data in next api call option
            const uniqueMajorData = res.data.data.filter(
              (item, index, self) =>
                self.findIndex((i) => i.name === item.name) === index
            );
            // const majorOptions = uniqueMajorData.map((item) => (
            //   <option key={item.name} value={item.name}>
            //     {item.name}
            //   </option>
            // ));
            const majorOptions = uniqueMajorData.map((item, index) => ({
              value: item.name,
              label: item.name,
            }));
            // const additionalOptions = [
            //   { value: "Others", label: "Others" },
            // ];
            // // Append the additional objects to the majorOptions array
            // const updatedMajorOptions = majorOptions.concat(additionalOptions);
            // // Set the state with the updated array
            setMajor(majorOptions);
          } else {
            setMajor(
              []
              //   [
              //   <option key="select" disabled value="select">
              //     Please select
              //   </option>,
              // ]
            );
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [sslcCerficates[2].UGDegree]);

  useEffect(() => {
    if (sslcCerficates[3].PGDegree !== "") {
      const dats = {
        degree_name: sslcCerficates[3].PGDegree,
        type: "PG",
      };
      AxiosInstance.post(`api/all/getDegreeMajor/`, dats)
        .then((res) => {
          if (res.data.data.length > 0) {
            const uniqueMajorData = res.data.data.filter(
              (item, index, self) =>
                self.findIndex((i) => i.name === item.name) === index
            );
            // const pgMajor = uniqueMajorData.map((item) => (
            //   <option key={item.name} value={item.name}>
            //     {item.name}
            //   </option>
            // ));
            const pgMajor = uniqueMajorData.map((item, index) => ({
              value: item.name,
              label: item.name,
            }));
            setPgMajor(pgMajor);
          } else {
            setPgMajor(
              []
              //   [
              //   <option key="select" disabled value="select">
              //     Please select
              //   </option>,
              // ]
            );
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [sslcCerficates[3].PGDegree]);

  useEffect(() => {
    if (sslcCerficates[4].IPDegree !== "") {
      const datss = {
        degree_name: sslcCerficates[4].IPDegree,
        type: "IPG",
      };
      AxiosInstance.post(`api/all/getDegreeMajor/`, datss)
        .then((res) => {
          if (res.data.data.length > 0) {
            const uniqueMajorData = res.data.data.filter(
              (item, index, self) =>
                self.findIndex((i) => i.name === item.name) === index
            );
            // const IpMajor = uniqueMajorData.map((item) => (
            //   <option key={item.name} value={item.name}>
            //     {item.name}
            //   </option>
            // ));
            const IpMajor = uniqueMajorData.map((item, index) => ({
              value: item.name,
              label: item.name,
            }));
            setIpMajor(IpMajor);
          } else {
            setIpMajor(
              []
              //   [
              //   <option key="select" disabled value="select">
              //     Please select
              //   </option>,
              // ]
            );
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [sslcCerficates[4].IPDegree]);

  useEffect(() => {
    if (sslcCerficates[5].DDegree !== "") {
      const datsss = {
        degree_name: sslcCerficates[5].DDegree,
        type: "diploma",
      };
      AxiosInstance.post(`api/all/getDegreeMajor/`, datsss)
        .then((res) => {
          if (res.data.data.length > 0) {
            const uniqueMajorData = res.data.data.filter(
              (item, index, self) =>
                self.findIndex((i) => i.name === item.name) === index
            );
            // const dmajor = uniqueMajorData.map((item) => (
            //   <option key={item.name} value={item.name}>
            //     {item.name}
            //   </option>
            // ));
            const dmajor = uniqueMajorData.map((item, index) => ({
              value: item.name,
              label: item.name,
            }));
            setDmajor(dmajor);
          } else {
            setDmajor(
              []
              //   [
              //   <option key="select" disabled value="select">
              //     Please select
              //   </option>,
              // ]
            );
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [sslcCerficates[5].DDegree]);

  useEffect(() => {
    if (sslcCerficates[6].PCDegree !== "") {
      const datssss = {
        degree_name: sslcCerficates[6].PCDegree,
        type: "PC",
      };
      AxiosInstance.post(`api/all/getDegreeMajor/`, datssss)
        .then((res) => {
          if (res.data.data.length > 0) {
            const uniqueMajorData = res.data.data.filter(
              (item, index, self) =>
                self.findIndex((i) => i.name === item.name) === index
            );
            // const pcMajor = uniqueMajorData.map((item) => (
            //   <option key={item.name} value={item.name}>
            //     {item.name}
            //   </option>
            // ));
            const pcMajor = uniqueMajorData.map((item, index) => ({
              value: item.name,
              label: item.name,
            }));
            setPcmajor(pcMajor);
          } else {
            setPcmajor(
              []
              //   [
              //   <option key="select" disabled value="select">
              //     Please select
              //   </option>,
              // ]
            );
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [sslcCerficates[6].PCDegree]);

  useEffect(() => {
    if (sslcCerficates[7].OtDegree !== "") {
      AxiosInstance.get(`api/all/getDegreeMajor/${sslcCerficates[7].OtDegree}`)
        .then((res) => {
          if (res.data.data.length > 0) {
            const uniqueMajorData = res.data.data.filter(
              (item, index, self) =>
                self.findIndex((i) => i.name === item.name) === index
            );
            const OtMajor = uniqueMajorData.map((item) => (
              <option key={item.name} value={item.name}>
                {item.name}
              </option>
            ));
            setOTmajor(OtMajor);
          } else {
            setOTmajor([
              <option key="select" disabled value="select">
                Please select
              </option>,
            ]);
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [sslcCerficates[7].OtDegree]);

  //major,designation , department , exam details , degree  dropdown
  useEffect(() => {
    AxiosInstance.get("api/all/getDesignation/2")
      .then((res) => {
        const designation = res.data.data
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((item, index) => ({
            value: item.name,
            label: item.name,
          }));
        setDesignation(designation);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/all/getDepartment/2")
      .then((res) => {
        // const department = res.data.data.map((item) => (
        //   <option key={item.name} value={item.name}>
        //     {item.name}
        //   </option>
        // ));
        // setDepartment(department);
        const sortedDepartments = res.data.data
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((item, index) => ({
            value: item.name,
            label: item.name,
          }));
        setDepartment(sortedDepartments);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.post("api/all/getPreviousExam")
      .then((res) => {
        const previousexam = res.data.data.map((item, index) => (
          // { key: index, value: item.name }
          <option key={item.name} value={item.name}>
            {item.name}
          </option>
        ));
        setPreviousexam(previousexam);

        const examination = res.data.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));

        setExamination(examination);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/all/getDegreeNames/UG")
      .then((res) => {
        // const ugDegree = res.data.data.map((item) => (
        //   <option key={item.name} value={item.name}>
        //     {item.name}
        //   </option>
        // ));
        // setUGDegree(ugDegree);

        const ugDegree = res.data.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));

        // const ugDegree = res.data.data.map((item) => item.name);
        setUGDegree(ugDegree);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/all/getDegreeNames/PG")
      .then((res) => {
        // const pgDegree = res.data.data.map((item, index) => (
        //   <option key={index} value={item.name}>
        //     {item.name}
        //   </option>
        // ));
        const pgDegree = res.data.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        setPGDegree(pgDegree);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/all/getDegreeNames/IPG")
      .then((res) => {
        // const ipgDegree = res.data.data.map((item) => (
        //   <option key={item.name} value={item.name}>
        //     {item.name}
        //   </option>
        // ));
        const ipgDegree = res.data.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        setIPGDegree(ipgDegree);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/all/getDegreeNames/diploma")
      .then((res) => {
        // const diplomaDegree = res.data.data.map((item) => (
        //   <option key={item.name} value={item.name}>
        //     {item.name}
        //   </option>
        // ));
        const diplomaDegree = res.data.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        setDiplomaDegree(diplomaDegree);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/all/getDegreeNames/PC")
      .then((res) => {
        // const pcDegree = res.data.data.map((item) => (
        //   <option key={item.name} value={item.name}>
        //     {item.name}
        //   </option>
        // ));
        const pcDegree = res.data.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        setPCDegree(pcDegree);
      })
      .catch((error) => {
        return error;
      });

    // console.log(readSpecialpre,"sjdhsjfh");
  }, []);
  const specialAdmissionHandleChanges = (option, id, spename) => {
    // console.log(option, spename);
    setSpecialAdmissionPre((prevState) => {
      // Check if name already exists in prevState
      const isNameExists = prevState.some(
        (q) => q.id !== id && q.name === option.value
      );
      if (isNameExists) {
        alert("Name already exists");
        return prevState;
      }

      // Update the name if it doesn't already exist
      return prevState.map((q) => {
        if (q.id === id) {
          return { ...q, ["name"]: option.value, ["error_name"]: "" };
        }
        return q;
      });
    });
  };
  //special preference handle change
  const specialAdmissionHandleChange = (e, id, spename) => {
    const { name, value, files, checked } = e.target;
    if (name === "file" && files && files.length > 0) {
      const pref_path = files[0];
      if (
        files[0].type == "application/pdf" ||
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("pref_path", pref_path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSpecialAdmissionPre((prevState) => {
                return prevState.map((q) => {
                  if (q.id === id) {
                    return {
                      ...q,
                      file: res.data.path,
                      original_pref_path: res.data.originalname,
                    };
                  }

                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          alert("File must be less than 2 mb");
        }
      }
    } else if (name === "path_sslc" && files && files.length > 0) {
      // console.log("sdsf");
      const scp_path_sslc = files[0];
      if (
        files[0].type == "application/pdf" ||
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("scp_path_sslc", scp_path_sslc);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSpecialAdmissionPre((prevState) => {
                return prevState.map((q) => {
                  if (q.id === id) {
                    return {
                      ...q,
                      path_sslc: res.data.path,
                      original_path_sslc: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          alert("File must be less than 2 mb");
        }
      }
    } else if (name === "path_hsc" && files && files.length > 0) {
      const scp_path_hsc = files[0];
      if (
        files[0].type == "application/pdf" ||
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("scp_path_hsc", scp_path_hsc);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSpecialAdmissionPre((prevState) => {
                return prevState.map((q) => {
                  if (q.id === id) {
                    return {
                      ...q,
                      path_hsc: res.data.path,
                      original_path_hsc: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          alert("File must be less than 2 mb");
        }
      }
    } else if (name === "path_ug" && files && files.length > 0) {
      const scp_path_ug = files[0];
      if (
        files[0].type == "application/pdf" ||
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("scp_path_ug", scp_path_ug);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSpecialAdmissionPre((prevState) => {
                return prevState.map((q) => {
                  if (q.id === id) {
                    return {
                      ...q,
                      path_ug: res.data.path,
                      original_path_ug: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          alert("File must be less than 2 mb");
        }
      }
    } else if (name === "path_pg" && files && files.length > 0) {
      const scp_path_pg = files[0];
      if (
        files[0].type == "application/pdf" ||
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("scp_path_pg", scp_path_pg);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSpecialAdmissionPre((prevState) => {
                return prevState.map((q) => {
                  if (q.id === id) {
                    return {
                      ...q,
                      path_pg: res.data.path,
                      original_path_pg: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          alert("File must be less than 2 mb");
        }
      }
    } else if (name === "pstm_type") {
      // console.log(value, name , checked);
      if (checked) {
        const psctm = [];
        setSpecialAdmissionPre((prevState) => {
          return prevState.map((q) => {
            if (q.id === id) {
              // console.log(value, "0 type");
              if (value == 0) {
                psctm.push = value;
                // console.log("0 type", psctm);
                return {
                  ...q,
                  [name]: psctm,
                  pstm_type: [0, ...q.pstm_type],
                  error_path_sslc: "",
                };
              } else if (value == 1) {
                if (q.pstm_type.includes(0)) {
                  psctm.push = value;
                  return {
                    ...q,
                    [name]: psctm,
                    pstm_type: [1, ...q.pstm_type],
                    error_path_sslc: "",
                  };
                }
                return {
                  ...q,
                  [name]: psctm,
                  error_path_sslc: "Please select sslc",
                };
              } else if (value == 2) {
                if (q.pstm_type.includes(0, 1)) {
                  psctm.push = value;
                  return {
                    ...q,
                    [name]: psctm,
                    pstm_type: [2, ...q.pstm_type],
                    error_path_sslc: "",
                  };
                }
                return {
                  ...q,
                  [name]: psctm,
                  error_path_sslc: "Please select sslc , hsc",
                };
              } else if (value == 3) {
                // console.log(q.pstm_type,"q.pstm_type");
                const valueTocheck = [0, 1, 2];
                if (
                  valueTocheck.every((values) => q.pstm_type.includes(values))
                ) {
                  psctm.push = value;
                  return {
                    ...q,
                    [name]: psctm,
                    pstm_type: [3, ...q.pstm_type],
                    error_path_sslc: "",
                  };
                }
                return {
                  ...q,
                  [name]: psctm,
                  error_path_sslc: "Please select sslc , hsc , ug",
                };
              }
            }
            return q;
          });
        });
      } else {
        const psctm = [];
        psctm.push = value;
        setSpecialAdmissionPre((prevState) => {
          return prevState.map((q) => {
            if (q.id === id) {
              if (value == 0) {
                return {
                  ...q,
                  [name]: psctm,
                  pstm_type: [],
                };
              } else if (value == 1) {
                return {
                  ...q,
                  [name]: psctm,
                  pstm_type: q.pstm_type.filter(
                    (item) => item !== 2 && item !== 1 && item !== 3
                  ),
                };
              } else if (value == 2) {
                return {
                  ...q,
                  [name]: psctm,
                  pstm_type: q.pstm_type.filter(
                    (item) => item !== 2 && item !== 3
                  ),
                };
              } else {
                return {
                  ...q,
                  [name]: psctm,
                  pstm_type: q.pstm_type.filter(
                    (item) => item !== parseInt(value)
                  ),
                };
              }
            }
            return q;
          });
        });
      }
    } else {
      setSpecialAdmissionPre((prevState) => {
        // Check if name already exists in prevState
        const isNameExists = prevState.some(
          (q) => q.id !== id && q.name === value
        );
        if (isNameExists) {
          alert("Name already exists");
          return prevState;
        }
        // Update the name if it doesn't already exist
        return prevState.map((q) => {
          if (q.id === id) {
            return { ...q, [name]: value };
          }
          return q;
        });
      });
      // setListErrors({
      //   ...listErrors,aaf
      //   ["spc"]:"",
      // });
    }
  };
  //special preference delete function
  const DeleteAdmissionspre = (id, name, spc_id) => {
    const userJSON = sessionStorage.getItem("userDetails");
    if (userJSON) {
      const user = JSON.parse(userJSON);
      if (user && user.user_id) {
        const userid = user.user_id;
        AxiosInstance.post("api/course/admission/delete/scp", {
          user_id: userid,
          name: name,
          id: spc_id,
          type: 1,
        })
          .then((res) => {
            if (res.status === 200) {
              setSpecialAdmissionPre((prevState) =>
                prevState
                  .filter((item) => item.id !== id)
                  .map((item, index) => ({ ...item, id: index + 1 }))
              );

              // Swal.fire({
              //   title: "success",
              //   text: "Deleted Successfully",
              //   icon: "success",
              //   confirmButtonText: "Ok",
              // }).then((result) => {
              //   if (result.isConfirmed) {

              //   }
              // });
            }
          })
          .catch((error) => {
            return error;
          });
      }
    } else {
      console.log("User Id cannot avaliable in session storage");
    }
  };
  //special preference Add function
  const AddPrefrence = () => {
    if (specialPrefrence.length > specialAdmissionPre.length) {
      setSpecialAdmissionPre((prevState) => [
        ...prevState,
        {
          id: prevState.length > 0 ? prevState.length + 1 : 1,
          name: "",
          file: "",
          scp_pk: "",
          path_sslc: "",
          path_hsc: "",
          path_ug: "",
          path_pg: "",
          original_pref_path: null,
          original_path_sslc: null,
          original_path_hsc: null,
          original_path_ug: null,
          original_path_pg: null,
          error_name: "",
          error_path_sslc: "",
          error_path_hsc: "",
          error_path_ug: "",
          error_path_pg: "",
          pstm_type: [],
        },
      ]);
      setListErrors({
        ...listErrors,
        ["SPCcategory"]: "",
      });
    } else {
      if (list.SPCcategory) {
        Swal.fire({
          title: "Warning",
          text: "you reach more Special Preferences",
          icon: "Warning",
          confirmButtonText: "Ok",
        });
      } else {
        setListErrors({
          ...listErrors,
          ["SPCcategory"]: "Please select at least one category",
        });
      }
    }
  };
  //dob convert to age function
  const DobCovertAge = (dob) => {
    var ageInYears = moment().diff(dob, "years", false);

    // const dobDate = new Date(dob);
    // const now = new Date();
    // const ageInMs = now - dobDate;
    // const ageInYears = Math.floor(ageInMs / 31536000000); // 1 year ≈ 31536000000 ms

    return ageInYears;
  };
  //handlechange event

  const handleChangeDate = (date, name) => {
    const dateDOB = moment(date).format("YYYY-MM-DD");
    // console.log(name, "name", dateDOB);
    const age = DobCovertAge(date);
    if (age >= 18 && age <= 60) {
      setList({
        ...list,
        [name]: dateDOB,
        ["age"]: age,
      });
      setListErrors({
        ...listErrors,
        [name]: "",
        ["age"]: "",
      });
    } else {
      const err =
        "Please enter a valid date of birth. age should be between 18 and 60 years";
      setList({
        ...list,
        age: "",
      });
      setListErrors({
        ...listErrors,
        DOB: err,
      });
    }
  };
  //batch details handle change and store state
  const handleBatchDetails = (id, payment_method, e) => {
    const { name, value, files, checked } = e.target;
    getDisocount(id)
    if (readbatch[0] !== null && readbatch.length > 0) {
      if (switchbatch || id === readbatch[0].batch_id) {
        setBatchDetails((prevState) => {
          return prevState.map((q) => {
            if (q.id === id) {
              return { ...q, [name]: checked };
              // }
            } else {
              return { ...q, [name]: false };
            }
            return q;
          });
        });
        setList({
          ...list,
          PPayment: payment_method.toString(),
        });
        // setBatchId(id);
        setListErrors({
          ...listErrors,
          batchDetails: "",
        });
      } else {
        if (checked && switchbatch == false) {
          Swal.fire({
            title: "Are you sure?",
            text: "Do you want to switch the batch?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
            cancelButtonText: "Cancel",
          }).then((result) => {
            if (result.isConfirmed) {
              setBatchDetails((prevState) => {
                return prevState.map((q) => {
                  if (q.id === id) {
                    return { ...q, [name]: checked };
                    // }
                  } else {
                    return { ...q, [name]: false };
                  }
                  return q;
                });
              });
              setList({
                ...list,
                PPayment: payment_method.toString(),
              });
              getDisocount(id);
              // setBatchId(id);
              setListErrors({
                ...listErrors,
                batchDetails: "",
              });
            } else {
              setBatchDetails((prevState) => {
                return prevState;
              });
              setList({
                ...list,
                PPayment: payment_method.toString(),
              });
              // setBatchId(readbatch[0].id);
              setListErrors({
                ...listErrors,
                batchDetails: "",
              });
            }
          });
        }
      }
    } else {
      setBatchDetails((prevState) => {
        return prevState.map((q) => {
          if (q.id === id) {
            return { ...q, [name]: checked };
            // }
          } else {
            return { ...q, [name]: false };
          }
          return q;
        });
      });
      setList({
        ...list,
        PPayment: payment_method.toString(),
      });
      // setBatchId(id);
      setListErrors({
        ...listErrors,
        batchDetails: "",
      });
    }
  };
  const validateFieldsPayment = (data) => {
    const errors = {};
    if (!data.PPayment) {
      errors.PPayment = "please select Payment Type";
    } else if (!data.PPaymentMode) {
      errors.PPaymentMode = "please select Payment Mode";
    } else if (Coupon_status === false && couponApplied.coupon_code != "") {
      errors.coupon_code = "";
    }
    validateFieldsPaymentF(data);
    return errors;
  };

  const validateFieldsPaymentF = (data) => {
    if (!data.PPayment) {
      txtAdPPayment.current.focus();
    } else if (!data.PPaymentMode) {
      txtAdPPaymentMode.current.focus();
    } else if (Coupon_status === false && couponApplied.coupon_code != "") {
      txtAdCouponCode.current.focus();
    }
  };
  // handlesubmit function
  const handleSubmit = (
    batchId,
    oldstudentAmount,
    damount,
    specialoffer,
    AmountPay,
    ToalAmount,
    gstAmount,
    cname,
    cId
  ) => {
    // alert(oldstudentAmount);
    const userJSON = sessionStorage.getItem("userDetails");
    if (userJSON) {
      const user = JSON.parse(userJSON);
      if (user && user.user_id) {
        const errorss = validateFieldsPayment(list);
        if (Object.keys(errorss).length === 0) {
          setStepperButton(true);
          const userid = user.user_id;
          const CouresAmount = AmountPay;
          const CouresName = cname;
          const gstrate = 18;
          const soffer = specialoffer;
          const discountAmount = damount;
          const coures_id = cId;
          const batch_id = batchId;
          // const receipt = "Order_" + Math.floor(Math.random() * 900 + 100);
          const receipt = "Order_" + userid;

          if (CouresAmount > 0) {
            AxiosInstance.post("api/payemnt/create_order", {
              amount: CouresAmount * 100,
              currency: "INR",
              receipt: receipt,
            })
              .then((res) => {
                if (res.data.status) {
                  const { data } = res;
                  let payment_status = "";

                  if (data.status === "failed") {
                    payment_status = 0;
                  } else if (data.status === "created") {
                    payment_status = 1;
                  } else if (data.status === "authenticated") {
                    payment_status = 2;
                  } else if (data.status === "authorized") {
                    payment_status = 3;
                  } else if (data.status === "captured") {
                    payment_status = 4;
                  } else if (data.status === "refunded") {
                    payment_status = 5;
                  }
                  setIsPaymentLoading(true);
                  const dat = {
                    step: 6,
                    location_id: parseInt(list.location),
                    category: list.SPCcategory
                      ? list.SPCcategory
                      : list.category
                        ? list.category
                        : "",
                    subject:
                      selectedSub.length > 0
                        ? selectedSub.map((item) => item.value)
                        : [], //send  if subject having only
                    type: 1,
                    Isverify: list.Verify || false,
                    AdmissionID: admissionID.adId ? admissionID.adId : 0,
                    CouresName: CouresName,
                    discountAmount: discountAmount,
                    gst: gstrate,
                    SpecialOffer: soffer,
                    spc_offer_type: 0, // 0 means Nil
                    batch_id: batch_id,
                    coures_id: coures_id,
                    user_id: userid,
                    old_stud_disc_perc: dis,
                    old_stud_disc: oldstudentAmount,
                    iscoupon: couponApplied.status === true ? true : false,
                    couponAmount:
                      (couponApplied.status &&
                        message === "Coupon code applied successfully"
                        ? parseInt(couponApplied.amount)
                        : 0) !== ""
                        ? couponApplied.status &&
                          message === "Coupon code applied successfully"
                          ? parseInt(couponApplied.amount)
                          : 0
                        : 0,
                    couponcode: couponApplied.coupon_code,
                    Netamount: data.amount / 100,
                    status: payment_status,
                    transaction_id: "",
                    razorpay_order_id: data.id,
                    razorpay_signature: "",
                    created_at: moment
                      .unix(data.created_at)
                      .format("YYYY-MM-DD HH:mm:ss"),
                    partial_payment: list.PPayment
                      ? parseInt(list.PPayment)
                      : "",
                    old_stud_disc_applied: list.PPayment === "1" ? 0 : 1,
                    tot_amt: Number(ToalAmount),
                    gst_amt: Number(gstAmount),
                    payment_type: list.PPaymentMode === "0" ? 0 : 1,
                  };
                  AxiosInstance.post("api/course/admission/register", dat)
                    .then((res) => {
                      if (res.data.status === true) {
                        setIsPaymentLoading(false);
                        const options = {
                          key: PaymentSKey,
                          amount: res.data.data.Netamount,
                          currency: "INR",
                          name: CouresName,
                          prefill: {
                            name:
                              list.FirstName !== null && list.FirstName !== ""
                                ? list.FirstName
                                : "Anna iasa",
                            email:
                              list.emailaddress !== null &&
                                list.emailaddress !== ""
                                ? list.emailaddress
                                : "info@annaiasacademy.com",
                            contact:
                              list.Mobile !== null && list.Mobile !== ""
                                ? list.Mobile
                                : "1234567890",
                          },
                          description: `For Test Admission  - ${batch_id}`,
                          image: "B",
                          order_id: res.data.data.razorpay_order_id,
                          handler: function (response) {
                            if (response) {
                              setIsPaymentLoading(true);
                              const dats = {
                                id: res.data.data.id,
                                step: 7,
                                location_id: parseInt(list.location),
                                category: list.SPCcategory
                                  ? list.SPCcategory
                                  : list.category
                                    ? list.category
                                    : "",
                                subject:
                                  selectedSub.length > 0
                                    ? selectedSub.map((item) => item.value)
                                    : [], //send  if subject having only
                                type: 1,
                                Isverify: list.Verify || false,
                                AdmissionID: admissionID.adId
                                  ? admissionID.adId
                                  : 0,
                                CouresName: CouresName,
                                discountAmount: discountAmount,
                                gst: gstrate,
                                SpecialOffer: soffer,
                                spc_offer_type: 0, // 0 means Nil
                                batch_id: batch_id,
                                coures_id: coures_id,
                                user_id: userid,
                                old_stud_disc_perc: dis,
                                old_stud_disc: oldstudentAmount,
                                iscoupon:
                                  couponApplied.status === true ? true : false,
                                couponAmount:
                                  (couponApplied.status &&
                                    message === "Coupon code applied successfully"
                                    ? parseInt(couponApplied.amount)
                                    : 0) !== ""
                                    ? couponApplied.status &&
                                      message ===
                                      "Coupon code applied successfully"
                                      ? parseInt(couponApplied.amount)
                                      : 0
                                    : 0,
                                couponcode: couponApplied.coupon_code,
                                Netamount: res.data.data.Netamount,
                                status: res.data.data.status,
                                transaction_id: response.razorpay_payment_id,
                                razorpay_order_id: response.razorpay_order_id,
                                razorpay_signature: response.razorpay_signature,
                                created_at: res.data.data.created_at,
                                partial_payment: list.PPayment
                                  ? parseInt(list.PPayment)
                                  : "",
                                old_stud_disc_applied:
                                  list.PPayment === "1" ? 0 : 1,
                                tot_amt: Number(ToalAmount),
                                gst_amt: Number(gstAmount),
                                payment_type: list.PPaymentMode === "0" ? 0 : 1,
                                created_by: userid,
                                updated_by: userid,
                                installment_type:
                                  list.PPayment === "1" ? [1] : [1, 2, 3],
                              };
                              AxiosInstance.post(
                                "api/course/admission/register",
                                dats
                              )
                                .then((res) => {
                                  // console.log(res,"mdsmfbmsdbm");
                                  if (res.data.status === true) {
                                    const message = res.data.data.batch_message;
                                    setBatchMessage([message]);
                                    setStep(step + 1);
                                    setIsPaymentLoading(false);
                                    setStepperButton(false);
                                  } else {
                                    setIsPaymentLoading(false);
                                    setStepperButton(false);
                                  }
                                })
                                .catch((error) => {
                                  return error;
                                });
                            } else {
                              setIsPaymentLoading(false);
                              setStepperButton(false);
                            }
                          },
                          modal: {
                            ondismiss: function () {
                              // Triggered when the Razorpay modal is closed by the user
                              navigate("/TransactionHistory/1"); // book tab for payment pending
                            },
                          },
                        };
                        setStepperButton(false);
                        const rzp1 = new window.Razorpay(options);
                        rzp1.open();
                      } else {
                        setIsPaymentLoading(false);
                        Swal.fire({
                          title: "Warning",
                          text: res.data.message,
                          icon: "Warning",
                          confirmButtonText: "Ok",
                        }).then((result) => {
                          if (
                            res.data.data &&
                            res.data.data.req_data &&
                            res.data.data &&
                            res.data.data.req_data.id
                          ) {
                            setIsPaymentLoading(true);
                            const dats = {
                              id:
                                res.data.data && res.data.data.req_data
                                  ? res.data.data.req_data.id
                                  : "",
                              step: 7,
                              location_id: parseInt(list.location),
                              category: list.SPCcategory
                                ? list.SPCcategory
                                : list.category
                                  ? list.category
                                  : "",
                              subject:
                                selectedSub.length > 0
                                  ? selectedSub.map((item) => item.value)
                                  : [], //send  if subject having only
                              type: 0,
                              Isverify: list.Verify || false,
                              AdmissionID: admissionID.adId
                                ? admissionID.adId
                                : 0,
                              CouresName: CouresName,
                              discountAmount: discountAmount,
                              gst: gstrate,
                              SpecialOffer: soffer,
                              spc_offer_type: 0, // 0 means Nil
                              batch_id: batch_id,
                              coures_id: coures_id,
                              user_id: userid,
                              old_stud_disc_perc: dis,
                              old_stud_disc: oldstudentAmount,
                              iscoupon:
                                couponApplied.status === true ? true : false,
                              couponAmount:
                                (couponApplied.status &&
                                  message === "Coupon code applied successfully"
                                  ? parseInt(couponApplied.amount)
                                  : 0) !== ""
                                  ? couponApplied.status &&
                                    message ===
                                    "Coupon code applied successfully"
                                    ? parseInt(couponApplied.amount)
                                    : 0
                                  : 0,
                              couponcode: couponApplied.coupon_code,
                              Netamount:
                                res.data.data && res.data.data.req_data
                                  ? res.data.data.rpay_data.trans_amount
                                  : "",
                              status:
                                res.data.data && res.data.data.req_data
                                  ? res.data.data.rpay_data.transaction_status
                                  : "",
                              transaction_id:
                                res.data.data && res.data.data.req_data
                                  ? res.data.data.rpay_data.transaction_id
                                  : "",
                              razorpay_order_id:
                                res.data.data && res.data.data.req_data
                                  ? res.data.data.rpay_data.transaction_order_id
                                  : "",
                              razorpay_signature:
                                res.data.data && res.data.data.req_data
                                  ? res.data.data.req_data.razorpay_signature
                                  : "",
                              created_at:
                                res.data.data && res.data.data.req_data
                                  ? res.data.data.req_data.created_at
                                  : "",
                              partial_payment: list.PPayment
                                ? parseInt(list.PPayment)
                                : "",
                              old_stud_disc_applied:
                                list.PPayment === "1" ? 0 : 1,
                              tot_amt: Number(ToalAmount),
                              gst_amt: Number(gstAmount),
                              payment_type: list.PPaymentMode === "0" ? 0 : 1,
                              created_by: userid,
                              updated_by: userid,
                              installment_type:
                                list.PPayment === "1" ? [1] : [1, 2, 3],
                            };
                            AxiosInstance.post(
                              "api/course/admission/register",
                              dats
                            )
                              .then((res) => {
                                // console.log(res,"mdsmfbmsdbm");
                                if (res.data.status === true) {
                                  const message = res.data.data.batch_message;
                                  setBatchMessage([message]);
                                  setStep(step + 1);
                                  setIsPaymentLoading(false);
                                  setStepperButton(false);
                                } else {
                                  setIsPaymentLoading(false);
                                  setStepperButton(false);
                                }
                              })
                              .catch((error) => {
                                return error;
                              });
                          } else {
                            // Swal.fire({
                            //   title: "Warning",
                            //   text: res.data.message,
                            //   icon: "Warning",
                            //   confirmButtonText: "Ok",
                            // });
                            setStep(1);
                            CallInfoView();
                            setIsPaymentLoading(false);
                            setStepperButton(false);
                          }
                        });
                      }
                    })
                    .catch((error) => {
                      Swal.fire({
                        title: "Warning",
                        text: error,
                        icon: "Warning",
                        confirmButtonText: "Ok",
                      });
                      setStepperButton(false);
                      setIsPaymentLoading(false);
                      return error;
                    });
                } else {
                  Swal.fire({
                    title: "Warning",
                    text: res.data.message,
                    icon: "Warning",
                    confirmButtonText: "Ok",
                  });
                  setIsPaymentLoading(false);
                  setStepperButton(false);
                }
              })
              .catch((error) => {
                Swal.fire({
                  title: "Warning",
                  text: error,
                  icon: "Warning",
                  confirmButtonText: "Ok",
                });
                setIsPaymentLoading(false);
                setStepperButton(false);
                return error;
              });
          } else {
            Swal.fire({
              title: "Warning",
              text: "Your fee should be a minimum of 1 rupee. Kindly reach out to the administrator for assistance with this matter.",
              icon: "Warning",
              confirmButtonText: "Ok",
            });
            setStepperButton(false);
            setIsPaymentLoading(false);
            // setSwalMsg({
            //   show: true,
            //   status: "Warning",
            //   message:
            //     "Your fee should be a minimum of 1 rupee. Kindly reach out to the administrator for assistance with this matter.",
            //   title: "Warning",
            //   BottomOkClose: "Ok",
            // });
          }
        } else {
          setStepperButton(false);
          setListErrors(errorss);
        }
      }
    } else {
      console.log("User Id cannot avaliable in session storage");
    }
  };

  const handleSubmitCash = (
    batchId,
    oldstudentAmount,
    damount,
    specialoffer,
    AmountPay,
    ToalAmount,
    gstAmount,
    cname,
    cId
  ) => {
    const userJSON = sessionStorage.getItem("userDetails");
    if (userJSON) {
      const user = JSON.parse(userJSON);
      if (user && user.user_id) {
        const errorss = validateFieldsPayment(list);
        if (Object.keys(errorss).length === 0) {
          const userid = user.user_id;
          const CouresAmount = AmountPay;
          const CouresName = cname;
          const gstrate = 18;
          const soffer = specialoffer;
          const discountAmount = damount;
          const coures_id = cId;
          const batch_id = batchId;
          // const receipt = "Order_" + Math.floor(Math.random() * 900 + 100);
          const receipt = "Order_" + userid;

          if (CouresAmount > 0) {
            setIsPaymentLoading(true);
            const dat = {
              step: 6,
              location_id: parseInt(list.location),
              category: list.SPCcategory
                ? list.SPCcategory
                : list.category
                  ? list.category
                  : "",
              subject:
                selectedSub.length > 0
                  ? selectedSub.map((item) => item.value)
                  : [], //send  if subject having only
              type: 1,
              Isverify: list.Verify || false,
              AdmissionID: admissionID.adId ? admissionID.adId : 0,
              CouresName: CouresName,
              discountAmount: discountAmount,
              gst: gstrate,
              SpecialOffer: soffer,
              spc_offer_type: 0, // 0 means Nil
              batch_id: batch_id,
              coures_id: coures_id,
              user_id: userid,
              old_stud_disc_perc: dis,
              old_stud_disc: oldstudentAmount,
              iscoupon: couponApplied.status === true ? true : false,
              couponAmount:
                (couponApplied.status &&
                  message === "Coupon code applied successfully"
                  ? parseInt(couponApplied.amount)
                  : 0) !== ""
                  ? couponApplied.status &&
                    message === "Coupon code applied successfully"
                    ? parseInt(couponApplied.amount)
                    : 0
                  : 0,
              couponcode: couponApplied.coupon_code,
              Netamount: CouresAmount,
              status: 1,
              transaction_id: "",
              razorpay_order_id: "",
              razorpay_signature: "",
              created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
              partial_payment: list.PPayment ? parseInt(list.PPayment) : "",
              old_stud_disc_applied: list.PPayment === "1" ? 0 : 1,
              tot_amt: Number(ToalAmount),
              gst_amt: Number(gstAmount),
              payment_type: list.PPaymentMode === "0" ? 0 : 1,
            };
            AxiosInstance.post("api/course/admission/register", dat)
              .then((res) => {
                // console.log(res, "res", res.data, res.status);
                if (res.data.status === true) {
                  const message = res.data.data.Batch_msg;
                  setBatchMessage([message]);
                  setStep(step + 1);
                  setIsPaymentLoading(false);
                } else {
                  Swal.fire({
                    title: "Warning",
                    text: res.data.message,
                    icon: "Warning",
                    confirmButtonText: "Ok",
                  });
                  setStep(1);
                  CallInfoView();
                  setIsPaymentLoading(false);
                }
              })
              .catch((error) => {
                Swal.fire({
                  title: "Warning",
                  text: error,
                  icon: "Warning",
                  confirmButtonText: "Ok",
                });
                setIsPaymentLoading(false);
                return error;
              });
          } else {
            Swal.fire({
              title: "Warning",
              text: "Your fee should be a minimum of 1 rupee. Kindly reach out to the administrator for assistance with this matter.",
              icon: "Warning",
              confirmButtonText: "Ok",
            });
          }
        } else {
          setListErrors(errorss);
        }
      }
    } else {
      console.log("User Id cannot avaliable in session storage");
    }
  };
  // store localstorge
  function appendToStorage(name, data) {
    sessionStorage.setItem(name, data);
  }
  //technical qualification add function
  const AddQualification = () => {
    if (technicalOption.length > techQualification.length) {
      setTechQualification((prevState) => [
        ...prevState,
        {
          id: 0,
          name: "",
          level: "",
          lang: "",
          Cnum: "",
          grade: "",
          year: "",
          file: "",
          error_name: "",
          edu_medium: "",
          error_certificate_no: "",
          error_year_of_passing: "",
          error_level: "",
          error_grade: "",
          error_certificate_path: "",
        },
      ]);
    } else {
      Swal.fire({
        title: "Warning",
        text: "you reach more Technical Qualification",
        icon: "Warning",
        confirmButtonText: "Ok",
      });
    }
  };
  //technical qualification delete function
  const DeleteQual = (id, name) => {
    const userJSON = sessionStorage.getItem("userDetails");
    if (userJSON) {
      const user = JSON.parse(userJSON);
      if (user && user.user_id) {
        const userid = user.user_id;
        AxiosInstance.post("api/course/admission/delete/qualifications", {
          user_id: userid,
          name: name,
          qualification_type: "THQ",
          id: id,
        })
          .then((res) => {
            if (res.status === 200) {
              const val = techQualification
                .filter((item) => item.id !== id)
                .map((item, index) => ({ ...item, id: index + 1 }));
              setTechQualification(val);

              // Swal.fire({
              //   title: 'Success',
              //   text: "Deleted successfully",
              //   icon: 'success',
              //   confirmButtonText: 'Ok'
              // }).then((result) => {
              //   if (result.isConfirmed) {

              //   }
              // });
            }
          })
          .catch((error) => {
            return error;
          });
      }
    } else {
      console.log("User Id cannot avaliable in session storage");
    }
  };

  const getDisocount = (batchId) => {
    // alert(batchId);
    const df = {
      user_id: userid,
      // "type": 1,
      batch_id: batchId,
    };
    AxiosInstance.post("api/all/getOldStudDisc", df)
      .then((res) => {
        // console.log(res, "discount batch");
        if (res.data.status === true) {
          let discount = res.data.old_stud_disc;
          // console.log(discount, "discount");
          setDis(discount);
        } else {
          setDis(null); // or set a default value for no discount
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const setMaxMonthYearTec = (value) => {
    // console.log(value);
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // Month is zero-based

    // Format the current month and year as "yyyy-MM"
    const maxMonthYear = `${currentYear}-${currentMonth
      .toString()
      .padStart(2, "0")}`;
    // Parse the provided value into a JavaScript Date object
    const selectedDate = new Date(value);

    if (selectedDate > currentDate) {
      alert("Year of passing should be in past");
    } else {
      // Return the value because it's not in the future
      return value;
    }
  };

  const TechhandleChanges = (option, id, index) => {
    setTechQualification((prevState) => {
      const isNameExists = prevState.some(
        (q, i) =>
          (id !== 0 ? q.id !== id : i !== index) && q.name === option.value
      );

      return prevState.map((q, i) => {
        const match = id !== 0 ? q.id === id : i === index;

        if (match) {
          if (isNameExists) {
            return { ...q, name: "", error_name: "Name Already exist" };
          } else {
            return { ...q, name: option.value, error_name: "" };
          }
        }

        return q;
      });
    });
  };

  const TechhandleChange_date = (date, id, name, index) => {
    const dateEYD = moment(date).format("YYYY-MM");

    if (setMaxMonthYearTec(dateEYD)) {
      setTechQualification((prevState) => {
        return prevState.map((q, i) => {
          if (id === 0) {
            return i === index
              ? { ...q, [name]: dateEYD, error_year_of_passing: "" }
              : q;
          } else {
            return q.id === id
              ? { ...q, [name]: dateEYD, error_year_of_passing: "" }
              : q;
          }
        });
      });
    }
  };

  //technical qualification handle change  function
  const TechhandleChange = (e, id, index) => {
    const { name, value, files } = e.target;

    const updateState = (updatedFields) => {
      setTechQualification((prevState) => {
        return prevState.map((q, i) => {
          if (id === 0) {
            return i === index ? { ...q, ...updatedFields } : q;
          } else {
            return q.id === id ? { ...q, ...updatedFields } : q;
          }
        });
      });
    };

    if (name === "file" && files && files.length > 0) {
      const TQ_path = files[0];
      const validTypes = [
        "image/png",
        "image/jpg",
        "image/jpeg",
        "application/pdf",
      ];

      if (validTypes.includes(files[0].type)) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("TQ_path", TQ_path);

          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              updateState({
                file: res.data.path,
                original_file_path: res.data.originalname,
              });
            })
            .catch((error) => {
              Swal.fire({
                title: "Warning",
                text: error.message || "Upload failed",
                icon: "warning",
                confirmButtonText: "Ok",
              });
            });
        } else {
          alert("File must be less than 2MB");
        }
      }
    } else if (name === "year") {
      if (setMaxMonthYearTec(value)) {
        updateState({ [name]: value, error_year_of_passing: "" });
      }
    } else if (name === "Cnum") {
      if (!/^[A-Za-z0-9]*$/.test(value)) {
        alert("Certificate number can only contain letters and numbers");
      } else {
        updateState({ [name]: value, error_certificate_no: "" });
      }
    } else if (name === "grade") {
      updateState({ [name]: value, error_grade: "" });
    } else if (name === "level") {
      updateState({ [name]: value, error_level: "" });
    } else if (name === "lang") {
      updateState({ [name]: value, error_edu_medium: "" });
    } else {
      updateState({ [name]: value });
    }
  };

  //handlebar function
  const handleblur = (event) => {
    const { name, value } = event.target;

    setList({
      ...list,
      [name]: value,
    });
  };
  //educational checkbox handlechange
  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    const checked = event.target.checked;

    if (checked) {
      setEducationQualification([...educationQualification, value]);
      setListErrors({
        ...listErrors,
        EducationQualification: "",
      });
    } else {
      // alert("uncheck");
      const userJSON = sessionStorage.getItem("userDetails");
      if (userJSON) {
        const user = JSON.parse(userJSON);
        if (user && user.user_id) {
          const userid = user.user_id;
          AxiosInstance.post("api/course/admission/delete/qualifications", {
            user_id: userid,
            name: value,
            qualification_type: "EDQ",
          })
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                setEducationQualification(
                  educationQualification.filter((item) => item !== value)
                );
                // Swal.fire({
                //   title: 'Success',
                //   text: "Deleted successfully",
                //   icon: 'success',
                //   confirmButtonText: 'Ok'
                // }).then((result) => {
                //   if (result.isConfirmed) {

                //   }
                // });
              }
            })
            .catch((error) => {
              return error;
            });
        }
      } else {
        console.log("User Id cannot avaliable in session storage");
      }
    }
  };

  const setMaxMonthYear = (value, names) => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // Month is zero-based

    // Format the current month and year as "yyyy-MM"
    const maxMonthYear = `${currentYear}-${currentMonth
      .toString()
      .padStart(2, "0")}`;

    // Parse the provided value into a JavaScript Date object
    const selectedDate = new Date(value);

    if (selectedDate > currentDate) {
      setListErrors({
        ...listErrors,
        [names]: "Year of passing should be in past",
      });
    } else {
      // Return the value because it's not in the future
      return value;
    }
  };

  const handleYearChange = (year, dname) => {
    if (dname === "DOB") {
      if (list.DOB !== null && list.DOB !== "") {
        const currentDate = new Date(list.DOB);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const currentDate_moment = moment(currentDate).format("YYYY-MM-DD");
        const age = DobCovertAge(currentDate_moment);
        if (age >= 18 && age <= 60) {
          setList({
            ...list,
            ["DOB"]: currentDate_moment,
            ["age"]: age,
          });
          setListErrors({
            ...listErrors,
            ["DOB"]: "",
            ["age"]: "",
          });
        } else {
          const err =
            "Please enter a valid date of birth. age should be between 18 and 60 years";
          setList({
            ...list,
            age: "",
          });
          setListErrors({
            ...listErrors,
            DOB: err,
          });
        }
      }
    } else if (dname === "JoinGovt") {
      if (
        list.JoinGovt !== null &&
        list.JoinGovt !== "" &&
        list.JoinGovt !== undefined
      ) {
        const currentDate = new Date(list.JoinGovt);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const currentDate_moment = moment(currentDate).format("YYYY-MM-DD");
        setList({
          ...list,
          ["JoinGovt"]: currentDate_moment,
        });
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const currentDate_moment = moment(currentDate).format("YYYY-MM-DD");
        setList({
          ...list,
          ["JoinGovt"]: currentDate_moment,
        });
      }
    }
  };

  const handleMonthChange = (month, dname) => {
    // console.log(month,"month");
    if (dname === "DOB") {
      if (list.DOB !== null && list.DOB !== "") {
        const currentDate = new Date(list.DOB);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const currentDate_moment = moment(currentDate).format("YYYY-MM-DD");
        const age = DobCovertAge(currentDate_moment);
        if (age >= 18 && age <= 60) {
          setList({
            ...list,
            ["DOB"]: currentDate_moment,
            ["age"]: age,
          });
          setListErrors({
            ...listErrors,
            ["DOB"]: "",
            ["age"]: "",
          });
        } else {
          const err =
            "Please enter a valid date of birth. age should be between 18 and 60 years";
          setList({
            ...list,
            age: "",
          });
          setListErrors({
            ...listErrors,
            DOB: err,
          });
        }
      }
    } else if (dname === "JoinGovt") {
      if (
        list.JoinGovt !== null &&
        list.JoinGovt !== "" &&
        list.JoinGovt !== undefined
      ) {
        const currentDate = new Date(list.JoinGovt);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const currentDate_moment = moment(currentDate).format("YYYY-MM-DD");
        setList({
          ...list,
          ["JoinGovt"]: currentDate_moment,
        });
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const currentDate_moment = moment(currentDate).format("YYYY-MM-DD");
        setList({
          ...list,
          ["JoinGovt"]: currentDate_moment,
        });
      }
    }
  };

  const handleEdus = (option, name, dname) => {
    if (name === "Integrated PG") {
      setUgOption((prevState) => ({
        ...prevState,
        ["Integrated_PG"]: option,
      }));
      setMOption((prevState) => ({
        ...prevState,
        ["IPMajor"]: "",
      }));
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === name) {
            return { ...q, [dname]: option.value };
          }
          return q;
        });
      });
    } else if (name === "Professional Courses") {
      setUgOption((prevState) => ({
        ...prevState,
        ["Professional_Courses"]: option,
      }));
      setMOption((prevState) => ({
        ...prevState,
        ["PCMajor"]: "",
      }));
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === name) {
            return { ...q, [dname]: option.value };
          }
          return q;
        });
      });
    } else if (name === "UG") {
      setUgOption((prevState) => ({
        ...prevState,
        ["UG"]: option,
      }));
      setMOption((prevState) => ({
        ...prevState,
        ["UGMajor"]: "",
      }));
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === name) {
            return { ...q, [dname]: option.value };
          }
          return q;
        });
      });
    } else if (name === "PG") {
      setUgOption((prevState) => ({
        ...prevState,
        ["PG"]: option,
      }));
      setMOption((prevState) => ({
        ...prevState,
        ["PGMajor"]: "",
      }));
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === name) {
            return { ...q, [dname]: option.value };
          }
          return q;
        });
      });
    } else if (name === "Diploma") {
      setUgOption((prevState) => ({
        ...prevState,
        ["Diploma"]: option,
      }));
      setMOption((prevState) => ({
        ...prevState,
        ["DMajor"]: "",
      }));
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === name) {
            return { ...q, [dname]: option.value };
          }
          return q;
        });
      });
    } else {
      setUgOption((prevState) => ({
        ...prevState,
        [name]: option,
      }));
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === name) {
            return { ...q, [dname]: option.value };
          }
          return q;
        });
      });
    }
    setListErrors({
      ...listErrors,
      [dname]: "",
    });
  };

  const handleEduMajor = (option, name, dname) => {
    if (option.label === "Others" && name === "UG" && dname === "UGMajor") {
      setUGIsOther(true);
    } else if (
      option.label !== "Others" &&
      name === "UG" &&
      dname === "UGMajor"
    ) {
      setUGIsOther(false);
    } else if (
      option.label === "Others" &&
      name === "PG" &&
      dname === "PGMajor"
    ) {
      setPGIsOther(true);
    } else if (
      option.label !== "Others" &&
      name === "PG" &&
      dname === "PGMajor"
    ) {
      setPGIsOther(false);
    } else if (
      option.label === "Others" &&
      name === "Integrated PG" &&
      dname === "IPMajor"
    ) {
      setIPGIsOther(true);
    } else if (
      option.label !== "Others" &&
      name === "Integrated PG" &&
      dname === "IPMajor"
    ) {
      setIPGIsOther(false);
    } else if (
      option.label === "Others" &&
      name === "Diploma" &&
      dname === "DMajor"
    ) {
      setDipIsOther(true);
    } else if (
      option.label !== "Others" &&
      name === "Diploma" &&
      dname === "DMajor"
    ) {
      setDipIsOther(false);
    } else if (
      option.label === "Others" &&
      name === "Professional Courses" &&
      dname === "PCMajor"
    ) {
      setPCIsOther(true);
    } else if (
      option.label !== "Others" &&
      name === "Professional Courses" &&
      dname === "PCMajor"
    ) {
      setPCIsOther(false);
    }
    setMOption((prevState) => ({
      ...prevState,
      [dname]: option,
    }));
    setSslcCerficates((prevState) => {
      return prevState.map((q) => {
        if (q.name === name) {
          return { ...q, [dname]: option.value };
        }
        return q;
      });
    });
    setListErrors({
      ...listErrors,
      [dname]: "",
    });
  };

  const handleSelectMulti = (option, name, dname) => {
    if (name === "CourseCate") {
      setList((prevState) => ({
        ...prevState,
        ["CourseCate"]: option.value,
        ["CouresName"]: option.course_name,
        ["CourseSubCate"]: option.subCategory,
      }));
      setDropDowns((prevState) => ({
        ...prevState,
        [dname]: option,
      }));
      setListErrors({
        ...listErrors,
        [dname]: "",
      });
    } else {
      setList((prevState) => ({
        ...prevState,
        [dname]: option.value,
      }));
      setDropDowns((prevState) => ({
        ...prevState,
        [dname]: option,
      }));
    }

    setListErrors({
      ...listErrors,
      [dname]: "",
    });
  };
  const handleSelectCH = (option, dname) => {
    // console.log(option, dname);
    setList((prevState) => ({
      ...prevState,
      [dname]: option.value,
    }));
    setListErrors({
      ...listErrors,
      [dname]: "",
    });
  };

  // all date format should handle function
  const handleChangeCuDate = (dates, name) => {
    const dateSam = moment(dates).format("YYYY-MM-DD");
    // console.log(name, "name", dateSam);
    if (name === "JoinGovt") {
      setList((prevState) => ({
        ...prevState,
        [name]: dateSam,
      }));
      setListErrors({
        ...listErrors,
        [name]: "",
      });
    }
  };

  const handleEYDate = (dates, name, dname) => {
    const dateEYD = moment(dates).format("YYYY-MM");
    // console.log(name, "name", dname, dateEYD);
    if (setMaxMonthYear(dateEYD, name)) {
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === dname) {
            return { ...q, [name]: dateEYD };
          }
          return q;
        });
      });
      setListErrors({
        ...listErrors,
        [name]: "",
      });
    } else {
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === dname) {
            return { ...q, [name]: "" };
          }
          return q;
        });
      });
    }
  };

  const handleYearChange_month = (year, dname) => {
    if (dname === "SSLC_Year") {
      if (
        sslcCerficates[0].SSLC_Year !== null &&
        sslcCerficates[0].SSLC_Year !== "" &&
        sslcCerficates[0].SSLC_Year !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[0].SSLC_Year);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "sslc") {
                return { ...q, ["SSLC_Year"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["SSLC_Year"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "sslc") {
                return { ...q, ["SSLC_Year"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "sslc") {
              return { ...q, ["SSLC_Year"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["SSLC_Year"]: "",
        });
      }
    } else if (dname === "HSC_Year") {
      if (
        sslcCerficates[1].HSC_Year !== null &&
        sslcCerficates[1].HSC_Year !== "" &&
        sslcCerficates[1].HSC_Year !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[1].HSC_Year);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "hsc") {
                return { ...q, ["HSC_Year"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["HSC_Year"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "hsc") {
                return { ...q, ["HSC_Year"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "hsc") {
              return { ...q, ["HSC_Year"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["HSC_Year"]: "",
        });
      }
    } else if (dname === "UGYearpassing") {
      if (
        sslcCerficates[2].UGYearpassing !== null &&
        sslcCerficates[2].UGYearpassing !== "" &&
        sslcCerficates[2].UGYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[2].UGYearpassing);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "UG") {
                return { ...q, ["UGYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["UGYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "UG") {
                return { ...q, ["UGYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "UG") {
              return { ...q, ["UGYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["UGYearpassing"]: "",
        });
      }
    } else if (dname === "PGYearpassing") {
      if (
        sslcCerficates[3].PGYearpassing !== null &&
        sslcCerficates[3].PGYearpassing !== "" &&
        sslcCerficates[3].PGYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[3].PGYearpassing);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "PG") {
                return { ...q, ["PGYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["PGYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "PG") {
                return { ...q, ["PGYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "PG") {
              return { ...q, ["PGYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["PGYearpassing"]: "",
        });
      }
    } else if (dname === "IPYearpassing") {
      if (
        sslcCerficates[4].IPYearpassing !== null &&
        sslcCerficates[4].IPYearpassing !== "" &&
        sslcCerficates[4].IPYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[4].IPYearpassing);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Integrated PG") {
                return { ...q, ["IPYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["IPYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Integrated PG") {
                return { ...q, ["IPYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Integrated PG") {
              return { ...q, ["IPYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["IPYearpassing"]: "",
        });
      }
    } else if (dname === "DYearpassing") {
      if (
        sslcCerficates[5].DYearpassing !== null &&
        sslcCerficates[5].DYearpassing !== "" &&
        sslcCerficates[5].DYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[5].DYearpassing);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Diploma") {
                return { ...q, ["DYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["DYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Diploma") {
                return { ...q, ["DYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Diploma") {
              return { ...q, ["DYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["DYearpassing"]: "",
        });
      }
    } else if (dname === "PCYearpassing") {
      if (
        sslcCerficates[6].PCYearpassing !== null &&
        sslcCerficates[6].PCYearpassing !== "" &&
        sslcCerficates[6].PCYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[6].PCYearpassing);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Professional Courses") {
                return { ...q, ["PCYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["PCYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Professional Courses") {
                return { ...q, ["PCYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Professional Courses") {
              return { ...q, ["PCYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["PCYearpassing"]: "",
        });
      }
    } else if (dname === "OtYearpassing") {
      if (
        sslcCerficates[7].OtYearpassing !== null &&
        sslcCerficates[7].OtYearpassing !== "" &&
        sslcCerficates[7].OtYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[7].OtYearpassing);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Others") {
                return { ...q, ["OtYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["OtYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Others") {
                return { ...q, ["OtYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Others") {
              return { ...q, ["OtYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["OtYearpassing"]: "",
        });
      }
    }
  };

  const handleMonthChange_month = (month, dname) => {
    if (dname === "SSLC_Year") {
      if (
        sslcCerficates[0].SSLC_Year !== null &&
        sslcCerficates[0].SSLC_Year !== "" &&
        sslcCerficates[0].SSLC_Year !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[0].SSLC_Year);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        // console.log(dateEYDa,"dateEYDa");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "sslc") {
                return { ...q, ["SSLC_Year"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["SSLC_Year"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "sslc") {
                return { ...q, ["SSLC_Year"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "sslc") {
              return { ...q, ["SSLC_Year"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["SSLC_Year"]: "",
        });
      }
    } else if (dname === "HSC_Year") {
      if (
        sslcCerficates[1].HSC_Year !== null &&
        sslcCerficates[1].HSC_Year !== "" &&
        sslcCerficates[1].HSC_Year !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[1].HSC_Year);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        // console.log(dateEYDa,"dateEYDa");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "hsc") {
                return { ...q, ["HSC_Year"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["HSC_Year"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "hsc") {
                return { ...q, ["HSC_Year"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "hsc") {
              return { ...q, ["HSC_Year"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["HSC_Year"]: "",
        });
      }
    } else if (dname === "UGYearpassing") {
      if (
        sslcCerficates[2].UGYearpassing !== null &&
        sslcCerficates[2].UGYearpassing !== "" &&
        sslcCerficates[2].UGYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[2].UGYearpassing);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        // console.log(dateEYDa,"dateEYDa");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "UG") {
                return { ...q, ["UGYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["UGYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "UG") {
                return { ...q, ["UGYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "UG") {
              return { ...q, ["UGYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["UGYearpassing"]: "",
        });
      }
    } else if (dname === "PGYearpassing") {
      if (
        sslcCerficates[3].PGYearpassing !== null &&
        sslcCerficates[3].PGYearpassing !== "" &&
        sslcCerficates[3].PGYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[3].PGYearpassing);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        // console.log(dateEYDa,"dateEYDa");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "PG") {
                return { ...q, ["PGYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["PGYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "PG") {
                return { ...q, ["PGYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "PG") {
              return { ...q, ["PGYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["PGYearpassing"]: "",
        });
      }
    } else if (dname === "IPYearpassing") {
      if (
        sslcCerficates[4].IPYearpassing !== null &&
        sslcCerficates[4].IPYearpassing !== "" &&
        sslcCerficates[4].IPYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[4].IPYearpassing);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        // console.log(dateEYDa,"dateEYDa");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Integrated PG") {
                return { ...q, ["IPYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["IPYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Integrated PG") {
                return { ...q, ["IPYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Integrated PG") {
              return { ...q, ["IPYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["IPYearpassing"]: "",
        });
      }
    } else if (dname === "DYearpassing") {
      if (
        sslcCerficates[5].DYearpassing !== null &&
        sslcCerficates[5].DYearpassing !== "" &&
        sslcCerficates[5].DYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[5].DYearpassing);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        // console.log(dateEYDa,"dateEYDa");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Diploma") {
                return { ...q, ["DYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["DYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Diploma") {
                return { ...q, ["DYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Diploma") {
              return { ...q, ["DYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["DYearpassing"]: "",
        });
      }
    } else if (dname === "PCYearpassing") {
      if (
        sslcCerficates[6].PCYearpassing !== null &&
        sslcCerficates[6].PCYearpassing !== "" &&
        sslcCerficates[6].PCYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[6].PCYearpassing);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        // console.log(dateEYDa,"dateEYDa");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Professional Courses") {
                return { ...q, ["PCYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["PCYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Professional Courses") {
                return { ...q, ["PCYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Professional Courses") {
              return { ...q, ["PCYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["PCYearpassing"]: "",
        });
      }
    } else if (dname === "OtYearpassing") {
      if (
        sslcCerficates[7].OtYearpassing !== null &&
        sslcCerficates[7].OtYearpassing !== "" &&
        sslcCerficates[7].OtYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[7].OtYearpassing);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        // console.log(dateEYDa,"dateEYDa");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Others") {
                return { ...q, ["OtYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["OtYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Others") {
                return { ...q, ["OtYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Others") {
              return { ...q, ["OtYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["OtYearpassing"]: "",
        });
      }
    }
  };

  // education cerficate handle change
  const handleEdu = (eduname, event) => {
    const names = event.target.name;
    const value = event.target.value;
    const files = event.target.files;

    if (names === "SSLC_Path" && files && files.length > 0) {
      const SSLC_Path = files[0];
      if (
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg" ||
        files[0].type == "application/pdf"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("SSLC_Path", SSLC_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            SSLC_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            SSLC_Path: err,
          });
        }
      } else {
        let err = "PDF, PNG, JPG, and JPEG files only allowed";
        setListErrors({
          ...listErrors,
          SSLC_Path: err,
        });
      }
    } else if (names === "HSC_Path" && files && files.length > 0) {
      const HSC_Path = files[0];
      if (
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg" ||
        files[0].type == "application/pdf"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("HSC_Path", HSC_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            HSC_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            HSC_Path: err,
          });
        }
      } else {
        let err = "PDF, PNG, JPG, and JPEG files only allowed";
        setListErrors({
          ...listErrors,
          HSC_Path: err,
        });
      }
    } else if (names === "UG_Path" && files && files.length > 0) {
      const UG_Path = files[0];
      if (
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg" ||
        files[0].type == "application/pdf"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("UG_Path", UG_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            UG_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            UG_Path: err,
          });
        }
      } else {
        let err = "PDF, PNG, JPG, and JPEG files only allowed";
        setListErrors({
          ...listErrors,
          UG_Path: err,
        });
      }
    } else if (names === "UG_Path" && files && files.length > 0) {
      const UG_Path = files[0];
      if (
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg" ||
        files[0].type == "application/pdf"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("UG_Path", UG_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            UG_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            UG_Path: err,
          });
        }
      } else {
        let err = "PDF, PNG, JPG, and JPEG files only allowed";
        setListErrors({
          ...listErrors,
          UG_Path: err,
        });
      }
    } else if (names === "PG_Path" && files && files.length > 0) {
      const PG_Path = files[0];
      if (
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg" ||
        files[0].type == "application/pdf"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("PG_Path", PG_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            PG_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            PG_Path: err,
          });
        }
      } else {
        let err = "PDF, PNG, JPG, and JPEG files only allowed";
        setListErrors({
          ...listErrors,
          PG_Path: err,
        });
      }
    } else if (names === "IP_Path" && files && files.length > 0) {
      const IP_Path = files[0];
      if (
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg" ||
        files[0].type == "application/pdf"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("IP_Path", IP_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            IP_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            IP_Path: err,
          });
        }
      } else {
        let err = "PDF, PNG, JPG, and JPEG files only allowed";
        setListErrors({
          ...listErrors,
          IP_Path: err,
        });
      }
    } else if (names === "PC_Path" && files && files.length > 0) {
      const PC_Path = files[0];
      if (
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg" ||
        files[0].type == "application/pdf"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("PC_Path", PC_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            PC_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            PC_Path: err,
          });
        }
      } else {
        let err = "PDF, PNG, JPG, and JPEG files only allowed";
        setListErrors({
          ...listErrors,
          PC_Path: err,
        });
      }
    } else if (names === "D_Path" && files && files.length > 0) {
      const D_Path = files[0];
      if (
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg" ||
        files[0].type == "application/pdf"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("D_Path", D_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            D_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            D_Path: err,
          });
        }
      } else {
        let err = "PDF, PNG, JPG, and JPEG files only allowed";
        setListErrors({
          ...listErrors,
          D_Path: err,
        });
      }
    } else if (names === "Ot_Path" && files && files.length > 0) {
      const Ot_Path = files[0];
      // New changes
      if (
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg" ||
        files[0].type == "application/pdf"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("Ot_Path", Ot_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            Ot_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            Ot_Path: err,
          });
        }
      } else {
        let err = "PDF, PNG, JPG, and JPEG files only allowed";
        setListErrors({
          ...listErrors,
          Ot_Path: err,
        });
      }
    } else if (names === "PG") {
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === eduname) {
            return { ...q, [names]: value };
          }
          return q;
        });
      });
      setListErrors({
        ...listErrors,
        [names]: "",
      });
    } else if (names === "SSLC_Marks") {
      if (Number(value) < 45 || Number(value) == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else if (Number(value) > 100) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45% and less than 100%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (names === "HSC_Marks") {
      if (Number(value) < 45 || Number(value) == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else if (Number(value) > 100) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45% and less than 100%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (names === "PGMarksPercentage") {
      if (Number(value) < 45 || Number(value) == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else if (Number(value) > 100) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45% and less than 100%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (names === "UGMarksPercentage") {
      if (Number(value) < 45 || Number(value) == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else if (Number(value) > 100) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45% and less than 100%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (names === "IPMarksPercentage") {
      if (Number(value) < 45 || Number(value) == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else if (Number(value) > 100) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45% and less than 100%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (names === "DMarksPercentage") {
      if (Number(value) < 45 || Number(value) == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else if (Number(value) > 100) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45% and less than 100%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (names === "PCMarksPercentage") {
      if (Number(value) < 45 || Number(value) == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else if (Number(value) > 100) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45% and less than 100%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (names === "OtMarksPercentage") {
      if (Number(value) < 45 || Number(value) == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else if (Number(value) > 100) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45% and less than 100%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (
      names === "SSLC_Year" ||
      names === "HSC_Year" ||
      names === "UGYearpassing" ||
      names === "PGYearpassing" ||
      names === "IPYearpassing" ||
      names === "DYearpassing" ||
      names === "PCYearpassing" ||
      names === "OtYearpassing"
    ) {
      if (setMaxMonthYear(value, names)) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else {
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === eduname) {
            return { ...q, [names]: value };
          }
          return q;
        });
      });
      setListErrors({
        ...listErrors,
        [names]: "",
      });
    }
  };

  const transformData = (data) => {
    const transformedData = [];

    data.forEach((item) => {
      const groupLabel = item.subcategory_code;
      const option = {
        value: item.id,
        label: item.course_name,
        category_code: item.category_code,
        name: item.name,
        subcategory_code: item.subcategory_code,
      };

      // Check if the group already exists in transformedData
      const groupIndex = transformedData.findIndex(
        (group) => group.label === groupLabel
      );

      if (groupIndex === -1) {
        // Group doesn't exist, create a new group
        transformedData.push({
          label: groupLabel,
          options: [option],
        });
      } else {
        // Group exists, add the option to the existing group
        transformedData[groupIndex].options.push(option);
      }
    });

    return transformedData;
  };

  const handleChangeCheckbox = (e, recordID) => {
    if (e) {
      // setSubjectselect([]);
      setSelectedSub([]);
      setSubjectselect(e);
      setList((prevState) => ({
        ...prevState,
        ["CourseCate"]: e.value,
        ["CouresName"]: e.label,
        ["CourseSubCate"]: e.subcategory_code,
      }));

      setListErrors({
        ...listErrors,
        ["CourseCate"]: "",
      });
    } else {
      // setSubjectselect([]);
      setSelectedSub([]);
      setSubjectselect(e);
      setList((prevState) => ({
        ...prevState,
        ["CourseCate"]: "",
        ["CouresName"]: "",
        ["CourseSubCate"]: "",
      }));

      setListErrors({
        ...listErrors,
        ["CourseCate"]: "Please select course for respective category",
      });
    }
  };
  const handleStepOne = () => {
    setStep(1);
  };

  //handlechange function
  // const handleChange = (event) => {
  //   const { name, value, files, checked } = event.target;

  //   if (name === "DOB") {
  //     DobCovertAge(value);
  //     setList({
  //       ...list,
  //       [name]: value,
  //     });
  //   } else if (name === "PincodePresent") {
  //     if (/^[1-9][0-9]{5}$/.test(value) || value.length === 0) {
  //       setList((prevList) => ({
  //         ...prevList,
  //         [name]: value,
  //         ["CityPresent"]: "",
  //       }));
  //       setListErrors({
  //         ...listErrors,
  //         ["PincodePresent"]: "",
  //       });
  //       // Proceed with other fields or actions if needed
  //     } else {
  //       setList((prevList) => ({
  //         ...prevList,
  //         [name]: value,
  //         ["CityPresent"]: "",
  //       }));
  //       setListErrors({
  //         ...listErrors,
  //         ["PincodePresent"]: "Please Enter valid Pincode",
  //       });
  //       return;
  //     }
  //   } else if (name === "PincodePermanent") {
  //     if (/^[1-9][0-9]{5}$/.test(value) || value.length === 0) {
  //       setList((prevList) => ({
  //         ...prevList,
  //         [name]: value,
  //         ["CityPermanent"]: "",
  //       }));
  //       setListErrors({
  //         ...listErrors,
  //         ["PincodePermanent"]: "",
  //       });
  //       // Proceed with other fields or actions if needed
  //     } else {
  //       setList((prevList) => ({
  //         ...prevList,
  //         [name]: value,
  //         ["CityPermanent"]: "",
  //       }));
  //       setListErrors({
  //         ...listErrors,
  //         ["PincodePermanent"]: "Please Enter valid Pincode",
  //       });
  //       return;
  //     }
  //   } else if (name === "Mobile") {
  //     if (value.length === 10 || value.length === 0) {
  //       setList((prevList) => ({
  //         ...prevList,
  //         [name]: value,
  //       }));
  //       setListErrors({
  //         ...listErrors,
  //         ["Mobile"]: "",
  //       });
  //       // Proceed with other fields or actions if needed
  //     } else {
  //       setList((prevList) => ({
  //         ...prevList,
  //         [name]: value,
  //       }));
  //       setListErrors({
  //         ...listErrors,
  //         ["Mobile"]: "Please Enter valid 10 digit number",
  //       });
  //       return;
  //     }
  //   } else if (name === "WhatsAppNumber") {
  //     if (value.length === 10 || value.length === 0) {
  //       setList((prevList) => ({
  //         ...prevList,
  //         [name]: value,
  //       }));
  //       setListErrors({
  //         ...listErrors,
  //         ["WhatsAppNumber"]: "",
  //       });
  //       // Proceed with other fields or actions if needed
  //     } else {
  //       setList((prevList) => ({
  //         ...prevList,
  //         [name]: value,
  //       }));
  //       setListErrors({
  //         ...listErrors,
  //         ["WhatsAppNumber"]: "Please Enter valid 10 digit number",
  //       });
  //       return;
  //     }
  //   } else if (name === "ParentMobileNo") {
  //     if (value.length === 10 || value.length === 0) {
  //       setList((prevList) => ({
  //         ...prevList,
  //         [name]: value,
  //       }));
  //       setListErrors({
  //         ...listErrors,
  //         ["ParentMobileNo"]: "",
  //       });
  //       // Proceed with other fields or actions if needed
  //     } else {
  //       setList((prevList) => ({
  //         ...prevList,
  //         [name]: value,
  //       }));
  //       setListErrors({
  //         ...listErrors,
  //         ["ParentMobileNo"]: "Please Enter valid 10 digit number",
  //       });
  //       return;
  //     }
  //   } else if (name == "aadharNo") {
  //     if (value.length === 12 || value.length === 0) {
  //       setList((prevList) => ({
  //         ...prevList,
  //         [name]: value,
  //       }));
  //       setListErrors({
  //         ...listErrors,
  //         ["aadharNo"]: "",
  //       });
  //       // Proceed with other fields or actions if needed
  //     } else {
  //       setList((prevList) => ({
  //         ...prevList,
  //         [name]: value,
  //       }));
  //       setListErrors({
  //         ...listErrors,
  //         ["aadharNo"]: "Please Enter valid 12 digit number",
  //       });
  //       return;
  //     }
  //   } else if (name == "ContactNumber") {
  //     if (checked) {
  //       setList((prevList) => ({
  //         ...prevList,
  //         [name]: checked,
  //       }));
  //       setListErrors({
  //         ...listErrors,
  //         ["WhatsAppNumber"]: "",
  //       });
  //     } else {
  //       setList((prevList) => ({
  //         ...prevList,
  //         ["WhatsAppNumber"]: "",
  //         [name]: checked,
  //       }));
  //       setListErrors({
  //         ...listErrors,
  //         ["WhatsAppNumber"]: "",
  //       });
  //     }
  //   } else if (name == "classMode") {
  //     if (checked) {
  //       setList((prevList) => ({
  //         ...prevList,
  //         [name]: value,
  //       }));
  //     }
  //     setListErrors({
  //       ...listErrors,
  //       classMode: "",
  //     });
  //   } else if (name == "BatchType") {
  //     if (checked) {
  //       setList((prevList) => ({
  //         ...prevList,
  //         [name]: value,
  //       }));
  //     }
  //     setListErrors({
  //       ...listErrors,
  //       BatchType: "",
  //     });
  //   } else if (name == "location") {
  //     setList((prevList) => ({
  //       ...prevList,
  //       [name]: value,
  //     }));
  //     setListErrors({
  //       ...listErrors,
  //       location: "",
  //     });
  //     const selectedId = event.target.options[event.target.selectedIndex].id;
  //     setList((prevList) => ({
  //       ...prevList,
  //       location_name: selectedId,
  //     }));
  //   } else if (name == "SamePresentAddress") {
  //     setList((prevList) => ({
  //       ...prevList,
  //       [name]: checked,
  //     }));
  //     setListErrors({
  //       ...listErrors,
  //       ["SamePresentAddress"]: "",
  //       ["BuildingNumberPermanent"]: "",
  //       ["StreetNamePermanent"]: "",
  //       ["AreaPermanent"]: "",
  //       ["LandmarkPermanent"]: "",
  //       ["districtPermanent"]: "",
  //       ["CityPermanent"]: "",
  //       ["statePermanent"]: "",
  //       ["PostPermanent"]: "",
  //       ["TalukPermanent"]: "",
  //       ["PincodePermanent"]: "",
  //     });
  //   } else if (name === "Profilephoto" && files && files.length > 0) {
  //     const profile_path = files[0];
  //     // console.log(profile_path);
  //     if (
  //       files[0].type == "image/png" ||
  //       files[0].type == "image/jpg" ||
  //       files[0].type == "image/jpeg"
  //     ) {
  //       if (files[0].size < 40 * 1024) {
  //         const formData = new FormData();
  //         formData.append("profile_path", profile_path);
  //         AxiosInstance.post("api/upload/", formData)
  //           .then((res) => {
  //             setList({
  //               ...list,
  //               Profilephoto: res.data.path,
  //               original_profile_path: res.data.originalname,
  //             });
  //             setListErrors({
  //               ...listErrors,
  //               Profilephoto: "",
  //             });
  //           })
  //           .catch((error) => {
  //             return error;
  //           });
  //       } else {
  //         let err = "File size must be less than 40KB.";
  //         setListErrors({
  //           ...listErrors,
  //           Profilephoto: err,
  //         });
  //       }
  //     } else {
  //       let err = "(Png , jpg ,jpeg )images only allowed";
  //       setListErrors({
  //         ...listErrors,
  //         Profilephoto: err,
  //       });
  //     }
  //   } else if (name === "aadharCardphoto" && files && files.length > 0) {
  //     const aadhar_path = files[0];
  //     if (
  //       files[0].type == "image/png" ||
  //       files[0].type == "image/jpg" ||
  //       files[0].type == "image/jpeg" ||
  //       files[0].type == "application/pdf"
  //     ) {
  //       if (files[0].size < 2 * 1024 * 1024) {
  //         const formData = new FormData();
  //         formData.append("aadhar_path", aadhar_path);
  //         AxiosInstance.post("api/upload/", formData)
  //           .then((res) => {
  //             setList({
  //               ...list,
  //               aadharCardphoto: res.data.path,
  //               original_aadhar_path: res.data.originalname,
  //             });
  //             setListErrors({
  //               ...listErrors,
  //               aadharCardphoto: "",
  //             });
  //           })
  //           .catch((error) => {
  //             return error;
  //           });
  //       } else {
  //         let err = "File size must be less than 2MB.";
  //         setListErrors({
  //           ...listErrors,
  //           aadharCardphoto: err,
  //         });
  //       }
  //     } else {
  //       let err = "PDF, PNG, JPG, and JPEG files only allowed";
  //       setListErrors({
  //         ...listErrors,
  //         aadharCardphoto: err,
  //       });
  //     }
  //   } else if (name === "CastFile" && files && files.length > 0) {
  //     const community_path = files[0];
  //     if (
  //       files[0].type == "application/pdf" ||
  //       files[0].type == "image/png" ||
  //       files[0].type == "image/jpg" ||
  //       files[0].type == "image/jpeg"
  //     ) {
  //       if (files[0].size < 2 * 1024 * 1024) {
  //         const formData = new FormData();
  //         formData.append("community_path", community_path);
  //         AxiosInstance.post("api/upload/", formData)
  //           .then((res) => {
  //             setList({
  //               ...list,
  //               CastFile: res.data.path,
  //               original_caste_path: res.data.originalname,
  //             });
  //             setListErrors({
  //               ...listErrors,
  //               CastFile: "",
  //             });
  //           })
  //           .catch((error) => {
  //             return error;
  //           });
  //       } else {
  //         let err = "File size must be less than 2MB.";
  //         setListErrors({
  //           ...listErrors,
  //           CastFile: err,
  //         });
  //       }
  //     } else {
  //       let err = "PDF, PNG, JPG, and JPEG files only allowed";
  //       setListErrors({
  //         ...listErrors,
  //         CastFile: err,
  //       });
  //     }
  //   } else if (name === "category") {
  //     setList({
  //       ...list,
  //       [name]: value,
  //     });

  //     setListErrors({
  //       ...listErrors,
  //       category: "",
  //     });
  //   } else if (name === "SPCcategory") {
  //     setList({
  //       ...list,
  //       [name]: value,
  //       ["category"]: value,
  //       ["CourseCate"]: "",
  //       ["CouresName"]: "",
  //       ["CourseSubCate"]: "",
  //     });

  //     setSpecialAdmissionPre((prevState) => {
  //       return prevState.map((q) => {
  //         return { ...q, ["name"]: "" };
  //       });
  //     });
  //     setBatchDetails([]);
  //     setSubjectselect([]);
  //     setSelectedSub([]);
  //     setListErrors({
  //       ...listErrors,
  //       SPCcategory: "",
  //     });
  //   } else if (name === "ExamDetailsRes") {
  //     const selectedOptions = Array.from(
  //       event.target.selectedOptions,
  //       (option) => option.value
  //     );
  //     setList((prevList) => ({ ...prevList, ExamDetailsRes: selectedOptions }));
  //     setListErrors({
  //       ...listErrors,
  //       ExamDetailsRes: "",
  //     });
  //   } else if (name === "IDPhoto" && files && files.length > 0) {
  //     const ID_photo_Path = files[0];
  //     if (
  //       files[0].type == "application/pdf" ||
  //       files[0].type == "image/png" ||
  //       files[0].type == "image/jpg" ||
  //       files[0].type == "image/jpeg"
  //     ) {
  //       if (files[0].size < 2 * 1024 * 1024) {
  //         const formData = new FormData();
  //         formData.append("ID_photo_Path", ID_photo_Path);
  //         AxiosInstance.post("api/upload/", formData)
  //           .then((res) => {
  //             setList({
  //               ...list,
  //               IDPhoto: res.data.path,
  //               original_aiasa_id_path: res.data.originalname,
  //             });
  //             setListErrors({
  //               ...listErrors,
  //               IDPhoto: "",
  //             });
  //           })
  //           .catch((error) => {
  //             return error;
  //           });
  //       } else {
  //         let err = "File size must be less than 2MB.";
  //         setListErrors({
  //           ...listErrors,
  //           IDPhoto: err,
  //         });
  //       }
  //     } else {
  //       let err = "PDF, PNG, JPG, and JPEG files only allowed";
  //       setListErrors({
  //         ...listErrors,
  //         IDPhoto: err,
  //       });
  //     }
  //   } else if (name == "Verify") {
  //     setList((prevList) => ({
  //       ...prevList,
  //       [name]: checked,
  //     }));
  //     setListErrors({
  //       ...listErrors,
  //       [name]: "",
  //     });
  //   } else if (name == "CouponCode") {
  //     setCouponApplied((prevState) => ({
  //       ...prevState,
  //       coupon_code: value,
  //     }));
  //     if (value == "") {
  //       // alert("90");
  //       setCouponApplied({
  //         status: false,
  //         amount: 0,
  //         coupon_code: "",
  //       });
  //     }
  //     // setListErrors({
  //     //   ...listErrors,
  //     //   [name]: "",
  //     // });
  //   } else if (name === "CourseCate") {
  //     setList({
  //       ...list,
  //       [name]: value,
  //     });

  //     setListErrors({
  //       ...listErrors,
  //       [name]: "",
  //     });

  //     const selectedOption = event.target.options[event.target.selectedIndex];
  //     setCouName({
  //       ...couName,
  //       coueName: selectedOption.getAttribute("name"),
  //     });
  //   } else if (name === "ExamWrite") {
  //     setList({
  //       ...list,
  //       [name]: value,
  //     });
  //     setExamDetailsExam([]);
  //     const examdetails_bb = Array.from({ length: value }, (_, index) => ({
  //       id: index,
  //       examvalue: "",
  //       error_name_exam: "", // Add other properties you need in the state
  //     }));
  //     setExamDetailsExam(examdetails_bb);
  //     setListErrors({
  //       ...listErrors,
  //       [name]: "",
  //     });
  //   } else if (name === "ExamPreviously") {
  //     if (value === "NO") {
  //       setList({
  //         ...list,
  //         [name]: value,
  //         ExamWrite: "",
  //       });
  //       setExamDetailsExam([]);
  //       setListErrors({
  //         ...listErrors,
  //         [name]: "",
  //       });
  //     } else {
  //       setList({
  //         ...list,
  //         [name]: value,
  //       });
  //       setExamDetailsExam([]);
  //       setListErrors({
  //         ...listErrors,
  //         [name]: "",
  //       });
  //     }
  //   } else {
  //     setList({
  //       ...list,
  //       [name]: value,
  //     });
  //     setListErrors({
  //       ...listErrors,
  //       [name]: "",
  //     });
  //   }
  // };
  const handleChange = (event) => {
    const { name, value, files, checked } = event.target;
    const letterPattern = /^[a-zA-Z]*$/;
    const numericValue = value.replace(/[^0-9]/g, "");
    if (name === "DOB") {
      DobCovertAge(value);
      setList({
        ...list,
        [name]: value,
      });
    } else if (name === "PincodePresent") {
      if (/^[1-9][0-9]{5}$/.test(value) || value.length === 0) {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
          ["CityPresent"]: "",
        }));
        setListErrors({
          ...listErrors,
          ["PincodePresent"]: "",
        });
      } else {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
          ["CityPresent"]: "",
        }));
        setListErrors({
          ...listErrors,
          ["PincodePresent"]: "Please Enter valid Pincode",
        });
        return;
      }
    } else if (name === "PincodePermanent") {
      if (/^[1-9][0-9]{5}$/.test(value) || value.length === 0) {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
          ["CityPermanent"]: "",
        }));
        setListErrors({
          ...listErrors,
          ["PincodePermanent"]: "",
        });
      } else {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
          ["CityPermanent"]: "",
        }));
        setListErrors({
          ...listErrors,
          ["PincodePermanent"]: "Please Enter valid Pincode",
        });
        return;
      }
    } else if (name === "Mobile") {
      if (value.length === 10 || value.length === 0) {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
          [name]: numericValue,
        }));
        setListErrors({
          ...listErrors,
          ["Mobile"]: "",
        });
      } else {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
          [name]: numericValue,
        }));
        setListErrors({
          ...listErrors,
          ["Mobile"]: "Please Enter valid 10 digit number",
        });
        return;
      }
    } else if (
      name === "FirstName" ||
      name === "LastName" ||
      name === "Fathername" ||
      name === "MotherName"
    ) {
      // if (!letterPattern.test(value)) {
      //   setListErrors({
      //     ...listErrors,
      //     [name]: "Only letters are allowed",
      //   });
      // } else {
      //   setListErrors({
      //     ...listErrors,
      //     [name]: "",
      //   });
      // }
      setList((prevFields) => ({
        ...prevFields,
        [name]: value,
      }));
    } else if (name === "WhatsAppNumber") {
      if (value.length === 10 || value.length === 0) {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
          [name]: numericValue,
        }));
        setListErrors({
          ...listErrors,
          ["WhatsAppNumber"]: "",
        });
      } else {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
          [name]: numericValue,
        }));
        setListErrors({
          ...listErrors,
          ["WhatsAppNumber"]: "Please Enter valid 10 digit number",
        });
        return;
      }
    } else if (name === "ParentMobileNo") {
      if (value.length === 10 || value.length === 0) {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
          [name]: numericValue,
        }));
        setListErrors({
          ...listErrors,
          ["ParentMobileNo"]: "",
        });
      } else {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
          [name]: numericValue,
        }));
        setListErrors({
          ...listErrors,
          ["ParentMobileNo"]: "Please Enter valid 10 digit number",
        });
        return;
      }
    } else if (name == "aadharNo") {
      if (value.length === 12 || value.length === 0) {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
          [name]: numericValue,
        }));
        setListErrors({
          ...listErrors,
          ["aadharNo"]: "",
        });
      } else {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
          [name]: numericValue,
        }));
        setListErrors({
          ...listErrors,
          ["aadharNo"]: "Please Enter valid 12 digit number",
        });
        return;
      }
    } else if (name == "ContactNumber") {
      if (checked) {
        setList((prevList) => ({
          ...prevList,
          [name]: checked,
        }));
        setListErrors({
          ...listErrors,
          ["WhatsAppNumber"]: "",
        });
      } else {
        setList((prevList) => ({
          ...prevList,
          ["WhatsAppNumber"]: "",
          [name]: checked,
        }));
        setListErrors({
          ...listErrors,
          ["WhatsAppNumber"]: "",
        });
      }
    } else if (name == "classMode") {
      if (checked) {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
        }));
      }
      setListErrors({
        ...listErrors,
        classMode: "",
      });
    } else if (name == "BatchType") {
      if (checked) {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
        }));
      }
      setListErrors({
        ...listErrors,
        BatchType: "",
      });
    } else if (name == "location") {
      setList((prevList) => ({
        ...prevList,
        [name]: value,
      }));
      setListErrors({
        ...listErrors,
        location: "",
      });
      const selectedId = event.target.options[event.target.selectedIndex].id;
      setList((prevList) => ({
        ...prevList,
        location_name: selectedId,
      }));
    } else if (name == "SamePresentAddress") {
      if (checked) {
        setList((prevList) => ({
          ...prevList,
          [name]: checked,
        }));
        setListErrors({
          ...listErrors,
          ["SamePresentAddress"]: "",
          ["BuildingNumberPermanent"]: "",
          ["StreetNamePermanent"]: "",
          ["AreaPermanent"]: "",
          ["LandmarkPermanent"]: "",
          ["districtPermanent"]: "",
          ["CityPermanent"]: "",
          ["statePermanent"]: "",
          ["PostPermanent"]: "",
          ["TalukPermanent"]: "",
          ["PincodePermanent"]: "",
        });
      } else {
        setList((prevList) => ({
          ...prevList,
          [name]: checked,
          ["BuildingNumberPermanent"]: "",
          ["StreetNamePermanent"]: "",
          ["AreaPermanent"]: "",
          ["LandmarkPermanent"]: "",
          ["districtPermanent"]: "",
          ["CityPermanent"]: "",
          ["statePermanent"]: "",
          ["PostPermanent"]: "",
          ["TalukPermanent"]: "",
          ["PincodePermanent"]: "",
        }));
      }
    } else if (name === "Profilephoto" && files && files.length > 0) {
      const profile_path = files[0];
      if (
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg"
      ) {
        if (files[0].size < 40 * 1024) {
          const formData = new FormData();
          formData.append("profile_path", profile_path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setList({
                ...list,
                Profilephoto: res.data.path,
                original_profile_path: res.data.originalname,
              });
              setListErrors({
                ...listErrors,
                Profilephoto: "",
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          let err = "File size must be less than 40KB.";
          setListErrors({
            ...listErrors,
            Profilephoto: err,
          });
        }
      } else {
        let err = "(Png , jpg ,jpeg )images only allowed";
        setListErrors({
          ...listErrors,
          Profilephoto: err,
        });
      }
    } else if (name === "aadharCardphoto" && files && files.length > 0) {
      const aadhar_path = files[0];
      if (
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg" ||
        files[0].type == "application/pdf"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("aadhar_path", aadhar_path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setList({
                ...list,
                aadharCardphoto: res.data.path,
                original_aadhar_path: res.data.originalname,
              });
              setListErrors({
                ...listErrors,
                aadharCardphoto: "",
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            aadharCardphoto: err,
          });
        }
      } else {
        let err = "PDF, PNG, JPG, and JPEG files only allowed";
        setListErrors({
          ...listErrors,
          aadharCardphoto: err,
        });
      }
    } else if (name === "CastFile" && files && files.length > 0) {
      const community_path = files[0];
      if (
        files[0].type == "application/pdf" ||
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("community_path", community_path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setList({
                ...list,
                CastFile: res.data.path,
                original_caste_path: res.data.originalname,
              });
              setListErrors({
                ...listErrors,
                CastFile: "",
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            CastFile: err,
          });
        }
      } else {
        let err = "PDF, PNG, JPG, and JPEG files only allowed";
        setListErrors({
          ...listErrors,
          CastFile: err,
        });
      }
    } else if (name === "category") {
      setList({
        ...list,
        [name]: value,
      });

      setListErrors({
        ...listErrors,
        category: "",
      });
    } else if (name === "SPCcategory") {
      setList({
        ...list,
        [name]: value,
        ["category"]: value,
        ["CourseCate"]: "",
        ["CouresName"]: "",
        ["CourseSubCate"]: "",
      });

      setSpecialAdmissionPre((prevState) => {
        return prevState.map((q) => {
          return { ...q, ["name"]: "" };
        });
      });
      setBatchDetails([]);
      setSubjectselect([]);
      setSelectedSub([]);
      setListErrors({
        ...listErrors,
        SPCcategory: "",
      });
    } else if (name === "ExamDetailsRes") {
      const selectedOptions = Array.from(
        event.target.selectedOptions,
        (option) => option.value
      );
      setList((prevList) => ({ ...prevList, ExamDetailsRes: selectedOptions }));
      setListErrors({
        ...listErrors,
        ExamDetailsRes: "",
      });
    } else if (name === "IDPhoto" && files && files.length > 0) {
      const ID_photo_Path = files[0];
      if (
        files[0].type == "application/pdf" ||
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("ID_photo_Path", ID_photo_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setList({
                ...list,
                IDPhoto: res.data.path,
                original_aiasa_id_path: res.data.originalname,
              });
              setListErrors({
                ...listErrors,
                IDPhoto: "",
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            IDPhoto: err,
          });
        }
      } else {
        let err = "PDF, PNG, JPG, and JPEG files only allowed";
        setListErrors({
          ...listErrors,
          IDPhoto: err,
        });
      }
    } else if (name == "Verify") {
      setList((prevList) => ({
        ...prevList,
        [name]: checked,
      }));
      setListErrors({
        ...listErrors,
        [name]: "",
      });
    } else if (name == "CouponCode") {
      if (value == "") {
        setCouponApplied({
          status: false,
          amount: 0,
          coupon_code: "",
        });
        setMessage("");
      } else {
        setCouponApplied((prevState) => ({
          ...prevState,
          coupon_code: value,
        }));
        setListErrors({
          ...listErrors,
          ["coupon_code"]: "",
        });
        setMessage("");
      }
    } else if (name === "CourseCate") {
      setList({
        ...list,
        [name]: value,
      });

      setListErrors({
        ...listErrors,
        [name]: "",
      });

      const selectedOption = event.target.options[event.target.selectedIndex];
      setCouName({
        ...couName,
        coueName: selectedOption.getAttribute("name"),
      });
    } else if (name === "ExamWrite") {
      setList({
        ...list,
        [name]: value,
      });
      setExamDetailsExam([]);
      const examdetails_bb = Array.from({ length: value }, (_, index) => ({
        id: index,
        examvalue: "",
        error_name_exam: "",
      }));
      setExamDetailsExam(examdetails_bb);
      setListErrors({
        ...listErrors,
        [name]: "",
      });
    } else if (name === "ExamPreviously") {
      if (value === "NO") {
        setList({
          ...list,
          [name]: value,
          ExamWrite: "",
        });
        setExamDetailsExam([]);
        setListErrors({
          ...listErrors,
          [name]: "",
        });
      } else {
        setList({
          ...list,
          [name]: value,
        });
        setExamDetailsExam([]);
        setListErrors({
          ...listErrors,
          [name]: "",
        });
      }
    } else {
      setList({
        ...list,
        [name]: value,
      });
      setListErrors({
        ...listErrors,
        [name]: "",
      });
    }
  };

  //handle Coupon code
  const handleCouponCode = (e, dAmount, id) => {
    let code = couponApplied.coupon_code;
    let BatchAmount = dAmount;

    AxiosInstance.post(`api/all/getCoupon`, {
      user_id: userid,
      coupon_code: code,
    })
      .then((res) => {
        const message = res.data.message;
        const couponStatus = res.data.status;
        setCoupon_status(couponStatus);
        setMessage(message);
        if (res.data[0].status === true || res.data.status === true) {
          if (res.data[0].data.dis_amt >= BatchAmount) {
            setListErrors({
              ...listErrors,
              ["coupon_code"]:
                "The coupon code exceeds the net amount and cannot be applied",
            });
            setCouponApplied((prevState) => ({
              ...prevState,
              coupon_code: "",
              status: false,
            }));
          } else {
            setListErrors({});
            setCouponApplied({
              status: true,
              amount: res.data[0].data.dis_amt,
              coupon_code: res.data[0].data.id,
            });
            setMessage("Coupon code applied successfully");
          }
        } else {
          setCouponApplied((prevState) => ({
            ...prevState,
            coupon_code: "",
            amount: 0,
            status: false,
          }));
          setMessage("Invalid coupon code. Please try again.");
          Swal.fire({
            title: "Warning",
            text: "coupon code is not avaliable ",
            icon: "Warning",
            confirmButtonText: "Ok",
          });
        }
      })
      .catch((error) => {
        return error;
      });
  };
  //dropdown api call
  useEffect(() => {
    // get response from api to fill dropdowns

    AxiosInstance.get("api/codevalues?codetype=EDQ")
      .then((res) => {
        const educationOptions = res.data.map((item) => (
          <option key={item.name} value={item.name}>
            {item.name}
          </option>
        ));
        setEducationOptions(educationOptions);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/codevalues?codetype=CLASS_EDQ")
      .then((res) => {
        const classOptions = res.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        setClassOption(classOptions);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/codevalues?codetype=THQ")
      .then((res) => {
        const technicalOption = res.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        // Sort the options alphabetically, ignoring "Nil"
        const sortedOptions = technicalOption
          .filter((item) => item.value !== "Nil")
          .sort((a, b) => a.value.localeCompare(b.value));
        const NilOption = technicalOption
          .filter((item) => item.value === "Nil")
          .sort((a, b) => a.value.localeCompare(b.value));
        // Set the sorted list to the state
        sortedOptions.push(...NilOption);
        setTechnicalOption(sortedOptions);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/codevalues?codetype=CTGY")
      .then((res) => {
        const categoryOption = res.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));

        // Sort the options alphabetically, ignoring "Nil"
        const sortedOptions = categoryOption
          .filter((item) => item.value !== "Nil")
          .sort((a, b) => a.value.localeCompare(b.value));
        const NilOption = categoryOption
          .filter((item) => item.value === "Nil")
          .sort((a, b) => a.value.localeCompare(b.value));
        // Set the sorted list to the state
        sortedOptions.push(...NilOption);
        setCategoryOption(sortedOptions);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/codevalues?codetype=CURS")
      .then((res) => {
        const cOption = res.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        setCOption(cOption);
        setCatOption(res.data);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/codevalues?codetype=MDP")
      .then((res) => {
        const teachMedium = res.data.map((item) => (
          <option key={item.name} value={item.name}>
            {item.name}
          </option>
        ));
        setTeachMedium(teachMedium);
      })
      .catch((error) => {
        return error;
      });
    // AxiosInstance.get("api/all/district/31")
    //   .then((res) => {
    //     const district = res.data.map((item) => (
    //       <option key={item.name} value={item.name}>
    //         {item.name}
    //       </option>
    //     ));
    //     setDistrict(district);
    //   })
    //   .catch((error) => {
    //     return error;
    //   });
  }, []);
  useEffect(() => {
    if (list.SPCcategory !== "") {
      let ValueAsp = "";
      if (list.SPCcategory === "UPSC") {
        ValueAsp = "UPSC_ASP";
      } else if (list.SPCcategory === "TNPSC") {
        ValueAsp = "TNPSC_ASP";
      } else if (list.SPCcategory === "TRB") {
        ValueAsp = "TRB_ASP";
      } else if (list.SPCcategory === "TET") {
        ValueAsp = "TET_ASP";
      } else if (list.SPCcategory === "TNUSRB") {
        ValueAsp = "TNUSRB_ASP";
      } else if (list.SPCcategory === "SSC") {
        ValueAsp = "SSC_ASP";
      } else if (list.SPCcategory === "Banking") {
        ValueAsp = "Banking_ASP";
      } else if (list.SPCcategory === "Others") {
        ValueAsp = "OTHERS_ASP";
      } else if (list.SPCcategory === "RRB") {
        ValueAsp = "RRB_ASP";
      }

      AxiosInstance.get(`api/codevalues?codetype=${ValueAsp}`)
        .then((res) => {
          const specialPrefrence = res.data.map((item, index) => ({
            value: item.name,
            label: item.name,
          }));
          // Sort the options alphabetically, ignoring "Nil"
          const sortedOptions = specialPrefrence
            .filter((item) => item.value !== "Nil")
            .sort((a, b) => a.value.localeCompare(b.value));
          const NilOption = specialPrefrence
            .filter((item) => item.value === "Nil")
            .sort((a, b) => a.value.localeCompare(b.value));
          // Set the sorted list to the state
          sortedOptions.push(...NilOption);
          setSpecialPrefrence(sortedOptions);
        })
        .catch((error) => {
          return error;
        });
      // setList({
      //   ...list,
      //   ['category']: list.SPCcategory,
      // });
    }
  }, [list.SPCcategory]);

  const handleExamPrev = (e, index) => {
    const { name, value } = e.target;
    // console.log(selectedPrev, name);
    // const objectIndex = selectedPrev.findIndex(obj => obj.examname === name);
    // // Create a copy of the selectedPrev state
    // const updatedSelectedPrev = [...selectedPrev];
    // if (objectIndex !== -1) {
    //   // If an object with the same 'examname' exists, update it
    //   updatedSelectedPrev[objectIndex] = { examname: name, examvalue: value };
    // } else {
    //   // If no matching object exists, add a new object to the array
    //   updatedSelectedPrev.push({ examname: name, examvalue: value });
    // }
    // // Set the updated state
    // setSelectedPrev(updatedSelectedPrev);
    // setListErrors({
    //   ...listErrors,
    //   ExamDetailsRes_0: "",
    // });
    setExamDetailsExam((prevDetails) => {
      const updatedDetails = [...prevDetails];
      updatedDetails[index] = { examvalue: value, error_name_exam: "" }; // Update other properties if needed
      return updatedDetails;
    });
  };

  // const handleSubject = (selected) => {

  //   // console.log(selected,"selected");

  //   const selectedSub = selected.map((option) => ({
  //     label: option.label,
  //     value: option.value,
  //     pk:option.pk,
  //   }));
  //   setSelectedSub(selectedSub);

  //   setListErrors({
  //     ...listErrors,
  //     Subject: "",
  //   });

  // }

  const handleSubject = (selected) => {
    const validationTnpsc = [281, "281"];
    const selectedSub = selected.map((option) => ({
      label: option.label,
      value: option.value,
      pk: option.pk,
    }));
    if (!validationTnpsc.includes(list.CourseCate)) {
      if (selectedSub.length <= 1) {
        setStepperButton(false);
        setSelectedSub(selectedSub);
        setListErrors({
          ...listErrors,
          Subject: "",
        });
      } else {
        setListErrors({
          ...listErrors,
          Subject: "Only One subject allowed to select",
        });
      }
    } else {
      if (selectedSub.length <= 2) {
        setSelectedSub(selectedSub);
        setListErrors({
          ...listErrors,
          Subject: "",
        });
      } else {
        setListErrors({
          ...listErrors,
          Subject: "Only Two subject allowed to selected",
        });
      }
    }
  };

  const handleStepPrevious = (count) => {
    setCouponApplied({
      status: false,
      amount: 0,
      coupon_code: "",
    });
    setListErrors((prevErrors) => ({
      ...prevErrors,
      coupon_code: "",
    }));
    setMessage("");
    if (step == 6) {
      Info_View(userid);
      setStep(1);
    } else {
      setStep(count);
    }
  };
  //step handle prev button click
  const handlePrevious = () => {
    setStep(step - 1);
  };

  const AdmissionRef_validation = {
    firstName: txtAdFname,
    lastName: txtAdLname,
    age: txtAdAge,
    mdob: txtAdMDob,
    mStatus: txtAdMStatus,
    gender: txtAdGender,
    father: txtAdFath,
    mother: txtAdMoth,
    pSize: txtAdPSize,
    ano: txtAdAno,
    apath: txtAdApath,
    cno: txtAdCno,
    cpath: txtAdCpath,
    pno: txtAdPno,
    wno: txtAdWno,
    fpo: txtAdFpo,
    email: txtAdEmail,
    SPCcategory: txtAdSpc,
    phno: txtAdPhno,
    psname: txtAdPsname,
    parea: txtAdParea,
    pland: txtAdPland,
    ppost: txtAdPpost,
    ptaluk: txtAdPtaluk,
    ppincode: txtAdPpincode,
    pcity: txtAdPcity,
    pstate: txtAdPstate,
    pdistrict: txtAdPdistrict,
    perhno: txtAdPerhno,
    persname: txtAdPersname,
    perarea: txtAdPerarea,
    perland: txtAdPerland,
    pererpost: txtAdPererpost,
    pertaluk: txtAdPertaluk,
    perpincode: txtAdPerpincode,
    percity: txtAdPercity,
    perstate: txtAdPerstate,
    perdistrict: txtAdPerdistrict,
    education: txtAdEduc,
    eduSCer: txtAdSslc,
    eduSpass: txtAdSpass,
    eduSmarks: txtAdSmarks,
    eduSboard: txtAdSboard,
    eduSschool: txtAdSschool,
    eduSins: txtAdSins,
    eduSfile: txtAdSfile,
    eduHCer: txtAdHslc,
    eduHpass: txtAdHpass,
    eduHmarks: txtAdHmarks,
    eduHboard: txtAdHboard,
    eduHschool: txtAdHschool,
    eduHins: txtAdHins,
    eduHfile: txtAdHfile,
    eduUCer: txtAdUCer,
    eduUpass: txtAdUpass,
    eduUmarks: txtAdUmarks,
    eduUdeg: txtAdUdeg,
    eduUMaj: txtAdUMaj,
    eduUMajOther: txtAdUMajOther,
    eduPMajOther: txtAdPMajOther,
    eduIMajOther: txtAdIMajOther,
    eduDMajOther: txtAdDMajOther,
    eduCMajOther: txtAdCMajOther,
    eduUclass: txtAdUclass,
    eduUins: txtAdUins,
    eduUfile: txtAdUfile,
    eduPCer: txtAdPCer,
    eduPpass: txtAdPpass,
    eduPmarks: txtAdPmarks,
    eduPdeg: txtAdPdeg,
    eduPMaj: txtAdPMaj,
    eduPclass: txtAdPclass,
    eduPins: txtAdPins,
    eduPfile: txtAdPfile,
    eduICer: txtAdICer,
    eduIpass: txtAdIpass,
    eduImarks: txtAdImarks,
    eduIdeg: txtAdIdeg,
    eduIMaj: txtAdIMaj,
    eduIclass: txtAdIclass,
    eduIins: txtAdIins,
    eduIfile: txtAdIfile,
    eduDCer: txtAdDCer,
    eduDpass: txtAdDpass,
    eduDmarks: txtAdDmarks,
    eduDdeg: txtAdDdeg,
    eduDMaj: txtAdDMaj,
    eduDclass: txtAdDclass,
    eduDins: txtAdDins,
    eduDfile: txtAdDfile,
    eduCCer: txtAdCCer,
    eduCpass: txtAdCpass,
    eduCmarks: txtAdCmarks,
    eduCdeg: txtAdCdeg,
    eduCMaj: txtAdCMaj,
    eduCclass: txtAdCclass,
    eduCins: txtAdCins,
    eduCfile: txtAdCfile,
    eduOCer: txtAdOCer,
    eduOpass: txtAdOpass,
    eduOmarks: txtAdOmarks,
    eduOdeg: txtAdOdeg,
    eduOMaj: txtAdOMaj,
    eduOclass: txtAdOclass,
    eduOins: txtAdOins,
    eduOfile: txtAdOfile,
    category: txtAdCate,
    course: txtAdCourse,
    medium: txtAdMedium,
    classMode: txtAdcMode,
    BatchType: txtAdBtype,
    location: txtAdLoca,
    batchDetails: txtbatchDet,
    examname: txtAdExam,
    institute: txtAdinsu,
    examdetail: txtAdEdetail,
    examclear: txtAdEclear,
    designation: txtAdDesg,
    department: txtAdDep,
    departJoin: txtAdDjoin,
    aiasayear: txtAdayear,
    aiasacate: txtAdacate,
    aiasacourse: txtAdacourse,
    aiasaIdnum: txtAdaIdnum,
    aiasafile: txtAdafile,
  };
  //step handle next button click
  const handleNext = () => {
    // alert("jio");
    setMessage("");
    const userJSON = sessionStorage.getItem("userDetails");
    if (userJSON) {
      const user = JSON.parse(userJSON);
      if (user && user.user_id) {
        const userid = user.user_id;
        const errors = validateFields(
          list,
          sslcCerficates,
          educationQualification,
          step,
          batchDetails,
          AdmissionRef_validation,
          selectedPrev,
          specialAdmissionPre,
          setSpecialAdmissionPre,
          techQualification,
          setTechQualification
        );
        // console.log(errors);
        if (
          Object.keys(errors).length === 0 &&
          specialAdmissionPre.length > 0 &&
          specialAdmissionPre.every(
            (el) =>
              el.name !== "" &&
              (el.name !== "Tamil Medium (PSTM)" || el.pstm_type.length > 0)
          )
        ) {
          if (step === 1) {
            setStepperButton(true);
            let SP = specialAdmissionPre.map((item) => {
              return {
                id: item.id,
                name: item.name,
                category: list.SPCcategory,
                file:
                  item.file !== null && item.file !== "null" ? item.file : "",
                path_sslc:
                  item.path_sslc !== null && item.path_sslc !== "null"
                    ? item.path_sslc
                    : "",
                path_hsc:
                  item.path_hsc !== null && item.path_hsc !== "null"
                    ? item.path_hsc
                    : "",
                path_ug:
                  item.path_ug !== null && item.path_ug !== "null"
                    ? item.path_ug
                    : "",
                path_pg:
                  item.path_pg !== null && item.path_pg !== "null"
                    ? item.path_pg
                    : "",
                original_pref_path:
                  item.original_pref_path !== null &&
                    item.original_pref_path !== "null"
                    ? item.original_pref_path
                    : "",
                original_path_sslc:
                  item.original_path_sslc !== null &&
                    item.original_path_sslc !== "null"
                    ? item.original_path_sslc
                    : "",
                original_path_hsc:
                  item.original_path_hsc !== null &&
                    item.original_path_hsc !== "null"
                    ? item.original_path_hsc
                    : "",
                original_path_ug:
                  item.original_path_ug !== null &&
                    item.original_path_ug !== "null"
                    ? item.original_path_ug
                    : "",
                original_path_pg:
                  item.original_path_pg !== null &&
                    item.original_path_pg !== "null"
                    ? item.original_path_pg
                    : "",
                pstm_type: item.pstm_type,
                admission_id: admissionID.adId ? admissionID.adId : 0,
              };
            });

            const SteponeData = {
              user_id: userid,
              step: 1,
              id: admissionID.adId ? admissionID.adId : 0,
              type: 1,
              first_name: list.FirstName,
              last_name: list.LastName,
              father_name: list.Fathername,
              mother_name: list.MotherName,
              dob: list.DOB,
              age: list.age,
              gender: list.gender,
              marital_status: list.MaritalStatus,
              profile_path: list.Profilephoto,
              aadhar_no: list.aadharNo,
              original_aadhar_path: list.original_aadhar_path,
              original_profile_path: list.original_profile_path,
              original_caste_path: list.original_caste_path,
              aadhar_path: list.aadharCardphoto,
              community_name: list.Cast,
              community_path: list.CastFile,
              scp: SP,
            };
            setIsLoading(true);
            // console.log(SteponeData);
            AxiosInstance.post("api/course/admission/register", SteponeData)
              .then((res) => {
                if (res.data.status === true) {
                  setIsLoading(false);
                  setStep(step + 1);
                  sessionStorage.removeItem("stateRefreshs_test");

                  setScp_stt(true);
                  setStepperButton(false);
                } else {
                  Swal.fire({
                    title: "Warning",
                    text: res.data.message,
                    icon: "Warning",
                    confirmButtonText: "Ok",
                  });
                  setScp_stt(false);
                  setStepperButton(false);
                  setIsLoading(false);
                }
              })
              .catch((error) => {
                setStepperButton(false);
                return error;
              });
          } else if (step === 2) {
            setStepperButton(true);
            const address = [
              {
                address1: list.BuildingNumberPresent,
                address2: list.StreetNamePresent,
                address3: list.AreaPresent,
                landmark: list.LandmarkPresent,
                post_name: list.PostPresent,
                taluk: list.TalukPresent,
                postal_code: list.PincodePresent ? list.PincodePresent : 0,
                city: list.CityPresent,
                district_name: list.districtPresent,
                state_name: list.statePresent,
                same_address: list.SamePresentAddress == true ? "0" : "1",
                address_type: "1",
              },
              {
                address1:
                  list.SamePresentAddress == true
                    ? list.BuildingNumberPresent
                    : list.BuildingNumberPermanent,
                address2:
                  list.SamePresentAddress == true
                    ? list.StreetNamePresent
                    : list.StreetNamePermanent,
                address3:
                  list.SamePresentAddress == true
                    ? list.AreaPresent
                    : list.AreaPermanent,
                landmark:
                  list.SamePresentAddress == true
                    ? list.LandmarkPresent
                    : list.LandmarkPermanent,
                post_name:
                  list.SamePresentAddress == true
                    ? list.PostPresent
                    : list.PostPermanent,
                taluk:
                  list.SamePresentAddress == true
                    ? list.TalukPresent
                    : list.TalukPermanent,
                postal_code:
                  list.SamePresentAddress == true
                    ? list.PincodePresent
                      ? list.PincodePresent
                      : 0
                    : list.PincodePermanent
                      ? list.PincodePermanent
                      : 0,
                city:
                  list.SamePresentAddress == true
                    ? list.CityPresent
                    : list.CityPermanent,
                district_name:
                  list.SamePresentAddress == true
                    ? list.districtPresent
                    : list.districtPermanent,
                state_name:
                  list.SamePresentAddress == true
                    ? list.statePresent
                    : list.statePermanent,
                same_address: list.SamePresentAddress == true ? "0" : "1",
                address_type: "2",
              },
            ];

            const StepTwoData = {
              user_id: userid,
              step: 2,
              phone_no: list.Mobile,
              country_code: list.MobileCode,
              whatsapp_no:
                list.ContactNumber === true ? list.Mobile : list.WhatsAppNumber,
              contact_type: list.ContactNumber === true ? "1" : "0",
              parent_mob_no: list.ParentMobileNo,
              email: list.emailaddress,
              address: address,
            };
            setIsLoading(true);
            // console.log(StepTwoData);
            AxiosInstance.post("api/course/admission/register", StepTwoData)
              .then((res) => {
                if (res.data.status === true) {
                  setIsLoading(false);
                  setStep(step + 1);
                  sessionStorage.removeItem("stateRefreshs_test");
                  setStepperButton(false);
                } else {
                  Swal.fire({
                    title: "Warning",
                    text: res.data.message,
                    icon: "Warning",
                    confirmButtonText: "Ok",
                  });
                  setStepperButton(false);
                  setIsLoading(false);
                }
              })
              .catch((error) => {
                setStepperButton(false);
                return error;
              });
          } else if (step === 3) {
            setStepperButton(true);
            const errors_thq = validateThq(
              techQualification,
              setTechQualification
            );
            if (
              errors_thq.length > 0 &&
              errors_thq.every(
                (el) =>
                  el.error_name === "" &&
                  el.error_certificate_no === "" &&
                  el.error_year_of_passing === "" &&
                  el.error_level === "" &&
                  el.error_grade === ""
              )
            ) {
              const filteredDetails = sslcCerficates.filter((detail) => {
                let cert = "";
                if (detail.name === "sslc") {
                  cert = detail.name.toUpperCase();
                } else if (detail.name === "hsc") {
                  cert = detail.name.toUpperCase();
                } else {
                  cert = detail.name;
                }
                if (detail.name === "UG") {
                  detail.UGMajor =
                    uGisOther === true ? detail.UGMajor_Other : detail.UGMajor;
                  detail.type_of_degree = uGisOther === true ? 1 : 0;
                } else if (detail.name === "PG") {
                  detail.PGMajor =
                    pGisOther === true ? detail.PGMajor_Other : detail.PGMajor;
                  detail.type_of_degree = pGisOther === true ? 1 : 0;
                } else if (detail.name === "Integrated PG") {
                  detail.IPMajor =
                    iPGisOther === true ? detail.IPMajor_Other : detail.IPMajor;
                  detail.type_of_degree = iPGisOther === true ? 1 : 0;
                } else if (detail.name === "Diploma") {
                  detail.DMajor =
                    dipisOther === true ? detail.DMajor_Other : detail.DMajor;
                  detail.type_of_degree = dipisOther === true ? 1 : 0;
                } else if (detail.name === "Professional Courses") {
                  detail.PCMajor =
                    pCisOther === true ? detail.PCMajor_Other : detail.PCMajor;
                  detail.type_of_degree = pCisOther === true ? 1 : 0;
                } else if (detail.name === "Others") {
                  detail.type_of_degree = 1;
                }
                return educationQualification.includes(cert);
              });

              const TQ = techQualification.map((item) => ({
                id: item.id,
                name: item.name,
                level:
                  item.name !== "Knowledge in computer"
                    ? item.level
                    : item.level,
                lang: item.lang,
                Cnum: item.Cnum,
                kdg_in_com:
                  item.name === "Knowledge in computer" ? item.level : "",
                grade: item.grade,
                year: item.year,
                file: item.file,
                original_file_path:
                  item.original_file_path !== null &&
                    item.original_file_path !== "null"
                    ? item.original_file_path
                    : null,
                type_of_degree: 0,
              }));
              const StepThreeData = {
                user_id: userid,
                step: 3,
                edu_details: filteredDetails,
                tech_qualification: TQ,
              };
              setIsLoading(true);
              // console.log(StepThreeData);
              AxiosInstance.post("api/course/admission/register", StepThreeData)
                .then((res) => {
                  if (res.data.status === true) {
                    setIsLoading(false);
                    setStep(step + 1);
                    sessionStorage.removeItem("stateRefreshs_test");
                    setStepperButton(false);
                  } else {
                    Swal.fire({
                      title: "Warning",
                      text: res.data.message,
                      icon: "Warning",
                      confirmButtonText: "Ok",
                    });
                    setStepperButton(false);
                    setIsLoading(false);
                  }
                })
                .catch((error) => {
                  setStepperButton(false);
                  return error;
                });
            }
          } else if (step === 4) {
            setStepperButton(true);
            const BatchDetails = batchDetails.filter((itm) => {
              return itm.is_selected === true;
            });
            const subjectarray = selectedSub.map((item) => item.value);
            const subjectPkarray = selectedSub.map((item) => item.pk);
            const ExamDetailsArray = examDetailsExam.map(
              (item) => item.examvalue
            );
            // const validsCourseCategories = [5, 6, 7, "5", "6", "7"];
            const validsCourseCategoriesTn = [
              279,
              280,
              281,
              313,
              312,
              "279",
              "280",
              "281",
              "313",
              "312",
            ];
            if (
              list.category === "TNPSC" &&
              validsCourseCategoriesTn.includes(list.CourseCate)
            ) {
              if (selectedSub.length === 0) {
                let err = "Please select subject ";
                txtAdSub.current.focus();
                setListErrors({
                  ...listErrors,
                  Subject: err,
                });
              } else {
                setListErrors({
                  ...listErrors,
                  Subject: "",
                });
                const errors_ExamDetails = validateExamDetails(
                  examDetailsExam,
                  setExamDetailsExam
                );
                if (
                  (step === 4 &&
                    list.ExamPreviously === "Yes" &&
                    errors_ExamDetails.length > 0 &&
                    errors_ExamDetails.every(
                      (el) => el.examvalue !== "" && el.error_name_exam === ""
                    )) ||
                  list.ExamPreviously === "NO"
                ) {
                  const StepFourData = {
                    user_id: userid,
                    step: 4,
                    type: 1,
                    id: admissionID.adId ? admissionID.adId : 0,
                    Category: list.category,
                    Courses: list.CourseCate,
                    MediumExam: list.TeachMedium,
                    subject: subjectarray.length > 0 ? subjectarray : [],
                    subject_pk: subjectPkarray.length > 0 ? subjectPkarray : [],
                    location:
                      list.location !== "" ? parseInt(list.location) : 2,
                    BatchDetails:
                      BatchDetails.length > 0 ? BatchDetails[0] : null,
                    Exam: list.CompetitiveExamination === "Yes" ? 1 : 0,
                    ExamName:
                      list.CompetitiveExamination === "Yes"
                        ? list.CompetitiveExamName
                        : null,
                    ExamInstitute:
                      list.CompetitiveExamination === "Yes"
                        ? list.Institute
                        : null,
                    PrevExam: list.ExamPreviously === "Yes" ? 1 : 0,
                    ExamDetail:
                      list.ExamPreviously === "Yes"
                        ? ExamDetailsArray.length > 0
                          ? ExamDetailsArray
                          : null
                        : null,
                    PastExam:
                      list.ExamPreviously === "Yes" ? list.ExamWrite : null,
                    GoveEmp: list.workingRes === "Yes" ? 1 : 0,
                    Designation:
                      list.workingRes === "Yes" ? list.Designation : null,
                    Department:
                      list.workingRes === "Yes" ? list.Department : null,
                    JoinGovt: list.workingRes === "Yes" ? list.JoinGovt : null,
                    AIASAStudent: list.AIASAStudent === "Yes" ? 1 : 0,
                    Year: list.AIASAStudent === "Yes" ? list.Year : null,
                    Aiasa_category:
                      list.AIASAStudent === "Yes" ? list.CategoryAias : null,
                    Aiasa_course:
                      list.AIASAStudent === "Yes" ? list.CourseAias : null,
                    IDNumber:
                      list.AIASAStudent === "Yes" ? list.IDNumber : null,
                    original_aiasa_id_path:
                      list.AIASAStudent === "Yes"
                        ? list.original_aiasa_id_path
                        : null,
                    IdCardPath:
                      list.AIASAStudent === "Yes" ? list.IDPhoto : null,
                    updated_by: userid,
                  };
                  setIsLoading(true);
                  // console.log(StepFourData);
                  AxiosInstance.post(
                    "api/course/admission/register",
                    StepFourData
                  )
                    .then((res) => {
                      // console.log(res);
                      if (res.data.status === true) {
                        setIsLoading(false);
                        // console.log(res.data.data,"stepfour admission id");
                        if (res.data.data) {
                          setAdmissionID({
                            adId: res.data.data,
                          });
                        }
                        setStep(step + 1);
                        sessionStorage.removeItem("stateRefreshs_test");
                        setStepperButton(false);
                        Info_View(userid);
                      } else {
                        Swal.fire({
                          title: "Warning",
                          text: res.data.message,
                          icon: "Warning",
                          confirmButtonText: "Ok",
                        });
                        setStepperButton(false);
                        setStep(1);
                        Info_View(userid);
                        setIsLoading(false);
                      }
                    })
                    .catch((error) => {
                      setStepperButton(false);
                      return error;
                    });
                }
              }
            } else {
              setListErrors({
                ...listErrors,
                Subject: "",
              });
              const errors_ExamDetails = validateExamDetails(
                examDetailsExam,
                setExamDetailsExam
              );
              if (
                (step === 4 &&
                  list.ExamPreviously === "Yes" &&
                  errors_ExamDetails.length > 0 &&
                  errors_ExamDetails.every(
                    (el) => el.examvalue !== "" && el.error_name_exam === ""
                  )) ||
                list.ExamPreviously === "NO"
              ) {
                const StepFourData = {
                  user_id: userid,
                  step: 4,
                  type: 1,
                  id: admissionID.adId ? admissionID.adId : 0,
                  Category: list.category,
                  Courses: list.CourseCate,
                  MediumExam: list.TeachMedium,
                  subject: subjectarray.length > 0 ? subjectarray : [],
                  subject_pk: subjectPkarray.length > 0 ? subjectPkarray : [],
                  location: list.location !== "" ? parseInt(list.location) : 2,
                  BatchDetails:
                    BatchDetails.length > 0 ? BatchDetails[0] : null,
                  Exam: list.CompetitiveExamination === "Yes" ? 1 : 0,
                  ExamName:
                    list.CompetitiveExamination === "Yes"
                      ? list.CompetitiveExamName
                      : null,
                  ExamInstitute:
                    list.CompetitiveExamination === "Yes"
                      ? list.Institute
                      : null,
                  PrevExam: list.ExamPreviously === "Yes" ? 1 : 0,
                  ExamDetail:
                    list.ExamPreviously === "Yes"
                      ? ExamDetailsArray.length > 0
                        ? ExamDetailsArray
                        : null
                      : null,
                  PastExam:
                    list.ExamPreviously === "Yes" ? list.ExamWrite : null,
                  GoveEmp: list.workingRes === "Yes" ? 1 : 0,
                  Designation:
                    list.workingRes === "Yes" ? list.Designation : null,
                  Department:
                    list.workingRes === "Yes" ? list.Department : null,
                  JoinGovt: list.workingRes === "Yes" ? list.JoinGovt : null,
                  AIASAStudent: list.AIASAStudent === "Yes" ? 1 : 0,
                  Year: list.AIASAStudent === "Yes" ? list.Year : null,
                  Aiasa_category:
                    list.AIASAStudent === "Yes" ? list.CategoryAias : null,
                  Aiasa_course:
                    list.AIASAStudent === "Yes" ? list.CourseAias : null,
                  IDNumber: list.AIASAStudent === "Yes" ? list.IDNumber : null,
                  original_aiasa_id_path:
                    list.AIASAStudent === "Yes"
                      ? list.original_aiasa_id_path
                      : null,
                  IdCardPath: list.AIASAStudent === "Yes" ? list.IDPhoto : null,
                  updated_by: userid,
                };
                setIsLoading(true);
                // console.log(StepFourData);
                AxiosInstance.post(
                  "api/course/admission/register",
                  StepFourData
                )
                  .then((res) => {
                    // console.log(res);
                    if (res.data.status === true) {
                      // console.log(res.data.data,"stepfour admission id");
                      if (res.data.data) {
                        setAdmissionID({
                          adId: res.data.data,
                        });
                      }
                      setStep(step + 1);
                      sessionStorage.removeItem("stateRefreshs_test");
                      setStepperButton(false);
                      setTimeout(() => {
                        setIsLoading(false);
                        Info_View(userid);
                      }, 2000)
                    } else {
                      Swal.fire({
                        title: "Warning",
                        text: res.data.message,
                        icon: "Warning",
                        confirmButtonText: "Ok",
                      });
                      setStepperButton(false);
                      setStep(1);
                      Info_View(userid);
                      setIsLoading(false);
                    }
                  })
                  .catch((error) => {
                    setStepperButton(false);
                    return error;
                  });
              }
            }
          } else if (step === 5) {
            if (list.Verify === true) {
              setStep(step + 1);
              sessionStorage.removeItem("stateRefreshs_test");
            } else {
              let err = "Please look and verify the Terms and Conditions.";
              txtadVerifyHere.current.focus();
              setListErrors({
                ...listErrors,
                Verify: err,
              });
            }
          }
          // setStep(step + 1);
          // appendToStorage("PersonalDetails", JSON.stringify(list));
        } else {
          setListErrors(errors);
        }
      }
    } else {
      console.log("User Id cannot avaliable in session storage");
    }
  };
  const validateThq = (techQualification, setTechQualification) => {
    if (techQualification && techQualification.length > 0) {
      const updateTHQ = techQualification.map((OB) => {
        let updatedOB = { ...OB };
        // console.log(techQualification,"techQualification");
        // if (!OB.name) {
        //   updatedOB.error_name = "Name is required";
        // }
        // if (OB.name === "Nil") {
        //   updatedOB.error_name = "";
        //   updatedOB.error_level = "";
        //   updatedOB.error_edu_medium = "";
        //   updatedOB.error_certificate_no = "";
        //   updatedOB.error_year_of_passing = "";
        //   updatedOB.error_grade = "";
        // }
        // if (!OB.level && OB.name !== "Nil") {
        //   updatedOB.error_level = "Level is required";
        // }

        // if (!OB.lang && OB.name !== "Nil") {
        //   updatedOB.error_edu_medium = "Lang is required";
        // }

        // if (!OB.Cnum && OB.name !== "Nil") {
        //   updatedOB.error_certificate_no = "Certificate No is required";
        // }

        // if (!OB.year && OB.name !== "Nil") {
        //   updatedOB.error_year_of_passing = "Year of passing is required";
        // }

        // if (!OB.grade && OB.name !== "Nil") {
        //   updatedOB.error_grade = "Grade is required";
        // }

        return updatedOB;
      });
      setTechQualification(updateTHQ);
      return updateTHQ;
    }
  };

  const validateExamDetails = (examDetailsExam, setExamDetailsExam) => {
    if (
      step === 4 &&
      examDetailsExam.length > 0 &&
      list.ExamPreviously === "Yes"
    ) {
      const updateExam = examDetailsExam.map((OB) => {
        let updatedOB = { ...OB };
        if (!OB.examvalue) {
          updatedOB.error_name_exam = "Exam Name is required";
          txtAdEdetail.current.focus();
        } else {
          updatedOB.error_name_exam = "";
        }
        return updatedOB;
      });
      setExamDetailsExam(updateExam);
      return updateExam;
    }
  };

  const handleCloseModels_Succ = () => {
    setSwalMsg({
      show: false,
      status: "",
      message: "",
      title: "",
      BottomOkClose: "",
    });

    // navigateToPreviousScreen();
  };

  const handleCloseModel = () => {
    setSwalMsg({
      show: false,
      status: "",
      message: "",
      title: "",
      BottomOkClose: "",
    });

    // navigateToPreviousScreen();
  };

  //  front end
  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className=" AdmissionForm AdmissionForm_section">
      <h4 className="Title">Test Batch Admission</h4>
      {swalMsg.show === true && (
        <ModelComForP
          show={swalMsg.show}
          message={swalMsg.message}
          status={swalMsg.status}
          title={swalMsg.title}
          BottomOkBtn={swalMsg.BottomOkBtn}
          BottomCancelBtn={swalMsg.BottomCancelBtn}
          handleCloseModels={handleCloseModel}
          // handleClose_yes={handleSPayfee}
          BottomOkClose={swalMsg.BottomOkClose}
          handleCloseModels_Succ={handleCloseModels_Succ}
        />
      )}
      <form>
        <div className="row progressTitle">
          <div className={`col-md-2 col-2 col-sm-2 col_progress `}>
            <div
              className={`${step === 1 ||
                step === 2 ||
                step === 3 ||
                step === 4 ||
                step === 5 ||
                step === 6 ||
                step === 7
                ? "Card"
                : "  Cards"
                }`}
            >
              <p
                className="circle"
                onClick={
                  step === 2 ||
                    step === 3 ||
                    step === 4 ||
                    step === 5 ||
                    step === 6 ||
                    step === 7
                    ? () => handleStepPrevious(1) // Wrap the call in an arrow function
                    : handleNext
                }
              >
                {step === 2 ||
                  step === 3 ||
                  step === 4 ||
                  step === 5 ||
                  step === 6 ||
                  step === 7
                  ? "✓"
                  : "1"}
              </p>
              <p className="cTitle fw-semibold">Personal Profile</p>
              <p className="cSubtitle">Define Your Identity</p>
              <span
                className={`${step === 2 ||
                  step === 3 ||
                  step === 4 ||
                  step === 5 ||
                  step === 6 ||
                  step === 7
                  ? "Stepborders"
                  : "Stepborder"
                  } display_none_Stepborder`}
              ></span>
            </div>
          </div>
          <div className={`col-md-2 col-2 col-sm-2 col_progress `}>
            <div
              className={`${step === 2 ||
                step === 3 ||
                step === 4 ||
                step === 5 ||
                step === 6 ||
                step === 7
                ? "Card"
                : "  Cards"
                }`}
            >
              <p
                className="circle"
                onClick={
                  step === 3 ||
                    step === 4 ||
                    step === 5 ||
                    step === 6 ||
                    step === 7
                    ? () => handleStepPrevious(2) // Wrap the call in an arrow function
                    : handleNext
                }
              >
                {step === 3 ||
                  step === 4 ||
                  step === 5 ||
                  step === 6 ||
                  step === 7
                  ? "✓"
                  : "2"}
              </p>
              <p className="cTitle ">Communication</p>
              <p className="cSubtitle">Stay Connected Always</p>
              <span
                className={`${step === 3 ||
                  step === 4 ||
                  step === 5 ||
                  step === 6 ||
                  step === 7
                  ? "Stepborders"
                  : "Stepborder"
                  } display_none_Stepborder`}
              ></span>
            </div>
          </div>
          <div className={`col-md-2 col-2 col-sm-2 `}>
            <div
              className={`${step === 3 ||
                step === 4 ||
                step === 5 ||
                step === 6 ||
                step === 7
                ? "Card"
                : "  Cards"
                }`}
            >
              <p
                className="circle"
                onClick={
                  step === 4 || step === 5 || step === 6 || step === 7
                    ? () => handleStepPrevious(3) // Wrap the call in an arrow function
                    : handleNext
                }
              >
                {step === 4 || step === 5 || step === 6 || step === 7
                  ? "✓"
                  : "3"}
              </p>
              <p className="cTitle ">Academic Background</p>
              <p className="cSubtitle ">Your Learning Journey</p>
              <span
                className={`${step === 4 || step === 5 || step === 6 || step === 7
                  ? "Stepborders"
                  : "Stepborder"
                  } display_none_Stepborder`}
              ></span>
            </div>
          </div>
          <div className={`col-md-2 col-2 col-sm-2 `}>
            <div
              className={`${step === 4 || step === 5 || step === 6 || step === 7
                ? "Card"
                : "  Cards"
                }`}
            >
              <p
                className="circle"
                onClick={
                  step === 5 || step === 6 || step === 7
                    ? () => handleStepPrevious(4) // Wrap the call in an arrow function
                    : handleNext
                }
              >
                {step === 5 || step === 6 || step === 7 ? "✓" : "4"}
              </p>
              <p className="cTitle ">Test Batch Selection</p>
              <p className="cSubtitle ">Choose Your Course</p>
              <span
                className={`${step === 5 || step === 6 || step === 7
                  ? "Stepborders"
                  : "Stepborder"
                  } display_none_Stepborder`}
              ></span>
            </div>
          </div>

          <div className={`col-md-2 col-2 col-sm-2 col_end_progress `}>
            <div
              className={`${step === 5 || step === 6 || step === 7 ? "Card" : "  Cards"
                }`}
            >
              <p
                className="circle"
                onClick={
                  step === 6 || step === 7
                    ? () => handleStepPrevious(5) // Wrap the call in an arrow function
                    : handleNext
                }
              >
                {step === 6 || step === 7 ? "✓" : "5"}
              </p>
              <p className="cTitle ">Review and Confirm</p>
              <p className="cSubtitle ">Review Your Details</p>
              <span
                className={`${step === 6 || step === 7 ? "Stepborders" : "Stepborder"
                  } display_none_Stepborder`}
              ></span>
            </div>
          </div>
          <div className={`col-md-2 col-2 col-sm-2 col_end_progress `}>
            <div className={`${step === 6 || step === 7 ? "Card" : "  Cards"}`}>
              <p
                className="circle"
                onClick={
                  step === 7
                    ? () => handleStepPrevious(6) // Wrap the call in an arrow function
                    : handleNext
                }
              >
                {step === 7 ? "✓" : "6"}
              </p>
              <p className="cTitle ">Payment Info</p>
              <p className="cSubtitle ">Your Test, Your Cost</p>
            </div>
          </div>
        </div>
        {/* {step === 1} */}
        {step === 1 && (
          <fieldset>
            <div className="row">
              <div className="col-md-12">
                <section className="StepOne ">
                  <div className="heading  mt-3 d-flex justify-content-end ">
                    <Link to="/" className="CancelButton">
                      Back to Home
                    </Link>

                    <button
                      type="button"
                      className="SaveButton"
                      disabled={stepperButton}
                      onClick={handleNext}
                    >
                      <a href="javascript:void(0)">
                        Save and Continue to Communication
                      </a>
                    </button>
                  </div>
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">{LBL_BASIC_DETAILS}</p>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="FirstName">First Name</label>
                            <input
                              ref={txtAdFname}
                              id="FirstName"
                              type="text"
                              name="FirstName"
                              className="Inputs"
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              onChange={handleChange}
                              placeholder="First Name"
                              value={list.FirstName}
                              autoComplete="FirstName"
                              minLength={5}
                              maxLength={15}
                              required
                            />
                            {listErrors.FirstName && (
                              <p className="errors">{listErrors.FirstName}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="LastName">Last Name</label>
                            <input
                              ref={txtAdLname}
                              id="LastName"
                              type="text"
                              name="LastName"
                              placeholder=" Last Name"
                              className="Inputs"
                              minLength={5}
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              maxLength={15}
                              onChange={handleChange}
                              value={list.LastName}
                              autoComplete="LastName"
                              required
                            />
                            {listErrors.LastName && (
                              <p className="errors">{listErrors.LastName}</p>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="Fathername">
                              Father's Name/Guardian's Name
                            </label>
                            <input
                              ref={txtAdFath}
                              id="Fathername"
                              type="text"
                              name="Fathername"
                              placeholder=" Fathers Name"
                              onChange={handleChange}
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              value={list.Fathername}
                              className="Inputs"
                              minLength={5}
                              maxLength={50}
                              autoComplete="Fathername"
                              required
                            />
                            {listErrors.Fathername && (
                              <p className="errors">{listErrors.Fathername}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="MotherName">Mother's Name</label>
                            <input
                              ref={txtAdMoth}
                              id="MotherName"
                              type="text"
                              // disabled={
                              //   list.admission_status === 1 ? true : false
                              // }
                              name="MotherName"
                              onChange={handleChange}
                              value={list.MotherName}
                              placeholder=" Mother Name"
                              className="Inputs"
                              minLength={5}
                              maxLength={15}
                              autoComplete="MotherName"
                              required
                            />
                            {listErrors.MotherName && (
                              <small className="errors fw-semibold">
                                {listErrors.MotherName}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="DOB">Date of Birth</label>
                            {/* <input
                                     ref={txtAdMDob}
                                  id="DOB"
                                  type="date"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  name="DOB"
                                  onChange={handleChange}
                                  value={list.DOB}
                                  className="Inputs"
                                  autoComplete="DOB"
                                  required
                                /> */}
                            <DatePickerSample
                              handleYearChange={handleYearChange}
                              handleMonthChange={handleMonthChange}
                              disabledProperty={
                                list.admission_status === 1 ? true : false
                              }
                              txtAdMDob={txtAdMDob}
                              name={"DOB"}
                              handleChange={handleChangeDate}
                              fieldInput={list.DOB}
                            />
                            {listErrors.DOB && (
                              <p className="errors">{listErrors.DOB}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="age">Age</label>
                            <input
                              ref={txtAdAge}
                              id="age"
                              type="text"
                              name="age"
                              readOnly
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              onChange={handleChange}
                              value={list.age}
                              className="Inputs"
                              placeholder="Age"
                              autoComplete="age"
                              required
                            />
                            {listErrors.age && (
                              <p className="errors">{listErrors.age}</p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row mb-4">
                        <div className="col-md-6">
                          <div className="forms row  ">
                            <label htmlFor="Gender">Gender</label>
                            <div
                              className="d-flex  col-md-12"
                              id="radiobuttons"
                            >
                              <div className="form-check form-check-inline">
                                <input
                                  ref={txtAdGender}
                                  className="checkbox_radio"
                                  type="radio"
                                  name="gender"
                                  onChange={handleChange}
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  checked={
                                    list.gender === "Male" ? true : false
                                  }
                                  id="Male"
                                  value="Male"
                                />
                                <label
                                  className="checkbox-label"
                                  htmlFor="Male"
                                >
                                  Male
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="checkbox_radio"
                                  type="radio"
                                  name="gender"
                                  id="Female"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  onChange={handleChange}
                                  checked={
                                    list.gender === "Female" ? true : false
                                  }
                                  value="Female"
                                />
                                <label
                                  className="checkbox-label"
                                  htmlFor="Female"
                                >
                                  Female
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="checkbox_radio"
                                  type="radio"
                                  name="gender"
                                  id="Transgender"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  onChange={handleChange}
                                  checked={
                                    list.gender === "Transgender" ? true : false
                                  }
                                  value="Transgender"
                                />
                                <label
                                  className="checkbox-label"
                                  htmlFor="Transgender"
                                >
                                  Transgender
                                </label>
                              </div>
                            </div>
                          </div>
                          {listErrors.gender && (
                            <small className="errors fw-semibold">
                              {listErrors.gender}
                            </small>
                          )}
                        </div>

                        <div className="col-md-6">
                          <div className="forms row  ">
                            <label htmlFor="MaritalStatus">
                              Marital Status
                            </label>
                            <div
                              className="d-flex ms-4  col-md-12"
                              id="radiobuttons"
                            >
                              <div className="form-checks form-check-inline">
                                <input
                                  ref={txtAdMStatus}
                                  className="checkbox_radio"
                                  type="radio"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  name="MaritalStatus"
                                  onChange={handleChange}
                                  checked={
                                    list.MaritalStatus === "Single/Unmarried"
                                      ? true
                                      : false
                                  }
                                  id="Single/Unmarried"
                                  value="Single/Unmarried"
                                />
                                <label
                                  className="checkbox-label"
                                  htmlFor="Single/Unmarried"
                                >
                                  Single/Unmarried
                                </label>
                              </div>
                              <div className="form-checks form-check-inline">
                                <input
                                  className="checkbox_radio"
                                  type="radio"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  name="MaritalStatus"
                                  id="Married"
                                  onChange={handleChange}
                                  checked={
                                    list.MaritalStatus === "Married"
                                      ? true
                                      : false
                                  }
                                  value="Married"
                                />
                                <label
                                  className="checkbox-label"
                                  htmlFor="Married"
                                >
                                  Married
                                </label>
                              </div>

                              <div className="form-checks form-check-inline">
                                <input
                                  className="checkbox_radio"
                                  type="radio"
                                  name="MaritalStatus"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  id="Widowed"
                                  onChange={handleChange}
                                  checked={
                                    list.MaritalStatus === "Widowed"
                                      ? true
                                      : false
                                  }
                                  value="Widowed"
                                />
                                <label
                                  className="checkbox-label"
                                  htmlFor="Widowed"
                                >
                                  Widowed
                                </label>
                              </div>
                            </div>
                          </div>
                          {listErrors.MaritalStatus && (
                            <small className="errors fw-semibold">
                              {listErrors.MaritalStatus}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section className="sectionTwo ">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Passport Size Photograph</p>
                      <div className="row">
                        <div className="col-md-6 d-flex  justify-content-center">
                          <div className="forms">
                            <img
                              className="ProfilePhoto  bg-opacity-75"
                              src={`${ImageUrlPrefix}/${list.Profilephoto}`}
                              alt="profile"
                            />

                            {!list.Profilephoto && (
                              <span id="text">Profile Picture</span>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="Profilephoto">
                              Upload Passport Size Photograph
                            </label>
                            <div className="row">
                              <div
                                className={
                                  list.Profilephoto !== "" &&
                                    list.Profilephoto !== null
                                    ? "col-md-3 "
                                    : "col-md-12"
                                }
                              >
                                <input
                                  ref={txtAdPSize}
                                  id="Profilephoto"
                                  type="file"
                                  name="Profilephoto"
                                  placeholder="Upload AADHAR Card"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  className={
                                    list.Profilephoto !== "" &&
                                      list.Profilephoto !== null
                                      ? "InputsFile nn_upload_width"
                                      : "InputsFile  vv_upload_width"
                                  }
                                  onChange={handleChange}
                                  autoComplete="Profilephoto"
                                  required
                                />
                              </div>

                              {list.Profilephoto !== "" &&
                                list.Profilephoto !== null && (
                                  <div
                                    className={
                                      "col-md-9 d-flex align-content-center p-0"
                                    }
                                  >
                                    <span className="nn_upload_file">
                                      {list.Profilephoto !== "" &&
                                        list.Profilephoto !== null
                                        ? list.original_profile_path
                                        : ""}
                                    </span>
                                    <span className="material-icons align-middle text-danger verified_upload">
                                      verified
                                    </span>
                                  </div>
                                )}
                            </div>
                            {listErrors.Profilephoto && (
                              <small className="errors fw-semibold">
                                {listErrors.Profilephoto}
                              </small>
                            )}
                            {/* <input
                              ref={txtAdPSize}
                              id="Profilephoto"
                              type="file"
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              name="Profilephoto"
                              onChange={handleChange}
                              className="InputsFile"
                              autoComplete="Profilephoto"
                              required
                            />
                            {listErrors.Profilephoto && (
                              <small className="errors fw-semibold">
                                {listErrors.Profilephoto}
                              </small>
                            )} */}
                          </div>

                          <div className="forms mt-4 ms-md-3 mb-4">
                            <h6 className="profileText">Note:</h6>
                            <h6 className="warningTwo">
                              <span className="fw-semibold">Image format</span>:
                              The recommended image format for profile pictures
                              on Anna IAS Academy is JPEG or PNG.
                            </h6>
                            <h6 className="warningTwo">
                              <span className="fw-semibold">Image size</span>:
                              Profile pictures should be a minimum of 400x400
                              pixels and a maximum of 1024x1024 pixels. The file
                              size should not exceed 40 KB.
                            </h6>
                            <h6 className="warningTwo">
                              <span className="fw-semibold">
                                Image quality and content
                              </span>
                              : Choose a clear and high-quality image for your
                              profile picture. Your profile picture should be
                              appropriate and professional.
                            </h6>
                            <h6 className="warningTwo">
                              <span className="fw-semibold">
                                Image orientation
                              </span>
                              :Profile pictures should be in a square format, as
                              they will be displayed as a circle on the
                              platform. Make sure your image is not stretched or
                              distorted.
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section className=" sectionTwo">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">{LBL_ID_PROOFS}</p>

                      <div className="row mb-4">
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="aadharNo">
                              AADHAR Number
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            <input
                              ref={txtAdAno}
                              id="aadharNo"
                              type="number"
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              name="aadharNo"
                              onChange={handleChange}
                              onKeyDown={handleKeyDown}
                              value={list.aadharNo < 0 ? 0 : list.aadharNo}
                              className="Inputs"
                              placeholder="AAdhar Number"
                              autoComplete="aadharNo"
                              required
                              minLength={12}
                            />
                            {listErrors.aadharNo && (
                              <p className="errors">{listErrors.aadharNo}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="forms ">
                            <label htmlFor="aadharCardphoto">
                              Upload AADHAR Card (In pdf/Image format)
                              {list.aadharCardphoto !== "" &&
                                list.aadharCardphoto !== null && (
                                  <a
                                    href={`${ImageUrlPrefix}/${list.aadharCardphoto}`}
                                    target="_blank"
                                    download
                                  >
                                    <span className="material-icons align-middle download_icon">
                                      file_download
                                    </span>
                                  </a>
                                )}
                            </label>
                            <div className="row">
                              <div
                                className={
                                  list.aadharCardphoto !== "" &&
                                    list.aadharCardphoto !== null
                                    ? "col-md-3 "
                                    : "col-md-12"
                                }
                              >
                                <input
                                  ref={txtAdApath}
                                  id="aadharCardphoto"
                                  type="file"
                                  name="aadharCardphoto"
                                  placeholder="Upload AADHAR Card"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  className={
                                    list.aadharCardphoto !== "" &&
                                      list.aadharCardphoto !== null
                                      ? "InputsFile nn_upload_width"
                                      : "InputsFile  vv_upload_width"
                                  }
                                  onChange={handleChange}
                                  autoComplete="aadharCardphoto"
                                  required
                                />
                              </div>
                              {list.aadharCardphoto !== "" &&
                                list.aadharCardphoto !== null && (
                                  <div
                                    className={
                                      "col-md-9 d-flex align-content-center p-0"
                                    }
                                  >
                                    <span className="nn_upload_file">
                                      {list.aadharCardphoto !== "" &&
                                        list.aadharCardphoto !== null
                                        ? list.original_aadhar_path
                                        : ""}
                                    </span>
                                    <span className="material-icons align-middle text-danger verified_upload">
                                      verified
                                    </span>
                                  </div>
                                )}
                            </div>
                            {listErrors.aadharCardphoto && (
                              <p className="errors">
                                {listErrors.aadharCardphoto}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="sectionTwo">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Communal Reservation Category</p>

                      <div className="row mb-4">
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="Cast">Category</label>
                            <Select
                              ref={txtAdCno}
                              id="Cast"
                              name="Cast"
                              isDisabled={
                                list.admission_status === 1 ? true : false
                              }
                              value={dropDowns.Cast}
                              onChange={(option) =>
                                handleSelectMulti(option, "Cast", "Cast")
                              }
                              options={categoryOption} // Sort options alphabetically by label
                              isSearchable={true} // Enables search functionality
                              placeholder="Select an option"
                              maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                              filterOption={(option, searchText) =>
                                option.label
                                  .toLowerCase()
                                  .includes(searchText.toLowerCase())
                              } // Filter options based on the search text
                              styles={customStyles} // Apply custom styles her
                            />
                            {listErrors.Cast && (
                              <small className="errors fw-semibold">
                                {listErrors.Cast}
                              </small>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="forms ">
                            <label htmlFor="CastFile">
                              Upload certificate (In pdf/Image format){" "}
                              <span className="optionFields">(Optional)</span>
                              {list.CastFile !== "" &&
                                list.CastFile !== null && (
                                  <a
                                    href={`${ImageUrlPrefix}/${list.CastFile}`}
                                    target="_blank"
                                    download
                                  >
                                    <span className="material-icons align-middle download_icon">
                                      file_download
                                    </span>
                                  </a>
                                )}
                            </label>
                            <div className="row">
                              <div
                                className={
                                  list.CastFile !== "" && list.CastFile !== null
                                    ? "col-md-3 "
                                    : "col-md-12"
                                }
                              >
                                <input
                                  ref={txtAdCpath}
                                  id="CastFile"
                                  type="file"
                                  name="CastFile"
                                  onChange={handleChange}
                                  className={
                                    list.CastFile !== "" &&
                                      list.CastFile !== null
                                      ? "InputsFile nn_upload_width"
                                      : "InputsFile  vv_upload_width"
                                  }
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  placeholder="Upload Certificate"
                                  autoComplete="CastFile"
                                />
                              </div>
                              {list.CastFile !== "" &&
                                list.CastFile !== null && (
                                  <div
                                    className={
                                      "col-md-9 d-flex align-content-center p-0"
                                    }
                                  >
                                    <span className="nn_upload_file">
                                      {list.CastFile !== "" &&
                                        list.CastFile !== null
                                        ? list.original_caste_path
                                        : ""}
                                    </span>
                                    <span className="material-icons align-middle text-danger verified_upload">
                                      verified
                                    </span>
                                  </div>
                                )}
                            </div>

                            {listErrors.CastFile && (
                              <small className="errors fw-semibold">
                                {listErrors.CastFile}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className=" sectionTwo">
                  {specialAdmissionPre.map((item, index) => (
                    <SpecialPre
                      key={index.toString()}
                      record={item}
                      // admission_status={list.admission_status === 1 ? 1 : 0}
                      length={specialAdmissionPre.length}
                      specialAdmissionHandleChanges={
                        specialAdmissionHandleChanges
                      }
                      specialHandleChange={specialAdmissionHandleChange}
                      sPrefrence={specialPrefrence}
                      Deletespre={DeleteAdmissionspre}
                      AddPrefrence={AddPrefrence}
                      txtAdSpc={txtAdSpc}
                      handleChange={handleChange}
                      list={list.SPCcategory}
                      listErrors={listErrors.SPCcategory}
                    />
                  ))}

                  <div className="heading mb-5 me-4 d-flex justify-content-end ">
                    {/* <Link to="/" className="CancelButton">
                      Back to Home
                    </Link> */}
                    <button
                      type="button"
                      className="SaveButton"
                      disabled={stepperButton}
                      onClick={handleNext}
                    >
                      <a href="javascript:void(0)">
                        Save and Continue to Communication
                      </a>
                    </button>
                  </div>
                </section>
              </div>
            </div>
          </fieldset>
        )}
        {/* {step === 2} */}
        {step === 2 && (
          <fieldset>
            <div className="row">
              <div className="col-md-12">
                <section className=" sectionThree">
                  <div className="heading  dflexbetww ">
                    <div className="">
                      <button
                        type="button"
                        className="SaveButton_Prev"
                        onClick={handlePrevious}
                      >
                        <a href="javascript:void(0)">Go to Personal Details</a>
                      </button>
                    </div>
                    <div className="d-flex smButton mobiledown">
                      <Link to="/" className="CancelButton">
                        Back to Home
                      </Link>
                      <button
                        type="button"
                        className="SaveButtons"
                        disabled={stepperButton}
                        onClick={handleNext}
                      >
                        <a href="javascript:void(0)">
                          Save and Continue to Academic Background
                        </a>
                      </button>
                    </div>
                  </div>
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">{LBL_CONTACT_DETAILS}</p>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="Mobile">Phone Number</label>
                            <input
                              ref={txtAdPno}
                              id="Mobile"
                              type="number"
                              name="Mobile"
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              onChange={handleChange}
                              onKeyDown={handleKeyDown}
                              value={list.Mobile}
                              className="Inputs_Phone"
                              placeholder="Phone Number"
                              autoComplete="Mobile"
                              required
                              minLength={10}
                              maxLength={10}
                              inputMode="tel"
                            />
                            {listErrors.Mobile && (
                              <p className="errors">{listErrors.Mobile}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="forms ">
                            <div className="d-flex justify-content-between">
                              <label htmlFor="WhatsAppNumber ">
                                WhatsApp Number
                              </label>
                              <label>
                                <input
                                  className=" form-check-input mt-0 me-2 align-items-center"
                                  type="checkbox"
                                  id="ContactNumber"
                                  name="ContactNumber"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  onChange={handleChange}
                                  value={list.ContactNumber}
                                  checked={
                                    list.ContactNumber === true ? true : false
                                  }
                                />
                                <span
                                  className="form-check-label"
                                  htmlFor="ContactNumber"
                                >
                                  Same as Contact Number
                                </span>
                              </label>
                            </div>
                            <input
                              ref={txtAdWno}
                              id="WhatsAppNumber"
                              type="number"
                              name="WhatsAppNumber"
                              placeholder="WhatsApp Number"
                              minLength={10}
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              maxLength={10}
                              className="Inputs_Phone"
                              onBlur={handleblur}
                              onChange={handleChange}
                              onKeyDown={handleKeyDown}
                              value={
                                list.ContactNumber !== true
                                  ? list.WhatsAppNumber
                                  : list.Mobile
                              }
                              autoComplete="WhatsAppNumber"
                              required
                              inputMode="tel"
                            />
                            {listErrors.WhatsAppNumber && (
                              <p className="errors">
                                {listErrors.WhatsAppNumber}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="ParentMobileNo">
                              Father/Guardian Phone Number
                            </label>
                            <input
                              ref={txtAdFpo}
                              id="ParentMobileNo"
                              type="number"
                              name="ParentMobileNo"
                              className="Inputs_Phone"
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              onChange={handleChange}
                              onKeyDown={handleKeyDown}
                              value={list.ParentMobileNo}
                              placeholder="MobileNo"
                              autoComplete="ParentMobileNo"
                              required
                              inputMode="tel"
                              minLength={10}
                              maxLength={10}
                            />
                            {listErrors.ParentMobileNo && (
                              <p className="errors">
                                {listErrors.ParentMobileNo}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="emailaddress">Email ID</label>
                            <input
                              ref={txtAdEmail}
                              id="emailaddress"
                              readOnly
                              type="email"
                              name="emailaddress"
                              className="Inputs"
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              onChange={handleChange}
                              value={list.emailaddress}
                              placeholder=" Email ID"
                              autoComplete="emailaddress"
                              required
                            />
                            {listErrors.emailaddress && (
                              <p className="errors">
                                {listErrors.emailaddress}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="sectionFour">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Present Address</p>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="BuildingNumberPresent">
                              House/Flat Number & Name
                            </label>
                            <input
                              ref={txtAdPhno}
                              id="BuildingNumberPresent"
                              type="text"
                              name="BuildingNumberPresent"
                              className="Inputs"
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              onChange={handleChange}
                              value={list.BuildingNumberPresent}
                              placeholder="House/Flat Number & Name"
                              autoComplete="BuildingNumberPresent"
                              required
                            // minLength={20}
                            // maxLength={20}
                            />
                            {listErrors.BuildingNumberPresent && (
                              <p className="errors">
                                {listErrors.BuildingNumberPresent}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="forms ">
                            <div className="forms ">
                              <label htmlFor="StreetNamePresent">
                                Street Name
                              </label>
                              <input
                                ref={txtAdPsname}
                                id="StreetNamePresent"
                                type="text"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                name="StreetNamePresent"
                                className="Inputs"
                                onChange={handleChange}
                                value={list.StreetNamePresent}
                                placeholder="Street Name"
                                autoComplete="StreetNamePresent"
                                required
                              />
                              {listErrors.StreetNamePresent && (
                                <p className="errors">
                                  {listErrors.StreetNamePresent}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="AreaPresent">Locality/Area</label>
                            <input
                              ref={txtAdParea}
                              id="AreaPresent"
                              type="text"
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              name="AreaPresent"
                              className="Inputs"
                              onChange={handleChange}
                              value={list.AreaPresent}
                              placeholder="Locality/Area"
                              autoComplete="AreaPresent"
                              required
                            />
                            {listErrors.AreaPresent && (
                              <p className="errors">{listErrors.AreaPresent}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="LandmarkPresent">Landmark</label>
                            <input
                              ref={txtAdPland}
                              id="LandmarkPresent"
                              type="text"
                              name="LandmarkPresent"
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              className="Inputs"
                              onChange={handleChange}
                              value={list.LandmarkPresent}
                              placeholder=" Landmark"
                              autoComplete="LandmarkPresent"
                              required
                            />
                            {listErrors.LandmarkPresent && (
                              <p className="errors">
                                {listErrors.LandmarkPresent}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="PostPresent">Post</label>
                            <input
                              ref={txtAdPpost}
                              id="PostPresent"
                              type="text"
                              name="PostPresent"
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              className="Inputs"
                              onChange={handleChange}
                              value={list.PostPresent}
                              placeholder=" Post"
                              autoComplete="PostPresent"
                              required
                            />

                            {listErrors.PostPresent && (
                              <p className="errors">{listErrors.PostPresent}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="TalukPresent">Taluk</label>
                            <input
                              ref={txtAdPtaluk}
                              id="TalukPresent"
                              type="text"
                              name="TalukPresent"
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              className="Inputs"
                              onChange={handleChange}
                              value={list.TalukPresent}
                              placeholder=" Taluk"
                              autoComplete="TalukPresent"
                              required
                            />
                            {listErrors.TalukPresent && (
                              <p className="errors">
                                {listErrors.TalukPresent}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="PincodePresent">
                              Pin/Postal Code
                            </label>
                            <input
                              ref={txtAdPpincode}
                              id="PincodePresent"
                              type="number"
                              onChange={handleChange}
                              onKeyDown={handleKeyDown}
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              value={list.PincodePresent}
                              name="PincodePresent"
                              className="Inputs"
                              placeholder="Pin/Postal Code"
                              autoComplete="PincodePresent"
                              required
                            />
                            {listErrors.PincodePresent && (
                              <p className="errors">
                                {listErrors.PincodePresent}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="CityPresent">
                              City/Town/Village
                            </label>
                            <Select
                              ref={txtAdPcity}
                              id="CityPresent"
                              name="CityPresent"
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              value={
                                list.CityPresent !== null &&
                                  list.CityPresent !== ""
                                  ? {
                                    value: list.CityPresent,
                                    label: list.CityPresent,
                                  }
                                  : null
                              }
                              onChange={(option) =>
                                handleSelectCH(option, "CityPresent")
                              }
                              options={
                                city
                                  .filter((item) => item && item.label) // Filter out null and undefined elements
                                  .sort((a, b) =>
                                    a.label.localeCompare(b.label)
                                  ) // Sort options alphabetically by label
                              }
                              isSearchable={true}
                              placeholder="Select an option"
                              maxMenuHeight={200}
                              filterOption={(option, searchText) =>
                                option.label
                                  .toLowerCase()
                                  .includes(searchText.toLowerCase())
                              }
                              styles={customStyles}
                            />

                            {/* <select
                                  ref={txtAdPcity}
                                  id="CityPresent"
                                  name="CityPresent"
                                  className="Inputs"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  onChange={handleChange}
                                  defaultValue={list.CityPresent}
                                  required
                                >
                                  <option value="" disabled>
                                    Please select
                                  </option>
                                  {city}
                                </select> */}

                            {listErrors.CityPresent && (
                              <p className="errors">{listErrors.CityPresent}</p>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row  mb-4">
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="districtPresent" id="hio">
                              District{" "}
                            </label>
                            <input
                              ref={txtAdPdistrict}
                              id="districtPresent"
                              type="text"
                              value={list.districtPresent}
                              name="districtPresent"
                              className="Inputs"
                              placeholder="district"
                              disabled
                              required
                            />

                            {listErrors.districtPresent && (
                              <p className="errors">
                                {listErrors.districtPresent}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="statePresent" id="hio">
                              State/Union Territory
                            </label>
                            <input
                              ref={txtAdPstate}
                              id="statePresent"
                              type="text"
                              value={list.statePresent}
                              name="statePresent"
                              className="Inputs"
                              placeholder=" State/Union Territory"
                              disabled
                              required
                            />
                            {/* <select
                          id="statePresent"
                          name="statePresent"
                          className="Inputs"
                          onChange={handleChange}
                          defaultValue={fieldInput.statePresent}
                          required
                        >
                          <option value="" disabled selected>
                            
                          </option>
                        </select> */}
                            {listErrors.statePresent && (
                              <p className="errors">
                                {listErrors.statePresent}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className=" sectionFour ">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="final">Permanent Address</p>

                      <div className="row row mt-4 ms-2">
                        <div className="col-md-12">
                          <div className="d-flex justify-content-between">
                            <label>
                              <input
                                className="me-2 mt-0 form-check-input align-items-center"
                                type="checkbox"
                                id="SamePresentAddress"
                                name="SamePresentAddress"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                onChange={handleChange}
                                value={list.SamePresentAddress}
                                checked={
                                  list.SamePresentAddress === true
                                    ? true
                                    : false
                                }
                              />
                              <span
                                className="form-check-label"
                                htmlFor="SamePresentAddress"
                              >
                                Same as Present Address
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="BuildingNumberPermanent">
                              House/Flat Number & Name
                            </label>
                            <input
                              ref={txtAdPerhno}
                              id="BuildingNumberPermanent"
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              type="text"
                              name="BuildingNumberPermanent"
                              className="Inputs"
                              onChange={handleChange}
                              value={
                                list.SamePresentAddress !== true
                                  ? list.BuildingNumberPermanent
                                  : list.BuildingNumberPresent
                              }
                              placeholder=" House/Building Number"
                              autoComplete="BuildingNumberPermanent"
                              required
                            />
                            {listErrors.BuildingNumberPermanent && (
                              <p className="errors">
                                {listErrors.BuildingNumberPermanent}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="forms ">
                            <div className="forms ">
                              <label htmlFor="StreetNamePermanent">
                                Street Name
                              </label>
                              <input
                                ref={txtAdPersname}
                                id="StreetNamePermanent"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                type="text"
                                name="StreetNamePermanent"
                                className="Inputs"
                                onChange={handleChange}
                                value={
                                  list.SamePresentAddress !== true
                                    ? list.StreetNamePermanent
                                    : list.StreetNamePresent
                                }
                                placeholder="Street Name"
                                autoComplete="StreetNamePermanent"
                                required
                              />
                              {listErrors.StreetNamePermanent && (
                                <p className="errors">
                                  {listErrors.StreetNamePermanent}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="AreaPermanent">Locality/Area</label>
                            <input
                              ref={txtAdPerarea}
                              id="AreaPermanent"
                              type="text"
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              name="AreaPermanent"
                              onChange={handleChange}
                              value={
                                list.SamePresentAddress !== true
                                  ? list.AreaPermanent
                                  : list.AreaPresent
                              }
                              className="Inputs"
                              placeholder="Locality/Area"
                              autoComplete="AreaPermanent"
                              required
                            />
                            {listErrors.AreaPermanent && (
                              <p className="errors">
                                {listErrors.AreaPermanent}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="LandmarkPermanent">Landmark</label>
                            <input
                              ref={txtAdPerland}
                              id="LandmarkPermanent"
                              type="text"
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              name="LandmarkPermanent"
                              className="Inputs"
                              onChange={handleChange}
                              value={
                                list.SamePresentAddress !== true
                                  ? list.LandmarkPermanent
                                  : list.LandmarkPresent
                              }
                              placeholder="Landmark"
                              autoComplete="LandmarkPermanent"
                              required
                            />
                            {listErrors.LandmarkPermanent && (
                              <p className="errors">
                                {listErrors.LandmarkPermanent}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="PostPermanent">Post</label>
                            <input
                              ref={txtAdPererpost}
                              id="PostPermanent"
                              type="text"
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              name="PostPermanent"
                              className="Inputs"
                              onChange={handleChange}
                              value={
                                list.SamePresentAddress !== true
                                  ? list.PostPermanent
                                  : list.PostPresent
                              }
                              placeholder=" Post"
                              autoComplete="PostPermanent"
                              required
                            />

                            {listErrors.PostPermanent && (
                              <p className="errors">
                                {listErrors.PostPermanent}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="TalukPermanent">Taluk</label>
                            <input
                              ref={txtAdPertaluk}
                              id="TalukPermanent"
                              type="text"
                              name="TalukPermanent"
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              className="Inputs"
                              onChange={handleChange}
                              value={
                                list.SamePresentAddress !== true
                                  ? list.TalukPermanent
                                  : list.TalukPresent
                              }
                              placeholder=" Taluk"
                              autoComplete="TalukPermanent"
                              required
                            />
                            {listErrors.TalukPermanent && (
                              <p className="errors">
                                {listErrors.TalukPermanent}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="PincodePermanent">
                              Pin/Postal Code
                            </label>
                            <input
                              ref={txtAdPerpincode}
                              id="PincodePermanent"
                              type="text"
                              disabled={
                                list.admission_status === 1 ||
                                list.SamePresentAddress === true
                              }
                              onChange={handleChange}
                              value={
                                list.SamePresentAddress !== true
                                  ? list.PincodePermanent
                                  : list.PincodePresent
                              }
                              name="PincodePermanent"
                              className="Inputs"
                              placeholder="Pin/Postal Code"
                              autoComplete="PincodePermanent"
                              required
                            />

                            {listErrors.PincodePermanent && (
                              <p className="errors">
                                {listErrors.PincodePermanent}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="CityPermanent">
                              City/Town/Village
                            </label>

                            {list.SamePresentAddress !== true ? (
                              <Select
                                ref={txtAdPercity}
                                id="CityPermanent"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                name="CityPermanent"
                                value={
                                  list.CityPermanent !== null &&
                                    list.CityPermanent !== ""
                                    ? {
                                      value: list.CityPermanent,
                                      label: list.CityPermanent,
                                    }
                                    : null
                                }
                                onChange={(option) =>
                                  handleSelectCH(option, "CityPermanent")
                                }
                                options={
                                  city
                                    .filter((item) => item && item.label) // Filter out null and undefined elements
                                    .sort((a, b) =>
                                      a.label.localeCompare(b.label)
                                    ) // Sort options alphabetically by label
                                }
                                isSearchable={true}
                                placeholder="Select an option"
                                maxMenuHeight={200}
                                filterOption={(option, searchText) =>
                                  option.label
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                }
                                styles={customStyles}
                              />
                            ) : (
                              <input
                                ref={txtAdPercity}
                                id="CityPermanent"
                                type="text"
                                onChange={handleChange}
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                value={
                                  list.SamePresentAddress === true
                                    ? list.CityPresent
                                    : list.CityPermanent
                                }
                                name="CityPermanent"
                                className="Inputs"
                                placeholder="City"
                                autoComplete="CityPermanent"
                                required
                              />
                            )}

                            {listErrors.CityPermanent && (
                              <p className="errors">
                                {listErrors.CityPermanent}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row  mb-4">
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="districtPermanent" id="hio">
                              District
                            </label>
                            <input
                              ref={txtAdPerdistrict}
                              id="districtPermanent"
                              type="text"
                              onChange={handleChange}
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              value={
                                list.SamePresentAddress !== true
                                  ? list.districtPermanent
                                  : list.districtPresent
                              }
                              name="districtPermanent"
                              className="Inputs"
                              placeholder="district"
                              autoComplete="districtPermanent"
                              required
                            />

                            {listErrors.districtPermanent && (
                              <p className="errors">
                                {listErrors.districtPermanent}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="statePermanent" id="hio">
                              State/Union Territory
                            </label>
                            <input
                              ref={txtAdPerstate}
                              id="statePermanent"
                              type="text"
                              onChange={handleChange}
                              value={
                                list.SamePresentAddress !== true
                                  ? list.statePermanent
                                  : list.statePresent
                              }
                              name="statePermanent"
                              disabled={
                                list.admission_status === 1 ? true : false
                              }
                              className="Inputs"
                              placeholder="State/Union Territory"
                              autoComplete="statePermanent"
                              required
                            />

                            {listErrors.statePermanent && (
                              <p className="errors">
                                {listErrors.statePermanent}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="heading  mb-4 dflexbetww ">
                    <div className="">
                      <button
                        type="button"
                        className="SaveButton_Prev"
                        onClick={handlePrevious}
                      >
                        <a href="javascript:void(0)">Go to Personal Details</a>
                      </button>
                    </div>
                    <div className="d-flex smButton mobiledown">
                      <Link to="/" className="CancelButton">
                        Back to Home
                      </Link>
                      <button
                        type="button"
                        className="SaveButtons"
                        disabled={stepperButton}
                        onClick={handleNext}
                      >
                        <a href="javascript:void(0)">
                          Save and Continue to Academic Background
                        </a>
                      </button>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </fieldset>
        )}
        {/* {step === 3} */}
        {step === 3 && (
          <fieldset>
            <div className="row">
              <div className="col-md-12">
                <section className=" sectionFive">
                  <div className="heading dflexbetww ">
                    <div className="">
                      <button
                        type="button"
                        className="SaveButton_Prev"
                        onClick={handlePrevious}
                      >
                        <a href="javascript:void(0)">Go to Communication</a>
                      </button>
                    </div>
                    <div className="d-flex smButton mobiledown">
                      <Link to="/" className="CancelButton">
                        Back to Home
                      </Link>
                      <button
                        type="button"
                        className="SaveButtons"
                        disabled={stepperButton}
                        onClick={handleNext}
                      >
                        <a href="javascript:void(0)">
                          Save and Continue to Course Selection Details
                        </a>
                      </button>
                    </div>
                  </div>
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Educational Qualification</p>

                      <div className="row mb-3">
                        <div className="col-md-12">
                          <div className="forms row ">
                            <label htmlFor="EducationQualification">
                              Select All The Academic Certificates You Have
                            </label>
                            <div
                              className="d-flex mt-4 ms-3  col-md-12"
                              id="radiobuttons"
                            >
                              <div className="form-check form-check-inline">
                                <input
                                  ref={txtAdEduc}
                                  className="form-check-input mt-0"
                                  type="checkbox"
                                  id="EducationQualification1"
                                  value="SSLC"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  checked={
                                    educationQualification.includes("SSLC")
                                      ? true
                                      : false
                                  }
                                  onChange={handleCheckboxChange}
                                />
                                <span
                                  className="form-check-label"
                                  htmlFor="EducationQualification1"
                                >
                                  SSLC
                                </span>
                              </div>

                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input mt-0"
                                  type="checkbox"
                                  id="EducationQualification2"
                                  value="HSC"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  checked={
                                    educationQualification.includes("HSC")
                                      ? true
                                      : false
                                  }
                                  onChange={handleCheckboxChange}
                                />
                                <span
                                  className="form-check-label"
                                  htmlFor="EducationQualification2"
                                >
                                  HSC
                                </span>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input mt-0"
                                  type="checkbox"
                                  id="EducationQualification3"
                                  value="UG"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  checked={educationQualification.includes(
                                    "UG"
                                  )}
                                  onChange={handleCheckboxChange}
                                />
                                <span
                                  className="form-check-label"
                                  htmlFor="EducationQualification3"
                                >
                                  UG
                                </span>
                              </div>

                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input mt-0"
                                  type="checkbox"
                                  id="EducationQualification4"
                                  value="PG"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  checked={educationQualification.includes(
                                    "PG"
                                  )}
                                  onChange={handleCheckboxChange}
                                />
                                <span
                                  className="form-check-label"
                                  htmlFor="EducationQualification4"
                                >
                                  PG
                                </span>
                              </div>

                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input mt-0"
                                  type="checkbox"
                                  id="EducationQualification5"
                                  value="Integrated PG"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  checked={educationQualification.includes(
                                    "Integrated PG"
                                  )}
                                  onChange={handleCheckboxChange}
                                />
                                <span
                                  className="form-check-label"
                                  htmlFor="EducationQualification5"
                                >
                                  Integrated PG
                                </span>
                              </div>

                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input mt-0"
                                  type="checkbox"
                                  id="EducationQualification6"
                                  value="Diploma"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  checked={educationQualification.includes(
                                    "Diploma"
                                  )}
                                  onChange={handleCheckboxChange}
                                />
                                <span
                                  className="form-check-label"
                                  htmlFor="EducationQualification6"
                                >
                                  Diploma
                                </span>
                              </div>

                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input mt-0"
                                  type="checkbox"
                                  id="EducationQualification7"
                                  value="Professional Courses"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  checked={educationQualification.includes(
                                    "Professional Courses"
                                  )}
                                  onChange={handleCheckboxChange}
                                />
                                <span
                                  className="form-check-label"
                                  htmlFor="EducationQualification7"
                                >
                                  Professional Courses
                                </span>
                              </div>

                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input mt-0"
                                  type="checkbox"
                                  id="EducationQualification8"
                                  value="Others"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  checked={educationQualification.includes(
                                    "Others"
                                  )}
                                  onChange={handleCheckboxChange}
                                />
                                <span
                                  className="form-check-label"
                                  htmlFor="EducationQualification8"
                                >
                                  Others
                                </span>
                              </div>
                            </div>

                            {listErrors.EducationQualification && (
                              <p className="errors">
                                {listErrors.EducationQualification}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                {/* //educational section */}

                {educationQualification.includes("SSLC") && (
                  <section className=" sectionFive">
                    <div className="row box">
                      <div className="col-md-12">
                        <p className="StepTitle">SSLC</p>

                        <div className="row ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="SSLC_CNo">
                                Certificate Number
                              </label>
                              <input
                                ref={txtAdSslc}
                                id="SSLC_CNo"
                                type="text"
                                name="SSLC_CNo"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                className="Inputs"
                                onChange={(e) => handleEdu("sslc", e)}
                                placeholder="Certificate Number"
                                value={sslcCerficates[0].SSLC_CNo}
                                autoComplete="Certificate Number"
                                required
                              />
                              {listErrors.SSLC_CNo && (
                                <p className="errors">{listErrors.SSLC_CNo}</p>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="SSLC_Year">Year of Passing</label>

                              {/* <input
                                ref={txtAdSpass}
                                id="SSLC_Year"
                                type="month"
                                name="SSLC_Year"
                                className="Inputs"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                onChange={(e) => handleEdu("sslc", e)}
                                placeholder="Year passing"
                                value={sslcCerficates[0].SSLC_Year}
                                autoComplete="SSLC_Year"
                                required
                              /> */}
                              <MonthDatePicker
                                handleYearChange={handleYearChange_month}
                                handleMonthChange={handleMonthChange_month}
                                disabledProperty={
                                  list.admission_status === 1 ? true : false
                                }
                                dname={"sslc"}
                                txtAdSpass={txtAdSpass}
                                name={"SSLC_Year"}
                                handleChange={handleEYDate}
                                fieldInput={sslcCerficates[0].SSLC_Year}
                              />
                              {listErrors.SSLC_Year && (
                                <p className="errors">{listErrors.SSLC_Year}</p>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="SSLC_Marks">
                                Marks Percentage
                              </label>
                              <input
                                ref={txtAdSmarks}
                                id="SSLC_Marks"
                                type="number"
                                name="SSLC_Marks"
                                className="Inputs"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                onChange={(e) => handleEdu("sslc", e)}
                                onKeyDown={handleKeyDown}
                                placeholder="Marks Percentage"
                                value={sslcCerficates[0].SSLC_Marks}
                                autoComplete="SSLC_Marks"
                                required
                              />
                              {listErrors.SSLC_Marks && (
                                <p className="errors">
                                  {listErrors.SSLC_Marks}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="SSLC_Eboard">
                                Education Board
                              </label>
                              <select
                                ref={txtAdSboard}
                                id="SSLC_Eboard"
                                name="SSLC_Eboard"
                                className="Inputs"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                onChange={(e) => handleEdu("sslc", e)}
                                defaultValue={sslcCerficates[0].SSLC_Eboard}
                                required
                              >
                                <option value="" disabled selected>
                                  Please select
                                </option>
                                <option className="StateBoard">
                                  State board
                                </option>
                                <option className="matriculation">
                                  Matriculation
                                </option>
                                <option className="CBSE">CBSE</option>
                                <option className="ICSE">ICSE</option>
                                <option className="others">others</option>
                              </select>

                              {listErrors.SSLC_Eboard && (
                                <p className="errors">
                                  {listErrors.SSLC_Eboard}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row mb-4 ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="SSLC_MI">
                                Medium of Instruction
                              </label>
                              <select
                                ref={txtAdSins}
                                id="SSLC_MI"
                                name="SSLC_MI"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                className="Inputs"
                                onChange={(e) => handleEdu("sslc", e)}
                                defaultValue={sslcCerficates[0].SSLC_MI}
                                required
                              >
                                <option value="" disabled selected>
                                  Please select
                                </option>
                                <option className="TM">Tamil Medium</option>
                                <option className="EM">English Medium</option>
                              </select>
                              {/* <input
                                    id="SSLC_MI"
                                    type="text"
                                    name="SSLC_MI"
                                    className="Inputs"
                                    onChange={(e) => handleEdu("sslc", e)}
                                    placeholder="Medium Instruction"
                                    value={sslcCerficates[0].SSLC_MI}
                                    autoComplete="Medium Instruction"
                                    required
                                  /> */}
                              {listErrors.SSLC_MI && (
                                <p className="errors">{listErrors.SSLC_MI}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="SSLC_Scl">School Name</label>
                              <input
                                ref={txtAdSschool}
                                id="SSLC_Scl"
                                type="text"
                                name="SSLC_Scl"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                className="Inputs"
                                onChange={(e) => handleEdu("sslc", e)}
                                placeholder="School Name"
                                value={sslcCerficates[0].SSLC_Scl}
                                autoComplete="SchoolName"
                                required
                              />
                              {listErrors.SSLC_Scl && (
                                <p className="errors">{listErrors.SSLC_Scl}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="SSLC_Path">
                                Upload SSLC Certificate (In pdf/Image format){" "}
                                <span className="optionFields">(Optional)</span>
                                {sslcCerficates[0].SSLC_Path !== "" &&
                                  sslcCerficates[0].SSLC_Path !== null && (
                                    <a
                                      href={`${ImageUrlPrefix}/${sslcCerficates[0].SSLC_Path}`}
                                      target="_blank"
                                      download
                                    >
                                      <span className="material-icons download_icon align-middle text-danger">
                                        file_download
                                      </span>
                                    </a>
                                  )}
                              </label>
                              <div className="row">
                                <div
                                  className={
                                    sslcCerficates[0].SSLC_Path !== "" &&
                                      sslcCerficates[0].SSLC_Path !== null
                                      ? "col-md-3 "
                                      : "col-md-12"
                                  }
                                >
                                  <input
                                    ref={txtAdSfile}
                                    id="SSLC_Path"
                                    type="file"
                                    name="SSLC_Path"
                                    disabled={
                                      list.admission_status === 1 ? true : false
                                    }
                                    className={
                                      sslcCerficates[0].SSLC_Path !== "" &&
                                        sslcCerficates[0].SSLC_Path !== null
                                        ? "InputsFile nn_upload_width"
                                        : "InputsFile  vv_upload_width"
                                    }
                                    onChange={(e) => handleEdu("sslc", e)}
                                    placeholder="SSLC_Path"
                                    autoComplete="SSLC_Path"
                                    required
                                  />
                                </div>
                                {sslcCerficates[0].SSLC_Path !== "" &&
                                  sslcCerficates[0].SSLC_Path !== null && (
                                    <div
                                      className={
                                        "col-md-9 d-flex align-content-center p-0"
                                      }
                                    >
                                      <span className="nn_upload_file">
                                        {sslcCerficates[0].SSLC_Path !== "" &&
                                          sslcCerficates[0].SSLC_Path !== null
                                          ? sslcCerficates[0].original_file_path
                                          : ""}
                                      </span>
                                      <span className="material-icons align-middle text-danger verified_upload">
                                        verified
                                      </span>
                                    </div>
                                  )}
                              </div>
                              {listErrors.SSLC_Path && (
                                <p className="errors">{listErrors.SSLC_Path}</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}
                {educationQualification.includes("HSC") && (
                  <section className="  sectionFive">
                    <div className="row box">
                      <div className="col-md-12">
                        <p className="StepTitle">HSC</p>
                        <div className="row">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="HSC_CNo">
                                Certificate Number
                              </label>
                              <input
                                ref={txtAdHslc}
                                id="HSC_CNo"
                                type="text"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                name="HSC_CNo"
                                className="Inputs"
                                onChange={(e) => handleEdu("hsc", e)}
                                placeholder="Certificate Number"
                                value={sslcCerficates[1].HSC_CNo}
                                autoComplete="Certificate Number"
                                required
                                minLength={10}
                                maxLength={10}
                              />
                              {listErrors.HSC_CNo && (
                                <p className="errors">{listErrors.HSC_CNo}</p>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="HSC_Year">Year of Passing</label>

                              {/* <input
                                ref={txtAdHpass}
                                id="HSC_Year"
                                type="month"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                name="HSC_Year"
                                className="Inputs"
                                onChange={(e) => handleEdu("hsc", e)}
                                placeholder="Year passing"
                                value={sslcCerficates[1].HSC_Year}
                                autoComplete="Yearpassing"
                                required
                              /> */}
                              <MonthDatePicker
                                handleYearChange={handleYearChange_month}
                                handleMonthChange={handleMonthChange_month}
                                minDate={
                                  sslcCerficates[0].SSLC_Year !== "" &&
                                    sslcCerficates[0].SSLC_Year !== null
                                    ? sslcCerficates[0].SSLC_Year
                                    : ""
                                }
                                disabledProperty={
                                  list.admission_status === 1 ? true : false
                                }
                                dname={"hsc"}
                                txtAdSpass={txtAdHpass}
                                name={"HSC_Year"}
                                handleChange={handleEYDate}
                                fieldInput={sslcCerficates[1].HSC_Year}
                              />
                              {listErrors.HSC_Year && (
                                <p className="errors">{listErrors.HSC_Year}</p>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="HSC_Marks">
                                Marks Percentage
                              </label>
                              <input
                                ref={txtAdHmarks}
                                id="HSC_Marks"
                                type="number"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                name="HSC_Marks"
                                className="Inputs"
                                onChange={(e) => handleEdu("hsc", e)}
                                onKeyDown={handleKeyDown}
                                placeholder="Marks Percentage"
                                value={sslcCerficates[1].HSC_Marks}
                                autoComplete="Marks Percentage"
                                required
                              />
                              {listErrors.HSC_Marks && (
                                <p className="errors">{listErrors.HSC_Marks}</p>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="HSC_Ebaord">
                                Education Board
                              </label>
                              <select
                                ref={txtAdHboard}
                                id="HSC_Ebaord"
                                name="HSC_Ebaord"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                className="Inputs"
                                onChange={(e) => handleEdu("hsc", e)}
                                defaultValue={sslcCerficates[1].HSC_Ebaord}
                                required
                              >
                                <option value="" disabled selected>
                                  Please select
                                </option>
                                <option className="StateBoard">
                                  State board
                                </option>
                                <option className="matriculation">
                                  Matriculation
                                </option>
                                <option className="CBSE">CBSE</option>
                                <option className="ICSE">ICSE</option>
                                <option className="others">others</option>
                              </select>
                              {/* <input
                                    id="HSC_Ebaord"
                                    type="text"
                                    name="HSC_Ebaord"
                                    className="Inputs"
                                    onChange={(e) => handleEdu("hsc", e)}
                                    placeholder="Education Borad"
                                    value={sslcCerficates[1].HSC_Ebaord}
                                    autoComplete="HSC_Ebaord"
                                    required
                                  /> */}
                              {listErrors.HSC_Ebaord && (
                                <p className="errors">
                                  {listErrors.HSC_Ebaord}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row mb-4 ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="HSC_MI">
                                Medium of Instruction
                              </label>
                              <select
                                ref={txtAdHins}
                                id="HSC_MI"
                                name="HSC_MI"
                                className="Inputs"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                onChange={(e) => handleEdu("hsc", e)}
                                defaultValue={sslcCerficates[1].HSC_MI}
                                required
                              >
                                <option value="" disabled selected>
                                  Please select
                                </option>
                                <option className="TM">Tamil Medium</option>
                                <option className="EM">English Medium</option>
                              </select>
                              {/* <input
                                    id="HSC_MI"
                                    type="text"
                                    name="HSC_MI"
                                    className="Inputs"
                                    onChange={(e) => handleEdu("hsc", e)}
                                    placeholder="Medium Instruction"
                                    value={sslcCerficates[1].HSC_MI}
                                    autoComplete="Medium Instruction"
                                    required
                                  /> */}
                              {listErrors.HSC_MI && (
                                <p className="errors">{listErrors.HSC_MI}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="HSC_Scl">School Name</label>
                              <input
                                ref={txtAdHschool}
                                id="HSC_Scl"
                                type="text"
                                name="HSC_Scl"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                className="Inputs"
                                onChange={(e) => handleEdu("hsc", e)}
                                placeholder="School Name"
                                value={sslcCerficates[1].HSC_Scl}
                                autoComplete="SchoolName"
                                required
                              />
                              {listErrors.HSC_Scl && (
                                <p className="errors">{listErrors.HSC_Scl}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="HSC_Path">
                                Upload HSC Certificate (In pdf/Image format){" "}
                                <span className="optionFields">(Optional)</span>
                                {sslcCerficates[1].HSC_Path !== "" &&
                                  sslcCerficates[1].HSC_Path !== null && (
                                    <a
                                      href={`${ImageUrlPrefix}/${sslcCerficates[1].HSC_Path}`}
                                      target="_blank"
                                      download
                                    >
                                      <span className="material-icons download_icon align-middle text-danger">
                                        file_download
                                      </span>
                                    </a>
                                  )}
                              </label>
                              <div className="row">
                                <div
                                  className={
                                    sslcCerficates[1].HSC_Path !== "" &&
                                      sslcCerficates[1].HSC_Path !== null
                                      ? "col-md-3 "
                                      : "col-md-12"
                                  }
                                >
                                  <input
                                    ref={txtAdHfile}
                                    id="HSC_Path"
                                    type="file"
                                    name="HSC_Path"
                                    className={
                                      sslcCerficates[1].HSC_Path !== "" &&
                                        sslcCerficates[1].HSC_Path !== null
                                        ? "InputsFile nn_upload_width"
                                        : "InputsFile  vv_upload_width"
                                    }
                                    onChange={(e) => handleEdu("hsc", e)}
                                    placeholder="HSC_Path"
                                    autoComplete="HSC_Path"
                                    disabled={
                                      list.admission_status === 1 ? true : false
                                    }
                                    required
                                  />
                                </div>
                                {sslcCerficates[1].HSC_Path !== "" &&
                                  sslcCerficates[1].HSC_Path !== null && (
                                    <div
                                      className={
                                        "col-md-9 d-flex align-content-center p-0"
                                      }
                                    >
                                      <span className="nn_upload_file">
                                        {sslcCerficates[1].HSC_Path !== "" &&
                                          sslcCerficates[1].HSC_Path !== null
                                          ? sslcCerficates[1].original_file_path
                                          : ""}
                                      </span>
                                      <span className="material-icons align-middle text-danger verified_upload">
                                        verified
                                      </span>
                                    </div>
                                  )}
                              </div>
                              {listErrors.HSC_Path && (
                                <p className="errors">{listErrors.HSC_Path}</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                {educationQualification.includes("UG") && (
                  <section className=" sectionFive">
                    <div className="row box">
                      <div className="col-md-12">
                        <p className="StepTitle">UG</p>
                        <div className="row ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms">
                              <label htmlFor="UGDegree">Degree</label>
                              <Select
                                ref={txtAdUdeg}
                                id="UGDegree"
                                name="UGDegree"
                                isDisabled={
                                  list.admission_status === 1 ? true : false
                                }
                                value={ugOption.UG} // Use ugOption.ug as the value
                                onChange={(option) =>
                                  handleEdus(option, "UG", "UGDegree")
                                }
                                options={ugDegree.sort((a, b) =>
                                  a.label.localeCompare(b.label)
                                )} // Sort options alphabetically by label
                                isSearchable={true} // Enables search functionality
                                placeholder="Select an option"
                                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                filterOption={(option, searchText) =>
                                  option.label
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                } // Filter options based on the search text
                                styles={customStyles} // Apply custom styles her
                              />

                              {/* {!uGisOther ? (
                              
                              ) : (

                                <input
                                  ref={txtAdUdeg}
                                  id="UGDegree"
                                  name="UGDegree"
                                  type="text"
                                  disabled={
                                    list.admission_status === 1
                                      ? true
                                      : false
                                  }
                                  className="Inputs"
                                  placeholder="Please enter degree"
                                  onChange={(e) => handleEdu("UG", e)}
                                  value={sslcCerficates[2].UGDegree}
                                  required
                                />

                              )} */}
                              {listErrors.UGDegree && (
                                <p className="errors">{listErrors.UGDegree}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="UGMajor">Major</label>
                              <Select
                                ref={txtAdUMaj}
                                id="UGMajor"
                                isDisabled={
                                  list.admission_status === 1 ? true : false
                                }
                                name="UGMajor"
                                value={mOption.UGMajor}
                                onChange={(option) =>
                                  handleEduMajor(option, "UG", "UGMajor")
                                }
                                options={major.sort((a, b) =>
                                  a.label.localeCompare(b.label)
                                )} // Sort options alphabetically by label
                                isSearchable={true} // Enables search functionality
                                placeholder="Select an option"
                                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                filterOption={(option, searchText) =>
                                  option.label
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                } // Filter options based on the search text
                                styles={customStyles} // Apply custom styles her
                              />

                              {listErrors.UGMajor && (
                                <p className="errors">{listErrors.UGMajor}</p>
                              )}
                            </div>
                          </div>
                          {uGisOther && (
                            <div className="col-md-6 col-sm-12">
                              <div className="forms ">
                                <label htmlFor="UGMajor_Other">
                                  Major(Other)
                                </label>
                                <input
                                  ref={txtAdUMajOther}
                                  id="UGMajor_Other"
                                  type="text"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  name="UGMajor_Other"
                                  className="Inputs"
                                  onChange={(e) => handleEdu("UG", e)}
                                  placeholder="Year passing"
                                  value={sslcCerficates[2].UGMajor_Other}
                                  required
                                />
                                {listErrors.UGMajor_Other && (
                                  <p className="errors">
                                    {listErrors.UGMajor_Other}
                                  </p>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="row ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="UGYearpassing">
                                Year of Passing
                              </label>

                              {/* <input
                                ref={txtAdUpass}
                                id="UGYearpassing"
                                type="month"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                name="UGYearpassing"
                                className="Inputs"
                                onChange={(e) => handleEdu("UG", e)}
                                placeholder="Year passing"
                                value={sslcCerficates[2].UGYearpassing}
                                autoComplete="Yearpassing"
                                required
                              /> */}
                              <MonthDatePicker
                                handleYearChange={handleYearChange_month}
                                handleMonthChange={handleMonthChange_month}
                                minDate={
                                  sslcCerficates[1].HSC_Year !== "" &&
                                    sslcCerficates[1].HSC_Year !== null
                                    ? sslcCerficates[1].HSC_Year
                                    : sslcCerficates[0].SSLC_Year !== "" &&
                                      sslcCerficates[0].SSLC_Year !== null
                                      ? sslcCerficates[0].SSLC_Year
                                      : ""
                                }
                                disabledProperty={
                                  list.admission_status === 1 ? true : false
                                }
                                dname={"UG"}
                                txtAdSpass={txtAdUpass}
                                name={"UGYearpassing"}
                                handleChange={handleEYDate}
                                fieldInput={sslcCerficates[2].UGYearpassing}
                              />
                              {listErrors.UGYearpassing && (
                                <p className="errors">
                                  {listErrors.UGYearpassing}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="UGCertificateNumber">
                                Certificate Number
                              </label>
                              <input
                                ref={txtAdUCer}
                                id="UGCertificateNumber"
                                type="text"
                                name="UGCertificateNumber"
                                className="Inputs"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                onChange={(e) => handleEdu("UG", e)}
                                placeholder="Certificate Number"
                                value={sslcCerficates[2].UGCertificateNumber}
                                minLength={10}
                                maxLength={10}
                                autoComplete="UGCertificate Number"
                                required
                              />
                              {listErrors.UGCertificateNumber && (
                                <p className="errors">
                                  {listErrors.UGCertificateNumber}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="UGMarksPercentage">
                                Marks Percentage
                              </label>
                              <input
                                ref={txtAdUmarks}
                                id="UGMarksPercentage"
                                type="number"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                name="UGMarksPercentage"
                                className="Inputs"
                                onChange={(e) => handleEdu("UG", e)}
                                onKeyDown={handleKeyDown}
                                placeholder="Marks Percentage"
                                value={sslcCerficates[2].UGMarksPercentage}
                                autoComplete="Marks Percentage"
                                required
                              />
                              {listErrors.UGMarksPercentage && (
                                <p className="errors">
                                  {listErrors.UGMarksPercentage}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="UGClassName">Class</label>
                              <Select
                                ref={txtAdUclass}
                                id="UGClassName"
                                type="text"
                                isDisabled={
                                  list.admission_status === 1 ? true : false
                                }
                                name="UGClassName"
                                value={mOption.UGClassName}
                                onChange={(option) =>
                                  handleEduMajor(option, "UG", "UGClassName")
                                }
                                options={classOption.sort((a, b) =>
                                  a.label.localeCompare(b.label)
                                )} // Sort options alphabetically by label
                                isSearchable={true} // Enables search functionality
                                placeholder="Select an option"
                                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                filterOption={(option, searchText) =>
                                  option.label
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                } // Filter options based on the search text
                                styles={customStyles} // Apply custom styles her
                              />
                              {/* <select
                                     ref={txtAdUclass}
                                     id="UGClassName"
                                     type="text"
                                     disabled={
                                       list.admission_status === 1 ? true : false
                                     }
                                     name="UGClassName"
                                     className="Inputs"
                                     onChange={(e) => handleEdu("UG", e)}
                                     placeholder="Class"
                                     value={sslcCerficates[2].UGClassName}
                                     autoComplete="UGClassName"
                                     required
                                    >
                                      <option value="" disabled>
                                        Please select
                                      </option>
                                      {classOption}
                                    </select>
                                 */}
                              {listErrors.UGClassName && (
                                <p className="errors">
                                  {listErrors.UGClassName}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row mb-4 ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="UGNameInstitute">
                                Name of the college / university
                              </label>
                              <input
                                ref={txtAdUins}
                                id="UGNameInstitute"
                                type="text"
                                name="UGNameInstitute"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                className="Inputs"
                                onChange={(e) => handleEdu("UG", e)}
                                placeholder="Name of the college / university"
                                value={sslcCerficates[2].UGNameInstitute}
                                autoComplete="UGNameInstitute"
                                required
                              />
                              {listErrors.UGNameInstitute && (
                                <p className="errors">
                                  {listErrors.UGNameInstitute}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="UG_Path">
                                Upload Certificate (In pdf/Image format){" "}
                                <span className="optionFields">(Optional)</span>
                                {sslcCerficates[2].UG_Path !== "" &&
                                  sslcCerficates[2].UG_Path !== null && (
                                    <a
                                      href={`${ImageUrlPrefix}/${sslcCerficates[2].UG_Path}`}
                                      target="_blank"
                                      download
                                    >
                                      <span className="material-icons align-middle download_icon">
                                        file_download
                                      </span>
                                    </a>
                                  )}
                              </label>
                              <div className="row">
                                <div
                                  className={
                                    sslcCerficates[2].UG_Path !== "" &&
                                      sslcCerficates[2].UG_Path !== null
                                      ? "col-md-3 "
                                      : "col-md-12"
                                  }
                                >
                                  <input
                                    ref={txtAdUfile}
                                    id="UG_Path"
                                    type="file"
                                    name="UG_Path"
                                    disabled={
                                      list.admission_status === 1 ? true : false
                                    }
                                    className={
                                      sslcCerficates[2].UG_Path !== "" &&
                                        sslcCerficates[2].UG_Path !== null
                                        ? "InputsFile nn_upload_width"
                                        : "InputsFile  vv_upload_width"
                                    }
                                    onChange={(e) => handleEdu("UG", e)}
                                    placeholder="UG_Path"
                                    autoComplete="UG_Path"
                                    required
                                  />
                                </div>
                                {sslcCerficates[2].UG_Path !== "" &&
                                  sslcCerficates[2].UG_Path !== null && (
                                    <div
                                      className={
                                        "col-md-9 d-flex align-content-center p-0"
                                      }
                                    >
                                      <span className="nn_upload_file">
                                        {sslcCerficates[2].UG_Path !== "" &&
                                          sslcCerficates[2].UG_Path !== null
                                          ? sslcCerficates[2].original_file_path
                                          : ""}
                                      </span>
                                      <span className="material-icons align-middle text-danger verified_upload">
                                        verified
                                      </span>
                                    </div>
                                  )}
                              </div>

                              {listErrors.UG_Path && (
                                <p className="errors">{listErrors.UG_Path}</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                {educationQualification.includes("PG") && (
                  <section className=" sectionFive">
                    <div className="row box">
                      <div className="col-md-12">
                        <p className="StepTitle">PG</p>
                        <div className="row ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="PGDegree">Degree</label>
                              <Select
                                id="PGDegree"
                                isDisabled={
                                  list.admission_status === 1 ? true : false
                                }
                                ref={txtAdPdeg}
                                name="PGDegree"
                                value={ugOption.PG} // Use ugOption.ug as the value
                                onChange={(option) =>
                                  handleEdus(option, "PG", "PGDegree")
                                }
                                options={pgDegree.sort((a, b) =>
                                  a.label.localeCompare(b.label)
                                )} // Sort options alphabetically by label
                                isSearchable={true} // Enables search functionality
                                placeholder="Select an option"
                                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                filterOption={(option, searchText) =>
                                  option.label
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                } // Filter options based on the search text
                                styles={customStyles} // Apply custom styles her
                              />
                              {/* {!pGisOther ? (
                                
                              ) : (

                                <input
                                  ref={txtAdPdeg}
                                  name="PGDegree"
                                  id="PGDegree"
                                  type="text"
                                  disabled={
                                    list.admission_status === 1
                                      ? true
                                      : false
                                  }
                                  className="Inputs"
                                  placeholder="Please enter degree"
                                  onChange={(e) => handleEdu("PG", e)}
                                  value={sslcCerficates[3].PGDegree}
                                  required
                                />

                              )} */}
                              {/* <select
                                    id="PGDegree"
                                    disabled={
                                      list.admission_status === 1 ? true : false
                                    }
                                    ref={txtAdPdeg}
                                    name="PGDegree"
                                    className="Inputs"
                                    onChange={(e) => handleEdu("PG", e)}
                                    defaultValue={sslcCerficates[3].PGDegree}
                                    required
                                  >
                                    <option value="" disabled selected>
                                      Please select
                                    </option>
                                    {pgDegree}
                                  </select> */}

                              {listErrors.PGDegree && (
                                <p className="errors">{listErrors.PGDegree}</p>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="PGMajor">Major</label>
                              <Select
                                id="PGMajor"
                                name="PGMajor"
                                isDisabled={
                                  list.admission_status === 1 ? true : false
                                }
                                ref={txtAdPMaj}
                                value={mOption.PGMajor} // Use ugOption.ug as the value
                                onChange={(option) =>
                                  handleEduMajor(option, "PG", "PGMajor")
                                }
                                options={pgMajor.sort((a, b) =>
                                  a.label.localeCompare(b.label)
                                )} // Sort options alphabetically by label
                                isSearchable={true} // Enables search functionality
                                placeholder="Select an option"
                                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                filterOption={(option, searchText) =>
                                  option.label
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                } // Filter options based on the search text
                                styles={customStyles} // Apply custom styles her
                              />
                              {listErrors.PGMajor && (
                                <p className="errors">{listErrors.PGMajor}</p>
                              )}
                            </div>
                          </div>

                          {pGisOther && (
                            <div className="col-md-6 col-sm-12">
                              <div className="forms ">
                                <label htmlFor="PGMajor_Other">Major</label>
                                <input
                                  type="text"
                                  id="PGMajor_Other"
                                  name="PGMajor_Other"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  ref={txtAdPMajOther}
                                  className="Inputs"
                                  onChange={(e) => handleEdu("PG", e)}
                                  defaultValue={sslcCerficates[3].PGMajor_Other}
                                  required
                                  placeholder="Please enter major"
                                />

                                {listErrors.PGMajor_Other && (
                                  <p className="errors">
                                    {listErrors.PGMajor_Other}
                                  </p>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="row ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="PGYearpassing">
                                Year of Passing
                              </label>
                              {/* <input
                                ref={txtAdPpass}
                                id="PGYearpassing"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                type="month"
                                name="PGYearpassing"
                                className="Inputs"
                                onChange={(e) => handleEdu("PG", e)}
                                placeholder="Year passing"
                                value={sslcCerficates[3].PGYearpassing}
                                autoComplete="Yearpassing"
                                required
                              /> */}
                              <MonthDatePicker
                                handleYearChange={handleYearChange_month}
                                handleMonthChange={handleMonthChange_month}
                                minDate={
                                  sslcCerficates[1].HSC_Year !== "" &&
                                    sslcCerficates[1].HSC_Year !== null
                                    ? sslcCerficates[1].HSC_Year
                                    : sslcCerficates[0].SSLC_Year !== "" &&
                                      sslcCerficates[0].SSLC_Year !== null
                                      ? sslcCerficates[0].SSLC_Year
                                      : ""
                                }
                                disabledProperty={
                                  list.admission_status === 1 ? true : false
                                }
                                dname={"PG"}
                                txtAdSpass={txtAdPpass}
                                name={"PGYearpassing"}
                                handleChange={handleEYDate}
                                fieldInput={sslcCerficates[3].PGYearpassing}
                              />
                              {listErrors.PGYearpassing && (
                                <p className="errors">
                                  {listErrors.PGYearpassing}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="PGCertificateNumber">
                                Certificate Number
                              </label>
                              <input
                                ref={txtAdPCer}
                                id="PGCertificateNumber"
                                type="text"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                name="PGCertificateNumber"
                                className="Inputs"
                                onChange={(e) => handleEdu("PG", e)}
                                placeholder="Certificate Number"
                                value={sslcCerficates[3].PGCertificateNumber}
                                autoComplete="Certificate Number"
                                required
                                minLength={10}
                                maxLength={10}
                              />
                              {listErrors.PGCertificateNumber && (
                                <p className="errors">
                                  {listErrors.PGCertificateNumber}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="PGMarksPercentage">
                                Marks Percentage
                              </label>
                              <input
                                ref={txtAdPmarks}
                                id="PGMarksPercentage"
                                type="number"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                name="PGMarksPercentage"
                                className="Inputs"
                                onChange={(e) => handleEdu("PG", e)}
                                onKeyDown={handleKeyDown}
                                placeholder="Marks Percentage"
                                value={sslcCerficates[3].PGMarksPercentage}
                                autoComplete="Marks Percentage"
                                required
                              />
                              {listErrors.PGMarksPercentage && (
                                <p className="errors">
                                  {listErrors.PGMarksPercentage}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="PGClassName">Class</label>
                              <Select
                                ref={txtAdPclass}
                                id="PGClassName"
                                type="text"
                                isDisabled={
                                  list.admission_status === 1 ? true : false
                                }
                                name="PGClassName"
                                value={mOption.PGClassName}
                                onChange={(option) =>
                                  handleEduMajor(option, "PG", "PGClassName")
                                }
                                options={classOption.sort((a, b) =>
                                  a.label.localeCompare(b.label)
                                )} // Sort options alphabetically by label
                                isSearchable={true} // Enables search functionality
                                placeholder="Select an option"
                                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                filterOption={(option, searchText) =>
                                  option.label
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                } // Filter options based on the search text
                                styles={customStyles} // Apply custom styles her
                              />
                              {listErrors.PGClassName && (
                                <p className="errors">
                                  {listErrors.PGClassName}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row mb-4 ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="PGNameInstitute">
                                Name of the college / university
                              </label>
                              <input
                                ref={txtAdPins}
                                id="PGNameInstitute"
                                type="text"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                name="PGNameInstitute"
                                className="Inputs"
                                onChange={(e) => handleEdu("PG", e)}
                                placeholder="Name of the college / university"
                                value={sslcCerficates[3].PGNameInstitute}
                                autoComplete="PGNameInstitute"
                                required
                              />
                              {listErrors.PGNameInstitute && (
                                <p className="errors">
                                  {listErrors.PGNameInstitute}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="PG_Path">
                                Upload Certificate (In pdf/Image format){" "}
                                <span className="optionFields">(Optional)</span>
                                {sslcCerficates[3].PG_Path !== "" &&
                                  sslcCerficates[3].PG_Path !== null && (
                                    <a
                                      href={`${ImageUrlPrefix}/${sslcCerficates[3].PG_Path}`}
                                      target="_blank"
                                      download
                                    >
                                      <span className="material-icons align-middle download_icon">
                                        file_download
                                      </span>
                                    </a>
                                  )}
                              </label>
                              <div className="row">
                                <div
                                  className={
                                    sslcCerficates[3].PG_Path !== "" &&
                                      sslcCerficates[3].PG_Path !== null
                                      ? "col-md-3 "
                                      : "col-md-12"
                                  }
                                >
                                  <input
                                    ref={txtAdPfile}
                                    id="PG_Path"
                                    type="file"
                                    disabled={
                                      list.admission_status === 1 ? true : false
                                    }
                                    name="PG_Path"
                                    className={
                                      sslcCerficates[3].PG_Path !== "" &&
                                        sslcCerficates[3].PG_Path !== null
                                        ? "InputsFile nn_upload_width"
                                        : "InputsFile  vv_upload_width"
                                    }
                                    onChange={(e) => handleEdu("PG", e)}
                                    placeholder="Path"
                                    autoComplete="Path"
                                    required
                                  />
                                </div>
                                {sslcCerficates[3].PG_Path !== "" &&
                                  sslcCerficates[3].PG_Path !== null && (
                                    <div
                                      className={
                                        "col-md-9 d-flex align-content-center p-0"
                                      }
                                    >
                                      <span className="nn_upload_file">
                                        {sslcCerficates[3].PG_Path !== "" &&
                                          sslcCerficates[3].PG_Path !== null
                                          ? sslcCerficates[3].original_file_path
                                          : ""}
                                      </span>
                                      <span className="material-icons align-middle text-danger verified_upload">
                                        verified
                                      </span>
                                    </div>
                                  )}
                              </div>

                              {listErrors.PG_Path && (
                                <p className="errors">{listErrors.PG_Path}</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                {educationQualification.includes("Integrated PG") && (
                  <section className=" sectionFive">
                    <div className="row box">
                      <div className="col-md-12">
                        <p className="StepTitle">Integrated PG</p>

                        <div className="row ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="IPDegree">Degree</label>
                              <Select
                                ref={txtAdIdeg}
                                id="IPDegree"
                                name="IPDegree"
                                isDisabled={
                                  list.admission_status === 1 ? true : false
                                }
                                value={ugOption.Integrated_PG} // Use ugOption.ug as the value
                                onChange={(option) =>
                                  handleEdus(
                                    option,
                                    "Integrated PG",
                                    "IPDegree"
                                  )
                                }
                                options={ipgDegree.sort((a, b) =>
                                  a.label.localeCompare(b.label)
                                )} // Sort options alphabetically by label
                                isSearchable={true} // Enables search functionality
                                placeholder="Select an option"
                                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                filterOption={(option, searchText) =>
                                  option.label
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                } // Filter options based on the search text
                                styles={customStyles} // Apply custom styles her
                              />
                              {/* {!iPGisOther ? (
                              
                              ) : (

                                <input
                                  ref={txtAdIdeg}
                                  id="IPDegree"
                                  name="IPDegree"
                                  type="text"
                                  disabled={
                                    list.admission_status === 1
                                      ? true
                                      : false
                                  }
                                  className="Inputs"
                                  placeholder="Please enter degree"
                                  onChange={(e) =>
                                    handleEdu("Integrated PG", e)
                                  }
                                  value={sslcCerficates[4].IPDegree}
                                  required
                                />

                              )} */}

                              {/* <select
                                    ref={txtAdIdeg}
                                    id="IPDegree"
                                    name="IPDegree"
                                    disabled={
                                      list.admission_status === 1 ? true : false
                                    }
                                    className="Inputs"
                                    onChange={(e) =>
                                      handleEdu("Integrated PG", e)
                                    }
                                    value={sslcCerficates[4].IPDegree}
                                    required
                                  >
                                    <option value="" disabled selected>
                                      Please select
                                    </option>
                                    {ipgDegree}
                                  </select> */}

                              {listErrors.IPDegree && (
                                <p className="errors">{listErrors.IPDegree}</p>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="IPMajor">Major</label>
                              <Select
                                ref={txtAdIMaj}
                                id="IPMajor"
                                name="IPMajor"
                                isDisabled={
                                  list.admission_status === 1 ? true : false
                                }
                                value={mOption.IPMajor} // Use ugOption.ug as the value
                                onChange={(option) =>
                                  handleEduMajor(
                                    option,
                                    "Integrated PG",
                                    "IPMajor"
                                  )
                                }
                                options={ipMajor.sort((a, b) =>
                                  a.label.localeCompare(b.label)
                                )} // Sort options alphabetically by label
                                isSearchable={true} // Enables search functionality
                                placeholder="Select an option"
                                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                filterOption={(option, searchText) =>
                                  option.label
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                } // Filter options based on the search text
                                styles={customStyles} // Apply custom styles her
                              />
                              {listErrors.IPMajor && (
                                <p className="errors">{listErrors.IPMajor}</p>
                              )}
                            </div>
                          </div>

                          {iPGisOther && (
                            <div className="col-md-6 col-sm-12">
                              <div className="forms ">
                                <label htmlFor="IPMajor_Other">Major</label>
                                <input
                                  type="text"
                                  ref={txtAdIMajOther}
                                  id="IPMajor_Other"
                                  name="IPMajor_Other"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  className="Inputs"
                                  onChange={(e) =>
                                    handleEdu("Integrated PG", e)
                                  }
                                  value={sslcCerficates[4].IPMajor_Other}
                                  required
                                  placeholder="Please enter major"
                                />
                                {listErrors.IPMajor_Other && (
                                  <p className="errors">
                                    {listErrors.IPMajor_Other}
                                  </p>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="row ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="IPYearpassing">
                                Year of Passing
                              </label>

                              {/* <input
                                ref={txtAdIpass}
                                id="IPYearpassing"
                                type="month"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                name="IPYearpassing"
                                className="Inputs"
                                onChange={(e) =>
                                  handleEdu("Integrated PG", e)
                                }
                                placeholder="Year passing"
                                value={sslcCerficates[4].IPYearpassing}
                                autoComplete="Yearpassing"
                                required
                              /> */}
                              <MonthDatePicker
                                handleYearChange={handleYearChange_month}
                                handleMonthChange={handleMonthChange_month}
                                minDate={
                                  sslcCerficates[1].HSC_Year !== "" &&
                                    sslcCerficates[1].HSC_Year !== null
                                    ? sslcCerficates[1].HSC_Year
                                    : sslcCerficates[0].SSLC_Year !== "" &&
                                      sslcCerficates[0].SSLC_Year !== null
                                      ? sslcCerficates[0].SSLC_Year
                                      : ""
                                }
                                disabledProperty={
                                  list.admission_status === 1 ? true : false
                                }
                                dname={"Integrated PG"}
                                txtAdSpass={txtAdIpass}
                                name={"IPYearpassing"}
                                handleChange={handleEYDate}
                                fieldInput={sslcCerficates[4].IPYearpassing}
                              />
                              {listErrors.IPYearpassing && (
                                <p className="errors">
                                  {listErrors.IPYearpassing}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="IPCertificateNumber">
                                Certificate Number
                              </label>
                              <input
                                ref={txtAdICer}
                                id="IPCertificateNumber"
                                type="text"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                name="IPCertificateNumber"
                                className="Inputs"
                                onChange={(e) => handleEdu("Integrated PG", e)}
                                placeholder="Certificate Number"
                                value={sslcCerficates[4].IPCertificateNumber}
                                autoComplete="Certificate Number"
                                required
                                minLength={10}
                                maxLength={10}
                              />
                              {listErrors.IPCertificateNumber && (
                                <p className="errors">
                                  {listErrors.IPCertificateNumber}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="IPMarksPercentage">
                                Marks Percentage
                              </label>
                              <input
                                ref={txtAdImarks}
                                id="IPMarksPercentage"
                                type="number"
                                name="IPMarksPercentage"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                className="Inputs"
                                onChange={(e) => handleEdu("Integrated PG", e)}
                                onKeyDown={handleKeyDown}
                                placeholder="Marks Percentage"
                                value={sslcCerficates[4].IPMarksPercentage}
                                autoComplete="Marks Percentage"
                                required
                              />
                              {listErrors.IPMarksPercentage && (
                                <p className="errors">
                                  {listErrors.IPMarksPercentage}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="IPClassName">Class</label>
                              <Select
                                ref={txtAdIclass}
                                id="IPClassName"
                                type="text"
                                name="IPClassName"
                                isDisabled={
                                  list.admission_status === 1 ? true : false
                                }
                                value={mOption.IPClassName}
                                onChange={(option) =>
                                  handleEduMajor(
                                    option,
                                    "Integrated PG",
                                    "IPClassName"
                                  )
                                }
                                options={classOption.sort((a, b) =>
                                  a.label.localeCompare(b.label)
                                )} // Sort options alphabetically by label
                                isSearchable={true} // Enables search functionality
                                placeholder="Select an option"
                                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                filterOption={(option, searchText) =>
                                  option.label
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                } // Filter options based on the search text
                                styles={customStyles} // Apply custom styles her
                              />

                              {/* <input
                                    ref={txtAdIclass}
                                    id="IPClassName"
                                    type="text"
                                    name="IPClassName"
                                    disabled={
                                      list.admission_status === 1 ? true : false
                                    }
                                    className="Inputs"
                                    onChange={(e) =>
                                      handleEdu("Integrated PG", e)
                                    }
                                    placeholder="Class Name"
                                    value={sslcCerficates[4].IPClassName}
                                    autoComplete="SchoolName"
                                    required
                                  /> */}
                              {listErrors.IPClassName && (
                                <p className="errors">
                                  {listErrors.IPClassName}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row mb-4 ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="IPNameInstitute">
                                Name of the college / university
                              </label>
                              <input
                                ref={txtAdIins}
                                id="IPNameInstitute"
                                type="text"
                                name="IPNameInstitute"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                className="Inputs"
                                onChange={(e) => handleEdu("Integrated PG", e)}
                                placeholder="Name of the college / university"
                                value={sslcCerficates[4].IPNameInstitute}
                                autoComplete="IPNameInstitute"
                                required
                              />
                              {listErrors.IPNameInstitute && (
                                <p className="errors">
                                  {listErrors.IPNameInstitute}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="IP_Path">
                                Upload Certificate (In pdf/Image format){" "}
                                <span className="optionFields">(Optional)</span>
                                {sslcCerficates[4].IP_Path !== "" &&
                                  sslcCerficates[4].IP_Path !== null && (
                                    <a
                                      href={`${ImageUrlPrefix}/${sslcCerficates[4].IP_Path}`}
                                      target="_blank"
                                      download
                                    >
                                      <span className="material-icons align-middle download_icon">
                                        file_download
                                      </span>
                                    </a>
                                  )}
                              </label>
                              <div className="row">
                                <div
                                  className={
                                    sslcCerficates[4].IP_Path !== "" &&
                                      sslcCerficates[4].IP_Path !== null
                                      ? "col-md-3 "
                                      : "col-md-12"
                                  }
                                >
                                  <input
                                    ref={txtAdIfile}
                                    id="IP_Path"
                                    type="file"
                                    name="IP_Path"
                                    className={
                                      sslcCerficates[4].IP_Path !== "" &&
                                        sslcCerficates[4].IP_Path !== null
                                        ? "InputsFile nn_upload_width"
                                        : "InputsFile  vv_upload_width"
                                    }
                                    disabled={
                                      list.admission_status === 1 ? true : false
                                    }
                                    onChange={(e) =>
                                      handleEdu("Integrated PG", e)
                                    }
                                    placeholder="Path"
                                    autoComplete="Path"
                                    required
                                  />
                                </div>
                                {sslcCerficates[4].IP_Path !== "" &&
                                  sslcCerficates[4].IP_Path !== null && (
                                    <div
                                      className={
                                        "col-md-9 d-flex align-content-center p-0"
                                      }
                                    >
                                      <span className="nn_upload_file">
                                        {sslcCerficates[4].IP_Path !== "" &&
                                          sslcCerficates[4].IP_Path !== null
                                          ? sslcCerficates[4].original_file_path
                                          : ""}
                                      </span>
                                      <span className="material-icons align-middle text-danger verified_upload">
                                        verified
                                      </span>
                                    </div>
                                  )}
                              </div>

                              {listErrors.IP_Path && (
                                <p className="errors">{listErrors.IP_Path}</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                {educationQualification.includes("Diploma") && (
                  <section className="sectionFive">
                    <div className="row box">
                      <div className="col-md-12">
                        <p className="StepTitle">Diploma</p>

                        <div className="row ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="DDegree">Diploma</label>
                              <Select
                                ref={txtAdDdeg}
                                id="DDegree"
                                name="DDegree"
                                isDisabled={
                                  list.admission_status === 1 ? true : false
                                }
                                value={ugOption.Diploma} // Use ugOption.ug as the value
                                onChange={(option) =>
                                  handleEdus(option, "Diploma", "DDegree")
                                }
                                options={diplomaDegree.sort((a, b) =>
                                  a.label.localeCompare(b.label)
                                )} // Sort options alphabetically by label
                                isSearchable={true} // Enables search functionality
                                placeholder="Select an option"
                                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                filterOption={(option, searchText) =>
                                  option.label
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                } // Filter options based on the search text
                                styles={customStyles} // Apply custom styles her
                              />
                              {/* {!dipisOther ? (
                              
                              ) : (

                                <input
                                  ref={txtAdDdeg}
                                  id="DDegree"
                                  name="DDegree"
                                  type="text"
                                  disabled={
                                    list.admission_status === 1
                                      ? true
                                      : false
                                  }
                                  className="Inputs"
                                  placeholder="Please enter degree"
                                  onChange={(e) => handleEdu("Diploma", e)}
                                  value={sslcCerficates[5].DDegree}
                                  required
                                />

                              )} */}
                              {/* <select
                                    ref={txtAdDdeg}
                                    id="DDegree"
                                    name="DDegree"
                                    disabled={
                                      list.admission_status === 1 ? true : false
                                    }
                                    className="Inputs"
                                    onChange={(e) => handleEdu("Diploma", e)}
                                    value={sslcCerficates[5].DDegree}
                                    required
                                  >
                                    <option value="" disabled selected>
                                      Please select
                                    </option>
                                    {diplomaDegree}
                                  </select> */}

                              {listErrors.DDegree && (
                                <p className="errors">{listErrors.DDegree}</p>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="DMajor">Major</label>
                              <Select
                                ref={txtAdDMaj}
                                id="DMajor"
                                name="DMajor"
                                isDisabled={
                                  list.admission_status === 1 ? true : false
                                }
                                value={mOption.DMajor} // Use ugOption.ug as the value
                                onChange={(option) =>
                                  handleEduMajor(option, "Diploma", "DMajor")
                                }
                                options={dmajor.sort((a, b) =>
                                  a.label.localeCompare(b.label)
                                )} // Sort options alphabetically by label
                                isSearchable={true} // Enables search functionality
                                placeholder="Select an option"
                                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                filterOption={(option, searchText) =>
                                  option.label
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                } // Filter options based on the search text
                                styles={customStyles} // Apply custom styles her
                              />

                              {listErrors.DMajor && (
                                <p className="errors">{listErrors.DMajor}</p>
                              )}
                            </div>
                          </div>

                          {dipisOther && (
                            <div className="col-md-6 col-sm-12">
                              <div className="forms ">
                                <label htmlFor="DMajor_other">Major</label>
                                <input
                                  type="text"
                                  placeholder="Please Enter Major"
                                  ref={txtAdDMajOther}
                                  id="DMajor_other"
                                  name="DMajor_other"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  className="Inputs"
                                  onChange={(e) => handleEdu("Diploma", e)}
                                  value={sslcCerficates[5].DMajor_other}
                                  required
                                />
                                {listErrors.DMajor_other && (
                                  <p className="errors">
                                    {listErrors.DMajor_other}
                                  </p>
                                )}
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="row ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="DYearpassing">
                                Year of Passing
                              </label>

                              {/* <input
                                ref={txtAdDpass}
                                id="DYearpassing"
                                type="month"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                name="DYearpassing"
                                className="Inputs"
                                onChange={(e) => handleEdu("Diploma", e)}
                                placeholder="Year passing"
                                value={sslcCerficates[5].DYearpassing}
                                autoComplete="Yearpassing"
                                required
                              /> */}
                              <MonthDatePicker
                                handleYearChange={handleYearChange_month}
                                handleMonthChange={handleMonthChange_month}
                                minDate={
                                  sslcCerficates[1].HSC_Year !== "" &&
                                    sslcCerficates[1].HSC_Year !== null
                                    ? sslcCerficates[1].HSC_Year
                                    : sslcCerficates[0].SSLC_Year !== "" &&
                                      sslcCerficates[0].SSLC_Year !== null
                                      ? sslcCerficates[0].SSLC_Year
                                      : ""
                                }
                                disabledProperty={
                                  list.admission_status === 1 ? true : false
                                }
                                dname={"Diploma"}
                                txtAdSpass={txtAdDpass}
                                name={"DYearpassing"}
                                handleChange={handleEYDate}
                                fieldInput={sslcCerficates[5].DYearpassing}
                              />
                              {listErrors.DYearpassing && (
                                <p className="errors">
                                  {listErrors.DYearpassing}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="DCertificateNumber">
                                Certificate Number
                              </label>
                              <input
                                ref={txtAdDCer}
                                id="DCertificateNumber"
                                type="text"
                                name="DCertificateNumber"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                className="Inputs"
                                onChange={(e) => handleEdu("Diploma", e)}
                                placeholder="Certificate Number"
                                value={sslcCerficates[5].DCertificateNumber}
                                autoComplete="Certificate Number"
                                required
                                minLength={10}
                                maxLength={10}
                              />
                              {listErrors.DCertificateNumber && (
                                <p className="errors">
                                  {listErrors.DCertificateNumber}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="DMarksPercentage">
                                Marks Percentage
                              </label>
                              <input
                                ref={txtAdDmarks}
                                id="DMarksPercentage"
                                type="number"
                                name="DMarksPercentage"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                className="Inputs"
                                onChange={(e) => handleEdu("Diploma", e)}
                                onKeyDown={handleKeyDown}
                                placeholder="Marks Percentage"
                                value={sslcCerficates[5].DMarksPercentage}
                                autoComplete="Marks Percentage"
                                required
                              />
                              {listErrors.DMarksPercentage && (
                                <p className="errors">
                                  {listErrors.DMarksPercentage}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="DClassName">Class</label>
                              <Select
                                ref={txtAdDclass}
                                id="DClassName"
                                type="text"
                                name="DClassName"
                                isDisabled={
                                  list.admission_status === 1 ? true : false
                                }
                                value={mOption.DClassName}
                                onChange={(option) =>
                                  handleEduMajor(
                                    option,
                                    "Diploma",
                                    "DClassName"
                                  )
                                }
                                options={classOption.sort((a, b) =>
                                  a.label.localeCompare(b.label)
                                )} // Sort options alphabetically by label
                                isSearchable={true} // Enables search functionality
                                placeholder="Select an option"
                                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                filterOption={(option, searchText) =>
                                  option.label
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                } // Filter options based on the search text
                                styles={customStyles} // Apply custom styles her
                              />

                              {/* <input
                                    ref={txtAdDclass}
                                    id="DClassName"
                                    type="text"
                                    name="DClassName"
                                    disabled={
                                      list.admission_status === 1 ? true : false
                                    }
                                    className="Inputs"
                                    onChange={(e) => handleEdu("Diploma", e)}
                                    placeholder=" Class Name"
                                    value={sslcCerficates[5].DClassName}
                                    autoComplete="SchoolName"
                                    required
                                  /> */}
                              {listErrors.DClassName && (
                                <p className="errors">
                                  {listErrors.DClassName}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row mb-4 ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="DNameInstitute">
                                Name of the college / university
                              </label>
                              <input
                                ref={txtAdDins}
                                id="DNameInstitute"
                                type="text"
                                name="DNameInstitute"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                className="Inputs"
                                onChange={(e) => handleEdu("Diploma", e)}
                                placeholder="Name of the college / university"
                                value={sslcCerficates[5].DNameInstitute}
                                autoComplete="DNameInstitute"
                                required
                              />
                              {listErrors.DNameInstitute && (
                                <p className="errors">
                                  {listErrors.DNameInstitute}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="D_Path">
                                Upload Certificate (In pdf/Image format){" "}
                                <span className="optionFields">(Optional)</span>
                                {sslcCerficates[5].D_Path !== "" &&
                                  sslcCerficates[5].D_Path !== null && (
                                    <a
                                      href={`${ImageUrlPrefix}/${sslcCerficates[5].D_Path}`}
                                      target="_blank"
                                      download
                                    >
                                      <span className="material-icons align-middle download_icon">
                                        file_download
                                      </span>
                                    </a>
                                  )}
                              </label>
                              <div className="row">
                                <div
                                  className={
                                    sslcCerficates[5].D_Path !== "" &&
                                      sslcCerficates[5].D_Path !== null
                                      ? "col-md-3 "
                                      : "col-md-12"
                                  }
                                >
                                  <input
                                    ref={txtAdDfile}
                                    id="D_Path"
                                    type="file"
                                    name="D_Path"
                                    disabled={
                                      list.admission_status === 1 ? true : false
                                    }
                                    className={
                                      sslcCerficates[5].D_Path !== "" &&
                                        sslcCerficates[5].D_Path !== null
                                        ? "InputsFile nn_upload_width"
                                        : "InputsFile  vv_upload_width"
                                    }
                                    onChange={(e) => handleEdu("Diploma", e)}
                                    placeholder="Path"
                                    autoComplete="Path"
                                    required
                                  />
                                </div>
                                {sslcCerficates[5].D_Path !== "" &&
                                  sslcCerficates[5].D_Path !== null && (
                                    <div
                                      className={
                                        "col-md-9 d-flex align-content-center p-0"
                                      }
                                    >
                                      <span className="nn_upload_file">
                                        {sslcCerficates[5].D_Path !== "" &&
                                          sslcCerficates[5].D_Path !== null
                                          ? sslcCerficates[5].original_file_path
                                          : ""}
                                      </span>
                                      <span className="material-icons align-middle text-danger verified_upload">
                                        verified
                                      </span>
                                    </div>
                                  )}
                              </div>

                              {listErrors.D_Path && (
                                <p className="errors">{listErrors.D_Path}</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                {educationQualification.includes("Professional Courses") && (
                  <section className=" sectionFive">
                    <div className="row box">
                      <div className="col-md-12">
                        <p className="StepTitle">Professional Courses</p>

                        <div className="row ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="PCDegree">Degree</label>
                              <Select
                                ref={txtAdCdeg}
                                id="PCDegree"
                                name="PCDegree"
                                isDisabled={
                                  list.admission_status === 1 ? true : false
                                }
                                value={ugOption.Professional_Courses} // Use ugOption.ug as the value
                                onChange={(option) =>
                                  handleEdus(
                                    option,
                                    "Professional Courses",
                                    "PCDegree"
                                  )
                                }
                                options={pcDegree.sort((a, b) =>
                                  a.label.localeCompare(b.label)
                                )} // Sort options alphabetically by label
                                isSearchable={true} // Enables search functionality
                                placeholder="Select an option"
                                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                filterOption={(option, searchText) =>
                                  option.label
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                } // Filter options based on the search text
                                styles={customStyles} // Apply custom styles her
                              />
                              {/* {!pCisOther ? (
                                
                                ) : (

                                  <input
                                    ref={txtAdCdeg}
                                    id="PCDegree"
                                    name="PCDegree"
                                    type="text"
                                    disabled={
                                      list.admission_status === 1
                                        ? true
                                        : false
                                    }
                                    className="Inputs"
                                    placeholder="Please enter degree"
                                    onChange={(e) =>
                                      handleEdu("Professional Courses", e)
                                    }
                                    value={sslcCerficates[6].PCDegree}
                                    required
                                  />

                                )} */}
                              {/* <select
                                    ref={txtAdCdeg}
                                    id="PCDegree"
                                    name="PCDegree"
                                    className="Inputs"
                                    disabled={
                                      list.admission_status === 1 ? true : false
                                    }
                                    onChange={(e) =>
                                      handleEdu("Professional Courses", e)
                                    }
                                    value={sslcCerficates[6].PCDegree}
                                    required
                                  >
                                    <option value="" disabled selected>
                                      Please select
                                    </option>
                                    {pcDegree}
                                  </select> */}

                              {listErrors.PCDegree && (
                                <p className="errors">{listErrors.PCDegree}</p>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="PCMajor">Major</label>
                              <Select
                                ref={txtAdCMaj}
                                id="PCMajor"
                                name="PCMajor"
                                isDisabled={
                                  list.admission_status === 1 ? true : false
                                }
                                value={mOption.PCMajor} // Use ugOption.ug as the value
                                onChange={(option) =>
                                  handleEduMajor(
                                    option,
                                    "Professional Courses",
                                    "PCMajor"
                                  )
                                }
                                options={pcMajor.sort((a, b) =>
                                  a.label.localeCompare(b.label)
                                )} // Sort options alphabetically by label
                                isSearchable={true} // Enables search functionality
                                placeholder="Select an option"
                                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                filterOption={(option, searchText) =>
                                  option.label
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                } // Filter options based on the search text
                                styles={customStyles} // Apply custom styles her
                              />
                              {listErrors.PCMajor && (
                                <p className="errors">{listErrors.PCMajor}</p>
                              )}
                            </div>
                          </div>
                          {pCisOther && (
                            <div className="col-md-6 col-sm-12">
                              <div className="forms ">
                                <label htmlFor="PCMajor_Other">Major</label>
                                <input
                                  type="text"
                                  placeholder="Please Enter Major"
                                  ref={txtAdCMajOther}
                                  id="PCMajor_Other"
                                  name="PCMajor_Other"
                                  className="Inputs"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  onChange={(e) =>
                                    handleEdu("Professional Courses", e)
                                  }
                                  defaultValue={sslcCerficates[6].PCMajor_Other}
                                  required
                                />

                                {listErrors.PCMajor_Other && (
                                  <p className="errors">
                                    {listErrors.PCMajor_Other}
                                  </p>
                                )}
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="row ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="PCYearpassing">
                                Year of Passing
                              </label>

                              {/* <input
                                  ref={txtAdCpass}
                                  id="PCYearpassing"
                                  type="month"
                                  name="PCYearpassing"
                                  disabled={
                                    list.admission_status === 1 ? true : false
                                  }
                                  className="Inputs"
                                  onChange={(e) =>
                                    handleEdu("Professional Courses", e)
                                  }
                                  placeholder="Year passing"
                                  value={sslcCerficates[6].PCYearpassing}
                                  autoComplete="Yearpassing"
                                  required
                                /> */}
                              <MonthDatePicker
                                handleYearChange={handleYearChange_month}
                                handleMonthChange={handleMonthChange_month}
                                minDate={
                                  sslcCerficates[1].HSC_Year !== "" &&
                                    sslcCerficates[1].HSC_Year !== null
                                    ? sslcCerficates[1].HSC_Year
                                    : sslcCerficates[0].SSLC_Year !== "" &&
                                      sslcCerficates[0].SSLC_Year !== null
                                      ? sslcCerficates[0].SSLC_Year
                                      : ""
                                }
                                disabledProperty={
                                  list.admission_status === 1 ? true : false
                                }
                                dname={"Professional Courses"}
                                txtAdSpass={txtAdCpass}
                                name={"PCYearpassing"}
                                handleChange={handleEYDate}
                                fieldInput={sslcCerficates[6].PCYearpassing}
                              />
                              {listErrors.PCYearpassing && (
                                <p className="errors">
                                  {listErrors.PCYearpassing}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="PCCertificateNumber">
                                Certificate Number
                              </label>
                              <input
                                ref={txtAdCCer}
                                id="PCCertificateNumber"
                                type="text"
                                name="PCCertificateNumber"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                className="Inputs"
                                onChange={(e) =>
                                  handleEdu("Professional Courses", e)
                                }
                                placeholder="Certificate Number"
                                value={sslcCerficates[6].PCCertificateNumber}
                                autoComplete="Certificate Number"
                                required
                                minLength={10}
                                maxLength={10}
                              />
                              {listErrors.PCCertificateNumber && (
                                <p className="errors">
                                  {listErrors.PCCertificateNumber}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="PCMarksPercentage">
                                Marks Percentage
                              </label>
                              <input
                                ref={txtAdCmarks}
                                id="PCMarksPercentage"
                                type="number"
                                name="PCMarksPercentage"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                className="Inputs"
                                onChange={(e) =>
                                  handleEdu("Professional Courses", e)
                                }
                                onKeyDown={handleKeyDown}
                                placeholder="Marks Percentage"
                                value={sslcCerficates[6].PCMarksPercentage}
                                autoComplete="Marks Percentage"
                                required
                              />
                              {listErrors.PCMarksPercentage && (
                                <p className="errors">
                                  {listErrors.PCMarksPercentage}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="PCClassName">Class</label>
                              <Select
                                ref={txtAdCclass}
                                id="PCClassName"
                                type="text"
                                name="PCClassName"
                                isDisabled={
                                  list.admission_status === 1 ? true : false
                                }
                                value={mOption.PCClassName}
                                onChange={(option) =>
                                  handleEduMajor(
                                    option,
                                    "Professional Courses",
                                    "PCClassName"
                                  )
                                }
                                options={classOption.sort((a, b) =>
                                  a.label.localeCompare(b.label)
                                )} // Sort options alphabetically by label
                                isSearchable={true} // Enables search functionality
                                placeholder="Select an option"
                                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                filterOption={(option, searchText) =>
                                  option.label
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                } // Filter options based on the search text
                                styles={customStyles} // Apply custom styles her
                              />

                              {/* <input
                                    ref={txtAdCclass}
                                    id="PCClassName"
                                    type="text"
                                    name="PCClassName"
                                    disabled={
                                      list.admission_status === 1 ? true : false
                                    }
                                    className="Inputs"
                                    onChange={(e) =>
                                      handleEdu("Professional Courses", e)
                                    }
                                    placeholder="ClassName"
                                    value={sslcCerficates[6].PCClassName}
                                    autoComplete="PCClassName"
                                    required
                                  /> */}
                              {listErrors.PCClassName && (
                                <p className="errors">
                                  {listErrors.PCClassName}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row mb-4 ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="PCNameInstitute">
                                Name of the college / university
                              </label>
                              <input
                                ref={txtAdCins}
                                id="PCNameInstitute"
                                type="text"
                                name="PCNameInstitute"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                className="Inputs"
                                onChange={(e) =>
                                  handleEdu("Professional Courses", e)
                                }
                                placeholder="Name of the college / university"
                                value={sslcCerficates[6].PCNameInstitute}
                                autoComplete="PCNameInstitute"
                                required
                              />
                              {listErrors.PCNameInstitute && (
                                <p className="errors">
                                  {listErrors.PCNameInstitute}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="PC_Path">
                                Upload Certificate (In pdf/Image format){" "}
                                <span className="optionFields">(Optional)</span>
                                {sslcCerficates[6].PC_Path !== "" &&
                                  sslcCerficates[6].PC_Path !== null && (
                                    <a
                                      href={`${ImageUrlPrefix}/${sslcCerficates[6].PC_Path}`}
                                      target="_blank"
                                      download
                                    >
                                      <span className="material-icons align-middle download_icon">
                                        file_download
                                      </span>
                                    </a>
                                  )}
                              </label>
                              <div className="row">
                                <div
                                  className={
                                    sslcCerficates[6].PC_Path !== "" &&
                                      sslcCerficates[6].PC_Path !== null
                                      ? "col-md-3 "
                                      : "col-md-12"
                                  }
                                >
                                  <input
                                    ref={txtAdCfile}
                                    id="PC_Path"
                                    type="file"
                                    name="PC_Path"
                                    disabled={
                                      list.admission_status === 1 ? true : false
                                    }
                                    className={
                                      sslcCerficates[6].PC_Path !== "" &&
                                        sslcCerficates[6].PC_Path !== null
                                        ? "InputsFile nn_upload_width"
                                        : "InputsFile  vv_upload_width"
                                    }
                                    onChange={(e) =>
                                      handleEdu("Professional Courses", e)
                                    }
                                    placeholder="Path"
                                    autoComplete="Path"
                                    required
                                  />
                                </div>
                                {sslcCerficates[6].PC_Path !== "" &&
                                  sslcCerficates[6].PC_Path !== null && (
                                    <div
                                      className={
                                        "col-md-9 d-flex align-content-center p-0"
                                      }
                                    >
                                      <span className="nn_upload_file">
                                        {sslcCerficates[6].PC_Path !== "" &&
                                          sslcCerficates[6].PC_Path !== null
                                          ? sslcCerficates[6].original_file_path
                                          : ""}
                                      </span>
                                      <span className="material-icons align-middle text-danger verified_upload">
                                        verified
                                      </span>
                                    </div>
                                  )}
                              </div>

                              {listErrors.PC_Path && (
                                <p className="errors">{listErrors.PC_Path}</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                {educationQualification.includes("Others") && (
                  <section className=" sectionFive">
                    <div className="row box">
                      <div className="col-md-12">
                        <p className="StepTitle">Others</p>

                        <div className="row ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="OtDegree">Degree</label>
                              {/* <select
                                    ref={txtAdOdeg}
                                    id="OtDegree"
                                    name="OtDegree"
                                    disabled={
                                      list.admission_status === 1 ? true : false
                                    }
                                    className="Inputs"
                                    onChange={(e) => handleEdu("Others", e)}
                                    value={sslcCerficates[7].OtDegree}
                                    required
                                  >
                                    <option value="" disabled selected>
                                      Please select
                                    </option>
                                    {ugDegree}
                                  </select> */}

                              <input
                                ref={txtAdOdeg}
                                id="OtDegree"
                                name="OtDegree"
                                placeholder="Please Enter Degree name"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                className="Inputs"
                                onChange={(e) => handleEdu("Others", e)}
                                value={sslcCerficates[7].OtDegree}
                                required
                              />

                              {listErrors.OtDegree && (
                                <p className="errors">{listErrors.OtDegree}</p>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="OtMajor">Major</label>
                              {/* {sslcCerficates[7].OtDegree === "Others" ? (
                                  
                                  ) : (
                                    <select
                                      ref={txtAdOMaj}
                                      id="OtMajor"
                                      name="OtMajor"
                                      disabled={
                                        list.admission_status === 1
                                          ? true
                                          : false
                                      }
                                      className="Inputs"
                                      onChange={(e) => handleEdu("Others", e)}
                                      defaultValue={sslcCerficates[7].OtMajor}
                                      required
                                    >
                                      <option value="" disabled selected>
                                        Please select
                                      </option>
                                      {otMajor}
                                    </select>
                                  )} */}

                              <input
                                type="text"
                                placeholder="Please Enter Major"
                                ref={txtAdOMaj}
                                id="OtMajor"
                                name="OtMajor"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                className="Inputs"
                                onChange={(e) => handleEdu("Others", e)}
                                defaultValue={sslcCerficates[7].OtMajor}
                                required
                              />

                              {listErrors.OtMajor && (
                                <p className="errors">{listErrors.OtMajor}</p>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="OtYearpassing">
                                Year of Passing
                              </label>

                              {/* <input
                                ref={txtAdOpass}
                                id="OtYearpassing"
                                type="month"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                name="OtYearpassing"
                                className="Inputs"
                                onChange={(e) => handleEdu("Others", e)}
                                placeholder="Year passing"
                                value={sslcCerficates[7].OtYearpassing}
                                autoComplete="Yearpassing"
                                required
                              /> */}
                              <MonthDatePicker
                                handleYearChange={handleYearChange_month}
                                handleMonthChange={handleMonthChange_month}
                                minDate={
                                  sslcCerficates[1].HSC_Year !== "" &&
                                    sslcCerficates[1].HSC_Year !== null
                                    ? sslcCerficates[1].HSC_Year
                                    : sslcCerficates[0].SSLC_Year !== "" &&
                                      sslcCerficates[0].SSLC_Year !== null
                                      ? sslcCerficates[0].SSLC_Year
                                      : ""
                                }
                                disabledProperty={
                                  list.admission_status === 1 ? true : false
                                }
                                dname={"Others"}
                                txtAdSpass={txtAdOpass}
                                name={"OtYearpassing"}
                                handleChange={handleEYDate}
                                fieldInput={sslcCerficates[7].OtYearpassing}
                              />
                              {listErrors.OtYearpassing && (
                                <p className="errors">
                                  {listErrors.OtYearpassing}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="OtCertificateNumber">
                                Certificate Number
                              </label>
                              <input
                                ref={txtAdOCer}
                                id="OtCertificateNumber"
                                type="text"
                                name="OtCertificateNumber"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                className="Inputs"
                                onChange={(e) => handleEdu("Others", e)}
                                placeholder="Certificate Number"
                                value={sslcCerficates[7].OtCertificateNumber}
                                autoComplete="Certificate Number"
                                required
                                minLength={10}
                                maxLength={10}
                              />
                              {listErrors.OtCertificateNumber && (
                                <p className="errors">
                                  {listErrors.OtCertificateNumber}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="OtMarksPercentage">
                                Marks Percentage
                              </label>
                              <input
                                ref={txtAdOmarks}
                                id="OtMarksPercentage"
                                type="number"
                                name="OtMarksPercentage"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                className="Inputs"
                                onChange={(e) => handleEdu("Others", e)}
                                onKeyDown={handleKeyDown}
                                placeholder="Marks Percentage"
                                value={sslcCerficates[7].OtMarksPercentage}
                                autoComplete="Marks Percentage"
                                required
                              />
                              {listErrors.OtMarksPercentage && (
                                <p className="errors">
                                  {listErrors.OtMarksPercentage}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="OtClassName">Class</label>
                              <Select
                                ref={txtAdOclass}
                                id="OtClassName"
                                type="text"
                                name="OtClassName"
                                isDisabled={
                                  list.admission_status === 1 ? true : false
                                }
                                value={mOption.OtClassName}
                                onChange={(option) =>
                                  handleEduMajor(
                                    option,
                                    "Others",
                                    "OtClassName"
                                  )
                                }
                                options={classOption.sort((a, b) =>
                                  a.label.localeCompare(b.label)
                                )} // Sort options alphabetically by label
                                isSearchable={true} // Enables search functionality
                                placeholder="Select an option"
                                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                filterOption={(option, searchText) =>
                                  option.label
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                } // Filter options based on the search text
                                styles={customStyles} // Apply custom styles her
                              />

                              {/* <input
                                    ref={txtAdOclass}
                                    id="OtClassName"
                                    type="text"
                                    name="OtClassName"
                                    disabled={
                                      list.admission_status === 1 ? true : false
                                    }
                                    className="Inputs"
                                    onChange={(e) => handleEdu("Others", e)}
                                    placeholder="Class Name"
                                    value={sslcCerficates[7].OtClassName}
                                    autoComplete="ClassName"
                                    required
                                  /> */}
                              {listErrors.OtClassName && (
                                <p className="errors">
                                  {listErrors.OtClassName}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row mb-4 ">
                          <div className="col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="OtNameInstitute">
                                Name of the college / university
                              </label>
                              <input
                                ref={txtAdOins}
                                id="OtNameInstitute"
                                type="text"
                                name="OtNameInstitute"
                                disabled={
                                  list.admission_status === 1 ? true : false
                                }
                                className="Inputs"
                                onChange={(e) => handleEdu("Others", e)}
                                placeholder="Name of the college / university"
                                value={sslcCerficates[7].OtNameInstitute}
                                autoComplete="OtNameInstitute"
                                required
                              />
                              {listErrors.OtNameInstitute && (
                                <p className="errors">
                                  {listErrors.OtNameInstitute}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="forms ">
                              <label htmlFor="Ot_Path">
                                Upload Certificate (In pdf/Image format){" "}
                                <span className="optionFields">(Optional)</span>
                                {sslcCerficates[7].Ot_Path !== "" &&
                                  sslcCerficates[7].Ot_Path !== null && (
                                    <a
                                      href={`${ImageUrlPrefix}/${sslcCerficates[7].Ot_Path}`}
                                      target="_blank"
                                      download
                                    >
                                      <span className="material-icons align-middle download_icon">
                                        file_download
                                      </span>
                                    </a>
                                  )}
                              </label>
                              <div className="row">
                                <div
                                  className={
                                    sslcCerficates[7].Ot_Path !== "" &&
                                      sslcCerficates[7].Ot_Path !== null
                                      ? "col-md-3 "
                                      : "col-md-12"
                                  }
                                >
                                  <input
                                    ref={txtAdOfile}
                                    id="Ot_Path"
                                    type="file"
                                    name="Ot_Path"
                                    disabled={
                                      list.admission_status === 1 ? true : false
                                    }
                                    className={
                                      sslcCerficates[7].Ot_Path !== "" &&
                                        sslcCerficates[7].Ot_Path !== null
                                        ? "InputsFile nn_upload_width"
                                        : "InputsFile  vv_upload_width"
                                    }
                                    onChange={(e) => handleEdu("Others", e)}
                                    placeholder="Path"
                                    autoComplete="Path"
                                    required
                                  />
                                </div>
                                {sslcCerficates[7].Ot_Path !== "" &&
                                  sslcCerficates[7].Ot_Path !== null && (
                                    <div
                                      className={
                                        "col-md-9 d-flex align-content-center p-0"
                                      }
                                    >
                                      <span className="nn_upload_file">
                                        {sslcCerficates[7].Ot_Path !== "" &&
                                          sslcCerficates[7].Ot_Path !== null
                                          ? sslcCerficates[7].original_file_path
                                          : ""}
                                      </span>
                                      <span className="material-icons align-middle text-danger verified_upload">
                                        verified
                                      </span>
                                    </div>
                                  )}
                              </div>

                              {listErrors.Ot_Path && (
                                <p className="errors">{listErrors.Ot_Path}</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                {/* //educational section  end */}

                <section className="  sectionFive">
                  {techQualification.map((item, index) => (
                    <TechQualification
                      key={item.id}
                      admission_status={list.admission_status === 1 ? 1 : 0}
                      length={techQualification.length}
                      AddQualification={AddQualification}
                      DeleteQual={DeleteQual}
                      technicalOption={technicalOption}
                      TechhandleChange_date={TechhandleChange_date}
                      TechhandleChange={TechhandleChange}
                      TechhandleChanges={TechhandleChanges}
                      record={item}
                      index={index}
                    />
                  ))}

                  <div className="heading  mb-4 dflexbetww ">
                    <div className="">
                      <button
                        type="button"
                        className="SaveButton_Prev"
                        onClick={handlePrevious}
                      >
                        <a href="javascript:void(0)">Go to Communication</a>
                      </button>
                    </div>
                    <div className="d-flex smButton mobiledown">
                      <Link to="/" className="CancelButton">
                        Back to Home
                      </Link>
                      <button
                        type="button"
                        className="SaveButtons"
                        disabled={stepperButton}
                        onClick={handleNext}
                      >
                        <a href="javascript:void(0)">
                          Save and Continue to Course Selection Details
                        </a>
                      </button>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </fieldset>
        )}
        {/* {step === 4} */}
        {step === 4 && (
          <fieldset>
            <div className="row">
              <div className="col-md-12">
                <section className=" sectionSix">
                  <div className="heading dflexbetww ">
                    <div className="">
                      <button
                        type="button"
                        className="SaveButton_Prev"
                        onClick={handlePrevious}
                      >
                        <a href="javascript:void(0)">
                          Go to Academic Background
                        </a>
                      </button>
                    </div>
                    <div className="d-flex smButton mobiledown">
                      <Link to="/" className="CancelButton">
                        Back to Home
                      </Link>
                      <button
                        type="button"
                        className="SaveButton"
                        disabled={stepperButton}
                        onClick={handleNext}
                      >
                        <a href="javascript:void(0)">
                          Save and Review Your Information
                        </a>
                      </button>
                    </div>
                  </div>
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Test Batch Enrollment</p>
                      <div className="row ">
                        <div className="col-lg-6 col-md-12">
                          <div className="forms row  ">
                            <label htmlFor="Category">
                              Category
                              {/* <small onClick={handleStepOne} className="errors stepOneCursor fw-semibold">
                              (You choose default category as {list.SPCcategory} in stepper one)
                            </small> */}
                            </label>
                            <div
                              className="d-flex flex-lg-row flex-md-row flex-column"
                              id="radiobuttons"
                            >
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip onClick={handleStepOne} id="tooltip">
                                    You choose default category as{" "}
                                    {list.SPCcategory} in stepper one
                                  </Tooltip>
                                }
                              >
                                <div className="form-check form-check-inline">
                                  <input
                                    ref={txtAdCate}
                                    className="checkbox_radio"
                                    type="radio"
                                    name="category"
                                    disabled
                                    id="UPSC"
                                    value="UPSC"
                                    onChange={handleChange}
                                    checked={
                                      list.category === "UPSC" ||
                                      list.SPCcategory === "UPSC"
                                    }
                                  />
                                  <label
                                    className="checkbox-label"
                                    htmlFor="UPSC"
                                  >
                                    UPSC
                                  </label>
                                </div>
                              </OverlayTrigger>

                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip onClick={handleStepOne} id="tooltip">
                                    You choose default category as{" "}
                                    {list.SPCcategory} in stepper one
                                  </Tooltip>
                                }
                              >
                                <div className="form-check form-check-inline">
                                  <input
                                    className="checkbox_radio"
                                    type="radio"
                                    name="category"
                                    id="TNPSC"
                                    disabled
                                    value="TNPSC"
                                    checked={
                                      list.category === "TNPSC" ||
                                      list.SPCcategory === "TNPSC"
                                    }
                                    onChange={handleChange}
                                  />
                                  <label
                                    className="checkbox-label"
                                    htmlFor="TNPSC"
                                  >
                                    TNPSC
                                  </label>
                                </div>
                              </OverlayTrigger>

                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip onClick={handleStepOne} id="tooltip">
                                    You choose default category as{" "}
                                    {list.SPCcategory} in stepper one
                                  </Tooltip>
                                }
                              >
                                <div className="form-check form-check-inline">
                                  <input
                                    className="checkbox_radio"
                                    type="radio"
                                    name="category"
                                    id="TRB"
                                    disabled
                                    value="TRB"
                                    checked={
                                      list.category === "TRB" ||
                                      list.SPCcategory === "TRB"
                                    }
                                    onChange={handleChange}
                                  />
                                  <label
                                    className="checkbox-label"
                                    htmlFor="TRB"
                                  >
                                    TRB
                                  </label>
                                </div>
                              </OverlayTrigger>

                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip onClick={handleStepOne} id="tooltip">
                                    You choose default category as{" "}
                                    {list.SPCcategory} in stepper one
                                  </Tooltip>
                                }
                              >
                                <div className="form-check form-check-inline">
                                  <input
                                    className="checkbox_radio"
                                    type="radio"
                                    name="category"
                                    id="TET"
                                    disabled
                                    value="TET"
                                    checked={
                                      list.category === "TET" ||
                                      list.SPCcategory === "TET"
                                    }
                                    onChange={handleChange}
                                  />
                                  <label
                                    className="checkbox-label"
                                    htmlFor="TET"
                                  >
                                    TET
                                  </label>
                                </div>
                              </OverlayTrigger>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip onClick={handleStepOne} id="tooltip">
                                    You choose default category as{" "}
                                    {list.SPCcategory} in stepper one
                                  </Tooltip>
                                }
                              >
                                <div className="form-check form-check-inline">
                                  <input
                                    className="checkbox_radio"
                                    type="radio"
                                    name="category"
                                    id="TNUSRB"
                                    disabled
                                    value="TNUSRB"
                                    checked={
                                      list.category === "TNUSRB" ||
                                      list.SPCcategory === "TNUSRB"
                                    }
                                    onChange={handleChange}
                                  />
                                  <label
                                    className="checkbox-label"
                                    htmlFor="TNUSRB"
                                  >
                                    TNUSRB
                                  </label>
                                </div>
                              </OverlayTrigger>
                            </div>
                            <div
                              className="d-flex flex-lg-row flex-md-row flex-column"
                              id="radiobuttons"
                            >
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip onClick={handleStepOne} id="tooltip">
                                    You choose default category as{" "}
                                    {list.SPCcategory} in stepper one
                                  </Tooltip>
                                }
                              >
                                <div className="form-check form-check-inline">
                                  <input
                                    className="checkbox_radio"
                                    type="radio"
                                    name="category"
                                    id="RRB"
                                    disabled
                                    value="RRB"
                                    checked={
                                      list.category === "RRB" ||
                                      list.SPCcategory === "RRB"
                                    }
                                    onChange={handleChange}
                                  />
                                  <label
                                    className="checkbox-label"
                                    htmlFor="RRB"
                                  >
                                    RRB
                                  </label>
                                </div>
                              </OverlayTrigger>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip onClick={handleStepOne} id="tooltip">
                                    You choose default category as{" "}
                                    {list.SPCcategory} in stepper one
                                  </Tooltip>
                                }
                              >
                                <div className="form-check form-check-inline">
                                  <input
                                    className="checkbox_radio"
                                    type="radio"
                                    name="category"
                                    id="SSC"
                                    disabled
                                    value="SSC"
                                    checked={
                                      list.category === "SSC" ||
                                      list.SPCcategory === "SSC"
                                    }
                                    onChange={handleChange}
                                  />
                                  <label
                                    className="checkbox-label"
                                    htmlFor="SSC"
                                  >
                                    SSC
                                  </label>
                                </div>
                              </OverlayTrigger>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip onClick={handleStepOne} id="tooltip">
                                    You choose default category as{" "}
                                    {list.SPCcategory} in stepper one
                                  </Tooltip>
                                }
                              >
                                <div className="form-check form-check-inline">
                                  <input
                                    className="checkbox_radio"
                                    type="radio"
                                    name="category"
                                    id="Banking"
                                    disabled
                                    value="Banking"
                                    checked={
                                      list.category === "Banking" ||
                                      list.SPCcategory === "Banking"
                                    }
                                    onChange={handleChange}
                                  />
                                  <label
                                    className="checkbox-label"
                                    htmlFor="Banking"
                                  >
                                    Banking
                                  </label>
                                </div>
                              </OverlayTrigger>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip onClick={handleStepOne} id="tooltip">
                                    You choose default category as{" "}
                                    {list.SPCcategory} in stepper one
                                  </Tooltip>
                                }
                              >
                                <div className="form-check form-check-inline">
                                  <input
                                    className="checkbox_radio"
                                    type="radio"
                                    name="category"
                                    id="Others"
                                    value="Others"
                                    disabled
                                    checked={
                                      list.category === "Others" ||
                                      list.SPCcategory === "Others"
                                    }
                                    onChange={handleChange}
                                  />
                                  <label
                                    className="checkbox-label"
                                    htmlFor="Others"
                                  >
                                    Others
                                  </label>
                                </div>
                              </OverlayTrigger>
                            </div>
                          </div>
                          {listErrors.category && (
                            <small className="errors fw-semibold">
                              {listErrors.category}
                            </small>
                          )}
                        </div>
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="CourseCate">Test Batch</label>
                            {/* <Select
                              ref={txtAdCourse}
                              id="CourseCate"
                              name="CourseCate"
                              // isDisabled={list.admission_status === 1 ? true : false}
                              value={dropDowns.CourseCate}
                              onChange={option => handleSelectMulti(option, 'CourseCate', 'CourseCate')}
                              options={coursesCate
                                .filter((item) => item && item.label) // Filter out null and undefined elements
                                .sort((a, b) => a.label.localeCompare(b.label)) // Sort options alphabetically by label
                              }
                              isSearchable={true} // Enables search functionality
                              placeholder="Select an option"
                              maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5 
                              filterOption={(option, searchText) =>
                                option.label.toLowerCase().includes(searchText.toLowerCase())
                              } // Filter options based on the search text
                              styles={customStyles} // Apply custom styles her
                            /> */}

                            <DropdownHeader
                              txtAdCourse={txtAdCourse}
                              id="CourseCate"
                              name="CourseCate"
                              items={list.CouresName}
                              record={courseListSortData}
                              handleChangeCheckbox={handleChangeCheckbox}
                            />
                            {listErrors.CourseCate && (
                              <p className="errors">{listErrors.CourseCate}</p>
                            )}
                          </div>
                        </div>
                        {isSubOpen === true && (
                          <div className="col-md-6 ">
                            <div className="forms ">
                              <label htmlFor="Subject">Subject</label>
                              <Select
                                ref={txtAdSub}
                                id="Subject"
                                name="Subject"
                                options={subject}
                                //  disabled={list.admission_status === 1 ? true : false}
                                isMulti
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                isClearable={true}
                                onChange={handleSubject}
                                value={selectedSub.map((value) => ({
                                  value: value.label,
                                  label: value.label,
                                  pk: value.pk,
                                }))}
                                components={{
                                  Option: CommonOption, // Correct the syntax here
                                }}
                                styles={multiCusutomStyle} // Apply custom styles her
                              />
                              {listErrors.Subject && (
                                <p className="errors">{listErrors.Subject}</p>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="row mb-3">
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="TeachMedium">
                              Medium of Examination
                            </label>
                            <select
                              ref={txtAdMedium}
                              id="TeachMedium"
                              name="TeachMedium"
                              className="Inputs"
                              onChange={handleChange}
                              value={list.TeachMedium}
                              required
                            >
                              <option value="" disabled selected>
                                Please select
                              </option>
                              <option value="Tamil">Tamil</option>
                              <option value="English">English</option>
                              <option value="Both">Both</option>
                            </select>
                            {listErrors.TeachMedium && (
                              <p className="errors">{listErrors.TeachMedium}</p>
                            )}
                          </div>
                        </div>
                        {list.classMode === "ClassRoom" && (
                          <div className="col-md-6">
                            <div className="forms ">
                              <label htmlFor="location">
                                Preferred Branch Location
                              </label>
                              <select
                                ref={txtAdLoca}
                                id="location"
                                name="location"
                                className="Inputs"
                                onChange={handleChange}
                                value={list.location}
                                required
                              >
                                <option value="" disabled selected>
                                  Please select
                                </option>
                                {locations}
                              </select>
                              {listErrors.location && (
                                <p className="errors">{listErrors.location}</p>
                              )}
                            </div>
                          </div>
                        )}

                        <div className="col-md-6">
                          <div className="forms ">
                            <label for="classMode">Test Mode:</label>

                            <div
                              className="d-flex  col-md-12"
                              id="radiobuttons"
                            >
                              <div className="form-check form-check-inline">
                                <input
                                  ref={txtAdcMode}
                                  className="checkbox_radio"
                                  type="radio"
                                  name="classMode"
                                  id="Online"
                                  value="Online"
                                  defaultChecked={list.classMode === "Online"}
                                  onChange={handleChange}
                                />
                                <label
                                  className="checkbox-label"
                                  htmlFor="Online"
                                >
                                  Online
                                </label>
                              </div>

                              <div className="form-check form-check-inline">
                                <input
                                  className="checkbox_radio"
                                  type="radio"
                                  name="classMode"
                                  id="ClassRoom"
                                  value="ClassRoom"
                                  defaultChecked={
                                    list.classMode === "ClassRoom"
                                      ? true
                                      : false
                                  }
                                  onChange={handleChange}
                                />
                                <label
                                  className="checkbox-label"
                                  htmlFor="ClassRoom"
                                >
                                  Offline
                                </label>
                              </div>
                            </div>
                            {listErrors.classMode && (
                              <small className="errors">
                                {listErrors.classMode}
                              </small>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="Weekend">
                              Class Schedule Preference
                            </label>
                            <div
                              className="d-flex  col-md-12"
                              id="radiobuttons"
                            >
                              <div className="form-check form-check-inline">
                                <input
                                  ref={txtAdBtype}
                                  className="checkbox_radio"
                                  type="radio"
                                  name="BatchType"
                                  id="Weekend"
                                  value="Weekend"
                                  onChange={handleChange}
                                  defaultChecked={
                                    list.BatchType === "Weekend" ? true : false
                                  }
                                />
                                <label
                                  className="checkbox-label"
                                  htmlFor="Weekend"
                                >
                                  Weekend
                                </label>
                              </div>

                              <div className="form-check form-check-inline">
                                <input
                                  className="checkbox_radio"
                                  type="radio"
                                  name="BatchType"
                                  id="Regular"
                                  value="Regular"
                                  defaultChecked={
                                    list.BatchType === "Regular" ? true : false
                                  }
                                  onChange={handleChange}
                                />
                                <label
                                  className="checkbox-label"
                                  htmlFor="Regular"
                                >
                                  Regular
                                </label>
                              </div>
                            </div>
                            {listErrors.BatchType && (
                              <p className="errors">{listErrors.BatchType}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                {batchDetails[0] !== null &&
                  Object.keys(batchDetails).length > 0 ? (
                  <section className=" sectionSix">
                    <div className="row box">
                      <div className="col-md-12">
                        <p className="StepTitle">Batch Details</p>
                        {batchDetails.map((el, index) => (
                          <div className="row" key={index}>
                            <div className="col-md-1 d-flex justify-content-lg-center mt-sm-4 align-items-center">
                              <input
                                ref={txtbatchDet}
                                className="checkbox_batch"
                                type="checkbox"
                                name="is_selected"
                                id="is_selected_batch"
                                onChange={(e) =>
                                  handleBatchDetails(
                                    el.id,
                                    el.partial_payment,
                                    e
                                  )
                                }
                                checked={el.is_selected === true ? true : false}
                                value={el.is_selected}
                              />
                            </div>
                            <div className="col-md-11 mt-3 mb-3">
                              <div className="card  text-dark">
                                <div className="card-body BatchImage">
                                  <div className="row">
                                    <div className="col-lg-2 col-md-6 col-sm-12 ">
                                      <img
                                        title={el.img_url}
                                        src={`${ImageUrlPrefix}/${el.img_url}`}
                                        id={el.id}
                                        alt="Imge"
                                      />
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-12 d-flex flex-column ImageText  justify-content-center">
                                      <p className="title m-0 ">
                                        {el.course_name || ""} - {el.name || ""}
                                      </p>
                                      <a
                                        target="_blank"
                                        href={`${ImageUrlPrefix}/${el.test_img_url}`}
                                        className="subtitle_testpdf "
                                      >
                                        Click here to view test schedule
                                      </a>
                                    </div>
                                    <div className="col-lg-6 col-md-10 col-sm-12 col-xl-6">
                                      <div className="row">
                                        <div className="col-md-12 col-sm-12 ">
                                          <div className="row">
                                            <div className="col-md-3">
                                              <li className="IconsImage">
                                                <span className="material-icons">
                                                  laptop_chromebook
                                                </span>
                                                <div className="d-flex flex-column">
                                                  <p className="title ms-1">
                                                    Class Mode
                                                  </p>
                                                  <p className="subtitle ms-1">
                                                    {el.class_mode}
                                                  </p>
                                                </div>
                                              </li>
                                            </div>
                                            <div className="col-md-3">
                                              <li className="IconsImage">
                                                <span className="material-icons">
                                                  event
                                                </span>
                                                <div className="d-flex flex-column ">
                                                  <p className="title ms-1">
                                                    Starts On
                                                  </p>
                                                  <p className="subtitle ms-1">
                                                    {moment
                                                      .utc(el.start_on)
                                                      .format("DD/MM/YYYY")}
                                                  </p>
                                                </div>
                                              </li>
                                            </div>
                                            <div className="col-md-3">
                                              <li className="IconsImage">
                                                <span className="material-icons-outlined">
                                                  timer
                                                </span>
                                                <div className="d-flex flex-column">
                                                  <p className="title ms-1">
                                                    Duration
                                                  </p>
                                                  <p className="subtitle ms-1">
                                                    {el.duration}
                                                  </p>
                                                </div>
                                              </li>
                                            </div>
                                            <div className="col-md-3">
                                              <li className="IconsImage">
                                                <span className="material-icons">
                                                  library_books
                                                </span>
                                                <div className="d-flex flex-column">
                                                  <p className="title ms-1">
                                                    Medium
                                                  </p>
                                                  <p className="subtitle ms-1">
                                                    {el.medium}
                                                  </p>
                                                </div>
                                              </li>
                                            </div>
                                          </div>
                                        </div>
                                        <span className="border mt-3"></span>
                                        <div className="col-md-12 col-sm-12">
                                          <div className="row mt-2">
                                            <div className="col-md-4">
                                              <li className="IconsImage">
                                                <span className="material-icons">
                                                  currency_rupee
                                                </span>
                                                <div className="d-flex flex-column">
                                                  <p className="title ms-1">
                                                    Actual Course Fee
                                                  </p>
                                                  <p className="subtitle ms-1">
                                                    {el.act_c_fee}
                                                  </p>
                                                </div>
                                              </li>
                                            </div>
                                            <div className="col-md-4">
                                              <li className="IconsImage">
                                                <span className="material-icons">
                                                  currency_rupee
                                                </span>
                                                <div className="d-flex flex-column">
                                                  <p className="title ms-1">
                                                    Special Offer
                                                  </p>
                                                  <p className="subtitle ms-1">
                                                    {el.offer_spl}
                                                  </p>
                                                </div>
                                              </li>
                                            </div>
                                            <div className="col-md-4">
                                              <li className="IconsImage">
                                                <span className="material-icons">
                                                  currency_rupee
                                                </span>
                                                <div className="d-flex flex-column">
                                                  <p className="title ms-1">
                                                    Amount Payable
                                                  </p>
                                                  <p className="subtitle ms-1">
                                                    {el.dis_amt}
                                                  </p>
                                                </div>
                                              </li>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {/* <div className="col-lg-1 col-xl-1 col-md-2 col-sm-12 mt-2 d-flex justify-content-start justify-content-sm-start  ">
                                          <input
                                            ref={txtbatchDet}
                                            className="checkbox "
                                            type="radio"
                                            name="is_selected"
                                            id="is_selected_batch"
                                            onChange={(e) =>
                                              handleBatchDetails(el.id, e)
                                            }
                                            checked={
                                              el.is_selected === true
                                                ? true
                                                : false
                                            }
                                            value={el.is_selected}
                                          />
                                          <label
                                            className="checkbox-label batch_Select ms-2 "
                                            htmlFor="is_selected_batch"
                                          >
                                            Select
                                          </label>
                                        </div> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                        {listErrors.batchDetails && (
                          <p className="errors mb-2">
                            {listErrors.batchDetails}
                          </p>
                        )}
                      </div>
                    </div>
                  </section>
                ) : (
                  <section className="  sectionSix">
                    <div className="row box">
                      <div className="col-md-12">
                        <p className="StepTitle">Batch Details</p>
                        <div className="row">
                          <div className="col-md-12 mt-3 mb-3">
                            <div className="card  text-dark">
                              <div className="card-body ">
                                <p className="batch_Err">No Batch Found</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                <section className=" sectionSix">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">
                        Have You Already Studied for Competitive Examination?
                      </p>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div className="forms ">
                            <label htmlFor="CompetitiveExamination">
                              Have You Already Studied for Competitive
                              Examination?
                            </label>
                            <div className="radioGroup d-flex flex-row">
                              <div className="formCheck ">
                                <input
                                  ref={txtAdExam}
                                  className="checkbox_radio"
                                  type="radio"
                                  name="CompetitiveExamination"
                                  id="CompetitiveExamination1"
                                  onChange={handleChange}
                                  checked={
                                    list.CompetitiveExamination === "Yes"
                                      ? true
                                      : false
                                  }
                                  value="Yes"
                                />
                                <label
                                  className="checkbox-label"
                                  htmlFor="CompetitiveExamination1"
                                >
                                  Yes
                                </label>

                                <input
                                  className="checkbox_radio"
                                  type="radio"
                                  name="CompetitiveExamination"
                                  id="CompetitiveExamination2"
                                  onChange={handleChange}
                                  checked={
                                    list.CompetitiveExamination === "NO"
                                      ? true
                                      : false
                                  }
                                  value="NO"
                                />
                                <label
                                  className="checkbox-label"
                                  htmlFor="CompetitiveExamination2"
                                >
                                  NO
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        {list.CompetitiveExamination === "Yes" && (
                          <>
                            <div className="col-md-6">
                              <div className="forms ">
                                <label htmlFor="CompetitiveExamName">
                                  Name of the Examination
                                </label>

                                <Select
                                  ref={txtAdExam}
                                  id="CompetitiveExamName"
                                  name="CompetitiveExamName"
                                  value={
                                    list.CompetitiveExamName !== null &&
                                      list.CompetitiveExamName !== ""
                                      ? {
                                        value: list.CompetitiveExamName,
                                        label: list.CompetitiveExamName,
                                      }
                                      : null
                                  }
                                  onChange={(option) =>
                                    handleSelectCH(
                                      option,
                                      "CompetitiveExamName",
                                      "CompetitiveExamName"
                                    )
                                  }
                                  options={
                                    examination
                                      .filter((item) => item && item.label) // Filter out null and undefined elements
                                      .sort((a, b) =>
                                        a.label.localeCompare(b.label)
                                      ) // Sort options alphabetically by label
                                  }
                                  isSearchable={true} // Enables search functionality
                                  placeholder="Select an option"
                                  maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                  filterOption={(option, searchText) =>
                                    option.label
                                      .toLowerCase()
                                      .includes(searchText.toLowerCase())
                                  } // Filter options based on the search text
                                  styles={customStyles} // Apply custom styles her
                                />

                                {listErrors.CompetitiveExamName && (
                                  <p className="errors">
                                    {listErrors.CompetitiveExamName}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="forms ">
                                <label htmlFor="Institute">
                                  Name of the Institute you studied
                                  before(separated by commas)
                                </label>
                                <input
                                  ref={txtAdinsu}
                                  id="Institute"
                                  type="text"
                                  name="Institute"
                                  className="Inputs"
                                  onChange={handleChange}
                                  value={list.Institute}
                                  placeholder="Enter the Name of the Institute"
                                  autoComplete="Institute"
                                  required
                                />
                                {listErrors.Institute && (
                                  <p className="errors">
                                    {listErrors.Institute}
                                  </p>
                                )}
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
                <section className=" sectionSix">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">
                        Have You Cleared Any Exam Previously?
                      </p>
                      <div className="row mt-2">
                        <div className="col-md-6">
                          <div className="forms ">
                            <label htmlFor="ExamPreviously">
                              Have You Cleared Any Exam Previously?
                            </label>
                            <div className="radioGroup d-flex flex-row">
                              <div className="formCheck ">
                                <input
                                  ref={txtAdEdetail}
                                  className="checkbox_radio"
                                  type="radio"
                                  name="ExamPreviously"
                                  id="ExamPreviously1"
                                  onChange={handleChange}
                                  checked={
                                    list.ExamPreviously === "Yes" ? true : false
                                  }
                                  value="Yes"
                                />
                                <label
                                  className="checkbox-label"
                                  htmlFor="ExamPreviously1"
                                >
                                  Yes
                                </label>

                                <input
                                  className="checkbox_radio"
                                  type="radio"
                                  name="ExamPreviously"
                                  id="inlineRadio2"
                                  onChange={handleChange}
                                  checked={
                                    list.ExamPreviously === "NO" ? true : false
                                  }
                                  value="NO"
                                />
                                <label
                                  className="checkbox-label"
                                  htmlFor="inlineRadio2"
                                >
                                  NO
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        {list.ExamPreviously === "Yes" && (
                          <>
                            <div className="col-md-6">
                              <div className="forms ">
                                <label htmlFor="ExamWrite">
                                  How many exams have you cleared in the past?
                                </label>
                                <input
                                  ref={txtAdEclear}
                                  id="ExamWrite"
                                  type="number"
                                  name="ExamWrite"
                                  className="Inputs"
                                  onChange={handleChange}
                                  value={
                                    list.ExamWrite < 0 ? 0 : list.ExamWrite
                                  }
                                  placeholder="Enter the total number of exam"
                                  autoComplete="ExamWrite"
                                  required
                                />
                                {listErrors.ExamWrite && (
                                  <p className="errors">
                                    {listErrors.ExamWrite}
                                  </p>
                                )}
                              </div>
                            </div>
                            {examDetailsExam.map((detail, index) => (
                              <div className="col-md-6" key={index}>
                                <div className="forms ">
                                  <label htmlFor={`ExamDetailsRes_${index}`}>
                                    Exam details - {index + 1}
                                  </label>
                                  <select
                                    ref={txtAdEdetail}
                                    id={`ExamDetailsRes_${index}`}
                                    name={`ExamDetailsRes_${index}`}
                                    className="Inputs"
                                    onChange={(e) => handleExamPrev(e, index)}
                                    value={detail.examvalue}
                                  >
                                    <option value="" selected>
                                      Please select
                                    </option>
                                    {previousexam}
                                  </select>
                                  {detail.error_name_exam && (
                                    <p className="errors">
                                      {detail.error_name_exam}
                                    </p>
                                  )}
                                </div>
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
                <section className=" sectionSix">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">
                        Are You a Government Employee?
                      </p>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="forms ">
                            <label htmlFor="workingRes">
                              Are You a Government Employee?
                            </label>
                            <div className="radioGroup d-flex flex-row">
                              <div className="formCheck ">
                                <input
                                  ref={txtAdDesg}
                                  className="checkbox_radio"
                                  type="radio"
                                  name="workingRes"
                                  id="workingRes1"
                                  onChange={handleChange}
                                  checked={
                                    list.workingRes === "Yes" ? true : false
                                  }
                                  value="Yes"
                                />
                                <label
                                  className="checkbox-label"
                                  htmlFor="workingRes1"
                                >
                                  Yes
                                </label>

                                <input
                                  className="checkbox_radio"
                                  type="radio"
                                  name="workingRes"
                                  id="workingRes2"
                                  onChange={handleChange}
                                  checked={
                                    list.workingRes === "NO" ? true : false
                                  }
                                  value="NO"
                                />
                                <label
                                  className="checkbox-label"
                                  htmlFor="workingRes2"
                                >
                                  NO
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        {list.workingRes === "Yes" && (
                          <div className="row ">
                            <div className="col-md-6">
                              <div className="forms ">
                                <label htmlFor="Designation">Designation</label>
                                {/* <input
                                        id="Designation"
                                        type="text"
                                        name="Designation"
                                        className="Inputs"
                                        onChange={handleChange}
                                        value={list.Designation}
                                        placeholder="Designation"
                                        autoComplete="Designation"
                                        required
                                      /> */}
                                <Select
                                  ref={txtAdDesg}
                                  id="Designation"
                                  name="Designation"
                                  value={
                                    list.Designation !== null &&
                                      list.Designation !== ""
                                      ? {
                                        value: list.Designation,
                                        label: list.Designation,
                                      }
                                      : null
                                  }
                                  onChange={(option) =>
                                    handleSelectCH(
                                      option,
                                      "Designation",
                                      "Designation"
                                    )
                                  }
                                  options={
                                    designation
                                      .filter((item) => item && item.label) // Filter out null and undefined elements
                                      .sort((a, b) =>
                                        a.label.localeCompare(b.label)
                                      ) // Sort options alphabetically by label
                                  }
                                  isSearchable={true} // Enables search functionality
                                  placeholder="Select an option"
                                  maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                  filterOption={(option, searchText) =>
                                    option.label
                                      .toLowerCase()
                                      .includes(searchText.toLowerCase())
                                  } // Filter options based on the search text
                                  styles={customStyles} // Apply custom styles her
                                />
                                {listErrors.Designation && (
                                  <p className="errors">
                                    {listErrors.Designation}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="forms ">
                                <label htmlFor="Department">Department</label>
                                {/* <input
                                        id="Department"
                                        type="text"
                                        name="Department"
                                        className="Inputs"
                                        onChange={handleChange}
                                        value={list.Department}
                                        placeholder="Department"
                                        autoComplete="Department"
                                        required
                                      /> */}
                                <Select
                                  ref={txtAdDep}
                                  id="Department"
                                  name="Department"
                                  value={
                                    list.Department !== null &&
                                      list.Department !== ""
                                      ? {
                                        value: list.Department,
                                        label: list.Department,
                                      }
                                      : null
                                  }
                                  onChange={(option) =>
                                    handleSelectCH(
                                      option,
                                      "Department",
                                      "Department"
                                    )
                                  }
                                  options={
                                    department
                                      .filter((item) => item && item.label) // Filter out null and undefined elements
                                      .sort((a, b) =>
                                        a.label.localeCompare(b.label)
                                      ) // Sort options alphabetically by label
                                  }
                                  isSearchable={true} // Enables search functionality
                                  placeholder="Select an option"
                                  maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                  filterOption={(option, searchText) =>
                                    option.label
                                      .toLowerCase()
                                      .includes(searchText.toLowerCase())
                                  } // Filter options based on the search text
                                  styles={customStyles} // Apply custom styles her
                                />
                                {listErrors.Department && (
                                  <p className="errors">
                                    {listErrors.Department}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="forms ">
                                <label htmlFor="JoinGovt">
                                  Joining Date of Government Job
                                </label>
                                {/* <input
                                      ref={txtAdDjoin}
                                      id="JoinGovt"
                                      type="date"
                                      name="JoinGovt"
                                      className="Inputs"
                                      onChange={handleChange}
                                      value={list.JoinGovt}
                                      placeholder="JoinGovt"
                                      autoComplete="JoinGovt"
                                      required
                                       max={currentDate_Join}
                                    /> */}
                                <DatePickerSample
                                  handleYearChange={handleYearChange}
                                  handleMonthChange={handleMonthChange}
                                  maxDate={currentDate_Join}
                                  txtAdMDob={txtAdDjoin}
                                  name={"JoinGovt"}
                                  handleChange={handleChangeCuDate}
                                  fieldInput={list.JoinGovt}
                                />
                                {listErrors.JoinGovt && (
                                  <p className="errors">
                                    {listErrors.JoinGovt}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
                <section className=" sectionSix">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Are You an AIASA Student?</p>
                      <div className="row mb-3">
                        <div className="col-md-12">
                          <div className="forms ">
                            <label htmlFor="AIASAStudent">
                              Are You an AIASA Student?
                              <span
                                id="impo"
                                class="material-icons text-danger"
                              >
                                error
                              </span>
                            </label>
                            <div className="radioGroup d-flex flex-row">
                              <div className="formCheck ">
                                <input
                                  ref={txtAdayear}
                                  className="checkbox_radio"
                                  type="radio"
                                  name="AIASAStudent"
                                  id="AIASAStudent1"
                                  onChange={handleChange}
                                  checked={
                                    list.AIASAStudent === "Yes" ? true : false
                                  }
                                  value="Yes"
                                />
                                <label
                                  className="checkbox-label"
                                  htmlFor="AIASAStudent1"
                                >
                                  Yes
                                </label>

                                <input
                                  className="checkbox_radio"
                                  type="radio"
                                  name="AIASAStudent"
                                  id="AIASAStudent2"
                                  onChange={handleChange}
                                  checked={
                                    list.AIASAStudent === "NO" ? true : false
                                  }
                                  value="NO"
                                />
                                <label
                                  className="checkbox-label"
                                  htmlFor="AIASAStudent2"
                                >
                                  NO
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        {list.AIASAStudent === "Yes" && (
                          <>
                            <div className="row">
                              <div className="col-md-6">
                                <div className="forms ">
                                  <label htmlFor="Year">Year</label>
                                  {/* <input
                                          id="Year"
                                          type="text"
                                          name="Year"
                                          className="Inputs"
                                          onChange={handleChange}
                                          value={list.Year}
                                          placeholder="Year"
                                          autoComplete="Year"
                                          required
                                        /> */}
                                  <select
                                    ref={txtAdayear}
                                    id="Year"
                                    name="Year"
                                    className="Inputs"
                                    onChange={handleChange}
                                    value={list.Year}
                                    required
                                  >
                                    <option value="">-- Select Year --</option>
                                    {Array.from({ length: 50 }, (_, index) => {
                                      const year =
                                        new Date().getFullYear() - index;
                                      return (
                                        <option key={year} value={year}>
                                          {year}
                                        </option>
                                      );
                                    })}
                                  </select>

                                  {listErrors.Year && (
                                    <p className="errors">{listErrors.Year}</p>
                                  )}
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="forms ">
                                  <label htmlFor="CategoryAias">Category</label>

                                  <Select
                                    ref={txtAdacate}
                                    id="CategoryAias"
                                    name="CategoryAias"
                                    value={
                                      list.CategoryAias !== null &&
                                        list.CategoryAias !== ""
                                        ? {
                                          value: list.CategoryAias,
                                          label: list.CategoryAias,
                                        }
                                        : null
                                    }
                                    onChange={(option) =>
                                      handleSelectCH(
                                        option,
                                        "CategoryAias",
                                        "CategoryAias"
                                      )
                                    }
                                    options={
                                      cOption
                                        .filter((item) => item && item.label) // Filter out null and undefined elements
                                        .sort((a, b) =>
                                          a.label.localeCompare(b.label)
                                        ) // Sort options alphabetically by label
                                    }
                                    isSearchable={true} // Enables search functionality
                                    placeholder="Select an option"
                                    maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                    filterOption={(option, searchText) =>
                                      option.label
                                        .toLowerCase()
                                        .includes(searchText.toLowerCase())
                                    } // Filter options based on the search text
                                    styles={customStyles} // Apply custom styles her
                                  />
                                  {listErrors.CategoryAias && (
                                    <p className="errors">
                                      {listErrors.CategoryAias}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-6">
                                <div className="forms ">
                                  <label htmlFor="CourseAias">Course</label>

                                  <Select
                                    ref={txtAdacourse}
                                    id="CourseAias"
                                    name="CourseAias"
                                    value={
                                      list.CourseAias !== null &&
                                        list.CourseAias !== ""
                                        ? {
                                          value: list.CourseAias,
                                          label: list.CourseAias,
                                        }
                                        : null
                                    }
                                    onChange={(option) =>
                                      handleSelectCH(
                                        option,
                                        "CourseAias",
                                        "CourseAias"
                                      )
                                    }
                                    options={
                                      courseAias
                                        .filter((item) => item && item.label) // Filter out null and undefined elements
                                        .sort((a, b) =>
                                          a.label.localeCompare(b.label)
                                        ) // Sort options alphabetically by label
                                    }
                                    isSearchable={true} // Enables search functionality
                                    placeholder="Select an option"
                                    maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                    filterOption={(option, searchText) =>
                                      option.label
                                        .toLowerCase()
                                        .includes(searchText.toLowerCase())
                                    } // Filter options based on the search text
                                    styles={customStyles} // Apply custom styles her
                                  />
                                  {listErrors.CourseAias && (
                                    <p className="errors">
                                      {listErrors.CourseAias}
                                    </p>
                                  )}
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="forms ">
                                  <label htmlFor="IDNumber">ID Number</label>
                                  <input
                                    ref={txtAdaIdnum}
                                    id="IDNumber"
                                    type="text"
                                    name="IDNumber"
                                    className="Inputs"
                                    onChange={handleChange}
                                    value={list.IDNumber}
                                    placeholder="ID Number"
                                    autoComplete="ID Number"
                                    required
                                    maxLength={10}
                                    minLength={10}
                                  />
                                  {listErrors.IDNumber && (
                                    <p className="errors">
                                      {listErrors.IDNumber}
                                    </p>
                                  )}
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="forms ">
                                  <label htmlFor="IDPhoto">
                                    Upload ID Card (In pdf/Image format)
                                    {list.IDPhoto !== "" &&
                                      list.IDPhoto !== null && (
                                        <a
                                          href={`${ImageUrlPrefix}/${list.IDPhoto}`}
                                          target="_blank"
                                          download
                                        >
                                          <span className="material-icons align-middle download_icon">
                                            file_download
                                          </span>
                                        </a>
                                      )}
                                  </label>
                                  <div className="row">
                                    <div
                                      className={
                                        list.IDPhoto !== "" &&
                                          list.IDPhoto !== null
                                          ? "col-md-3 "
                                          : "col-md-12"
                                      }
                                    >
                                      <input
                                        ref={txtAdafile}
                                        id="IDPhoto"
                                        type="file"
                                        name="IDPhoto"
                                        placeholder="Upload ID Card"
                                        className={
                                          list.IDPhoto !== "" &&
                                            list.IDPhoto !== null
                                            ? "InputsFile nn_upload_width"
                                            : "InputsFile  vv_upload_width"
                                        }
                                        onChange={handleChange}
                                        autoComplete="IDPhoto"
                                        required
                                      />
                                    </div>
                                    {list.IDPhoto !== "" &&
                                      list.IDPhoto !== null && (
                                        <div
                                          className={
                                            "col-md-9 d-flex align-content-center p-0"
                                          }
                                        >
                                          <span className="nn_upload_file">
                                            {list.IDPhoto !== "" &&
                                              list.IDPhoto !== null
                                              ? list.original_aiasa_id_path
                                              : ""}
                                          </span>
                                          <span className="material-icons align-middle text-danger verified_upload">
                                            verified
                                          </span>
                                        </div>
                                      )}
                                  </div>
                                  {listErrors.IDPhoto && (
                                    <p className="errors">
                                      {listErrors.IDPhoto}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="heading  mb-4 dflexbetww ">
                    <div className="">
                      <button
                        type="button"
                        className="SaveButton_Prev"
                        onClick={handlePrevious}
                      >
                        <a href="javascript:void(0)">
                          {" "}
                          Go to Academic Background
                        </a>
                      </button>
                    </div>
                    <div className="d-flex smButton  mobiledown">
                      <Link to="/" className="CancelButton">
                        Back to Home
                      </Link>
                      <button
                        type="button"
                        className="SaveButton"
                        disabled={stepperButton}
                        onClick={handleNext}
                      >
                        {" "}
                        <a href="javascript:void(0)">
                          {" "}
                          Save and Review Your Information
                        </a>
                      </button>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </fieldset>
        )}
        {/* {step === 5} */}
        {step === 5 && (
          <fieldset>
            <div className="row">
              <div className="col-md-12">
                <section className=" sectionSix">
                  <div className="heading  dflexbetww ">
                    <div className="">
                      <button
                        type="button"
                        className="SaveButton_Prev"
                        onClick={handlePrevious}
                      >
                        <a href="javascript:void(0)">Go to Course Selection</a>
                      </button>
                    </div>
                    <div className="d-flex smButton  mobiledown">
                      <Link to="/" className="CancelButton">
                        Back to Home
                      </Link>
                      <button
                        type="button"
                        className="SaveButton"
                        disabled={stepperButton}
                        onClick={handleNext}
                      >
                        <a href="javascript:void(0)">
                          Save and Continue to Payment Info
                        </a>
                      </button>
                    </div>
                  </div>

                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Basic Details</p>

                      <div className="row">
                        <div className="col-lg-9 col-md-9">
                          <div className="row">
                            <div className="col-md-4">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted "
                                >
                                  First Name
                                </label>
                                <span className="ReviewLabel">
                                  {list.FirstName || "-"}
                                </span>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted "
                                >
                                  Last Name
                                </label>
                                <span className="ReviewLabel">
                                  {list.LastName || "-"}
                                </span>
                              </div>
                            </div>

                            <div className="col-lg-4 col-md-12">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted "
                                >
                                  Father's Name/Guardian's Name
                                </label>
                                <span className="ReviewLabel">
                                  {" "}
                                  {list.Fathername || "-"}
                                </span>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted "
                                >
                                  Mother's Name
                                </label>
                                <span className="ReviewLabel">
                                  {" "}
                                  {list.MotherName || "-"}
                                </span>
                              </div>
                            </div>

                            <div className="col-lg-4 col-md-6">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted "
                                >
                                  Date of Birth
                                </label>
                                <span className="ReviewLabel">
                                  {moment(list.DOB).format("DD/MM/YYYY") || "-"}
                                </span>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted "
                                >
                                  Gender
                                </label>
                                <span className="ReviewLabel">
                                  {list.gender || "-"}
                                </span>
                              </div>
                            </div>

                            <div className="col-lg-4 col-md-6">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted "
                                >
                                  Age
                                </label>
                                <span className="ReviewLabel">
                                  {list.age || "-"}
                                </span>
                              </div>
                            </div>

                            <div className="col-lg-4 col-md-6">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted "
                                >
                                  Marital Status
                                </label>
                                <span className="ReviewLabel">
                                  {" "}
                                  {list.MaritalStatus || "-"}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-3 col-md-3">
                          <div className="forms mb-2  ">
                            <div id="profilephotos">
                              {list.Profilephoto && (
                                <img
                                  src={`${ImageUrlPrefix}/${list.Profilephoto}`}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <div className="sectionSix">
                  <div className="row">
                    <div className="col-md-6">
                      <section className="sectionSix">
                        <div className="row box">
                          <div className="col-md-12">
                            <p className="StepTitle">ID Proofs</p>

                            <div className="row mb-3">
                              <div className="col-lg-4 col-md-12">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted "
                                  >
                                    AADHAR Number
                                  </label>
                                  <span className="ReviewLabel">
                                    {list.aadharNo || "-"}
                                  </span>
                                </div>
                              </div>

                              <div className="col-lg-8 col-md-12">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted "
                                  >
                                    Upload AADHAR Card
                                    {list.aadharCardphoto && (
                                      <a
                                        target="_blank"
                                        href={`${ImageUrlPrefix}/${list.aadharCardphoto}`}
                                      >
                                        {" "}
                                        <Download className="download_icon" />
                                      </a>
                                    )}
                                  </label>
                                  <span className="ReviewLabel">
                                    {list.aadharCardphoto !== null
                                      ? list.original_aadhar_path
                                      : "-"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                    <div className="col-md-6">
                      <section className="sectionSix ">
                        <div className="row box">
                          <div className="col-md-12">
                            <p className="StepTitle">
                              Communal Reservation Category
                            </p>

                            <div className="row mb-3">
                              <div className="col-lg-4 col-md-12">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted "
                                  >
                                    Category
                                  </label>
                                  <span className="ReviewLabel">
                                    {list.Cast || "-"}
                                  </span>
                                </div>
                              </div>

                              <div className="col-lg-8 col-md-12">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted "
                                  >
                                    Uploaded Certificate
                                    {list.CastFile && (
                                      <a
                                        target="_blank"
                                        href={`${ImageUrlPrefix}/${list.CastFile}`}
                                      >
                                        {" "}
                                        <Download className="download_icon" />
                                      </a>
                                    )}
                                  </label>
                                  <span className="ReviewLabel">
                                    {list.CastFile !== null
                                      ? list.original_caste_path
                                      : "-"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>

                <div className="sectionSix">
                  <div className="row">
                    {specialAdmissionPre.length > 0 &&
                      specialAdmissionPre.map((el, index) => (
                        <div
                          className={
                            specialAdmissionPre.length % 2 !== 0
                              ? specialAdmissionPre.length - 1 === index
                                ? "col-md-12"
                                : "col-md-6 "
                              : "col-lg-6 col-md-6 "
                          }
                          key={index}
                        >
                          <section className="sectionSix">
                            <div className="row box">
                              <div className="col-md-12">
                                <p className="StepTitle">
                                  Special Category{" "}
                                  {specialAdmissionPre.length === 1
                                    ? " "
                                    : `- ${el.id}`}
                                </p>
                                <div className="row mb-3">
                                  <div className="col-md-4">
                                    <div className="forms ">
                                      <label
                                        htmlFor="inputName"
                                        className="form-label text-muted "
                                      >
                                        Category
                                      </label>
                                      <span className="ReviewLabel">
                                        {el.name || ""}
                                      </span>
                                    </div>
                                  </div>
                                  {el.file !== "" && el.file !== null && (
                                    <div className="col-lg-8 col-md-12 d-flex justify-content-lg-center">
                                      <div className="forms ">
                                        <label
                                          htmlFor="inputName"
                                          className="form-label text-muted "
                                        >
                                          Uploaded Certificate
                                          {el.file !== "" &&
                                            el.file !== null && (
                                              <a
                                                target="_blank"
                                                href={`${ImageUrlPrefix}/${el.file}`}
                                              >
                                                {" "}
                                                <Download className="download_icon" />
                                              </a>
                                            )}
                                        </label>
                                        <span className="ReviewLabel">
                                          {el.file !== null
                                            ? el.original_pref_path
                                            : ""}
                                        </span>
                                      </div>
                                    </div>
                                  )}

                                  {el.path_sslc !== "" &&
                                    el.path_sslc !== null && (
                                      <div className="col-lg-8 col-md-12 d-flex justify-content-lg-center">
                                        <div className="forms ">
                                          <label
                                            htmlFor="inputName"
                                            className="form-label text-muted "
                                          >
                                            Uploaded Certificate for sslc
                                            {el.path_sslc !== "" &&
                                              el.path_sslc !== null && (
                                                <a
                                                  target="_blank"
                                                  href={`${ImageUrlPrefix}/${el.path_sslc}`}
                                                >
                                                  {" "}
                                                  <Download className="download_icon" />
                                                </a>
                                              )}
                                          </label>
                                          <span className="ReviewLabel">
                                            {el.path_sslc !== null
                                              ? el.original_path_sslc
                                              : ""}
                                          </span>
                                        </div>
                                      </div>
                                    )}

                                  {el.path_hsc !== "" &&
                                    el.path_hsc !== null && (
                                      <div className="col-lg-8 col-md-12 d-flex justify-content-lg-center">
                                        <div className="forms ">
                                          <label
                                            htmlFor="inputName"
                                            className="form-label text-muted "
                                          >
                                            Uploaded Certificate for HSC
                                            {el.path_hsc !== "" &&
                                              el.path_hsc !== null && (
                                                <a
                                                  target="_blank"
                                                  href={`${ImageUrlPrefix}/${el.path_hsc}`}
                                                >
                                                  {" "}
                                                  <Download className="download_icon" />
                                                </a>
                                              )}
                                          </label>
                                          <span className="ReviewLabel">
                                            {el.path_sslc !== null
                                              ? el.original_path_hsc
                                              : ""}
                                          </span>
                                        </div>
                                      </div>
                                    )}

                                  {el.path_ug !== "" && el.path_ug !== null && (
                                    <div className="col-lg-8 col-md-12 d-flex justify-content-lg-center">
                                      <div className="forms ">
                                        <label
                                          htmlFor="inputName"
                                          className="form-label text-muted "
                                        >
                                          Uploaded Certificate for UG
                                          {el.path_ug !== "" &&
                                            el.path_ug !== null && (
                                              <a
                                                target="_blank"
                                                href={`${ImageUrlPrefix}/${el.path_ug}`}
                                              >
                                                {" "}
                                                <Download className="download_icon" />
                                              </a>
                                            )}
                                        </label>
                                        <span className="ReviewLabel">
                                          {el.path_sslc !== null
                                            ? el.original_path_ug
                                            : ""}
                                        </span>
                                      </div>
                                    </div>
                                  )}

                                  {el.path_pg !== "" && el.path_pg !== null && (
                                    <div className="col-lg-8 col-md-12 d-flex justify-content-lg-center">
                                      <div className="forms ">
                                        <label
                                          htmlFor="inputName"
                                          className="form-label text-muted "
                                        >
                                          Uploaded Certificate for PG
                                          {el.path_pg !== "" &&
                                            el.path_pg !== null && (
                                              <a
                                                target="_blank"
                                                href={`${ImageUrlPrefix}/${el.path_pg}`}
                                              >
                                                {" "}
                                                <Download className="download_icon" />
                                              </a>
                                            )}
                                        </label>
                                        <span className="ReviewLabel">
                                          {el.path_sslc !== null
                                            ? el.original_path_pg
                                            : ""}
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      ))}
                  </div>
                </div>

                <section className=" sectionSix">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Contact details</p>

                      <div className="row mb-3">
                        <div className="col-lg-3 col-md-6">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Phone Number
                            </label>
                            <span className="ReviewLabel">
                              {list.Mobile || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              WhatsApp Number
                            </label>
                            <span className="ReviewLabel">
                              {list.ContactNumber === true
                                ? list.Mobile
                                : list.WhatsAppNumber || "-"}
                            </span>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Father/Guardian Phone Number
                            </label>
                            <span className="ReviewLabel">
                              {list.ParentMobileNo || "-"}
                            </span>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Email ID
                            </label>
                            <span className="ReviewLabel">
                              {list.emailaddress || ""}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <div className="sectionSix">
                  <div className="row">
                    <div className="col-md-6">
                      <section className="sectionSix">
                        <div className="row box">
                          <div className="col-md-12">
                            <p className="StepTitle">Present Address</p>
                            <div className="row mb-3">
                              <div className="col-md-6">
                                <div className="forms">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted"
                                  >
                                    Present Address
                                  </label>
                                </div>
                              </div>

                              {[
                                list.BuildingNumberPresent,
                                list.StreetNamePresent,
                                list.AreaPresent,
                                list.LandmarkPresent,
                                list.TalukPresent,
                                list.PostPresent,
                                list.PincodePresent,
                                list.CityPresent,
                                list.districtPresent,
                                list.statePresent,
                              ].some(Boolean) ? (
                                <div className="d-flex flex-column">
                                  {[
                                    [
                                      list.BuildingNumberPresent,
                                      list.StreetNamePresent,
                                    ],
                                    [list.AreaPresent, list.LandmarkPresent],
                                    [list.TalukPresent, list.PostPresent],
                                    [list.PincodePresent, list.CityPresent],
                                    [list.districtPresent, list.statePresent],
                                  ].map((pair, index) => {
                                    const value = pair
                                      .filter(Boolean)
                                      .join(", ");
                                    return value ? (
                                      <span
                                        key={index}
                                        className="ReviewLabel mb-2"
                                      >
                                        {value}
                                      </span>
                                    ) : null;
                                  })}
                                </div>
                              ) : (
                                <p className="text-center mb-0 mt-2">
                                  No records to display
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                    <div className="col-md-6">
                      <section className="sectionSix ">
                        <div className="row box">
                          <div className="col-md-12">
                            <p className="StepTitle">Permanent Address</p>
                            <div className="row mb-3">
                              <div className="col-md-12">
                                <div className="forms">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted"
                                  >
                                    Permanent Address
                                  </label>
                                </div>
                              </div>

                              {(() => {
                                const addressSource = list.SamePresentAddress
                                  ? {
                                    BuildingNumber:
                                      list.BuildingNumberPresent,
                                    StreetName: list.StreetNamePresent,
                                    Area: list.AreaPresent,
                                    Landmark: list.LandmarkPresent,
                                    Taluk: list.TalukPresent,
                                    Post: list.PostPresent,
                                    Pincode: list.PincodePresent,
                                    City: list.CityPresent,
                                    District: list.districtPresent,
                                    State: list.statePresent,
                                  }
                                  : {
                                    BuildingNumber:
                                      list.BuildingNumberPermanent,
                                    StreetName: list.StreetNamePermanent,
                                    Area: list.AreaPermanent,
                                    Landmark: list.LandmarkPermanent,
                                    Taluk: list.TalukPermanent,
                                    Post: list.PostPermanent,
                                    Pincode: list.PincodePermanent,
                                    City: list.CityPermanent,
                                    District: list.districtPermanent,
                                    State: list.statePermanent,
                                  };

                                const addressFields = [
                                  [
                                    addressSource.BuildingNumber,
                                    addressSource.StreetName,
                                  ],
                                  [addressSource.Area, addressSource.Landmark],
                                  [addressSource.Taluk, addressSource.Post],
                                  [addressSource.Pincode, addressSource.City],
                                  [addressSource.District, addressSource.State],
                                ];

                                const hasAnyData =
                                  Object.values(addressSource).some(Boolean);

                                return hasAnyData ? (
                                  <div className="d-flex flex-column">
                                    {addressFields.map((pair, index) => {
                                      const value = pair
                                        .filter(Boolean)
                                        .join(", ");
                                      return value ? (
                                        <span
                                          key={index}
                                          className="ReviewLabel mb-2"
                                        >
                                          {value}
                                        </span>
                                      ) : null;
                                    })}
                                  </div>
                                ) : (
                                  <p className="text-center mb-0 mt-2">
                                    No records to display
                                  </p>
                                );
                              })()}
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>

                <div className="sectionSix">
                  <div className="row">
                    {educationQualification.includes("SSLC") && (
                      <div
                        className={
                          educationQualification.includes("SSLC") &&
                            !educationQualification.includes("HSC")
                            ? " col-md-12"
                            : " col-md-6"
                        }
                      >
                        <section className="sectionSix ">
                          <div className="row box">
                            <div className="col-md-12">
                              <p className="StepTitle">SSLC</p>

                              <div className="row mb-3">
                                <div className="col-md-6">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted "
                                    >
                                      Certificate Number
                                    </label>
                                    <span className="ReviewLabel">
                                      {sslcCerficates[0].SSLC_CNo || "-"}
                                    </span>
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted "
                                    >
                                      {" "}
                                      Year of Passing
                                    </label>
                                    <span className="ReviewLabel">
                                      {sslcCerficates[0].SSLC_Year || "-"}
                                    </span>
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted "
                                    >
                                      {" "}
                                      Marks Percentage
                                    </label>
                                    <span className="ReviewLabel">
                                      {sslcCerficates[0].SSLC_Marks || "-"}
                                    </span>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted "
                                    >
                                      {" "}
                                      Education Board
                                    </label>
                                    <span className="ReviewLabel">
                                      {sslcCerficates[0].SSLC_Eboard || "-"}
                                    </span>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted "
                                    >
                                      {" "}
                                      Medium of Instruction
                                    </label>
                                    <span className="ReviewLabel">
                                      {sslcCerficates[0].SSLC_MI || "-"}
                                    </span>
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted "
                                    >
                                      {" "}
                                      School Name
                                    </label>
                                    <span className="ReviewLabel">
                                      {sslcCerficates[0].SSLC_Scl || "-"}
                                    </span>
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted "
                                    >
                                      {" "}
                                      Uploaded Certificate
                                      {sslcCerficates[0].SSLC_Path && (
                                        <a
                                          target="_blank"
                                          href={`${ImageUrlPrefix}/${sslcCerficates[0].SSLC_Path}`}
                                        >
                                          {" "}
                                          <Download className="download_icon" />
                                        </a>
                                      )}
                                    </label>
                                    <span className="ReviewLabel">
                                      {sslcCerficates[0].SSLC_Path !== null
                                        ? sslcCerficates[0].original_file_path
                                        : "-"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>{" "}
                      </div>
                    )}
                    {educationQualification.includes("HSC") && (
                      <div
                        className={
                          !educationQualification.includes("SSLC") &&
                            educationQualification.includes("HSC")
                            ? " col-md-12"
                            : " col-md-6 "
                        }
                      >
                        <section
                          className={`${!educationQualification.includes("SSLC") &&
                            educationQualification.includes("HSC")
                            ? ""
                            : ""
                            } sectionSix`}
                        >
                          <div className="row box">
                            <div className="col-md-12">
                              <p className="StepTitle">HSC</p>

                              <div className="row mb-3">
                                <div className="col-md-6">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted "
                                    >
                                      Certificate Number
                                    </label>
                                    <div className="ReviewLabel">
                                      {sslcCerficates[1].HSC_CNo || "-"}
                                    </div>
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted "
                                    >
                                      {" "}
                                      Year of Passing
                                    </label>
                                    <span className="ReviewLabel">
                                      {sslcCerficates[1].HSC_Year || "-"}
                                    </span>
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted "
                                    >
                                      {" "}
                                      Marks Percentage
                                    </label>
                                    <span className="ReviewLabel">
                                      {sslcCerficates[1].HSC_Marks || "-"}
                                    </span>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted "
                                    >
                                      {" "}
                                      Education Board
                                    </label>
                                    <span className="ReviewLabel">
                                      {sslcCerficates[1].HSC_Ebaord || "-"}
                                    </span>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted "
                                    >
                                      {" "}
                                      Medium of Instruction
                                    </label>
                                    <span className="ReviewLabel">
                                      {sslcCerficates[1].HSC_MI || "-"}
                                    </span>
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted "
                                    >
                                      {" "}
                                      School Name
                                    </label>
                                    <span className="ReviewLabel">
                                      {sslcCerficates[1].HSC_Scl || "-"}
                                    </span>
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted "
                                    >
                                      {" "}
                                      Uploaded Certificate
                                      {sslcCerficates[1].HSC_Path && (
                                        <a
                                          target="_blank"
                                          href={`${ImageUrlPrefix}/${sslcCerficates[1].HSC_Path}`}
                                        >
                                          {" "}
                                          <Download className="download_icon" />
                                        </a>
                                      )}
                                    </label>
                                    <span className="ReviewLabel">
                                      {sslcCerficates[1].HSC_Path !== null
                                        ? sslcCerficates[1].original_file_path
                                        : "-"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                    )}
                  </div>
                </div>
                {educationQualification.includes("UG") && (
                  <section className=" sectionSix">
                    <div className="row box">
                      <div className="col-md-12">
                        <p className="StepTitle">UG</p>

                        <div className="row mb-3">
                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Certificate Number
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[2].UGCertificateNumber || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Year of Passing
                              </label>
                              <span className="ReviewLabel">
                                {" "}
                                {sslcCerficates[2].UGYearpassing || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Degree
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[2].UGDegree || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Major
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[2].UGMajor || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Marks Percentage
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[2].UGMarksPercentage || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Class
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[2].UGClassName || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Name of Institute
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[2].UGNameInstitute || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Uploaded UG Certificate
                                {sslcCerficates[2].UG_Path && (
                                  <a
                                    target="_blank"
                                    href={`${ImageUrlPrefix}/${sslcCerficates[2].UG_Path}`}
                                  >
                                    {" "}
                                    <Download className="download_icon" />
                                  </a>
                                )}
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[2].UG_Path !== null
                                  ? sslcCerficates[2].original_file_path
                                  : "-"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                {educationQualification.includes("PG") && (
                  <section className=" sectionSix">
                    <div className="row box">
                      <div className="col-md-12">
                        <p className="StepTitle">PG</p>

                        <div className="row mb-3">
                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Certificate Number
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[3].PGCertificateNumber || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Year of Passing
                              </label>
                              <span className="ReviewLabel">
                                {" "}
                                {sslcCerficates[3].PGYearpassing || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Degree
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[3].PGDegree || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Major
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[3].PGMajor || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Marks Percentage
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[3].PGMarksPercentage || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                class
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[3].PGClassName || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Name of the college / university
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[3].PGNameInstitute || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Uploaded Certificate
                                {sslcCerficates[3].PG_Path && (
                                  <a
                                    target="_blank"
                                    href={`${ImageUrlPrefix}/${sslcCerficates[3].PG_Path}`}
                                  >
                                    {" "}
                                    <Download className="download_icon" />
                                  </a>
                                )}
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[3].PG_Path !== null
                                  ? sslcCerficates[3].original_file_path
                                  : "-"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                {educationQualification.includes("Integrated PG") && (
                  <section className=" sectionSix">
                    <div className="row box">
                      <div className="col-md-12">
                        <p className="StepTitle">Integrated PG</p>

                        <div className="row mb-3">
                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Certificate Number
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[4].IPCertificateNumber || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Year of Passing
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[4].IPYearpassing || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Degree
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[4].IPDegree || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Major
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[4].IPMajor || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Marks Percentage
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[4].IPMarksPercentage || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Class
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[4].IPClassName || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Name of the college / university
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[4].IPNameInstitute || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Uploaded Certificate
                                {sslcCerficates[4].IP_Path && (
                                  <a
                                    target="_blank"
                                    href={`${ImageUrlPrefix}/${sslcCerficates[4].IP_Path}`}
                                  >
                                    {" "}
                                    <Download className="download_icon" />
                                  </a>
                                )}
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[4].IP_Path !== null
                                  ? sslcCerficates[4].original_file_path
                                  : "-"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                {educationQualification.includes("Diploma") && (
                  <section className=" sectionSix">
                    <div className="row box">
                      <div className="col-md-12">
                        <p className="StepTitle">Diploma</p>

                        <div className="row mb-3">
                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Certificate Number
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[5].DCertificateNumber || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Year of Passing
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[5].DYearpassing || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Degree
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[5].DDegree || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Major
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[5].DMajor || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Marks of percentage
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[5].DMarksPercentage || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Class
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[5].DClassName || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Name of the college / university
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[5].DNameInstitute || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Uploaded Certificate
                                {sslcCerficates[5].D_Path && (
                                  <a
                                    target="_blank"
                                    href={`${ImageUrlPrefix}/${sslcCerficates[5].D_Path}`}
                                  >
                                    {" "}
                                    <Download className="download_icon" />
                                  </a>
                                )}
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[5].D_Path !== null
                                  ? sslcCerficates[5].original_file_path
                                  : "-"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                {educationQualification.includes("Professional Courses") && (
                  <section className=" sectionSix">
                    <div className="row box">
                      <div className="col-md-12">
                        <p className="StepTitle">Professional Courses</p>

                        <div className="row mb-3">
                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Certificate Number
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[6].PCCertificateNumber || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Year of Passing
                              </label>
                              <span className="ReviewLabel">
                                {" "}
                                {sslcCerficates[6].PCYearpassing || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Degree
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[6].PCDegree || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Major
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[6].PCMajor || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Marks Percentage
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[6].PCMarksPercentage || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Class
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[6].PCClassName || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Name of the college / university
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[6].PCNameInstitute || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Uploaded Certificate
                                {sslcCerficates[6].PC_Path && (
                                  <a
                                    target="_blank"
                                    href={`${ImageUrlPrefix}/${sslcCerficates[6].PC_Path}`}
                                  >
                                    {" "}
                                    <Download className="download_icon" />
                                  </a>
                                )}
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[6].PC_Path !== null
                                  ? sslcCerficates[6].original_file_path
                                  : "-"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                {educationQualification.includes("Others") && (
                  <section className="sectionSix">
                    <div className="row box">
                      <div className="col-md-12">
                        <p className="StepTitle">Others</p>

                        <div className="row mb-3">
                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Certificate Number
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[7].OtCertificateNumber || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Year of Passing
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[7].OtYearpassing || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Degree
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[7].OtDegree || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Major
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[7].OtMajor || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Marks Percentage
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[7].OtMarksPercentage || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Class
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[7].OtClassName || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Name of the college / university
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[7].OtNameInstitute || "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Uploaded Certificate
                                {sslcCerficates[7].Ot_Path && (
                                  <a
                                    target="_blank"
                                    href={`${ImageUrlPrefix}/${sslcCerficates[7].Ot_Path}`}
                                  >
                                    {" "}
                                    <Download className="download_icon" />
                                  </a>
                                )}
                              </label>
                              <span className="ReviewLabel">
                                {sslcCerficates[7].Ot_Path !== null
                                  ? sslcCerficates[7].original_file_path
                                  : "-"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                <div className="sectionSix">
                  <div className="row">
                    {techQualification.length > 0 &&
                      !(
                        techQualification[0].name === "" &&
                        techQualification[0].level === "" &&
                        techQualification[0].lang === "" &&
                        techQualification[0].Cnum === "" &&
                        techQualification[0].grade === "" &&
                        techQualification[0].year === "" &&
                        techQualification[0].file === ""
                      ) &&
                      techQualification.map((el, index) => (
                        <div
                          className={
                            techQualification.length === 1
                              ? "col-md-12 "
                              : "col-md-12 "
                          }
                          key={index}
                        >
                          <section className=" sectionSix">
                            <div className="row box ">
                              <div className="col-md-12 ">
                                <p className="StepTitle">
                                  Technical Qualification{" "}
                                  {techQualification.length === 1
                                    ? " "
                                    : `- ${index + 1}`}
                                </p>

                                <div className="row mb-3">
                                  <div className="col-md-3">
                                    <div className="forms ">
                                      <label
                                        htmlFor="inputName"
                                        className="form-label text-muted "
                                      >
                                        Technicnal Course
                                      </label>
                                      <span className="ReviewLabel">
                                        {el.name || "-"}
                                      </span>
                                    </div>
                                  </div>
                                  {el.name !== "Nil" && (
                                    <div className="col-md-3">
                                      <div className="forms ">
                                        <label
                                          htmlFor="inputName"
                                          className="form-label text-muted "
                                        >
                                          Typewriting Level
                                        </label>
                                        <span className="ReviewLabel">
                                          {el.level || "-"}
                                        </span>
                                      </div>
                                    </div>
                                  )}

                                  {el.name !== "Nil" && (
                                    <div className="col-md-3">
                                      <div className="forms ">
                                        <label
                                          htmlFor="inputName"
                                          className="form-label text-muted "
                                        >
                                          Language
                                        </label>
                                        <span className="ReviewLabel">
                                          {el.lang || "-"}
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                  {el.name !== "Nil" && (
                                    <div className="col-md-3">
                                      <div className="forms ">
                                        <label
                                          htmlFor="inputName"
                                          className="form-label text-muted "
                                        >
                                          Certificate Number
                                        </label>
                                        <span className="ReviewLabel">
                                          {el.Cnum || "-"}
                                        </span>
                                      </div>
                                    </div>
                                  )}

                                  {el.name !== "Nil" && (
                                    <div className="col-md-3">
                                      <div className="forms ">
                                        <label
                                          htmlFor="inputName"
                                          className="form-label text-muted "
                                        >
                                          Grade
                                        </label>
                                        <span className="ReviewLabel">
                                          {el.grade || "-"}
                                        </span>
                                      </div>
                                    </div>
                                  )}

                                  {el.name !== "Nil" && (
                                    <div className="col-md-3">
                                      <div className="forms ">
                                        <label
                                          htmlFor="inputName"
                                          className="form-label text-muted "
                                        >
                                          Year of Passing
                                        </label>
                                        <span className="ReviewLabel">
                                          {el.year !== "" ? el.year : "-"}
                                        </span>
                                      </div>
                                    </div>
                                  )}

                                  {el.name !== "Nil" && (
                                    <div className="col-md-3">
                                      <div className="forms ">
                                        <label
                                          htmlFor="inputName"
                                          className="form-label text-muted "
                                        >
                                          Upload Certificate
                                          {el.file && (
                                            <a
                                              target="_blank"
                                              href={`${ImageUrlPrefix}/${el.file}`}
                                            >
                                              {" "}
                                              <Download className="download_icon" />
                                            </a>
                                          )}
                                        </label>
                                        <span className="ReviewLabel">
                                          {el.original_file_path || "-"}
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      ))}
                  </div>
                </div>

                <section className="sectionSix">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Test Batch Enrollment</p>

                      <div className="row mb-3">
                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Category
                            </label>
                            <span className="ReviewLabel">
                              {" "}
                              {list.category || "-"}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Test Batch
                            </label>
                            <span className="ReviewLabel">
                              {list.CouresName !== ""
                                ? list.CouresName
                                : couName !== ""
                                  ? couName.coueName
                                  : ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Medium of Examination
                            </label>
                            <span className="ReviewLabel">
                              {list.TeachMedium || "-"}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Location
                            </label>
                            <span className="ReviewLabel">
                              {list.location_name !== ""
                                ? list.location_name
                                : list.location || "-"}
                            </span>
                          </div>
                        </div>
                        {selectedSub.length > 0 && (
                          <div className="col-md-7">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Subject
                              </label>
                              <span className="ReviewLabel">
                                {selectedSub.length > 0
                                  ? selectedSub.map((el) => el.value).join(", ")
                                  : null}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>

                <section className="sectionSix">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Batch Details</p>

                      {batchDetails
                        .filter((item) => item.is_selected === true)
                        .map((el, index) => (
                          <div className="row" key={index}>
                            <div className="col-md-12 mt-3 mb-3">
                              <div className="card  text-dark">
                                <div className="card-body BatchImage">
                                  <div className="row">
                                    <div className="col-lg-2 col-md-6 col-sm-12">
                                      <img
                                        src={`${ImageUrlPrefix}/${el.img_url}`}
                                        id={el.id}
                                        alt="Imge"
                                      />
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-12 d-flex flex-column ImageText  justify-content-center">
                                      <span className="ReviewLabels">
                                        {el.course_name || ""} - {el.name || ""}
                                      </span>
                                      {/* AIASA-000109 - v1 issues solved by lalitha */}
                                      <a
                                        target="_blank"
                                        href={`${ImageUrlPrefix}/${el.test_img_url}`}
                                        className="subtitle_testpdf ReviewLabel"
                                      >
                                        Click here to view test schedule
                                      </a>
                                    </div>
                                    <div className="col-lg-6 col-md-10 col-sm-12 col-xl-6 mt-2 ms-5 d-flex flex-column justify-content-center">
                                      <div className="row">
                                        <div className="col-md-12 col-sm-12 ">
                                          <div className="row">
                                            <div className="col-md-3">
                                              <li className="IconsImage">
                                                <span className="material-icons">
                                                  laptop_chromebook
                                                </span>
                                                <div className="d-flex flex-column">
                                                  <p className="title ms-1">
                                                    Class Mode
                                                  </p>
                                                  <span className="ReviewLabelss">
                                                    {el.class_mode || "-"}
                                                  </span>
                                                </div>
                                              </li>
                                            </div>
                                            <div className="col-md-3">
                                              <li className="IconsImage">
                                                <span className="material-icons">
                                                  event
                                                </span>
                                                <div className="d-flex flex-column ">
                                                  <p className="title ms-1">
                                                    Starts On
                                                  </p>
                                                  <span className="ReviewLabelss">
                                                    {moment
                                                      .utc(el.start_on)
                                                      .format("DD/MM/YYYY") ||
                                                      "-"}
                                                  </span>
                                                </div>
                                              </li>
                                            </div>
                                            <div className="col-md-3">
                                              <li className="IconsImage">
                                                <span className="material-icons">
                                                  assignment
                                                </span>
                                                <div className="d-flex flex-column">
                                                  <p className="title ms-1">
                                                    {/* Duration   */}
                                                    No. of Tests
                                                  </p>
                                                  <span className="ReviewLabelss">
                                                    {el.no_of_test || "-"}
                                                  </span>
                                                </div>
                                              </li>
                                            </div>
                                            <div className="col-md-3">
                                              <li className="IconsImage">
                                                <span className="material-icons">
                                                  currency_rupee
                                                </span>
                                                <div className="d-flex flex-column">
                                                  <p className="title ms-1">
                                                    Amount Payable
                                                  </p>
                                                  <span className="ReviewLabelss">
                                                    {el.dis_amt || "-"}
                                                  </span>
                                                </div>
                                              </li>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </section>

                <section className="sectionSix">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">
                        Have You Already Studied for Competitive Examination?
                      </p>
                      <div className="row mt-2 mb-3">
                        <div className="col-lg-3 col-md-6">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted  oneline"
                            >
                              Have You Already Studied for Competitive
                              Examination?
                            </label>
                            <span className="ReviewLabel mt-2">
                              {list.CompetitiveExamination || "-"}
                            </span>
                          </div>
                        </div>
                        {list.CompetitiveExamination === "Yes" && (
                          <div className="col-lg-3 col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Name of the Examination
                              </label>
                              <span className="ReviewLabel">
                                {list.CompetitiveExamination === "Yes"
                                  ? list.CompetitiveExamName || "-"
                                  : "-"}
                              </span>
                            </div>
                          </div>
                        )}

                        {list.CompetitiveExamination === "Yes" && (
                          <div className="col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Name of the Institute
                              </label>
                              <span className="ReviewLabel">
                                {list.CompetitiveExamination === "Yes"
                                  ? list.Institute || "-"
                                  : "-"}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>

                <section className=" sectionSix">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">
                        Have You Cleared Any Exam Previously?
                      </p>
                      <div className="row mt-2 mb-3">
                        <div className="col-lg-3 col-md-6">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted  oneline"
                            >
                              Have You Cleared Any Exam Previously?
                            </label>
                            <span className="ReviewLabel mt-2">
                              {list.ExamPreviously || "-"}
                            </span>
                          </div>
                        </div>
                        {list.ExamPreviously === "Yes" && (
                          <div className="col-lg-3 col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted  oneline"
                              >
                                How many exams have you cleared in the past?
                              </label>
                              <span className="ReviewLabel mt-2">
                                {list.ExamPreviously === "Yes"
                                  ? list.ExamWrite || ""
                                  : ""}
                              </span>
                            </div>
                          </div>
                        )}

                        {list.ExamPreviously === "Yes" && (
                          <div className="col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted  oneline"
                              >
                                Exam details
                              </label>
                              <span className="register_app_val mb-3">
                                {list.ExamPreviously === "Yes"
                                  ? examDetailsExam
                                    .map((item) => item.examvalue)
                                    .join(",") || ""
                                  : ""}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>

                <section className="sectionSix">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">
                        Are You a Government Employee?
                      </p>
                      <div className="row mb-3">
                        <div className="col-lg-3 col-md-6">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted  oneline"
                            >
                              Are You a Government Employee?
                            </label>
                            <span className="ReviewLabel">
                              {list.workingRes || ""}
                            </span>
                          </div>
                        </div>
                        {list.workingRes === "Yes" && (
                          <div className="col-lg-3 col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Designation
                              </label>
                              <span className="ReviewLabel">
                                {list.workingRes === "Yes"
                                  ? list.Designation || ""
                                  : ""}
                              </span>
                            </div>
                          </div>
                        )}

                        {list.workingRes === "Yes" && (
                          <div className="col-lg-3 col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Department
                              </label>
                              <span className="ReviewLabel">
                                {list.workingRes === "Yes"
                                  ? list.Department || ""
                                  : ""}
                              </span>
                            </div>
                          </div>
                        )}

                        {list.workingRes === "Yes" && (
                          <div className="col-lg-3 col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Joining Date of Government Job
                              </label>
                              <span className="ReviewLabel">
                                {list.workingRes === "Yes" ? list.JoinGovt : ""}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>

                <section className=" sectionSix">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Are You an AIASA Student?</p>
                      <div className="row mb-3">
                        <div className="col-lg-3 col-md-6">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted  oneline"
                            >
                              Are You an AIASA Student?
                            </label>
                            <span className="ReviewLabel">
                              {list.AIASAStudent || ""}
                            </span>
                          </div>
                        </div>
                        {list.AIASAStudent === "Yes" && (
                          <>
                            <div className="col-lg-3 col-md-6">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted "
                                >
                                  Year
                                </label>
                                <span className="ReviewLabel">
                                  {list.AIASAStudent === "Yes"
                                    ? list.Year || ""
                                    : "-"}
                                </span>
                              </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted "
                                >
                                  category
                                </label>
                                <span className="ReviewLabel">
                                  {list.AIASAStudent === "Yes"
                                    ? list.CategoryAias || ""
                                    : "-"}
                                </span>
                              </div>
                            </div>

                            <div className="col-lg-3 col-md-6">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted "
                                >
                                  Course
                                </label>
                                <span className="ReviewLabel">
                                  {list.AIASAStudent === "Yes"
                                    ? list.CourseAias || ""
                                    : "-"}
                                </span>
                              </div>
                            </div>

                            <div className="col-lg-3 col-md-6">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted "
                                >
                                  ID Number
                                </label>
                                <span className="ReviewLabel">
                                  {list.AIASAStudent === "Yes"
                                    ? list.IDNumber || ""
                                    : "-"}
                                </span>
                              </div>
                            </div>

                            <div className="col-lg-3 col-md-6">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted  "
                                >
                                  Upload ID Card
                                  {list.AIASAStudent === "Yes" &&
                                    list.IDPhoto !== "" &&
                                    list.IDPhoto !== null && (
                                      <a
                                        target="_blank"
                                        href={`${ImageUrlPrefix}/${list.IDPhoto}`}
                                      >
                                        {" "}
                                        <Download className="download_icon" />
                                      </a>
                                    )}
                                </label>
                                <span className="ReviewLabel">
                                  {list.AIASAStudent === "Yes"
                                    ? list.IDPhoto !== null &&
                                      list.IDPhoto !== ""
                                      ? list.original_aiasa_id_path
                                      : ""
                                    : "-"}
                                </span>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div
                      className="form-check  form-check-inline"
                      id="Verifycheckbox"
                    >
                      <input
                        ref={txtadVerifyHere}
                        className="form-check-input mt-0"
                        type="checkbox"
                        id="Verify"
                        name="Verify"
                        onChange={handleChange}
                        checked={list.Verify === true ? true : false}
                        value="Yes"
                      />
                      <label className="LablePrivacyText" htmlFor="Verify">
                        I hereby certify that the above information are true and
                        correct to the best of my knowledge and belief.
                        <a
                          className="LablePrivacy align-baseline"
                        href={"/AdmissionTermsAndCondition"}
                        >
                          Terms and Conditions
                        </a>
                      </label>
                      {listErrors.Verify && (
                        <span className="errors align-top ms-3">
                          {listErrors.Verify}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="heading mt-3 mb-4 dflexbetww ">
                    <div className="">
                      <button
                        type="button"
                        className="SaveButton_Prev"
                        onClick={handlePrevious}
                      >
                        <a href="javascript:void(0)">Go to Course Selection</a>
                      </button>
                    </div>
                    <div className="d-flex smButton  mobiledown">
                      <Link to="/" className="CancelButton">
                        Back to Home
                      </Link>
                      <button
                        type="button"
                        className="SaveButton"
                        disabled={stepperButton}
                        onClick={handleNext}
                      >
                        <a href="javascript:void(0)">
                          Save and Continue to Payment Info
                        </a>
                      </button>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </fieldset>
        )}
        {/* {step === 6} */}
        {step === 6 && (
          <fieldset>
            <div className="sectionSix">
              {batchDetails
                .filter((item) => item.is_selected === true)
                .map((itk, index) => (
                  <>
                    {" "}
                    <div className="heading mb-4 dflexbetww " key={index}>
                      <div className="">
                        <button
                          type="button"
                          className="SaveButton_Prev"
                          onClick={handlePrevious}
                        >
                          <a href="javascript:void(0)">
                            Go to Review Information
                          </a>
                        </button>
                      </div>
                      <div className="d-flex smButton mobiledown">
                        <Link to="/" className="CancelButton">
                          Back to Home
                        </Link>
                        {list.PPaymentMode === "0" ? (
                          <button
                            onClick={() =>
                              handleSubmitCash(
                                itk.id,
                                dis,
                                itk.offer_spl - couponApplied.amount,
                                itk.offer_spl,
                                list.PPayment === "1"
                                  ? (
                                    ((itk.dis_amt -
                                      couponApplied.amount +
                                      GSTPRICE *
                                      (itk.dis_amt -
                                        couponApplied.amount)) *
                                      itk.pay_1_perc) /
                                    100
                                  ).toFixed(2)
                                  : (
                                    itk.dis_amt -
                                    couponApplied.amount +
                                    GSTPRICE *
                                    (itk.dis_amt - couponApplied.amount) -
                                    dis
                                  ).toFixed(2),
                                list.PPayment === "1"
                                  ? (
                                    itk.dis_amt -
                                    couponApplied.amount +
                                    GSTPRICE *
                                    (itk.dis_amt - couponApplied.amount) -
                                    dis
                                  ).toFixed(2)
                                  : (
                                    itk.dis_amt -
                                    couponApplied.amount +
                                    GSTPRICE *
                                    (itk.dis_amt - couponApplied.amount) -
                                    dis
                                  ).toFixed(2),
                                (
                                  (itk.dis_amt - couponApplied.amount) *
                                  GSTPRICE
                                ).toFixed(2),
                                itk.course_name,
                                list.CourseCate
                              )
                            }
                            type="button"
                            className={`primaryButton text-center ${stepperButton || list.PPayment === "1"
                              ? ((itk.dis_amt -
                                (couponApplied.status &&
                                  message ===
                                  "Coupon code applied successfully"
                                  ? parseInt(couponApplied.amount)
                                  : 0) +
                                GSTPRICE *
                                (itk.dis_amt -
                                  (couponApplied.status &&
                                    message ===
                                    "Coupon code applied successfully"
                                    ? parseInt(couponApplied.amount)
                                    : 0))) *
                                itk.pay_1_perc) /
                                100 <=
                                0
                                ? "disabledbtn"
                                : "SaveButton"
                              : itk.dis_amt -
                                couponApplied.amount +
                                GSTPRICE *
                                (itk.dis_amt - couponApplied.amount) -
                                (dis || 0) <=
                                0
                                ? "disabledbtn"
                                : "SaveButton"
                              }`}
                            disabled={
                              stepperButton || list.PPayment === "1"
                                ? ((itk.dis_amt -
                                  (couponApplied.status &&
                                    message ===
                                    "Coupon code applied successfully"
                                    ? parseInt(couponApplied.amount)
                                    : 0) +
                                  GSTPRICE *
                                  (itk.dis_amt -
                                    (couponApplied.status &&
                                      message ===
                                      "Coupon code applied successfully"
                                      ? parseInt(couponApplied.amount)
                                      : 0))) *
                                  itk.pay_1_perc) /
                                100 <=
                                0
                                : itk.dis_amt -
                                couponApplied.amount +
                                GSTPRICE *
                                (itk.dis_amt - couponApplied.amount) -
                                (dis || 0) <=
                                0
                            }
                          >
                            {/* <a href="javascript:void(0)"> */}
                            Submit
                            {/* </a> */}
                          </button>
                        ) : (
                          <button
                            type="button"
                            className={`primaryButton text-center ${stepperButton || list.PPayment === "1"
                              ? ((itk.dis_amt -
                                (couponApplied.status &&
                                  message ===
                                  "Coupon code applied successfully"
                                  ? parseInt(couponApplied.amount)
                                  : 0) +
                                GSTPRICE *
                                (itk.dis_amt -
                                  (couponApplied.status &&
                                    message ===
                                    "Coupon code applied successfully"
                                    ? parseInt(couponApplied.amount)
                                    : 0))) *
                                itk.pay_1_perc) /
                                100 <=
                                0
                                ? "disabledbtn"
                                : "SaveButton"
                              : itk.dis_amt -
                                couponApplied.amount +
                                GSTPRICE *
                                (itk.dis_amt - couponApplied.amount) -
                                (dis || 0) <=
                                0
                                ? "disabledbtn"
                                : "SaveButton"
                              }`}
                            disabled={
                              stepperButton || list.PPayment === "1"
                                ? ((itk.dis_amt -
                                  (couponApplied.status &&
                                    message ===
                                    "Coupon code applied successfully"
                                    ? parseInt(couponApplied.amount)
                                    : 0) +
                                  GSTPRICE *
                                  (itk.dis_amt -
                                    (couponApplied.status &&
                                      message ===
                                      "Coupon code applied successfully"
                                      ? parseInt(couponApplied.amount)
                                      : 0))) *
                                  itk.pay_1_perc) /
                                100 <=
                                0
                                : itk.dis_amt -
                                couponApplied.amount +
                                GSTPRICE *
                                (itk.dis_amt - couponApplied.amount) -
                                (dis || 0) <=
                                0
                            }
                            onClick={() =>
                              handleSubmit(
                                itk.id,
                                dis,
                                itk.offer_spl - couponApplied.amount,
                                itk.offer_spl,
                                list.PPayment === "1"
                                  ? (
                                    ((itk.dis_amt -
                                      couponApplied.amount +
                                      GSTPRICE *
                                      (itk.dis_amt -
                                        couponApplied.amount)) *
                                      itk.pay_1_perc) /
                                    100
                                  ).toFixed(2)
                                  : (
                                    itk.dis_amt -
                                    couponApplied.amount +
                                    GSTPRICE *
                                    (itk.dis_amt - couponApplied.amount) -
                                    dis
                                  ).toFixed(2),
                                list.PPayment === "1"
                                  ? (
                                    itk.dis_amt -
                                    couponApplied.amount +
                                    GSTPRICE *
                                    (itk.dis_amt - couponApplied.amount) -
                                    dis
                                  ).toFixed(2)
                                  : (
                                    itk.dis_amt -
                                    couponApplied.amount +
                                    GSTPRICE *
                                    (itk.dis_amt - couponApplied.amount) -
                                    dis
                                  ).toFixed(2),
                                (
                                  (itk.dis_amt - couponApplied.amount) *
                                  GSTPRICE
                                ).toFixed(2),
                                itk.course_name,
                                list.CourseCate
                              )
                            }
                          >
                            {/* <a href="javascript:void(0)"> */}
                            Save and Continue to Payment Gateway
                            {/* </a> */}
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row" id={itk.id} key={index}>
                          <div className="col-lg-6 col-md-12">
                            <div className="card h-100">
                              <div className="row">
                                <div className="col-md-6 d-flex flex-column  justify-content-center align-center mt-4">
                                  <img
                                    className="payment"
                                    src={`${ImageUrlPrefix}/${itk.img_url}`}
                                    alt="course_book"
                                    style={{
                                      width: "130px",
                                      height: "130px",
                                      alignSelf: "center",
                                    }}
                                  />
                                  <h5 className="card-title payment_course_name">
                                    {itk.course_name || ""} {"-"}{" "}
                                    {itk.name || ""}
                                  </h5>
                                  <p className=" ms-3 text-center payment_batch_name">
                                    {itk.batch_type} - {itk.batch_details}
                                  </p>
                                </div>
                                <div className="col-md-6">
                                  <div
                                    className="d-flex mt-4 flex-column align-items-start payment
"
                                  >
                                    <div className="">
                                      <LaptopChromebook className="payment_icon" />
                                      <div className="innerflex_payment">
                                        <h6 className="payment flex_title">
                                          Class Mode
                                        </h6>
                                        <h6 className="payment flex_subtitle">
                                          {itk.class_mode}
                                        </h6>
                                      </div>
                                    </div>

                                    <div className="">
                                      <Today className="payment_icon" />
                                      <div className="innerflex_payment">
                                        <h6 className="payment flex_title">
                                          Starts On
                                        </h6>
                                        <h6 className="payment flex_subtitle">
                                          {moment
                                            .utc(itk.start_on)
                                            .format("DD/MM/YYYY")}
                                        </h6>
                                      </div>
                                    </div>
                                    <div className="">
                                      <Alarm className="payment_icon" />
                                      <div className="innerflex_payment">
                                        <h6 className="payment flex_title">
                                          Duration
                                        </h6>
                                        <h6 className="payment flex_subtitle">
                                          {itk.duration}
                                        </h6>
                                      </div>
                                    </div>
                                    <div className="">
                                      <span class="material-icons payment_icon">
                                        g_translate
                                      </span>
                                      <div className="innerflex_payment">
                                        <h6 className="payment flex_title">
                                          Medium of Instruction
                                        </h6>
                                        <h6 className="payment flex_subtitle">
                                          {itk.medium}
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <div className="card h-100">
                              <div className="row mt-4">
                                <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                  <h6 className="Payment_labelInfo">
                                    Actual Course Fee
                                  </h6>
                                </div>
                                <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                  <h6 className="Payment_labelInfos">
                                    <CurrencyRupee className="payment_currency" />
                                    {itk.act_c_fee}
                                  </h6>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                  <h6 className="payment_fees_name">
                                    Special Offer
                                  </h6>
                                </div>
                                <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                  <h6 className="payment_fees">
                                    <CurrencyRupee className="payment_currency" />
                                    {itk.offer_spl}
                                  </h6>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                  <h6 className="payment_fees_name PymentCoun">
                                    Coupon Code
                                  </h6>
                                </div>
                                <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                  <div className="d-flex coupon_box mb-1">
                                    <input
                                      ref={txtAdCouponCode}
                                      type="text"
                                      id="CouponCode"
                                      name="CouponCode"
                                      onChange={handleChange}
                                      value={couponApplied.coupon_code}
                                      // className={`payment_fees payment_input gap-2 payment_fees_mobile ${listErrors.coupon_code ? 'mb-0' : 'mb-0'} ${couponApplied.status === false ? 'mb-0' : ''} `}

                                      className={`payment_fees payment_input gap-2 payment_fees_mobile ${listErrors.coupon_code ? "mb-0" : ""
                                        }`}
                                      placeholder="Coupon Code"
                                    />
                                    &nbsp;&nbsp;
                                    <button
                                      className={`btn payment payment_coupen ${listErrors.coupon_code ? "mb-0" : ""
                                        } ${couponApplied.status === false
                                          ? "mb-0"
                                          : "mb-0"
                                        }`}
                                      type="button"
                                      onClick={(e) =>
                                        handleCouponCode(
                                          e,
                                          itk.act_c_fee,
                                          itk.id
                                        )
                                      }
                                    >
                                      Apply Coupon Code
                                    </button>
                                  </div>

                                  {listErrors.coupon_code && (
                                    <p className="errors mx-0 my-1">
                                      {listErrors.coupon_code}
                                    </p>
                                  )}

                                  {message && (
                                    <p
                                      className={`mx-0 my-1 ${couponApplied.status &&
                                        message ===
                                        "Coupon code applied successfully"
                                        ? "text-success"
                                        : "errors"
                                        }`}
                                    >
                                      {message}
                                    </p>
                                  )}
                                </div>
                              </div>
                              {couponApplied.status &&
                                message ===
                                "Coupon code applied successfully" && (
                                  <div className="row">
                                    <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                      <h6 className="payment_fees_name">
                                        Coupon Code Amount
                                      </h6>
                                    </div>
                                    <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                      <h6 className="payment_fees">
                                        <CurrencyRupee className="payment_currency" />
                                        <span>{couponApplied.amount}</span>
                                      </h6>
                                    </div>
                                  </div>
                                )}

                              <div className="row">
                                <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                  <h6
                                    className="Payment_labelInfo"
                                    style={{ paddingTop: "9px" }}
                                  >
                                    Total Discount
                                  </h6>
                                </div>
                                <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                  <h6 className="Payment_labelInfos">
                                    <CurrencyRupee className="payment_currency" />
                                    <span>
                                      {couponApplied.status &&
                                        message ===
                                        "Coupon code applied successfully"
                                        ? parseInt(itk.offer_spl) +
                                        parseInt(couponApplied.amount)
                                        : 0}
                                    </span>
                                  </h6>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                  <h6 className="payment_fees_name">
                                    Amount Payable
                                  </h6>
                                </div>
                                <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                  <h6 className="payment_fees">
                                    <CurrencyRupee className="payment_currency" />
                                    <span>
                                      {itk.dis_amt -
                                        (couponApplied.status &&
                                          message ===
                                          "Coupon code applied successfully"
                                          ? parseInt(itk.offer_spl) +
                                          parseInt(couponApplied.amount)
                                          : 0)}
                                    </span>
                                  </h6>
                                </div>
                              </div>
                              {/* <div className="row">
                                <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                  <h6 className="payment_fees_name">
                                    GST(0%)
                                  </h6>
                                </div>
                                <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                  <h6 className="payment_fees">
                                    <CurrencyRupee className="payment_currency" />
                                    <span className="">
                                      {" "}
                                      {(
                                        (itk.dis_amt - (couponApplied.status && message === "Coupon code applied successfully"
                                          ? parseInt(couponApplied.amount)
                                          : 0)) *
                                        GSTPRICE
                                      ).toFixed(2)}
                                    </span>
                                  </h6>
                                </div>
                              </div> */}
                              <div className="row">
                                <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                  <h6
                                    className="Payment_labelInfo"
                                    id="remain_fee"
                                  >
                                    Net Amount to Pay
                                  </h6>
                                </div>
                                <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                  <h6 className="Payment_labelInfos">
                                    <CurrencyRupee className="payment_currency" />
                                    <span>
                                      {(
                                        itk.dis_amt -
                                        (couponApplied.status &&
                                          message ===
                                          "Coupon code applied successfully"
                                          ? parseInt(couponApplied.amount)
                                          : 0) +
                                        GSTPRICE *
                                        (itk.dis_amt -
                                          (couponApplied.status &&
                                            message ===
                                            "Coupon code applied successfully"
                                            ? parseInt(couponApplied.amount)
                                            : 0))
                                      ).toFixed(2)}
                                    </span>
                                  </h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {dis !== 0 && (
                      <section className="sectionSix">
                        <div className="row box">
                          <div className="col-md-12">
                            <p className="StepTitle">Old Student Discount</p>
                            <div className="row mb-3">
                              <div className="col-md-3">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted"
                                  >
                                    Old Student Discount
                                  </label>
                                  <span className="ReviewLabel align-middle">
                                    <CurrencyRupee className="payment_currency" />{" "}
                                    {dis}
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-12 col-lg-12 mt-2 mb-2">
                                <div className="forms ">
                                  <span className="ReviewLabel_note alert_info">
                                    <strong> Note :</strong> The Old Student
                                    Discount will be applied to the final
                                    installment only if you select the Partial
                                    Payment option. Alternatively, if you choose
                                    the Full Payment option, the Old Student
                                    Discount amount will be deducted from the
                                    payment immediately.
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    )}
                    <section className="sectionSix">
                      <div className="row box">
                        <div className="col-md-12">
                          <p className="StepTitle">Payment Mode</p>
                          <div className="row ">
                            <div className="col-md-6 col-lg-6">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted"
                                >
                                  Payment Mode
                                </label>
                                <div
                                  className="d-flex  col-md-12"
                                  id="radiobuttons"
                                >
                                  <div className="form-check form-check-inline">
                                    <input
                                      ref={txtAdPPaymentMode}
                                      className="checkbox_radio"
                                      type="radio"
                                      name="PPaymentMode"
                                      id="onlinemode"
                                      checked={
                                        list.PPaymentMode === "1" ? true : false
                                      }
                                      value="1"
                                      onChange={handleChange}
                                    />
                                    <label
                                      className="checkbox-label mt-1"
                                      htmlFor="onlinemode"
                                    >
                                      Online
                                    </label>
                                  </div>
                                  <div className="form-check form-check-inline">
                                    <input
                                      className="checkbox_radio"
                                      type="radio"
                                      name="PPaymentMode"
                                      id="CashMode"
                                      value="0"
                                      checked={
                                        list.PPaymentMode === "0" ? true : false
                                      }
                                      onChange={handleChange}
                                    />
                                    <label
                                      className="checkbox-label mt-1"
                                      htmlFor="CashMode"
                                    >
                                      Cash
                                    </label>
                                  </div>
                                </div>
                                {listErrors.PPaymentMode && (
                                  <p className="errors">
                                    {listErrors.PPaymentMode}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="row mb-3">
                            <div className="col-md-12 col-lg-12 mt-2 mb-2">
                              <div className="forms ">
                                <span className="ReviewLabel_note alert_info">
                                  <strong> NOTE: </strong> If you've chosen cash
                                  payment, a unique Order ID will be shared
                                  after form submission. Note it down and visit
                                  the office reception to pay your specified
                                  fees. Contact the finance admin at the
                                  reception for assistance.
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                    <section className="sectionSix">
                      <div className="row box">
                        <div className="col-md-12">
                          <p className="StepTitle">Payment Option</p>
                          <div className="row mb-3">
                            <div className="col-md-6 col-lg-6">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted"
                                >
                                  Payment Option
                                </label>
                                <div
                                  className="d-flex  col-md-12"
                                  id="radiobuttons"
                                >
                                  <div className="form-check form-check-inline">
                                    <input
                                      ref={txtAdPPayment}
                                      className="checkbox_radio"
                                      type="radio"
                                      name="PPayment"
                                      id="full"
                                      checked={
                                        list.PPayment === "0" ? true : false
                                      }
                                      value="0"
                                      onChange={handleChange}
                                    />
                                    <label
                                      className="checkbox-label mt-1"
                                      htmlFor="full"
                                    >
                                      Full Payment
                                    </label>
                                  </div>
                                  {itk.partial_payment === 1 ? (
                                    <div className="form-check form-check-inline">
                                      <input
                                        className="checkbox_radio"
                                        type="radio"
                                        name="PPayment"
                                        id="Partial"
                                        value="1"
                                        checked={
                                          list.PPayment == "1" ||
                                            list.PPayment == 1
                                            ? true
                                            : false
                                        }
                                        onChange={handleChange}
                                      />
                                      <label
                                        className="checkbox-label mt-1"
                                        htmlFor="Partial"
                                      >
                                        Partial Payment
                                      </label>
                                    </div>
                                  ) : (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip id="tooltip">
                                          For this batch, the partial payment
                                          option is not available.
                                        </Tooltip>
                                      }
                                    >
                                      <div className="form-check form-check-inline">
                                        <input
                                          className="checkbox_radio"
                                          type="radio"
                                          name="PPayment"
                                          id="Partial"
                                          value="1"
                                          disabled
                                          checked={
                                            list.PPayment == "1" ||
                                              list.PPayment == 1
                                              ? true
                                              : false
                                          }
                                          onChange={handleChange}
                                        />
                                        <label
                                          className="checkbox-label mt-1"
                                          htmlFor="Partial"
                                        >
                                          Partial Payment
                                        </label>
                                      </div>
                                    </OverlayTrigger>
                                  )}
                                </div>
                                {listErrors.PPayment && (
                                  <p className="errors">
                                    {listErrors.PPayment}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6 col-lg-6">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted"
                                >
                                  Amount To Pay{" "}
                                  {dis !== 0
                                    ? list.PPayment === "0"
                                      ? `(${itk.pay_1_perc
                                        ? itk.pay_1_perc +
                                        itk.pay_2_perc +
                                        itk.pay_3_perc
                                        : "100"
                                      } % Final Course Fee - Old Student Discount)`
                                      : `(${itk.pay_1_perc
                                        ? itk.pay_1_perc
                                        : "100"
                                      }% Final Course Fee)`
                                    : list.PPayment === "0"
                                      ? `(${itk.pay_1_perc
                                        ? itk.pay_1_perc +
                                        itk.pay_2_perc +
                                        itk.pay_3_perc
                                        : "100"
                                      } % Final Course Fee)`
                                      : `(${itk.pay_1_perc ? itk.pay_1_perc : "100"
                                      }% Final Course Fee)`}
                                </label>
                                <span className="ReviewLabel align-middle mt-sm-4 mt-lg-1">
                                  <CurrencyRupee className="payment_currency" />
                                  {list.PPayment === "1"
                                    ? (
                                      ((itk.dis_amt -
                                        (couponApplied.status &&
                                          message ===
                                          "Coupon code applied successfully"
                                          ? parseInt(couponApplied.amount)
                                          : 0) +
                                        GSTPRICE *
                                        (itk.dis_amt -
                                          (couponApplied.status &&
                                            message ===
                                            "Coupon code applied successfully"
                                            ? parseInt(couponApplied.amount)
                                            : 0))) *
                                        itk.pay_1_perc) /
                                      100
                                    ).toFixed(2)
                                    : (
                                      itk.dis_amt -
                                      (couponApplied.status &&
                                        message ===
                                        "Coupon code applied successfully"
                                        ? parseInt(couponApplied.amount)
                                        : 0) +
                                      GSTPRICE *
                                      (itk.dis_amt -
                                        (couponApplied.status &&
                                          message ===
                                          "Coupon code applied successfully"
                                          ? parseInt(couponApplied.amount)
                                          : 0)) -
                                      dis
                                    ).toFixed(2) > 0
                                      ? (
                                        itk.dis_amt -
                                        (couponApplied.status &&
                                          message ===
                                          "Coupon code applied successfully"
                                          ? parseInt(couponApplied.amount)
                                          : 0) +
                                        GSTPRICE *
                                        (itk.dis_amt -
                                          (couponApplied.status &&
                                            message ===
                                            "Coupon code applied successfully"
                                            ? parseInt(couponApplied.amount)
                                            : 0)) -
                                        dis
                                      ).toFixed(2)
                                      : 0}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                    {list.PPayment === "1" && (
                      <section className="sectionSix">
                        <div className="row box">
                          <div className="col-md-12">
                            <p className="StepTitle">
                              Partial Payment Schedule Details
                            </p>
                            <div className="row mb-3">
                              <div className="col-md-6 col-lg-6">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted"
                                  >
                                    2nd Payment Date (On or Before)
                                  </label>
                                  <span className="ReviewLabel  ">
                                    {itk.pay_2_duedate
                                      ? moment(
                                        itk.pay_2_duedate,
                                        "DD-MM-YYYY",
                                        true
                                      ).isValid()
                                        ? moment(
                                          itk.pay_2_duedate,
                                          "DD-MM-YYYY"
                                        ).format("YYYY-MM-DD")
                                        : moment(itk.pay_2_duedate).format(
                                          "YYYY-MM-DD"
                                        )
                                      : ""}
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-6 col-lg-6">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted"
                                  >
                                    2nd Payment Amount (
                                    {itk.pay_2_perc ? itk.pay_2_perc : "0"}% of
                                    Final Course Fee)
                                  </label>
                                  <span className="ReviewLabel align-middle mt-sm-4 mt-lg-1">
                                    <CurrencyRupee className="payment_currency" />{" "}
                                    {(
                                      ((itk.dis_amt -
                                        (couponApplied.status &&
                                          message ===
                                          "Coupon code applied successfully"
                                          ? parseInt(couponApplied.amount)
                                          : 0) +
                                        GSTPRICE *
                                        (itk.dis_amt -
                                          (couponApplied.status &&
                                            message ===
                                            "Coupon code applied successfully"
                                            ? parseInt(couponApplied.amount)
                                            : 0))) *
                                        itk.pay_2_perc) /
                                      100
                                    ).toFixed(2)}
                                  </span>
                                </div>
                              </div>

                              <div className="col-md-6 col-lg-6">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted"
                                  >
                                    3rd Payment Date (On or Before)
                                  </label>
                                  <span className="ReviewLabel align-middle">
                                    {itk.pay_3_duedate
                                      ? moment(
                                        itk.pay_3_duedate,
                                        "DD-MM-YYYY",
                                        true
                                      ).isValid()
                                        ? moment(
                                          itk.pay_3_duedate,
                                          "DD-MM-YYYY"
                                        ).format("YYYY-MM-DD")
                                        : moment(itk.pay_3_duedate).format(
                                          "YYYY-MM-DD"
                                        )
                                      : ""}
                                  </span>
                                </div>
                              </div>

                              <div className="col-md-6 col-lg-6">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted"
                                  >
                                    3rd Payment Amount{" "}
                                    {dis !== 0
                                      ? `(${itk.pay_3_perc ? itk.pay_3_perc : "0"
                                      }% of Final Course Fee - Old Student Discount)`
                                      : `(${itk.pay_3_perc}% of Final Course Fee)`}
                                  </label>
                                  <span className="ReviewLabel align-middle mt-sm-4 mt-lg-1">
                                    <CurrencyRupee className="payment_currency" />
                                    {dis !== 0 && itk.pay_3_perc !== null
                                      ? (
                                        ((itk.dis_amt -
                                          (couponApplied.status &&
                                            message ===
                                            "Coupon code applied successfully"
                                            ? parseInt(couponApplied.amount)
                                            : 0) +
                                          GSTPRICE *
                                          (itk.dis_amt -
                                            (couponApplied.status &&
                                              message ===
                                              "Coupon code applied successfully"
                                              ? parseInt(
                                                couponApplied.amount
                                              )
                                              : 0))) *
                                          itk.pay_3_perc) /
                                        100 -
                                        dis
                                      ).toFixed(2)
                                      : (
                                        ((itk.dis_amt -
                                          (couponApplied.status &&
                                            message ===
                                            "Coupon code applied successfully"
                                            ? parseInt(couponApplied.amount)
                                            : 0) +
                                          GSTPRICE *
                                          (itk.dis_amt -
                                            (couponApplied.status &&
                                              message ===
                                              "Coupon code applied successfully"
                                              ? parseInt(
                                                couponApplied.amount
                                              )
                                              : 0))) *
                                          itk.pay_3_perc) /
                                        100
                                      ).toFixed(2)}
                                  </span>
                                </div>
                              </div>

                              <div className="col-md-12 col-lg-12">
                                <div className="forms  ">
                                  <span className=" ReviewLabel_warning alert_warning ">
                                    <div className="blink">
                                      <span class="material-icons ">
                                        warning
                                      </span>
                                      <strong className="waning_message">
                                        WARNING
                                      </strong>
                                      <span className="">
                                        : Please pay your fees by the given date
                                        to keep your schedule active. If you
                                        don't pay on time, you will not be
                                        allowed to attend classes until the fees
                                        are paid.
                                      </span>
                                    </div>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    )}
                    <div className="heading  mb-4 dflexbetww ">
                      <div className="">
                        <button
                          type="button"
                          className="SaveButton_Prev"
                          onClick={handlePrevious}
                        >
                          <a href="javascript:void(0)">
                            Go to Review Information
                          </a>
                        </button>
                      </div>
                      <div className="d-flex smButton  mobiledown">
                        <Link to="/" className="CancelButton">
                          Back to Home
                        </Link>
                        {list.PPaymentMode === "0" ? (
                          <button
                            onClick={() =>
                              handleSubmitCash(
                                itk.id,
                                dis,
                                itk.offer_spl - couponApplied.amount,
                                itk.offer_spl,
                                list.PPayment === "1"
                                  ? (
                                    ((itk.dis_amt -
                                      couponApplied.amount +
                                      GSTPRICE *
                                      (itk.dis_amt -
                                        couponApplied.amount)) *
                                      itk.pay_1_perc) /
                                    100
                                  ).toFixed(2)
                                  : (
                                    itk.dis_amt -
                                    couponApplied.amount +
                                    GSTPRICE *
                                    (itk.dis_amt - couponApplied.amount) -
                                    dis
                                  ).toFixed(2),
                                list.PPayment === "1"
                                  ? (
                                    itk.dis_amt -
                                    couponApplied.amount +
                                    GSTPRICE *
                                    (itk.dis_amt - couponApplied.amount) -
                                    dis
                                  ).toFixed(2)
                                  : (
                                    itk.dis_amt -
                                    couponApplied.amount +
                                    GSTPRICE *
                                    (itk.dis_amt - couponApplied.amount) -
                                    dis
                                  ).toFixed(2),
                                (
                                  (itk.dis_amt - couponApplied.amount) *
                                  GSTPRICE
                                ).toFixed(2),
                                itk.course_name,
                                list.CourseCate
                              )
                            }
                            type="button"
                            className={`primaryButton text-center ${stepperButton || list.PPayment === "1"
                              ? ((itk.dis_amt -
                                (couponApplied.status &&
                                  message ===
                                  "Coupon code applied successfully"
                                  ? parseInt(couponApplied.amount)
                                  : 0) +
                                GSTPRICE *
                                (itk.dis_amt -
                                  (couponApplied.status &&
                                    message ===
                                    "Coupon code applied successfully"
                                    ? parseInt(couponApplied.amount)
                                    : 0))) *
                                itk.pay_1_perc) /
                                100 <=
                                0
                                ? "disabledbtn"
                                : "SaveButton"
                              : itk.dis_amt -
                                couponApplied.amount +
                                GSTPRICE *
                                (itk.dis_amt - couponApplied.amount) -
                                (dis || 0) <=
                                0
                                ? "disabledbtn"
                                : "SaveButton"
                              }`}
                            disabled={
                              stepperButton || list.PPayment === "1"
                                ? ((itk.dis_amt -
                                  (couponApplied.status &&
                                    message ===
                                    "Coupon code applied successfully"
                                    ? parseInt(couponApplied.amount)
                                    : 0) +
                                  GSTPRICE *
                                  (itk.dis_amt -
                                    (couponApplied.status &&
                                      message ===
                                      "Coupon code applied successfully"
                                      ? parseInt(couponApplied.amount)
                                      : 0))) *
                                  itk.pay_1_perc) /
                                100 <=
                                0
                                : itk.dis_amt -
                                couponApplied.amount +
                                GSTPRICE *
                                (itk.dis_amt - couponApplied.amount) -
                                (dis || 0) <=
                                0
                            }
                          >
                            {/* <a href="javascript:void(0)"> */}
                            Submit
                            {/* </a> */}
                          </button>
                        ) : (
                          <button
                            type="button"
                            className={`primaryButton text-center ${stepperButton || list.PPayment === "1"
                              ? ((itk.dis_amt -
                                (couponApplied.status &&
                                  message ===
                                  "Coupon code applied successfully"
                                  ? parseInt(couponApplied.amount)
                                  : 0) +
                                GSTPRICE *
                                (itk.dis_amt -
                                  (couponApplied.status &&
                                    message ===
                                    "Coupon code applied successfully"
                                    ? parseInt(couponApplied.amount)
                                    : 0))) *
                                itk.pay_1_perc) /
                                100 <=
                                0
                                ? "disabledbtn"
                                : "SaveButton"
                              : itk.dis_amt -
                                couponApplied.amount +
                                GSTPRICE *
                                (itk.dis_amt - couponApplied.amount) -
                                (dis || 0) <=
                                0
                                ? "disabledbtn"
                                : "SaveButton"
                              }`}
                            disabled={
                              stepperButton || list.PPayment === "1"
                                ? ((itk.dis_amt -
                                  (couponApplied.status &&
                                    message ===
                                    "Coupon code applied successfully"
                                    ? parseInt(couponApplied.amount)
                                    : 0) +
                                  GSTPRICE *
                                  (itk.dis_amt -
                                    (couponApplied.status &&
                                      message ===
                                      "Coupon code applied successfully"
                                      ? parseInt(couponApplied.amount)
                                      : 0))) *
                                  itk.pay_1_perc) /
                                100 <=
                                0
                                : itk.dis_amt -
                                couponApplied.amount +
                                GSTPRICE *
                                (itk.dis_amt - couponApplied.amount) -
                                (dis || 0) <=
                                0
                            }
                            onClick={() =>
                              handleSubmit(
                                itk.id,
                                dis,
                                itk.offer_spl - couponApplied.amount,
                                itk.offer_spl,
                                list.PPayment === "1"
                                  ? (
                                    ((itk.dis_amt -
                                      couponApplied.amount +
                                      GSTPRICE *
                                      (itk.dis_amt -
                                        couponApplied.amount)) *
                                      itk.pay_1_perc) /
                                    100
                                  ).toFixed(2)
                                  : (
                                    itk.dis_amt -
                                    couponApplied.amount +
                                    GSTPRICE *
                                    (itk.dis_amt - couponApplied.amount) -
                                    dis
                                  ).toFixed(2),
                                list.PPayment === "1"
                                  ? (
                                    itk.dis_amt -
                                    couponApplied.amount +
                                    GSTPRICE *
                                    (itk.dis_amt - couponApplied.amount) -
                                    dis
                                  ).toFixed(2)
                                  : (
                                    itk.dis_amt -
                                    couponApplied.amount +
                                    GSTPRICE *
                                    (itk.dis_amt - couponApplied.amount) -
                                    dis
                                  ).toFixed(2),
                                (
                                  (itk.dis_amt - couponApplied.amount) *
                                  GSTPRICE
                                ).toFixed(2),
                                itk.course_name,
                                list.CourseCate
                              )
                            }
                          >
                            {/* <a href="javascript:void(0)"> */}
                            Save and Continue to Payment Gateway
                            {/* </a> */}
                          </button>
                        )}
                      </div>
                    </div>
                  </>
                ))}
            </div>
          </fieldset>
        )}
        {/* {step === 7} */}
        {step === 7 && (
          <div className=" sectionSeven">
            <div className="row">
              <div className="col-md-12 d-flex justify-content-center">
                {list.PPaymentMode === "1" ? (
                  <div className="stepSeven">
                    <p className="psubtitle">{batchMessage || ""}</p>
                  </div>
                ) : (
                  <div className="stepSeven">
                    <p className="psubtitle">{batchMessage || ""}</p>
                    <p className="psubtitle_cash">
                      You've selected cash payment and a unique Order ID has
                      been sent to your email. Note it down and visit the office
                      reception to pay your specified fees.
                    </p>

                    <p className="psubtitle">
                      Contact the finance admin at the office reception for
                      assistance.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </form>
      {/* loader */}
      {isPaymentLoading && (
        <Dialog open={isPaymentLoading}>
          <DialogContent>
            <div style={{ margin: "15px" }}>
              {/* <div className="spinner-border text-danger"></div>{" "} */}
              <p> We are processing your payment. Please wait...</p>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}
export default TestBatch;
